/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents a calendar date, represented as an ISO-8601 encoded date string. */
  Date: any;
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  DateTime: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** The `Iterable` scalar type represents an array or a Traversable with any kind of data. */
  Iterable: any;
  JSON: any;
  JSONObject: any;
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: any;
  /** The `Void` scalar type represents no value being returned. */
  Void: any;
};

export type AcademicPeriod = Node & {
  __typename?: 'AcademicPeriod';
  _id: Scalars['String'];
  districtId: Scalars['String'];
  eoyConfig: EoyConfig;
  eoyPeriod: DatePeriod;
  eoyStatus?: Maybe<EoyStatusEnum>;
  id: Scalars['ID'];
  period: Scalars['String'];
  schoolYear: DatePeriod;
};

export type AcademicStandardInput = {
  currentSchoolId?: InputMaybe<Scalars['String']>;
  documentUuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  standard?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type AcademicStandardsPayload = {
  __typename?: 'AcademicStandardsPayload';
  adaptDate?: Maybe<Scalars['DateTime']>;
  child: Array<AcademicStandardsPayload>;
  description?: Maybe<Scalars['String']>;
  documentId: Scalars['String'];
  id: Scalars['Int'];
  isRoot: Scalars['Boolean'];
  standard: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export enum AccessesEnum {
  All = 'ALL',
  CreateStudentAssignment = 'CREATE_STUDENT_ASSIGNMENT',
  GradeStudentAssignments = 'GRADE_STUDENT_ASSIGNMENTS',
  SeeGradebook = 'SEE_GRADEBOOK',
}

export type AccessPolicy = {
  __typename?: 'AccessPolicy';
  applications?: Maybe<Array<Application>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions: Array<ScopedPermission>;
};

export type AccessPolicyPageConnection = {
  __typename?: 'AccessPolicyPageConnection';
  collection: Array<AccessPolicy>;
  paginationInfo?: Maybe<AccessPolicyPaginationInfo>;
};

export type AccessPolicyPaginationInfo = {
  __typename?: 'AccessPolicyPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AccessPolicyPayload = {
  __typename?: 'AccessPolicyPayload';
  accessPolicy: AccessPolicy;
};

export type AclApplication = {
  __typename?: 'AclApplication';
  name: Scalars['String'];
  modules: Array<ApplicationModule>;
  schools: Array<ApplicationSchool>;
};

/** Activity params input for status reseting */
export type ActivityParamsInput = {
  activityId: Scalars['String'];
  studentId: Scalars['String'];
};

export enum ActivityTypeEnum {
  Assessment = 'ASSESSMENT',
  AssessmentPackageBox = 'ASSESSMENT_PACKAGE_BOX',
  BankQuestion = 'BANK_QUESTION',
  AssessmentBenchmark = 'ASSESSMENT_BENCHMARK',
}

export type AddLinkedVideoInput = {
  glossaryTerm?: InputMaybe<Scalars['String']>;
  groupIdentifier?: InputMaybe<Scalars['String']>;
  groupType: VideoGroupEnum;
  k5?: Scalars['Boolean'];
  videoId: Scalars['String'];
  videoIndex?: InputMaybe<Scalars['String']>;
  force?: Scalars['Boolean'];
};

export type AddPermissionInput = {
  id: Scalars['ID'];
  scopedPermission: ScopedPermissionInput;
};

export type AddQuestionsToVideoInput = {
  questionList: Array<Scalars['String']>;
  videoId: Scalars['String'];
};

/** AddSchoolTos a Student. */
export type AddSchoolToStudentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  schoolId: Scalars['String'];
  studentId: Scalars['String'];
};

/** AddSchoolTos a Student. */
export type AddSchoolToStudentPayload = {
  __typename?: 'addSchoolToStudentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type AddStudentsToClassInput = {
  classId: Scalars['String'];
  studentIds: Scalars['Iterable'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AddStudentsToClassPayload = {
  __typename?: 'addStudentsToClassPayload';
  class?: Maybe<Class>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddStudentsToStudentSubgroupInput = {
  studentIds: Scalars['Iterable'];
  subgroupId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AddStudentsToStudentSubgroupPayload = {
  __typename?: 'addStudentsToStudentSubgroupPayload';
  studentSubgroup?: Maybe<StudentSubgroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddStudentToClassesInput = {
  classesIds: Scalars['Iterable'];
  studentId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AddStudentToClassesPayload = {
  __typename?: 'addStudentToClassesPayload';
  classes?: Maybe<Classes>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AdminKnowledgeTreeInput = {
  grade?: InputMaybe<Scalars['String']>;
  currentSchoolId?: InputMaybe<Scalars['String']>;
  isPlatformAdmin?: Scalars['Boolean'];
};

export type AdoptionAccount = {
  __typename?: 'AdoptionAccount';
  active: Scalars['Boolean'];
  adoptionEvent: AdoptionEvent;
  beginDate?: Maybe<Scalars['Date']>;
  communityAccess?: Maybe<CommunityAccess>;
  communityAccessMembers: Array<CommunityAccessMember>;
  communityRegistrationToken: Scalars['String'];
  district: District;
  expirationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  registrationToken: Scalars['String'];
  reviewers: Array<AdoptionReviewer>;
  state: StateEnum;
  subscriptionPackage: SubscriptionPackage;
};

export type AdoptionAccountFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  adoptionEventId?: InputMaybe<Scalars['ID']>;
  beginDate?: InputMaybe<Scalars['DateTime']>;
  districtId?: InputMaybe<Scalars['ID']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<StateEnum>;
};

export type AdoptionAccountImportRequest = {
  __typename?: 'AdoptionAccountImportRequest';
  adoptionEventId: Scalars['String'];
  importLog: DemoImportLog;
};

export type AdoptionAccountOrderInput = {
  active?: InputMaybe<SortEnum>;
  beginDate?: InputMaybe<SortEnumMissingLast>;
  expirationDate?: InputMaybe<SortEnumMissingLast>;
  id?: InputMaybe<SortEnum>;
  name?: InputMaybe<SortEnum>;
  state?: InputMaybe<SortEnum>;
};

export type AdoptionAccountPageConnection = {
  __typename?: 'AdoptionAccountPageConnection';
  collection: Array<AdoptionAccount>;
  paginationInfo?: Maybe<AdoptionAccountPaginationInfo>;
};

export type AdoptionAccountPaginationInfo = {
  __typename?: 'AdoptionAccountPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AdoptionAccountPayload = {
  __typename?: 'AdoptionAccountPayload';
  adoptionAccount: AdoptionAccount;
};

export type AdoptionAccountsCsvPostObjectInput = {
  adoptionEventId: Scalars['ID'];
  fileName: Scalars['String'];
};

export type AdoptionEvent = {
  __typename?: 'AdoptionEvent';
  active: Scalars['Boolean'];
  adoptionAccounts: Array<AdoptionAccount>;
  beginDate?: Maybe<Scalars['Date']>;
  category: AdoptionEventCategoryEnum;
  contentTimestamp?: Maybe<Scalars['Int']>;
  gradeAndActivities: Array<GradeAndActivity>;
  expirationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productGroups: Array<ProductGroup>;
  products: Array<Product>;
  uiCustomization?: Maybe<Scalars['String']>;
  urlCode: Scalars['String'];
};

export enum AdoptionEventCategoryEnum {
  Mathnation = 'mathnation',
  Stemscopes = 'stemscopes',
}

export type AdoptionEventFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  beginDate?: InputMaybe<Scalars['DateTime']>;
  category?: InputMaybe<AdoptionEventCategoryEnum>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AdoptionEventGradeAndActivityInput = {
  activities: Array<Scalars['String']>;
  grade: Scalars['String'];
};

export type AdoptionEventOrderInput = {
  active?: InputMaybe<SortEnum>;
  beginDate?: InputMaybe<SortEnumMissingLast>;
  category?: InputMaybe<SortEnum>;
  expirationDate?: InputMaybe<SortEnumMissingLast>;
  id?: InputMaybe<SortEnum>;
  name?: InputMaybe<SortEnum>;
};

export type AdoptionEventPageConnection = {
  __typename?: 'AdoptionEventPageConnection';
  collection: Array<AdoptionEvent>;
  paginationInfo?: Maybe<AdoptionEventPaginationInfo>;
};

export type AdoptionEventPaginationInfo = {
  __typename?: 'AdoptionEventPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AdoptionEventPayload = {
  __typename?: 'AdoptionEventPayload';
  adoptionEvent: AdoptionEvent;
};

export type AdoptionReviewer = {
  __typename?: 'AdoptionReviewer';
  active: Scalars['Boolean'];
  adoptionAccount: AdoptionAccount;
  beginDate?: Maybe<Scalars['Date']>;
  expirationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  multiSession: Scalars['Boolean'];
  school: School;
  type: AdoptionReviewerTypeEnum;
  user: User;
};

export type AdoptionReviewerFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  adoptionAccountId?: InputMaybe<Scalars['ID']>;
  adoptionEventId?: InputMaybe<Scalars['ID']>;
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  username?: InputMaybe<Scalars['String']>;
};

export type AdoptionReviewerImportRequest = {
  __typename?: 'AdoptionReviewerImportRequest';
  adoptionAccountId: Scalars['String'];
  importLog: DemoImportLog;
  importLogId: Scalars['String'];
};

export type AdoptionReviewerOrderInput = {
  active?: InputMaybe<SortEnum>;
  adoptionAccountId?: InputMaybe<SortEnum>;
  adoptionAccountName?: InputMaybe<SortEnum>;
  beginDate?: InputMaybe<SortEnumMissingLast>;
  expirationDate?: InputMaybe<SortEnumMissingLast>;
  username?: InputMaybe<SortEnum>;
};

export type AdoptionReviewerPageConnection = {
  __typename?: 'AdoptionReviewerPageConnection';
  collection: Array<AdoptionReviewer>;
  paginationInfo?: Maybe<AdoptionReviewerPaginationInfo>;
};

export type AdoptionReviewerPaginationInfo = {
  __typename?: 'AdoptionReviewerPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AdoptionReviewerPayload = {
  __typename?: 'AdoptionReviewerPayload';
  adoptionReviewer: AdoptionReviewer;
};

export enum AdoptionReviewerTypeEnum {
  ContentReviewer = 'CONTENT_REVIEWER',
  Reviewer = 'REVIEWER',
}

export type AiChatHistoryPayload = {
  __typename?: 'AiChatHistoryPayload';
  history: Array<AiChatMessage>;
};

export type AiChatInput = {
  query: Scalars['String'];
  scopeId?: InputMaybe<Scalars['Int']>;
  edition?: InputMaybe<Scalars['String']>;
  gradeLevel: Scalars['String'];
  clearHistory?: Scalars['Boolean'];
};

export type AiChatMessage = {
  __typename?: 'AiChatMessage';
  userContent: Scalars['String'];
  systemContent: Scalars['String'];
};

export type AiChatPayload = {
  __typename?: 'AiChatPayload';
  answer: Scalars['String'];
  historyContext?: Maybe<Scalars['String']>;
};

export enum ApiModeEnum {
  YearSpecific = 'YEAR_SPECIFIC',
  SharedInstance = 'SHARED_INSTANCE',
}

export type Application = {
  __typename?: 'Application';
  name: Scalars['String'];
  modules: Array<ApplicationModule>;
  split: Scalars['Boolean'];
};

export type ApplicationInput = {
  name: Scalars['String'];
  modules: Array<ApplicationModuleInput>;
  split?: InputMaybe<Scalars['Boolean']>;
};

export type ApplicationModule = {
  __typename?: 'ApplicationModule';
  name: Scalars['String'];
  operations: Array<ApplicationModuleOperation>;
  modules: Array<ApplicationModule>;
};

export type ApplicationModuleInput = {
  name: Scalars['String'];
  operations: Array<ApplicationModuleOperationInput>;
  modules?: InputMaybe<Array<ApplicationModuleInput>>;
};

export type ApplicationModuleOperation = {
  __typename?: 'ApplicationModuleOperation';
  name: Scalars['String'];
  behaviour: BehaviourEnum;
  scopes: Array<Scalars['String']>;
};

export type ApplicationModuleOperationInput = {
  name: Scalars['String'];
  behaviour?: InputMaybe<BehaviourEnum>;
  scopes?: InputMaybe<Array<PermissionScope>>;
};

export type ApplicationSchool = {
  __typename?: 'ApplicationSchool';
  schoolIds: Array<Scalars['String']>;
  modules: Array<ApplicationModule>;
};

export type ApplicationSettings = Node & {
  __typename?: 'ApplicationSettings';
  id: Scalars['ID'];
  value: Scalars['Iterable'];
};

export enum ArchiveAssignmentAction {
  Archive = 'ARCHIVE',
  Unarchive = 'UNARCHIVE',
}

export enum ArchiveStatuses {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Both = 'BOTH',
}

export type AssessmentInput = {
  edgexlInput?: InputMaybe<EdgexlAssessmentInput>;
  stemscopesInput?: InputMaybe<StemscopesAssessmentInput>;
};

export type AssessmentPackageBoxPayload = {
  __typename?: 'AssessmentPackageBoxPayload';
  stemscopesPayload?: Maybe<StemscopesAssessmentPackageBoxPayload>;
};

export type AssessmentPayload = {
  __typename?: 'AssessmentPayload';
  edgexlPayload?: Maybe<EdgexlAssessmentPayload>;
  platformAdminPayload?: Maybe<PlatformAdminUpdateAssessmentPayload>;
  statusPayload?: Maybe<StatusPayload>;
  stemscopesPayload?: Maybe<StemscopesAssessmentPayload>;
};

export type AssessmentPoolEnumsInput = {
  libraries: Array<StemscopesLibraryEnum>;
  currentSchoolId: Scalars['String'];
};

export type AssessmentPoolEnumsPayload = {
  __typename?: 'AssessmentPoolEnumsPayload';
  curriculumAreas: Array<Scalars['String']>;
  grades: Array<Scalars['String']>;
};

export type AssessmentPoolInput = {
  edgexlInput?: InputMaybe<EdgexlAssessmentPoolInput>;
  platformAdminInput?: InputMaybe<PlatformAdminAssessmentPoolInput>;
  stemscopesInput?: InputMaybe<StemscopesAssessmentPoolInput>;
};

export type AssessmentPoolPayload = {
  __typename?: 'AssessmentPoolPayload';
  edgexlPayload?: Maybe<EdgexlAssessmentPoolPayload>;
  platformAdminPayload?: Maybe<PlatformAdminAssessmentPoolPayload>;
  stemscopesPayload?: Maybe<StemscopesAssessmentPoolPayload>;
};

/** Assessment views enum */
export enum AssessmentViewEnum {
  Teacher = 'teacher',
  Student = 'student',
}

/** Assignment Object Type */
export type Assignment = {
  __typename?: 'Assignment';
  archived?: Maybe<Scalars['Boolean']>;
  assessmentId?: Maybe<Scalars['String']>;
  assignmentId: Scalars['String'];
  assignmentListId: Scalars['String'];
  assignmentSource?: Maybe<AssignmentSource>;
  calculator?: Maybe<Calculator>;
  canBePaused?: Maybe<Scalars['Boolean']>;
  classId: Scalars['String'];
  endDate: Scalars['ISO8601Date'];
  immediatelyShareResults?: Maybe<ImmediatelyShareResults>;
  labels?: Maybe<Array<Scalars['String']>>;
  lateTurnIn?: Maybe<Scalars['Boolean']>;
  learnosityReferenceId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  originLearnosityId?: Maybe<Scalars['String']>;
  ownerId: Scalars['String'];
  quantileId?: Maybe<Scalars['String']>;
  releaseFeedback?: Maybe<Scalars['Boolean']>;
  schoolId?: Maybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
  status: AssignmentStatus;
  studentAssignments?: Maybe<Array<StudentAssignment>>;
  studentIds?: Maybe<Array<Scalars['String']>>;
  subgroupIds?: Maybe<Array<Scalars['String']>>;
};

/** AssigneesInput */
export type AssignmentAssigneesInput = {
  studentIds?: InputMaybe<Array<Scalars['String']>>;
  subgroups?: InputMaybe<Array<AssignmentSubgroupInput>>;
};

/** Class Input */
export type AssignmentClassInput = {
  id: Scalars['String'];
  studentIds?: InputMaybe<Array<Scalars['String']>>;
  subgroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AssignmentDataPayload = {
  __typename?: 'AssignmentDataPayload';
  classId?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  learnosityActivityId: Scalars['String'];
  learnosityAssignmentId: Scalars['String'];
  modified: Scalars['String'];
  sessionUuid: Scalars['String'];
  status: Scalars['String'];
  studentUuid: Scalars['String'];
  teacherUuid: Scalars['String'];
  type: Scalars['String'];
  standard: Scalars['String'];
  displayName: Scalars['String'];
  domainName: Scalars['String'];
};

/** Attributes for filtering assignments by start/end date from/to */
export type AssignmentDateFilterInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Assignment Ids Type */
export type AssignmentId = {
  __typename?: 'AssignmentId';
  assignmentId?: Maybe<Scalars['String']>;
};

export enum AssignmentLearnosityRenderingType {
  Assess = 'assess',
  Inline = 'inline',
  Unspecified = 'unspecified',
}

export enum AssignmentLearnosityState {
  Initial = 'initial',
  Preview = 'preview',
  Resume = 'resume',
  Review = 'review',
  Unspecified = 'unspecified',
}

export enum AssignmentLearnosityType {
  Feedback = 'feedback',
  LocalPractice = 'local_practice',
  SubmitPractice = 'submit_practice',
  Unspecified = 'unspecified',
}

/** Assignments Object Type */
export type Assignments = {
  __typename?: 'Assignments';
  collection?: Maybe<Array<Assignment>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AssignmentsFilter = {
  assignmentListId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['String']>>;
};

/** AssignmentSource Object Type */
export type AssignmentSource = {
  __typename?: 'AssignmentSource';
  assessment?: Maybe<AssignmentSourceAssessment>;
  element?: Maybe<Element>;
};

/** assignment source Assessment */
export type AssignmentSourceAssessment = {
  __typename?: 'AssignmentSourceAssessment';
  assessmentId: Scalars['String'];
};

/** assignment source AssessmentInput */
export type AssignmentSourceAssessmentInput = {
  assessmentId: Scalars['String'];
};

/** AssignmentSourceInput */
export type AssignmentSourceInput = {
  assessment?: InputMaybe<AssignmentSourceAssessmentInput>;
  element?: InputMaybe<ElementInput>;
  /** Use for all types of MN assignments */
  mnContentId?: InputMaybe<Scalars['String']>;
};

export enum AssignmentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
  Paused = 'PAUSED',
}

/** SubgroupInput */
export type AssignmentSubgroupInput = {
  studentIds: Array<Scalars['String']>;
  subgroupId: Scalars['String'];
};

/** Assignment Union */
export type AssignmentUnion =
  | AssignmentId
  | DistrictAssignmentType
  | EdgexlAssignmentType
  | LtiEdgexlAssignmentType
  | StemscopesAssignment;

export type AthenaDistrict = Node & {
  __typename?: 'athenaDistrict';
  _id: Scalars['String'];
  city: Scalars['String'];
  externalId: Scalars['String'];
  externalSystem: Scalars['String'];
  globalName: Scalars['String'];
  id: Scalars['ID'];
  mathnationId?: Maybe<Scalars['String']>;
  source: DistrictSourceEnum;
  state: Scalars['String'];
};

/** Page connection for athenaDistrict. */
export type AthenaDistrictPageConnection = {
  __typename?: 'athenaDistrictPageConnection';
  collection?: Maybe<Array<Maybe<AthenaDistrict>>>;
  paginationInfo: AthenaDistrictPaginationInfo;
};

/** Information about the pagination. */
export type AthenaDistrictPaginationInfo = {
  __typename?: 'athenaDistrictPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AttachQuestionContainerInput = {
  platformAdminInput?: InputMaybe<PlatformAdminAttachQuestionContainerInput>;
};

export enum Audience {
  Admin = 'ADMIN',
  Leader = 'LEADER',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export enum AudienceEnum {
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type AuthorSignRequestServiceInput = {
  /** JSON string */
  config?: InputMaybe<Scalars['String']>;
};

export type BaseScope = {
  __typename?: 'BaseScope';
  contentGroups: Array<Scalars['String']>;
  displayName: Scalars['String'];
  editionName: Scalars['String'];
  elementTitles: Array<Scalars['String']>;
  id: Scalars['String'];
  image: Scalars['String'];
  internalName: Scalars['String'];
  jsonUrl: Scalars['String'];
  metadata: Scalars['JSON'];
  positionNumber: Scalars['Int'];
  projectId: Scalars['String'];
  projectType: Scalars['String'];
  sections: Array<Scalars['JSON']>;
  state: Scalars['String'];
  subscriptionContentGroups?: Maybe<Array<Scalars['String']>>;
  taxonomy: Array<Scalars['JSON']>;
};

export enum BehaviourEnum {
  Restricted = 'RESTRICTED',
  Display = 'DISPLAY',
  Hidden = 'HIDDEN',
}

export type BenchmarkInput = {
  currentSchoolId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type BenchmarkObjectsPayload = {
  __typename?: 'BenchmarkObjectsPayload';
  benchmarks: Array<BenchmarkPayload>;
};

export type BenchmarkPayload = {
  __typename?: 'BenchmarkPayload';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  standard: Scalars['String'];
  state: Scalars['String'];
  subject: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type BulkSelectionInput = {
  all?: Scalars['Boolean'];
  excludedIds?: Array<Scalars['ID']>;
  includedIds?: Array<Scalars['ID']>;
};

export type BulkUpdate = {
  __typename?: 'BulkUpdate';
  id: Scalars['ID'];
  active?: Maybe<Scalars['Boolean']>;
  itemType: BulkUpdateItemTypeEnum;
  itemIds: Array<Scalars['ID']>;
  multiSession?: Maybe<Scalars['Boolean']>;
  status: BulkUpdateStatusEnum;
};

export type BulkUpdateAdoptionAccountsInput = {
  active: Scalars['Boolean'];
};

export type BulkUpdateAdoptionReviewersInput = {
  multiSession: Scalars['Boolean'];
};

export type BulkUpdateContentsInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BulkUpdatedLogMessages = {
  __typename?: 'BulkUpdatedLogMessages';
  path: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum BulkUpdateItemTypeEnum {
  AdoptionAccount = 'ADOPTION_ACCOUNT',
  AdoptionReviewer = 'ADOPTION_REVIEWER',
}

export type BulkUpdateLog = {
  __typename?: 'BulkUpdateLog';
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  success: Scalars['Boolean'];
  messages: Array<BulkUpdatedLogMessages>;
};

export type BulkUpdatePayload = {
  __typename?: 'BulkUpdatePayload';
  id: Scalars['String'];
};

export enum BulkUpdateStatusEnum {
  Completed = 'COMPLETED',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED',
}

/** Calculator Object Type */
export type Calculator = {
  __typename?: 'Calculator';
  fourFunction?: Maybe<Scalars['Boolean']>;
  grading?: Maybe<Scalars['Boolean']>;
  scientific?: Maybe<Scalars['Boolean']>;
};

/** Calculator Input */
export type CalculatorInput = {
  fourFunction?: InputMaybe<Scalars['Boolean']>;
  grading?: InputMaybe<Scalars['Boolean']>;
  scientific?: InputMaybe<Scalars['Boolean']>;
};

export type Calendar = Node & {
  __typename?: 'Calendar';
  _id: Scalars['String'];
  calendarEntries?: Maybe<EntryPageConnection>;
  calendarId?: Maybe<Scalars['String']>;
  calendarTemplateId?: Maybe<Scalars['String']>;
  calendarType?: Maybe<CalendarTypeEnum>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pacingGuideId?: Maybe<Scalars['String']>;
  pacingGuideTemplateId?: Maybe<Scalars['String']>;
  pacingGuideType?: Maybe<PacingGuideTypeEnum>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopePlanId?: Maybe<Scalars['String']>;
  scopePlanType?: Maybe<ScopePlanTypeEnum>;
  searchName?: Maybe<Scalars['String']>;
  sharedBy?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

export type CalendarCalendarEntriesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<EntryTypeEnum>;
  filter?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
};

export type CalendarFilter = {
  calendarId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  endDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CalendarFilter_Order = {
  name?: InputMaybe<SortEnum>;
};

/** Page connection for Calendar. */
export type CalendarPageConnection = {
  __typename?: 'CalendarPageConnection';
  collection?: Maybe<Array<Maybe<Calendar>>>;
  paginationInfo: CalendarPaginationInfo;
};

/** Information about the pagination. */
export type CalendarPaginationInfo = {
  __typename?: 'CalendarPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type CalendarTemplateFilter = {
  calendarType?: InputMaybe<CalendarTypeEnum>;
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
};

/** Calendar type: Individual / Team / Template */
export enum CalendarTypeEnum {
  /** Individual Type */
  Individual = 'Individual',
  /** Team Type */
  Team = 'Team',
  /** Template Type */
  Template = 'Template',
}

/** Cancels a Impersonation. */
export type CancelImpersonationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Cancels a Impersonation. */
export type CancelImpersonationPayload = {
  __typename?: 'cancelImpersonationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  impersonation?: Maybe<CancelImpersonationPayloadData>;
};

/** Cancels a Impersonation. */
export type CancelImpersonationPayloadData = Node & {
  __typename?: 'cancelImpersonationPayloadData';
  id: Scalars['ID'];
  user?: Maybe<User>;
};

export type CanvasConfig = {
  __typename?: 'CanvasConfig';
  jsonEntry: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type CanvasSsoConfig = {
  __typename?: 'CanvasSsoConfig';
  xml: Scalars['String'];
};

export enum CategoryEnum {
  Nl = 'NL',
  Fl = 'FL',
  Im = 'IM',
}

export type ChatbotResponse = {
  __typename?: 'ChatbotResponse';
  answer?: Maybe<Scalars['String']>;
  threadId?: Maybe<Scalars['String']>;
};

export type ChatGptDistrictPayload = {
  __typename?: 'ChatGPTDistrictPayload';
  districtId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  id: Scalars['String'];
};

export type Class = {
  __typename?: 'Class';
  id: Scalars['ID'];
  _id: Scalars['String'];
  archived: Scalars['Boolean'];
  curriculumArea?: Maybe<CurriculumAreaEnum>;
  classStudents?: Maybe<ClassStudentPageConnection>;
  classTeachers?: Maybe<ClassTeacherPageConnection>;
  externalId?: Maybe<Scalars['String']>;
  gradeOrCourse?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['String']>;
  lmsId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  school: School;
  schoolId: Scalars['String'];
  status?: Maybe<StatusEnum>;
  /** @deprecated Remove after migrate to PostgresSql */
  studentCount: Scalars['Int'];
  subgroups?: Maybe<StudentSubgroupPageConnection>;
  language: Scalars['String'];
};

export type ClassClassStudentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type ClassClassTeachersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type ClassSubgroupsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type Classes = {
  __typename?: 'Classes';
  id: Scalars['ID'];
};

export type ClassFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  hasLmsId?: InputMaybe<Scalars['Boolean']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatusEnum>;
  studentsId?: InputMaybe<Scalars['String']>;
  teachersId?: InputMaybe<Scalars['String']>;
};

export type ClassFilter_Order = {
  archived?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
  name?: InputMaybe<SortEnum>;
};

/** Attributes for creating stemscopes class other assignment */
export type ClassOtherAssignment = {
  classId: Scalars['String'];
  otherAssignment: OtherAssignmentInput;
};

export type ClassPageConnection = {
  __typename?: 'ClassPageConnection';
  collection?: Maybe<Array<Maybe<Class>>>;
  paginationInfo: ClassPaginationInfo;
};

export type ClassPaginationInfo = {
  __typename?: 'ClassPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ClassStudent = {
  __typename?: 'ClassStudent';
  /** @deprecated Remove after migrate to PostgresSql */
  _id: Scalars['String'];
  /** @deprecated Remove after migrate to PostgresSql */
  id: Scalars['ID'];
  student: Student;
  /** @deprecated Remove after migrate to PostgresSql */
  studentId: Scalars['String'];
  subgroups?: Maybe<StudentSubgroupPageConnection>;
};

export type ClassStudentSubgroupsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type ClassStudentPageConnection = {
  __typename?: 'ClassStudentPageConnection';
  collection?: Maybe<Array<Maybe<ClassStudent>>>;
  paginationInfo: ClassStudentPaginationInfo;
};

export type ClassStudentPaginationInfo = {
  __typename?: 'ClassStudentPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ClassTeacher = {
  __typename?: 'ClassTeacher';
  /** @deprecated Remove after migrate to PostgresSql */
  _id: Scalars['String'];
  /** @deprecated Remove after migrate to PostgresSql */
  id: Scalars['ID'];
  accesses: Array<AccessesEnum>;
  mainTeacher: Scalars['Boolean'];
  orderListStudents?: Maybe<Scalars['String']>;
  teacher: Teacher;
  /** @deprecated Remove after migrate to PostgresSql */
  teacherId: Scalars['String'];
  subgroups?: Maybe<StudentSubgroupPageConnection>;
};

export type ClassTeacherSubgroupsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type ClassTeacherPageConnection = {
  __typename?: 'ClassTeacherPageConnection';
  collection?: Maybe<Array<Maybe<ClassTeacher>>>;
  paginationInfo: ClassTeacherPaginationInfo;
};

export type ClassTeacherPaginationInfo = {
  __typename?: 'ClassTeacherPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type CleverSchool = {
  __typename?: 'CleverSchool';
  id: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['Int'];
  stateId?: Maybe<Scalars['String']>;
};

export type CommunityAccess = {
  __typename?: 'CommunityAccess';
  accessToAnswerKeys: Scalars['Boolean'];
  accessToStudentContent: Scalars['Boolean'];
  accessToTeacherContent: Scalars['Boolean'];
  accessToTests: Scalars['Boolean'];
  active: Scalars['Boolean'];
  beginDate?: Maybe<Scalars['Date']>;
  expirationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
};

export type CommunityAccessMember = {
  __typename?: 'CommunityAccessMember';
  id: Scalars['String'];
  school: School;
  user: User;
};

/** Completes a DistrictSetupStatus. */
export type CompleteDistrictSetupStatusInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Completes a DistrictSetupStatus. */
export type CompleteDistrictSetupStatusPayload = {
  __typename?: 'completeDistrictSetupStatusPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  districtSetupStatus?: Maybe<DistrictSetupStatus>;
};

export type ComponentPayload = {
  __typename?: 'ComponentPayload';
  mnIdentifier: Scalars['String'];
  componentNo: Scalars['String'];
  componentName: Scalars['String'];
  standards: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export enum ConsumerEnum {
  MathNation = 'MathNation',
  StemScopes = 'StemScopes',
}

export type ContainersVisibilityPayload = {
  __typename?: 'ContainersVisibilityPayload';
  visibilityPayload?: Maybe<VisibilityPayload>;
};

export type Content = {
  __typename?: 'Content';
  active: Scalars['Boolean'];
  grade?: Maybe<Scalars['String']>;
  editionName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  projectType: ProjectTypeEnum;
};

export type ContentGroup = {
  __typename?: 'ContentGroup';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  contents: Array<Content>;
  /** Use only for merging data! */
  _id: Scalars['ID'];
};

export type ContentGroupFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  contentIds?: InputMaybe<Array<Scalars['ID']>>;
  productType?: InputMaybe<ProductTypeEnum>;
};

export type ContentGroupMapping = {
  contentGroup: Scalars['String'];
  grade: Scalars['String'];
};

export type ContentGroupOrderInput = {
  active?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
};

export type ContentGroupPageConnection = {
  __typename?: 'ContentGroupPageConnection';
  collection: Array<ContentGroup>;
  paginationInfo?: Maybe<ContentGroupPaginationInfo>;
};

export type ContentGroupPaginationInfo = {
  __typename?: 'ContentGroupPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentGroupPayload = {
  __typename?: 'ContentGroupPayload';
  contentGroup: ContentGroup;
};

export type ContentGroupWithSchoolPayload = {
  __typename?: 'ContentGroupWithSchoolPayload';
  schoolId: Scalars['String'];
  contentGroups?: Maybe<Array<Scalars['String']>>;
};

export type ContentIdInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ContentInput = {
  currentSchoolId?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  conceptNumber?: InputMaybe<Scalars['String']>;
  conceptName?: InputMaybe<Scalars['String']>;
  topicNumber?: InputMaybe<Scalars['String']>;
  topicName?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryEnum>;
  status?: InputMaybe<ContentStatusEnum>;
};

/** Must be used for STEMscopes LTI 1.3 */
export type ContentItem = {
  elementId: Scalars['String'];
  elementView: ElementViewEnum;
  projectId: Scalars['String'];
  scopeId: Scalars['String'];
  sectionId: Scalars['String'];
  viewId: Scalars['String'];
};

export type ContentItemLinkData = {
  __typename?: 'ContentItemLinkData';
  fields: GpbJwt;
  ltiVersion: Scalars['String'];
  url: Scalars['String'];
};

export type ContentKeyword = {
  __typename?: 'ContentKeyword';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Use only for merging data! */
  _id: Scalars['ID'];
};

export type ContentKeywordFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type ContentKeywordOrderInput = {
  id?: InputMaybe<SortEnum>;
  name?: InputMaybe<SortEnum>;
};

export type ContentKeywordPageConnection = {
  __typename?: 'ContentKeywordPageConnection';
  collection: Array<ContentKeyword>;
  paginationInfo?: Maybe<ContentKeywordPaginationInfo>;
};

export type ContentKeywordPaginationInfo = {
  __typename?: 'ContentKeywordPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentKeywordPayload = {
  __typename?: 'ContentKeywordPayload';
  keyword: ContentKeyword;
};

export type ContentPageConnection = {
  __typename?: 'ContentPageConnection';
  collection: Array<Content>;
  paginationInfo?: Maybe<ContentPaginationInfo>;
};

export type ContentPaginationInfo = {
  __typename?: 'ContentPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentPayload = {
  __typename?: 'ContentPayload';
  content: Content;
  status: Scalars['String'];
};

export enum ContentStatusEnum {
  True = 'TRUE',
  False = 'FALSE',
}

export type ContentTag = {
  __typename?: 'ContentTag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ContentTagFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type ContentTagPageConnection = {
  __typename?: 'ContentTagPageConnection';
  collection: Array<ContentTag>;
  paginationInfo?: Maybe<ContentTagPaginationInfo>;
};

export type ContentTagPaginationInfo = {
  __typename?: 'ContentTagPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentTagPayload = {
  __typename?: 'ContentTagPayload';
  tag: ContentTag;
};

export type ContentTagValue = {
  __typename?: 'ContentTagValue';
  id: Scalars['ID'];
  name: Scalars['String'];
  tag: ContentTag;
  /** Use only for merging data! */
  _id: Scalars['ID'];
};

export type ContentTagValueFilterInput = {
  tagId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type ContentTagValuePageConnection = {
  __typename?: 'ContentTagValuePageConnection';
  collection: Array<ContentTagValue>;
  paginationInfo?: Maybe<ContentTagValuePaginationInfo>;
};

export type ContentTagValuePaginationInfo = {
  __typename?: 'ContentTagValuePaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentTagValuePayload = {
  __typename?: 'ContentTagValuePayload';
  tagValue: ContentTagValue;
};

export enum ControlActionEnum {
  Show = 'SHOW',
  Hide = 'HIDE',
}

export type ControlAssessmentInput = {
  platformAdminInput?: InputMaybe<PlatformAdminControlAssessmentInput>;
};

export type ControlContainerInput = {
  platformAdminInput?: InputMaybe<PlatformAdminControlContainerInput>;
};

export type CopyAssessmentInput = {
  edgexlInput?: InputMaybe<EdgexlCopyAssessmentInput>;
  stemscopesInput?: InputMaybe<StemscopesCopyAssessmentInput>;
};

export type CreateAccessPolicyInput = {
  applications?: InputMaybe<Array<ApplicationInput>>;
  name: Scalars['String'];
  permissions: Array<ScopedPermissionInput>;
};

export type CreateAdoptionAccountInput = {
  active: Scalars['Boolean'];
  adoptionEventId: Scalars['ID'];
  communityAccess?: InputMaybe<CreateCommunityAccessInput>;
  name: Scalars['String'];
  state: StateEnum;
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type CreateAdoptionEventInput = {
  active: Scalars['Boolean'];
  category: AdoptionEventCategoryEnum;
  gradeAndActivities?: InputMaybe<
    Array<InputMaybe<AdoptionEventGradeAndActivityInput>>
  >;
  lockContent?: Scalars['Boolean'];
  name: Scalars['String'];
  uiCustomization?: InputMaybe<Scalars['String']>;
  urlCode: Scalars['String'];
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  productGroupIds: Array<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
};

export type CreateAdoptionReviewerInput = {
  active: Scalars['Boolean'];
  adoptionAccountId: Scalars['ID'];
  multiSession?: Scalars['Boolean'];
  plainPassword: Scalars['String'];
  type?: AdoptionReviewerTypeEnum;
  username: Scalars['String'];
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type CreateAssessmentInput = {
  edgexlInput?: InputMaybe<EdgexlCreateAssessmentInput>;
  stemscopesInput?: InputMaybe<StemscopesCreateAssessmentInput>;
};

export type CreateAssessmentPackageBoxInput = {
  stemscopesInput?: InputMaybe<StemscopesCreateAssessmentPackageBoxInput>;
};

/** Attributes for creating assignment */
export type CreateAssignmentInput = {
  assessmentId?: InputMaybe<Scalars['String']>;
  assignmentSource?: InputMaybe<AssignmentSourceInput>;
  calculator?: InputMaybe<CalculatorInput>;
  canBePaused?: InputMaybe<Scalars['Boolean']>;
  classes: Array<AssignmentClassInput>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  immediatelyShareResults?: InputMaybe<ImmediatelyShareResults>;
  labels: Array<Scalars['String']>;
  lateTurnIn: Scalars['Boolean'];
  learnosityReferenceId: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  releaseFeedback: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Creates a Calendar. */
export type CreateCalendarInput = {
  calendarId?: InputMaybe<Scalars['String']>;
  calendarTemplateId?: InputMaybe<Scalars['String']>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstDayOfSchool?: InputMaybe<Scalars['Iterable']>;
  gradingPeriods?: InputMaybe<Scalars['Iterable']>;
  holidays?: InputMaybe<Scalars['Iterable']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastDayOfSchool?: InputMaybe<Scalars['Iterable']>;
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Creates a Calendar. */
export type CreateCalendarPayload = {
  __typename?: 'createCalendarPayload';
  calendar?: Maybe<Calendar>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateClassInput = {
  archived?: Scalars['Boolean'];
  classTeachers?: InputMaybe<Array<InputMaybe<CreateClassTeacherNestedInput>>>;
  curriculumArea?: InputMaybe<CurriculumAreaEnum>;
  gradeOrCourse?: InputMaybe<Scalars['String']>;
  language?: Scalars['String'];
  lmsId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  schoolId: Scalars['String'];
  status?: InputMaybe<StatusEnum>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateClassPayload = {
  __typename?: 'createClassPayload';
  class?: Maybe<Class>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateClassTeacherNestedInput = {
  _id: Scalars['String'];
  accesses?: InputMaybe<Array<InputMaybe<AccessesEnum>>>;
  id?: InputMaybe<Scalars['ID']>;
  mainTeacher?: Scalars['Boolean'];
  orderListStudents: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateCommunityAccessInput = {
  accessToAnswerKeys?: Scalars['Boolean'];
  accessToStudentContent?: Scalars['Boolean'];
  accessToTeacherContent?: Scalars['Boolean'];
  accessToTests?: Scalars['Boolean'];
  active: Scalars['Boolean'];
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type CreateContentGroupInput = {
  active?: Scalars['Boolean'];
  id: Scalars['ID'];
  contents: Array<ContentIdInput>;
};

export type CreateContentKeywordInput = {
  name: Scalars['String'];
};

export type CreateContentTagInput = {
  name: Scalars['String'];
};

export type CreateContentTagValueInput = {
  name: Scalars['String'];
  tagId: Scalars['ID'];
};

/** Creates a District. */
export type CreateDistrictInput = {
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<Scalars['String']>;
  globalName: Scalars['String'];
  localName: Scalars['String'];
  mathNationId?: InputMaybe<Scalars['String']>;
  state: StateEnum;
};

/** Creates a District. */
export type CreateDistrictPayload = {
  __typename?: 'createDistrictPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
};

export type CreateEmailTemplateInput = {
  attachments: Array<InputMaybe<EmailTemplateAttachmentInput>>;
  body: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromName?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  subject: Scalars['String'];
  type: EmailTemplateTypeEnum;
};

/** Creates a Entry. */
export type CreateEntryInput = {
  calendarId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  startDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EntryTypeEnum>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Creates a Entry. */
export type CreateEntryPayload = {
  __typename?: 'createEntryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
};

export type CreateImageCategoryInput = {
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};

export type CreateImageFileInput = {
  language?: InputMaybe<LanguageEnum>;
  originalFileName: Scalars['String'];
  path: Scalars['String'];
};

export type CreateImageInput = {
  altText?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  files: Array<CreateImageFileInput>;
  name: Scalars['String'];
  tagAssociations?: InputMaybe<Array<ImageTagAssociationInput>>;
  contentTagValueIds?: InputMaybe<Array<Scalars['ID']>>;
  contentKeywordIds?: InputMaybe<Array<Scalars['ID']>>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateImageKeywordInput = {
  name: Scalars['String'];
};

export type CreateImageTagInput = {
  name: Scalars['String'];
};

export type CreateImageTagValueInput = {
  name: Scalars['String'];
  tagId: Scalars['ID'];
};

/** Creates a Impersonation. */
export type CreateImpersonationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** Creates a Impersonation. */
export type CreateImpersonationPayload = {
  __typename?: 'createImpersonationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  impersonation?: Maybe<CreateImpersonationPayloadData>;
};

/** Creates a Impersonation. */
export type CreateImpersonationPayloadData = Node & {
  __typename?: 'createImpersonationPayloadData';
  id: Scalars['ID'];
  user?: Maybe<CreateUserNestedPayload>;
};

/** Creates a PacingGuide. */
export type CreatePacingGuideInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  curriculumArea: Scalars['String'];
  grade: Scalars['String'];
  name: Scalars['String'];
  pacingGuideTemplateId?: InputMaybe<Scalars['String']>;
  pacingGuideType: PacingGuideTypeEnum;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  selectedCalendar?: InputMaybe<Scalars['Iterable']>;
  startDate?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Creates a PacingGuide. */
export type CreatePacingGuidePayload = {
  __typename?: 'createPacingGuidePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pacingGuide?: Maybe<PacingGuide>;
};

/** Creates a PasswordChange. */
export type CreatePasswordChangeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  repeatedPassword: Scalars['String'];
};

/** Creates a PasswordChange. */
export type CreatePasswordChangePayload = {
  __typename?: 'createPasswordChangePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  passwordChange?: Maybe<CreatePasswordChangePayloadData>;
};

/** Creates a PasswordChange. */
export type CreatePasswordChangePayloadData = Node & {
  __typename?: 'createPasswordChangePayloadData';
  id: Scalars['ID'];
};

export type CreatePdfAssessmentInput = {
  /** Signed request for items to be included in PDF. */
  signedRequest: Scalars['String'];
  /** Assessment title. */
  title: Scalars['String'];
  /** Assessment view: teacher's with keys or student's. */
  view: AssessmentViewEnum;
  /** Print date inside PDF. */
  date?: InputMaybe<Scalars['String']>;
  /** Print variant number inside PDF. */
  variant?: InputMaybe<Scalars['String']>;
  /** Print only one question per page. Default = false. */
  printQuestionPerPage?: InputMaybe<Scalars['Boolean']>;
  /** image access token */
  imagesAccessToken?: InputMaybe<Scalars['String']>;
};

/** Creates a Post. */
export type CreatePostInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  currentSchoolId: Scalars['String'];
  documentKey?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  isSticky?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['Int']>;
  wallId?: InputMaybe<Scalars['String']>;
};

/** Creates a Post. */
export type CreatePostPayload = {
  __typename?: 'createPostPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
};

export type CreatePreviewAccountInput = {
  accountExecutiveFirstName?: InputMaybe<Scalars['String']>;
  accountExecutiveLastName?: InputMaybe<Scalars['String']>;
  activityPeriodEnd: Scalars['DateTime'];
  activityPeriodStart: Scalars['DateTime'];
  email: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<DemoExternalSystemEnum>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  opportunity?: InputMaybe<Scalars['String']>;
  state: StateEnum;
  username?: InputMaybe<Scalars['String']>;
  productGroupIds: Array<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
};

export type CreateProductGroupInput = {
  key?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  productIds: Array<Scalars['ID']>;
};

export type CreateProductInput = {
  contentGroups?: InputMaybe<Array<Scalars['ID']>>;
  description: Scalars['String'];
  productType: ProductTypeEnum;
  scopeGroups?: InputMaybe<Array<Scalars['ID']>>;
  sku: Scalars['String'];
};

export type CreateQrcodeTemplateInput = {
  className?: InputMaybe<Scalars['String']>;
  users: Array<QrcodeUserData>;
  type: QrcodeRenderEnum;
};

export type CreateQuestionContainerInput = {
  platformAdminInput?: InputMaybe<PlatformAdminCreateQuestionContainerInput>;
};

export type CreateReaderLibraryInput = {
  title: Scalars['String'];
  enPdfFile?: InputMaybe<Scalars['Upload']>;
  esPdfFile?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
  tagValueIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Attributes for creating resource */
export type CreateResourceInput = {
  classes: Array<AssignmentClassInput>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  labels: Array<Scalars['String']>;
  learnosityReferenceId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  resourceSource: ResourceSourceInput;
};

export type CreateRoleInput = {
  code?: InputMaybe<RoleCodeEnum>;
  name: Scalars['String'];
  policies: Array<Scalars['String']>;
};

/** Creates a School. */
export type CreateSchoolInput = {
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  districtId: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<Scalars['String']>;
  globalName: Scalars['String'];
  localName: Scalars['String'];
  mathNationId?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
};

/** Creates a School. */
export type CreateSchoolPayload = {
  __typename?: 'createSchoolPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  school?: Maybe<School>;
};

/** Creates a ScopePlan. */
export type CreateScopePlanInput = {
  approachType?: InputMaybe<ScopePlanApproachEnum>;
  classSize?: InputMaybe<Scalars['Int']>;
  classTime?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  curriculumArea?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  scopePlanTemplateId?: InputMaybe<Scalars['String']>;
  scopePlanType: ScopePlanTypeEnum;
  scopes?: InputMaybe<Scalars['Iterable']>;
  teacherExp?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Creates a ScopePlan. */
export type CreateScopePlanPayload = {
  __typename?: 'createScopePlanPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  scopePlan?: Maybe<ScopePlan>;
};

export type CreateSignRequestInput = {
  authorService?: InputMaybe<AuthorSignRequestServiceInput>;
  devDomain?: InputMaybe<Scalars['String']>;
  itemsService?: InputMaybe<ItemsSignRequestRequestInput>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateStemscopesMediaPackInput = {
  area?: StemscopesVideoAreaEnum;
  items: Array<CreateStemscopesMediaPostObjectInput>;
  title: Scalars['String'];
};

export type CreateStemscopesMediaPackPayload = {
  __typename?: 'CreateStemscopesMediaPackPayload';
  pack: StemscopesMediaPack;
  items: Array<StemscopesMediaPostObjectPayload>;
};

export type CreateStemscopesMediaPostObjectInput = {
  area?: StemscopesVideoAreaEnum;
  forceCreate?: Scalars['Boolean'];
  language?: LanguageEnum;
  mediaType?: MediaTypeEnum;
  quality?: VideoQualityEnum;
  subtitles?: Scalars['Boolean'];
  subtitlesSrtFormat?: Scalars['Boolean'];
  title: Scalars['String'];
  uniquePackTitle?: InputMaybe<Scalars['String']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateStreamingVideoPostObjectInput = {
  date?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  forceCreate?: Scalars['Boolean'];
  language?: LanguageEnum;
  mediaType?: MediaTypeEnum;
  quality?: VideoQualityEnum;
  title: Scalars['String'];
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateSubscriptionInput = {
  dateEnd: Scalars['DateTime'];
  dateStart: Scalars['DateTime'];
  productIds: Array<Scalars['ID']>;
  quantity: Scalars['Int'];
};

export type CreateSubscriptionPackageInput = {
  districtId?: InputMaybe<Scalars['String']>;
  schoolIds: Array<Scalars['ID']>;
  scope?: InputMaybe<SubscriptionScopeEnum>;
  subscriptionIds: Array<Scalars['ID']>;
};

export type CreateTeamInput = {
  context: TeamContextEnum;
  /** User IDs */
  members: Array<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateTutorInput = {
  depthScale: Scalars['Int'];
  firstName: Scalars['String'];
  initialTag: LanguageTagEnum;
  mainProfilePhoto: Scalars['Upload'];
  profilePhoto: Scalars['Upload'];
  bioText?: InputMaybe<Scalars['String']>;
  bioVideo?: InputMaybe<Scalars['Upload']>;
  lastName?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Creates a UserExportRequest. */
export type CreateUserExportRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  filters: Scalars['Iterable'];
};

/** Creates a UserExportRequest. */
export type CreateUserExportRequestPayload = {
  __typename?: 'createUserExportRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userExportRequest?: Maybe<UserExportRequest>;
};

/** Creates a User. */
export type CreateUserInput = {
  active?: Scalars['Boolean'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  curriculumAreas?: InputMaybe<Scalars['Iterable']>;
  districtUuid?: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<GradeLevelEnum>;
  language?: LanguageEnum;
  lastName?: InputMaybe<Scalars['String']>;
  lmsId?: InputMaybe<Scalars['String']>;
  manualMaintenance?: InputMaybe<Scalars['Boolean']>;
  middleName?: InputMaybe<Scalars['String']>;
  plainPassword?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  sisId?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  type: UserTypeEnum;
  userRoles?: InputMaybe<Array<InputMaybe<CreateUserRoleNestedInput>>>;
  userRolesExplicitDelete?: InputMaybe<
    Array<InputMaybe<CreateUserRoleNestedInput>>
  >;
  username: Scalars['String'];
};

/** Creates a User. */
export type CreateUserNestedPayload = Node & {
  __typename?: 'createUserNestedPayload';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  authenticationToken?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUsername?: Maybe<Scalars['String']>;
  curriculumAreas?: Maybe<Scalars['Iterable']>;
  district?: Maybe<District>;
  /** @deprecated Used from Session User */
  districtUuid: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSystemName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<GradeLevelEnum>;
  id: Scalars['ID'];
  importId?: Maybe<Scalars['String']>;
  inactivityReason?: Maybe<UserInactivityReasonEnum>;
  language: LanguageEnum;
  lastName?: Maybe<Scalars['String']>;
  lmsId?: Maybe<Scalars['String']>;
  manualMaintenance?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  plainPassword?: Maybe<Scalars['String']>;
  preferences?: Maybe<Scalars['String']>;
  purpose?: Maybe<UserPurposeEnum>;
  sisId?: Maybe<Scalars['String']>;
  staffId?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
  type: UserTypeEnum;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByUsername?: Maybe<Scalars['String']>;
  userRoles?: Maybe<CreateUserRoleNestedPayloadPageConnection>;
  username: Scalars['String'];
};

/** Creates a User. */
export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Creates a UserRole. */
export type CreateUserRoleInput = {
  allSchoolsAccess?: Scalars['Boolean'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId?: Scalars['String'];
  schoolIds: Scalars['Iterable'];
};

/** Creates a UserRole. */
export type CreateUserRoleNestedInput = {
  allSchoolsAccess?: Scalars['Boolean'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  roleId?: Scalars['String'];
  schoolIds: Scalars['Iterable'];
};

/** Creates a UserRole. */
export type CreateUserRoleNestedPayload = Node & {
  __typename?: 'createUserRoleNestedPayload';
  allSchoolsAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  role: Role;
  /** @deprecated Use the Role property instead */
  roleId: Scalars['String'];
  schoolIds: Scalars['Iterable'];
};

/** Page connection for createUserRoleNestedPayload. */
export type CreateUserRoleNestedPayloadPageConnection = {
  __typename?: 'createUserRoleNestedPayloadPageConnection';
  collection?: Maybe<Array<Maybe<CreateUserRoleNestedPayload>>>;
  paginationInfo: CreateUserRoleNestedPayloadPaginationInfo;
};

/** Information about the pagination. */
export type CreateUserRoleNestedPayloadPaginationInfo = {
  __typename?: 'createUserRoleNestedPayloadPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Creates a UserRole. */
export type CreateUserRolePayload = {
  __typename?: 'createUserRolePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userRole?: Maybe<UserRole>;
};

export type CreateVideoPostObjectInput = {
  description?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  forceCreate?: Scalars['Boolean'];
  glossaryTerm?: InputMaybe<Scalars['String']>;
  groupIdentifier?: InputMaybe<Scalars['String']>;
  groupType: VideoGroupEnum;
  k5?: Scalars['Boolean'];
  mediaType?: MediaTypeEnum;
  tutorId?: InputMaybe<Scalars['String']>;
  videoId?: InputMaybe<Scalars['String']>;
  videoIndex?: InputMaybe<Scalars['String']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Creates a WallAgeControl. */
export type CreateWallAgeControlInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  isVerified: Scalars['Boolean'];
  studentId: Scalars['String'];
};

/** Creates a WallAgeControl. */
export type CreateWallAgeControlPayload = {
  __typename?: 'createWallAgeControlPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  wallAgeControl?: Maybe<WallAgeControl>;
};

/** Creates a WallPostPin. */
export type CreateWallPostPinInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  isSticky: Scalars['Boolean'];
  postId: Scalars['String'];
};

/** Creates a WallPostPin. */
export type CreateWallPostPinPayload = {
  __typename?: 'createWallPostPinPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  wallPostPin?: Maybe<WallPostPin>;
};

export type CreateWidgetInput = {
  x: Scalars['Int'];
  y: Scalars['Int'];
  w: Scalars['Int'];
  h: Scalars['Int'];
  collapsed: Scalars['Boolean'];
  expandedH: Scalars['Int'];
  expandedW: Scalars['Int'];
  minH: Scalars['Int'];
  minW: Scalars['Int'];
  type: WidgetType;
  config?: InputMaybe<Scalars['JSONObject']>;
};

export enum CurriculumAreaEnum {
  Math = 'Math',
  Science = 'Science',
}

export type CurriculumAreas = {
  __typename?: 'CurriculumAreas';
  curriculumAreas?: Maybe<Array<Scalars['String']>>;
};

export type CyuQuestionContainerInput = {
  category: Scalars['String'];
  grade: Scalars['String'];
  lesson: Scalars['String'];
  unit: Scalars['String'];
};

export enum DaAssignType {
  GradeLevEl = 'GRADE_LEVEl',
  School = 'SCHOOL',
}

export type DatePeriod = Node & {
  __typename?: 'DatePeriod';
  end: Scalars['String'];
  id: Scalars['ID'];
  start: Scalars['String'];
};

export type DatePeriodNestedInput = {
  end: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  start: Scalars['String'];
};

/** DefaultElementObject Type */
export type DefaultElement = {
  __typename?: 'DefaultElement';
  id: Scalars['String'];
  name: Scalars['String'];
  scopeId: Scalars['String'];
  studentView: Array<Scalars['JSON']>;
};

export type DeleteAdoptionAccountInput = {
  id: Scalars['ID'];
};

export type DeleteAdoptionEventInput = {
  id: Scalars['ID'];
};

export type DeleteAdoptionReviewerInput = {
  id: Scalars['ID'];
};

export type DeleteAssessmentInput = {
  edgexlInput?: InputMaybe<EdgexlDeleteAssessmentInput>;
  stemscopesInput?: InputMaybe<StemscopesDeleteAssessmentInput>;
};

export type DeleteClassInput = {
  id: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteClassPayload = {
  __typename?: 'deleteClassPayload';
  class?: Maybe<Class>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteContentInput = {
  currentSchoolId?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryEnum>;
  conceptNumber?: InputMaybe<Scalars['String']>;
  topicNumber?: InputMaybe<Scalars['String']>;
};

export type DeleteContentKeywordInput = {
  id: Scalars['ID'];
};

export type DeleteContentPayload = {
  __typename?: 'DeleteContentPayload';
  status: Scalars['String'];
};

export type DeleteContentTagInput = {
  id: Scalars['ID'];
};

export type DeleteContentTagValueInput = {
  id: Scalars['ID'];
};

/** Deletes a District. */
export type DeleteDistrictInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Deletes a District. */
export type DeleteDistrictPayload = {
  __typename?: 'deleteDistrictPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
};

export type DeleteImageCategoryInput = {
  id: Scalars['ID'];
};

export type DeleteImageInput = {
  id: Scalars['ID'];
};

export type DeleteImageKeywordInput = {
  id: Scalars['ID'];
};

export type DeleteImageTagInput = {
  id: Scalars['ID'];
};

export type DeleteImageTagValueInput = {
  id: Scalars['ID'];
};

export type DeletePreviewAccountInput = {
  id: Scalars['ID'];
};

export type DeleteProductGroupInput = {
  id: Scalars['ID'];
};

export type DeleteProductInput = {
  id: Scalars['ID'];
};

/** Deletes a School. */
export type DeleteSchoolInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Deletes a School. */
export type DeleteSchoolPayload = {
  __typename?: 'deleteSchoolPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  school?: Maybe<School>;
};

export type DeleteStemscopesMediaPackPayload = {
  __typename?: 'DeleteStemscopesMediaPackPayload';
  pack: StemscopesMediaPack;
};

export type DeleteSubscriptionInput = {
  id: Scalars['ID'];
};

export type DeleteSubscriptionPackageInput = {
  id: Scalars['ID'];
};

export type DeleteTeacherAssignmentInput = {
  assignmentId: Scalars['Int'];
  currentSchoolId: Scalars['String'];
};

export type DeleteTeacherAssignmentPayload = {
  __typename?: 'DeleteTeacherAssignmentPayload';
  response: Scalars['String'];
};

/** Deletes a UserCalendar. */
export type DeleteUserCalendarInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Deletes a UserCalendar. */
export type DeleteUserCalendarPayload = {
  __typename?: 'deleteUserCalendarPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userCalendar?: Maybe<UserCalendar>;
};

/** Deletes a User. */
export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Deletes a User. */
export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type DeleteVideoInput = {
  groupIdentifier?: InputMaybe<Scalars['String']>;
  groupType: VideoGroupEnum;
  mediaType?: MediaTypeEnum;
  tutorId?: InputMaybe<Scalars['String']>;
  videoIndex?: InputMaybe<Scalars['String']>;
};

export type DeleteWidgetInput = {
  id: Scalars['String'];
};

export enum DeliveryEnum {
  Digital = 'DIGITAL',
  Paper = 'PAPER',
}

export enum DemoExternalSystemEnum {
  Salesforce = 'salesforce',
}

export type DemoImportCsvPostObjectInput = {
  adoptionAccountId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
};

export type DemoImportCsvPostObjectPayload = {
  __typename?: 'DemoImportCsvPostObjectPayload';
  fileKey: Scalars['String'];
  formAttributes: Scalars['String'];
  formInputs: Scalars['String'];
  importRequestId: Scalars['String'];
  importItem: DemoImportItemEnum;
};

export enum DemoImportItemEnum {
  AdoptionAccount = 'ADOPTION_ACCOUNT',
  AdoptionReviewer = 'ADOPTION_REVIEWER',
  PreviewAccount = 'PREVIEW_ACCOUNT',
}

export type DemoImportLog = {
  __typename?: 'DemoImportLog';
  id: Scalars['ID'];
  errors: Array<DemoImportLogError>;
  originalFilename: Scalars['String'];
  importEnd?: Maybe<Scalars['DateTime']>;
  importItem: DemoImportItemEnum;
  importStart: Scalars['DateTime'];
  importSucceeded: Scalars['Boolean'];
  message: DemoImportLogMessageEnum;
  type: DemoImportLogTypeEnum;
};

export type DemoImportLogError = {
  __typename?: 'DemoImportLogError';
  id: Scalars['ID'];
  field: Scalars['String'];
  importLogId: Scalars['String'];
  value: Scalars['String'];
};

export enum DemoImportLogMessageEnum {
  ImportFailedDueToFileError = 'IMPORT_FAILED_DUE_TO_FILE_ERROR',
  ImportFailedForSpecificField = 'IMPORT_FAILED_FOR_SPECIFIC_FIELD',
  ImportPending = 'IMPORT_PENDING',
  ImportStartedAndNotFinished = 'IMPORT_STARTED_AND_NOT_FINISHED',
  ImportSucceeded = 'IMPORT_SUCCEEDED',
}

export type DemoImportLogPageConnection = {
  __typename?: 'DemoImportLogPageConnection';
  collection: Array<DemoImportLog>;
  paginationInfo?: Maybe<DemoImportLogPaginationInfo>;
};

export type DemoImportLogPaginationInfo = {
  __typename?: 'DemoImportLogPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum DemoImportLogTypeEnum {
  Csv = 'csv',
}

export type DigitalNotebookCover = {
  __typename?: 'DigitalNotebookCover';
  curriculumArea: Scalars['String'];
  gradeLevel: Scalars['String'];
  href: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  title: Scalars['String'];
};

export type DigitalNotebookCoverFilter = {
  curriculumArea?: InputMaybe<Array<Scalars['String']>>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalNotebookCovers = {
  __typename?: 'DigitalNotebookCovers';
  collection?: Maybe<Array<DigitalNotebookCover>>;
};

/** Use only for merging data! */
export type District = Node & {
  __typename?: 'District';
  id: Scalars['ID'];
  _id: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<Scalars['String']>;
  globalName: Scalars['String'];
  localName: Scalars['String'];
  mathNationId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  state: StateEnum;
};

/** Attributes for filtering district assignments by start/end date from/to */
export type DistrictAssignmentDateFilterInput = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};

/** DA page info input */
export type DistrictAssignmentPageInfoInput = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type DistrictAssignmentsFilter = {
  teacherFilter?: InputMaybe<TeacherDistrictAssignmentsFilter>;
};

/** Params to start District Assignments */
export type DistrictAssignmentSignRequestInput = {
  referenceId: Scalars['String'];
  signItem?: InputMaybe<ItemSignRequestInput>;
};

/** Start District Assignment response type */
export type DistrictAssignmentSignRequestType = {
  __typename?: 'DistrictAssignmentSignRequestType';
  sessionId?: Maybe<Scalars['String']>;
  sign?: Maybe<Scalars['String']>;
};

/** Attributes for District Student Assignments share_results update */
export type DistrictAssignmentsShareResultsInput = {
  assignmentId: Scalars['String'];
  shareResults: ShareResults;
  studentIds: Array<Scalars['String']>;
};

/** District Assignment Object Type */
export type DistrictAssignmentType = {
  __typename?: 'DistrictAssignmentType';
  daId: Scalars['String'];
};

/** District Base Assignments Object Type */
export type DistrictBaseAssignmentsType = {
  __typename?: 'DistrictBaseAssignmentsType';
  collection?: Maybe<Array<DistrictBaseAssignmentType>>;
  pageInfo?: Maybe<PageInfo>;
};

/** District Base Assignment Object Type */
export type DistrictBaseAssignmentType = {
  __typename?: 'DistrictBaseAssignmentType';
  assignType?: Maybe<DaAssignType>;
  daId?: Maybe<Scalars['String']>;
  districtId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  name?: Maybe<Scalars['String']>;
  schoolGradeLevels?: Maybe<Array<SchoolGradeLevels>>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
};

/** District Class Assignments Object Type */
export type DistrictClassAssignmentsType = {
  __typename?: 'DistrictClassAssignmentsType';
  collection: Array<DistrictClassAssignmentType>;
  pageInfo?: Maybe<PageInfo>;
};

/** District Class Assignment Object Type */
export type DistrictClassAssignmentType = {
  __typename?: 'DistrictClassAssignmentType';
  assessmentId: Scalars['String'];
  assignmentId: Scalars['String'];
  assignmentSource?: Maybe<AssignmentSource>;
  availableDate?: Maybe<Scalars['ISO8601Date']>;
  classId: Scalars['String'];
  daId: Scalars['String'];
  districtId: Scalars['String'];
  endDate: Scalars['ISO8601Date'];
  gradeLevel: Scalars['String'];
  name: Scalars['String'];
  originLearnosityId?: Maybe<Scalars['String']>;
  quantileId?: Maybe<Scalars['String']>;
  schoolId: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
  studentAssignments?: Maybe<Array<DistrictStudentAssignmentType>>;
  teacherId: Scalars['String'];
};

/** Attributes for creating district assignment */
export type DistrictCreateInput = {
  assessmentId: Scalars['String'];
  assignType?: InputMaybe<DaAssignType>;
  assignmentSource?: InputMaybe<AssignmentSourceInput>;
  districtId: Scalars['String'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  name: Scalars['String'];
  schoolGradeLevels: Array<SchoolGradeLevelsInput>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Contains string types to be used for filtering. */
export type DistrictFilter = {
  /** Filter by ID */
  id?: InputMaybe<Scalars['String']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by name */
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<DistrictFilter_Order>>>;
  /** Filter by state */
  state?: InputMaybe<Scalars['String']>;
  /** Filter by source */
  source?: InputMaybe<DistrictSourceEnumFilterType>;
};

export type DistrictFilter_Order = {
  city?: InputMaybe<SortEnum>;
  globalName?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
  state?: InputMaybe<SortEnum>;
};

export type DistrictInput = {
  id: Scalars['String'];
};

/** Page connection for District. */
export type DistrictPageConnection = {
  __typename?: 'DistrictPageConnection';
  collection?: Maybe<Array<Maybe<District>>>;
  paginationInfo: DistrictPaginationInfo;
};

/** Information about the pagination. */
export type DistrictPaginationInfo = {
  __typename?: 'DistrictPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type DistrictSettingsInput = {
  teacherCanUsePerryBot: Scalars['Boolean'];
  studentCanUsePerryBot: Scalars['Boolean'];
};

export type DistrictSettingsKnowledgeBase = {
  __typename?: 'DistrictSettingsKnowledgeBase';
  studentCanUsePerryBot: Scalars['Boolean'];
  teacherCanUsePerryBot: Scalars['Boolean'];
};

export type DistrictSettingsLessonPlanner = Node & {
  __typename?: 'DistrictSettingsLessonPlanner';
  id: Scalars['ID'];
  teacherCanUseAiAssistedLessonPlan: Scalars['Boolean'];
};

export type DistrictSettingsLogin = {
  __typename?: 'DistrictSettingsLogin';
  ltiHighestScore: Scalars['Boolean'];
};

export type DistrictSettingsLoginInput = {
  ltiHighestScore?: Scalars['Boolean'];
};

export type DistrictSettingsRoster = {
  __typename?: 'DistrictSettingsRoster';
  id: Scalars['ID'];
  teacherCanAddAdditionalTeacher: Scalars['Boolean'];
  teacherCanCreateClasses: Scalars['Boolean'];
  teacherCanEditClassRoster: Scalars['Boolean'];
};

export type DistrictSettingsUserManagement = Node & {
  __typename?: 'DistrictSettingsUserManagement';
  id: Scalars['ID'];
  teacherCanCreateStudents: Scalars['Boolean'];
  teacherCanEditStudentPassword: Scalars['Boolean'];
  teacherCanImpersonateStudents: Scalars['Boolean'];
};

export type DistrictSetupStatus = Node & {
  __typename?: 'DistrictSetupStatus';
  id: Scalars['ID'];
  status: SetupStatusEnum;
};

/** DistrictSort type: city / globalName / id / source / state by ASC or DESC */
export type DistrictSort = {
  /** sort by city asc or desc */
  city?: InputMaybe<SortEnum>;
  /** sort by globalName asc or desc */
  globalName?: InputMaybe<SortEnum>;
  /** sort by id asc or desc */
  id?: InputMaybe<SortEnum>;
  /** sort by source asc or desc */
  source?: InputMaybe<SortEnum>;
  /** sort by state asc or desc */
  state?: InputMaybe<SortEnum>;
};

export enum DistrictSourceEnum {
  Manual = 'MANUAL',
  Unspecified = 'UNSPECIFIED',
  OneRosterCsv = 'ONE_ROSTER_CSV',
  Clever = 'CLEVER',
  Classlink = 'CLASSLINK',
  EdFi = 'ED_FI',
  Mathnation = 'MATHNATION',
  Skyward = 'SKYWARD',
}

/** DistrictSourceEnum type: MANUAL, UNSPECIFIED, ONE_ROSTER_CSV, CLEVER, CLASSLINK, ED_FI, MATHNATION, SKYWARD */
export enum DistrictSourceEnumFilterType {
  Manual = 'MANUAL',
  Unspecified = 'UNSPECIFIED',
  OneRosterCsv = 'ONE_ROSTER_CSV',
  Clever = 'CLEVER',
  Classlink = 'CLASSLINK',
  EdFi = 'ED_FI',
  Mathnation = 'MATHNATION',
  Skyward = 'SKYWARD',
}

/** District Student Assignments Object Type */
export type DistrictStudentAssignmentsType = {
  __typename?: 'DistrictStudentAssignmentsType';
  collection: Array<DistrictStudentAssignmentType>;
  pageInfo?: Maybe<PageInfo>;
};

/** District Student Assignment Object Type */
export type DistrictStudentAssignmentType = {
  __typename?: 'DistrictStudentAssignmentType';
  answers?: Maybe<Scalars['JSON']>;
  assessmentId: Scalars['String'];
  assignmentId: Scalars['String'];
  availableDate?: Maybe<Scalars['ISO8601Date']>;
  classId: Scalars['String'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  daId: Scalars['String'];
  districtId: Scalars['String'];
  endDate: Scalars['ISO8601Date'];
  grade?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  learnosityReferenceId: Scalars['String'];
  name: Scalars['String'];
  quantileScore?: Maybe<Scalars['String']>;
  reopenDate?: Maybe<Scalars['ISO8601Date']>;
  schoolId: Scalars['String'];
  sessionId?: Maybe<Scalars['String']>;
  shareResults?: Maybe<ShareResults>;
  startDate: Scalars['ISO8601Date'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<StudentAssignmentStatus>;
  studentAvailability: Scalars['String'];
  studentId: Scalars['String'];
  studentNotes?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  teacherId: Scalars['String'];
};

export enum DocTypeEnum {
  Doc = 'Doc',
  Docx = 'Docx',
}

export type DownloadPayload = {
  __typename?: 'DownloadPayload';
  downloadUrl: Scalars['String'];
};

export type DownloadTccPackage = {
  __typename?: 'DownloadTccPackage';
  downloadLink: Scalars['String'];
};

export type EdfiGradeLevel = {
  __typename?: 'EdfiGradeLevel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EdfiJobRole = {
  __typename?: 'EdfiJobRole';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EdfiSchool = {
  __typename?: 'EdfiSchool';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EdgePayload = {
  __typename?: 'EdgePayload';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type EdgexlAssessmentInput = {
  field: FieldEnum;
  value: Scalars['String'];
  currentSchoolId: Scalars['String'];
};

export type EdgexlAssessmentItemPayload = {
  __typename?: 'EdgexlAssessmentItemPayload';
  status: Scalars['String'];
  tags: Array<TagPayload>;
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UserPayload>;
  items: Array<Scalars['String']>;
};

export type EdgexlAssessmentPayload = {
  __typename?: 'EdgexlAssessmentPayload';
  item?: Maybe<EdgexlAssessmentItemPayload>;
};

export type EdgexlAssessmentPoolInput = {
  library: EdgexlLibraryEnum;
  sort?: InputMaybe<SortInput>;
  category?: InputMaybe<EdgexlCategoryEnum>;
  grade?: InputMaybe<EdgexlGradeEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Array<Scalars['String']>>;
  next?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type EdgexlAssessmentPoolPayload = {
  __typename?: 'EdgexlAssessmentPoolPayload';
  list: Array<EdgexlAssessmentItemPayload>;
  next: Scalars['String'];
};

export type EdgexlAssignmentProgressInfoType = {
  __typename?: 'EdgexlAssignmentProgressInfoType';
  activityId?: Maybe<Scalars['String']>;
  maxScore?: Maybe<Scalars['String']>;
  responses?: Maybe<Scalars['JSON']>;
  score?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Settings for edgexl assignment */
export type EdgexlAssignmentSettingsInput = {
  classesSettings: Array<EdgexlClassSettingsInput>;
  settings: EdgexlSettingsInput;
};

/** info about last attemption or all attemptions */
export type EdgexlAssignmentsProgressInfoInput = {
  activityId?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type EdgexlAssignmentsProgressInfoType = {
  __typename?: 'EdgexlAssignmentsProgressInfoType';
  collection?: Maybe<Array<EdgexlAssignmentProgressInfoType>>;
  pageInfo?: Maybe<PageInfo>;
};

/** Edgexl Assignments Object Type */
export type EdgexlAssignmentsType = {
  __typename?: 'EdgexlAssignmentsType';
  assignments: Array<EdgexlAssignmentType>;
  pageInfo?: Maybe<PageInfo>;
  studentAssignments?: Maybe<Array<EdgexlStudentAssignmentType>>;
};

/** Edgexl Assignment Object Type */
export type EdgexlAssignmentType = {
  __typename?: 'EdgexlAssignmentType';
  assessmentId?: Maybe<Scalars['String']>;
  assignmentId?: Maybe<Scalars['String']>;
  assignmentSettings?: Maybe<EdgexlSettingsType>;
  classesSettings?: Maybe<Scalars['JSON']>;
  schoolId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum EdgexlCategoryEnum {
  Fl = 'FL',
  Im = 'IM',
  Le = 'LE',
  Mf = 'MF',
  On = 'ON',
  Nl = 'NL',
  Sc = 'SC',
  Ms = 'MS',
  Ca = 'CA',
}

/** Settings for class */
export type EdgexlClassSettingsInput = {
  classId: Scalars['String'];
  settings: EdgexlSettingsInput;
  students: Array<EdgexlStudentSettingsInput>;
};

export type EdgexlCopyAssessmentInput = {
  id: Scalars['ID'];
  currentSchoolId: Scalars['String'];
};

export type EdgexlCreateAssessmentInput = {
  attemptsNumber?: InputMaybe<Scalars['Int']>;
  deliveries: Array<DeliveryEnum>;
  isAllowViewCorrectAnswers?: InputMaybe<Scalars['Boolean']>;
  isAssigned?: Scalars['Boolean'];
  isRetakeOnlyIncorrect?: InputMaybe<Scalars['Boolean']>;
  isSameQuestionNumber?: InputMaybe<Scalars['Boolean']>;
  isScramble?: InputMaybe<Scalars['Boolean']>;
  items: Array<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  category?: InputMaybe<EdgexlCategoryEnum>;
  grade?: InputMaybe<EdgexlGradeEnum>;
  currentSchoolId: Scalars['String'];
};

/** Attributes for creating edgexl assignment */
export type EdgexlCreateInput = {
  assignmentSettings: EdgexlAssignmentSettingsInput;
  assignmentSource: AssignmentSourceInput;
  learnosityReferenceId: Scalars['String'];
  schoolId: Scalars['String'];
  title: Scalars['String'];
};

export type EdgexlDeleteAssessmentInput = {
  id: Scalars['ID'];
  currentSchoolId: Scalars['String'];
};

/** Attributes for editing edgexl assignment */
export type EdgexlEditInput = {
  assignmentId: Scalars['String'];
  assignmentSettings: EdgexlAssignmentSettingsInput;
};

export enum EdgexlGradeEnum {
  G01 = 'G01',
  G02 = 'G02',
  G03 = 'G03',
  G04 = 'G04',
  G05 = 'G05',
  G06 = 'G06',
  G6A = 'G6A',
  G07 = 'G07',
  G7A = 'G7A',
  G08 = 'G08',
  Ga1 = 'GA1',
  Ga2 = 'GA2',
  Gac = 'GAC',
  Ggo = 'GGO',
  Gkg = 'GKG',
  Gon = 'GON',
  Gp8 = 'GP8',
  Gpt = 'GPT',
  Gsa = 'GSA',
}

export enum EdgexlLibraryEnum {
  Individual = 'INDIVIDUAL',
  Mathnation = 'MATHNATION',
  District = 'DISTRICT',
  Others = 'OTHERS',
}

export type EdgexlQuestionContainerInput = {
  category: Scalars['String'];
  grade: Scalars['String'];
  unit: Scalars['String'];
};

export type EdgexlQuestionPoolInput = {
  category: EdgexlCategoryEnum;
  grade: EdgexlGradeEnum;
  units?: InputMaybe<Array<Scalars['String']>>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  standards?: InputMaybe<Array<Scalars['String']>>;
  currentSchoolId: Scalars['String'];
};

/** Shared type for settings */
export type EdgexlSettingsInput = {
  attemptsNumber: Scalars['String'];
  endDate: Scalars['ISO8601DateTime'];
  notes: Scalars['String'];
  startDate: Scalars['ISO8601DateTime'];
};

/** Edgexl Settings Object Type */
export type EdgexlSettingsType = {
  __typename?: 'EdgexlSettingsType';
  attemptsNumber?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  notes?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type EdgexlShareAssessmentInput = {
  id: Scalars['ID'];
  currentSchoolId: Scalars['String'];
};

/** Edgexl Student Assignments Object Type */
export type EdgexlStudentAssignmentsType = {
  __typename?: 'EdgexlStudentAssignmentsType';
  collection?: Maybe<Array<EdgexlStudentAssignmentType>>;
  pageInfo?: Maybe<PageInfo>;
};

/** Edgexl Student Assignment Object Type */
export type EdgexlStudentAssignmentType = {
  __typename?: 'EdgexlStudentAssignmentType';
  assignmentId: Scalars['String'];
  classId?: Maybe<Scalars['String']>;
  completedAttemptsNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAllowViewCorrectAnswers?: Maybe<Scalars['String']>;
  isRetakeOnlyIncorrect?: Maybe<Scalars['String']>;
  isSameQuestionNumber?: Maybe<Scalars['String']>;
  isScramble?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Scalars['String']>>;
  learnosityReferenceId?: Maybe<Scalars['String']>;
  maxScore?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  studentSettings?: Maybe<EdgexlSettingsType>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  title?: Maybe<Scalars['String']>;
};

/** Student assignment settings */
export type EdgexlStudentSettingsInput = {
  settings: EdgexlSettingsInput;
  studentId: Scalars['String'];
};

export type EdgexlUpdateAssessmentInput = {
  id: Scalars['ID'];
  attemptsNumber?: InputMaybe<Scalars['Int']>;
  deliveries: Array<DeliveryEnum>;
  isAllowViewCorrectAnswers?: InputMaybe<Scalars['Boolean']>;
  isAssigned?: Scalars['Boolean'];
  isRetakeOnlyIncorrect?: InputMaybe<Scalars['Boolean']>;
  isSameQuestionNumber?: InputMaybe<Scalars['Boolean']>;
  isScramble?: InputMaybe<Scalars['Boolean']>;
  items: Array<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  category?: InputMaybe<EdgexlCategoryEnum>;
  grade?: InputMaybe<EdgexlGradeEnum>;
  currentSchoolId: Scalars['String'];
};

/** Edit Assignment Input */
export type EditAssignmentInput = {
  edgexlEditAssignmentInput: EdgexlEditInput;
};

/** Element Object Type */
export type Element = {
  __typename?: 'Element';
  elementId: Scalars['String'];
  elementName: Scalars['String'];
  projectId: Scalars['String'];
  scopeId: Scalars['String'];
  scopeName: Scalars['String'];
  sectionId: Scalars['String'];
  sectionName: Scalars['String'];
  viewId?: Maybe<Scalars['String']>;
};

export type ElementFilter = {
  curriculumArea?: InputMaybe<Array<Scalars['String']>>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['String']>>;
  projectId?: InputMaybe<Scalars['String']>;
  resourceDefault?: InputMaybe<Scalars['Boolean']>;
  scopeId?: InputMaybe<Scalars['String']>;
  assignable?: InputMaybe<Scalars['Boolean']>;
  contentGroups?: InputMaybe<Array<Scalars['String']>>;
};

/** ElementInput */
export type ElementInput = {
  elementId: Scalars['String'];
  elementName: Scalars['String'];
  projectId: Scalars['String'];
  scopeId: Scalars['String'];
  scopeName: Scalars['String'];
  sectionId: Scalars['String'];
  sectionName: Scalars['String'];
  viewId: Scalars['String'];
};

export type Elements = {
  __typename?: 'Elements';
  collection?: Maybe<Array<SearchableElement>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum ElementViewEnum {
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  id: Scalars['ID'];
  body: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  subject: Scalars['String'];
  type: EmailTemplateTypeEnum;
  attachments: Array<EmailTemplateAttachment>;
};

export type EmailTemplateAttachment = {
  __typename?: 'EmailTemplateAttachment';
  id: Scalars['ID'];
  emailTemplateId: Scalars['String'];
  originalFileName: Scalars['String'];
  downloadLink: Scalars['String'];
  path: Scalars['String'];
};

export type EmailTemplateAttachmentInput = {
  id: Scalars['String'];
  originalFileName: Scalars['String'];
  path: Scalars['String'];
};

export type EmailTemplateAttachmentUploadForm = {
  __typename?: 'EmailTemplateAttachmentUploadForm';
  id: Scalars['String'];
  fileName: Scalars['String'];
  formAttributes: Scalars['String'];
  formInputs: Scalars['String'];
};

export type EmailTemplateAttachmentUploadFormPayload = {
  __typename?: 'EmailTemplateAttachmentUploadFormPayload';
  collection: Array<EmailTemplateAttachmentUploadForm>;
};

export type EmailTemplateFilterInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EmailTemplateTypeEnum>;
};

export type EmailTemplateImageUploadForm = {
  __typename?: 'EmailTemplateImageUploadForm';
  fileKey: Scalars['String'];
  formAttributes: Scalars['String'];
  formInputs: Scalars['String'];
  imageUrl: Scalars['String'];
};

export type EmailTemplatePageConnection = {
  __typename?: 'EmailTemplatePageConnection';
  collection: Array<EmailTemplate>;
  paginationInfo?: Maybe<EmailTemplatePaginationInfo>;
};

export type EmailTemplatePaginationInfo = {
  __typename?: 'EmailTemplatePaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EmailTemplatePayload = {
  __typename?: 'EmailTemplatePayload';
  emailTemplate: EmailTemplate;
};

export type EmailTemplatePlaceholder = {
  __typename?: 'EmailTemplatePlaceholder';
  code: EmailTemplatePlaceholderEnum;
  exampleValue: Scalars['String'];
};

export enum EmailTemplatePlaceholderEnum {
  DistrictGlobalName = 'district_global_name',
  MfaCode = 'mfa_code',
  ParentRegistrationLink = 'parent_registration_link',
  Password = 'password',
  PreviewAccountActivityEndDate = 'preview_account_activity_end_date',
  PreviewAccountActivityStartDate = 'preview_account_activity_start_date',
  PreviewAccountId = 'preview_account_id',
  UserFirstName = 'user_first_name',
  UserLastName = 'user_last_name',
  Username = 'username',
  UserPasswordRecoveryApplication = 'user_password_recovery_application',
  UserPasswordRecoveryResetLink = 'user_password_recovery_reset_link',
  UserPasswordRecoveryResetLinkLifetimeHours = 'user_password_recovery_reset_link_lifetime_hours',
}

export type EmailTemplatePlaceholdersPayload = {
  __typename?: 'EmailTemplatePlaceholdersPayload';
  collection: Array<EmailTemplatePlaceholder>;
};

export enum EmailTemplateTypeEnum {
  AddChildToParent = 'addChildToParent',
  AdminMfa = 'adminMfa',
  PostReplyAdded = 'postReplyAdded',
  PreviewAccountActivityPeriodUpdated = 'previewAccountActivityPeriodUpdated',
  PreviewAccountActivityPeriodUpdatedMn = 'previewAccountActivityPeriodUpdatedMn',
  PreviewAccountCreated = 'previewAccountCreated',
  PreviewAccountCreatedMn = 'previewAccountCreatedMn',
  PreviewAccountExpires = 'previewAccountExpires',
  PreviewAccountExpiresMn = 'previewAccountExpiresMn',
  PreviewAccountFinished = 'previewAccountFinished',
  PreviewAccountFinishedMn = 'previewAccountFinishedMn',
  PreviewAccountStarted = 'previewAccountStarted',
  PreviewAccountStartedMn = 'previewAccountStartedMn',
  ParentRegistration = 'parentRegistration',
  UserPasswordRecovery = 'userPasswordRecovery',
}

export type EmbedUrlResponse = {
  __typename?: 'EmbedUrlResponse';
  EmbedUrl: Scalars['String'];
};

export type Entry = Node & {
  __typename?: 'Entry';
  _id: Scalars['String'];
  calendarId?: Maybe<Scalars['String']>;
  calendarType?: Maybe<CalendarTypeEnum>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructionalDays?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  pacingGuideId?: Maybe<Scalars['String']>;
  pacingGuideTemplateId?: Maybe<Scalars['String']>;
  pacingGuideType?: Maybe<PacingGuideTypeEnum>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopeId?: Maybe<Scalars['String']>;
  scopePlanId?: Maybe<Scalars['String']>;
  scopePlanType?: Maybe<ScopePlanTypeEnum>;
  sharedBy?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  startDate: Scalars['String'];
  type: EntryTypeEnum;
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

export type EntryFilter = {
  endDate?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<EntryTypeEnum>;
  startDate?: InputMaybe<Scalars['String']>;
};

/** Page connection for Entry. */
export type EntryPageConnection = {
  __typename?: 'EntryPageConnection';
  collection?: Maybe<Array<Maybe<Entry>>>;
  paginationInfo: EntryPaginationInfo;
};

/** Information about the pagination. */
export type EntryPaginationInfo = {
  __typename?: 'EntryPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Entry types available */
export enum EntryTypeEnum {
  /** Entry type: Event */
  Event = 'Event',
  /** Entry type: First Day Of School */
  FirstDayOfSchool = 'FirstDayOfSchool',
  /** Entry type: Grading Period */
  GradingPeriod = 'GradingPeriod',
  /** Entry type: Holiday */
  Holiday = 'Holiday',
  /** Entry type: Last Day Of School */
  LastDayOfSchool = 'LastDayOfSchool',
  /** Entry type: Non Instructional Day */
  NonInstructionalDay = 'NonInstructionalDay',
  /** Entry type: Note */
  Note = 'Note',
  /** Entry type: Pacing Guide Scope */
  Scope = 'Scope',
  /** Entry type: Testing Day */
  TestingDay = 'TestingDay',
}

export type EoyConfig = Node & {
  __typename?: 'EoyConfig';
  activeStudents: Scalars['Boolean'];
  activeTeachers: Scalars['Boolean'];
  excludedTeacherIds: Scalars['Iterable'];
  id: Scalars['ID'];
  inactiveStudents: Scalars['Boolean'];
  inactiveTeachers: Scalars['Boolean'];
};

export type EoyConfigNestedInput = {
  activeStudents?: Scalars['Boolean'];
  activeTeachers?: Scalars['Boolean'];
  excludedTeacherIds: Scalars['Iterable'];
  id?: InputMaybe<Scalars['ID']>;
  inactiveStudents?: Scalars['Boolean'];
  inactiveTeachers?: Scalars['Boolean'];
};

export enum EoyStatusEnum {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  TimeToStart = 'TIME_TO_START',
}

export type EventInput = {
  payload: Scalars['String'];
  type: Scalars['String'];
};

export type EventStatusPayload = {
  __typename?: 'EventStatusPayload';
  success: Scalars['Boolean'];
};

export enum ExternalFieldEnum {
  Email = 'EMAIL',
  Id = 'ID',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Username = 'USERNAME',
  LmsId = 'LMS_ID',
}

export enum ExternalSystemNameEnum {
  SystemManual = 'SYSTEM_MANUAL',
  SystemOnerosterCsv = 'SYSTEM_ONEROSTER_CSV',
  SystemClever = 'SYSTEM_CLEVER',
  SystemClasslink = 'SYSTEM_CLASSLINK',
  SystemEdFi = 'SYSTEM_ED_FI',
  SystemMathnation = 'SYSTEM_MATHNATION',
  SystemSkyward = 'SYSTEM_SKYWARD',
}

export type ExtractOneRosterSchoolsInput = {
  districtId: Scalars['String'];
  file: Scalars['Upload'];
};

export enum FieldEnum {
  Title = 'TITLE',
  Id = 'ID',
}

export type FilterIconInput = {
  /** Used for retrieving specific icon information based in elementIconType */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterTeamInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  membersActive?: InputMaybe<Scalars['Boolean']>;
};

export type FromMoveVideoInput = {
  groupIdentifier: Scalars['String'];
  tutorId?: InputMaybe<Scalars['String']>;
  videoIndex?: InputMaybe<Scalars['String']>;
};

export type GenerateQuestionResponse = {
  __typename?: 'GenerateQuestionResponse';
  jsonResponse?: Maybe<Scalars['String']>;
};

export type GetQuestionHintResponse = {
  __typename?: 'GetQuestionHintResponse';
  hint?: Maybe<Scalars['String']>;
};

export enum GlossaryFilterConditionEnum {
  Contain = 'CONTAIN',
  BeginWith = 'BEGIN_WITH',
}

export type GpbJwt = {
  __typename?: 'GpbJwt';
  JWT: Scalars['String'];
};

export type GradeAndActivity = {
  __typename?: 'GradeAndActivity';
  activities: Array<Scalars['String']>;
  grade: Scalars['String'];
};

export enum GradeLevelEnum {
  GlPreK = 'gl_pre_k',
  GlK = 'gl_k',
  Gl_1 = 'gl_1',
  Gl_2 = 'gl_2',
  Gl_3 = 'gl_3',
  Gl_4 = 'gl_4',
  Gl_5 = 'gl_5',
  Gl_6 = 'gl_6',
  Gl_7 = 'gl_7',
  Gl_8 = 'gl_8',
  Gl_9 = 'gl_9',
  Gl_10 = 'gl_10',
  Gl_11 = 'gl_11',
  Gl_12 = 'gl_12',
}

export enum GradeLevelFilterEnum {
  GlUndefined = 'gl_undefined',
  GlPreK = 'gl_pre_k',
  GlK = 'gl_k',
  Gl_1 = 'gl_1',
  Gl_2 = 'gl_2',
  Gl_3 = 'gl_3',
  Gl_4 = 'gl_4',
  Gl_5 = 'gl_5',
  Gl_6 = 'gl_6',
  Gl_7 = 'gl_7',
  Gl_8 = 'gl_8',
  Gl_9 = 'gl_9',
  Gl_10 = 'gl_10',
  Gl_11 = 'gl_11',
  Gl_12 = 'gl_12',
}

export enum GradeLevels {
  /** 3-5 grade levels */
  Gl_35 = 'GL_35',
  /** 6-8(Middle School) grade levels */
  Gl_68 = 'GL_68',
  /** High School grade levels */
  GlHs = 'GL_HS',
  /** K-2 grade levels */
  GlK2 = 'GL_K2',
}

/** Available grade levels sorted by grades */
export type GradeLevelsByGrade = {
  __typename?: 'GradeLevelsByGrade';
  gl1?: Maybe<Array<GradeLevels>>;
  gl10?: Maybe<Array<GradeLevels>>;
  gl11?: Maybe<Array<GradeLevels>>;
  gl12?: Maybe<Array<GradeLevels>>;
  gl2?: Maybe<Array<GradeLevels>>;
  gl3?: Maybe<Array<GradeLevels>>;
  gl4?: Maybe<Array<GradeLevels>>;
  gl5?: Maybe<Array<GradeLevels>>;
  gl6?: Maybe<Array<GradeLevels>>;
  gl7?: Maybe<Array<GradeLevels>>;
  gl8?: Maybe<Array<GradeLevels>>;
  gl9?: Maybe<Array<GradeLevels>>;
  glk?: Maybe<Array<GradeLevels>>;
  glpk?: Maybe<Array<GradeLevels>>;
};

/** Available grade levels sorted by grades */
export type GradeLevelsByGradeInput = {
  gl1?: InputMaybe<Array<GradeLevels>>;
  gl10?: InputMaybe<Array<GradeLevels>>;
  gl11?: InputMaybe<Array<GradeLevels>>;
  gl12?: InputMaybe<Array<GradeLevels>>;
  gl2?: InputMaybe<Array<GradeLevels>>;
  gl3?: InputMaybe<Array<GradeLevels>>;
  gl4?: InputMaybe<Array<GradeLevels>>;
  gl5?: InputMaybe<Array<GradeLevels>>;
  gl6?: InputMaybe<Array<GradeLevels>>;
  gl7?: InputMaybe<Array<GradeLevels>>;
  gl8?: InputMaybe<Array<GradeLevels>>;
  gl9?: InputMaybe<Array<GradeLevels>>;
  glk?: InputMaybe<Array<GradeLevels>>;
  glpk?: InputMaybe<Array<GradeLevels>>;
};

export type Grades = {
  __typename?: 'Grades';
  grades: Array<Scalars['String']>;
};

/** Grading Session Type */
export type GradingSession = {
  __typename?: 'GradingSession';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum GradingTypeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export type HelpPageInput = {
  audience: Audience;
};

export type HelpPageStructure = {
  __typename?: 'HelpPageStructure';
  audience: Audience;
  link: Scalars['String'];
};

export type Icon = {
  __typename?: 'Icon';
  id: Scalars['ID'];
  fileName: Scalars['String'];
  type: Scalars['String'];
  filePath: Scalars['String'];
  languageFilePath: Array<LanguageFilePath>;
  consumer: ConsumerEnum;
};

export type IconPageConnection = {
  __typename?: 'IconPageConnection';
  collection: Array<Icon>;
  paginationInfo?: Maybe<IconPaginationInfo>;
};

export type IconPaginationInfo = {
  __typename?: 'IconPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type IconPayload = {
  __typename?: 'IconPayload';
  icon: Icon;
};

export type IdentifyUserFilter = {
  districtId?: InputMaybe<Scalars['String']>;
  lmsId?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']>;
  categories: Array<ImageCategory>;
  contentKeywords?: Maybe<Array<ContentKeyword>>;
  contentTagValues?: Maybe<Array<ContentTagValue>>;
  createdAt: Scalars['DateTime'];
  files: Array<ImageFile>;
  id: Scalars['ID'];
  /**
   * Deprecated, use contentKeywords instead
   * @deprecated use getContentKeywords instead
   */
  keywords: Array<ImageKeyword>;
  name: Scalars['String'];
  /**
   * Deprecated, use contentTagValues instead
   * @deprecated use getContentTagValues instead
   */
  tagAssociations: Array<ImageTagAssociation>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageCategory = {
  __typename?: 'ImageCategory';
  children: Array<ImageCategory>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<ImageCategory>;
  path: Array<ImageCategoryPathPart>;
};

export type ImageCategoryFilterInput = {
  parentId?: InputMaybe<Scalars['ID']>;
};

export type ImageCategoryPageConnection = {
  __typename?: 'ImageCategoryPageConnection';
  collection: Array<ImageCategory>;
  paginationInfo?: Maybe<ImageCategoryPaginationInfo>;
};

export type ImageCategoryPaginationInfo = {
  __typename?: 'ImageCategoryPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImageCategoryPathPart = {
  __typename?: 'ImageCategoryPathPart';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ImageCategoryPayload = {
  __typename?: 'ImageCategoryPayload';
  imageCategory: ImageCategory;
};

export type ImageFile = {
  __typename?: 'ImageFile';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  height?: Maybe<Scalars['Int']>;
  language?: Maybe<LanguageEnum>;
  mimeType?: Maybe<Scalars['String']>;
  originalFileName: Scalars['String'];
  path: Scalars['String'];
  processed: Scalars['Boolean'];
  sha256: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImageFileUploadForm = {
  __typename?: 'ImageFileUploadForm';
  fileKey: Scalars['String'];
  formAttributes: Scalars['String'];
  formInputs: Scalars['String'];
  imageUrl: Scalars['String'];
};

export type ImageFilterInput = {
  language?: InputMaybe<LanguageEnum>;
  categoryId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  tagAssociations?: InputMaybe<Array<ImageTagAssociationInput>>;
  contentTagValueIds?: InputMaybe<Array<Scalars['ID']>>;
  contentKeywordIds?: InputMaybe<Array<Scalars['ID']>>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ImageKeyword = {
  __typename?: 'ImageKeyword';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ImageKeywordFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type ImageKeywordPageConnection = {
  __typename?: 'ImageKeywordPageConnection';
  collection: Array<ImageKeyword>;
  paginationInfo?: Maybe<ImageKeywordPaginationInfo>;
};

export type ImageKeywordPaginationInfo = {
  __typename?: 'ImageKeywordPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImageKeywordPayload = {
  __typename?: 'ImageKeywordPayload';
  imageKeyword: ImageKeyword;
};

export type ImagePageConnection = {
  __typename?: 'ImagePageConnection';
  collection: Array<Image>;
  paginationInfo?: Maybe<ImagePaginationInfo>;
};

export type ImagePaginationInfo = {
  __typename?: 'ImagePaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImagePayload = {
  __typename?: 'ImagePayload';
  image: Image;
};

export type ImageSortInput = {
  id?: InputMaybe<SortEnum>;
  nameCanonical?: InputMaybe<SortEnum>;
};

export type ImageTag = {
  __typename?: 'ImageTag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ImageTagAssociation = {
  __typename?: 'ImageTagAssociation';
  id: Scalars['ID'];
  tag: ImageTag;
  values: Array<ImageTagValue>;
};

export type ImageTagAssociationInput = {
  tagId: Scalars['ID'];
  valueIds: Array<Scalars['ID']>;
};

export type ImageTagFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type ImageTagPageConnection = {
  __typename?: 'ImageTagPageConnection';
  collection: Array<ImageTag>;
  paginationInfo?: Maybe<ImageTagPaginationInfo>;
};

export type ImageTagPaginationInfo = {
  __typename?: 'ImageTagPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImageTagPayload = {
  __typename?: 'ImageTagPayload';
  imageTag: ImageTag;
};

export type ImageTagValue = {
  __typename?: 'ImageTagValue';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ImageTagValueFilterInput = {
  tagId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type ImageTagValuePageConnection = {
  __typename?: 'ImageTagValuePageConnection';
  collection: Array<ImageTagValue>;
  paginationInfo?: Maybe<ImageTagValuePaginationInfo>;
};

export type ImageTagValuePaginationInfo = {
  __typename?: 'ImageTagValuePaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImageTagValuePayload = {
  __typename?: 'ImageTagValuePayload';
  imageTagValue: ImageTagValue;
};

export enum ImmediatelyShareResults {
  Disabled = 'DISABLED',
  WithoutCorrectAnswers = 'WITHOUT_CORRECT_ANSWERS',
  WithCorrectAnswers = 'WITH_CORRECT_ANSWERS',
}

export type ImportError = {
  __typename?: 'ImportError';
  id: Scalars['String'];
  message: Scalars['String'];
};

export type ImportErrorPageConnection = {
  __typename?: 'ImportErrorPageConnection';
  collection: Array<ImportError>;
  paginationInfo: ImportErrorPaginationInfo;
};

export type ImportErrorPaginationInfo = {
  __typename?: 'ImportErrorPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ImportResult = {
  __typename?: 'ImportResult';
  endDate?: Maybe<Scalars['String']>;
  errorCount: Scalars['Int'];
  id: Scalars['String'];
  logs: Array<ImportResultLog>;
  statistics: Array<ImportStatistic>;
  source: IntegrationEnum;
  startDate: Scalars['String'];
  status: ImportStatusEnum;
};

export type ImportResultErrorFilterInput = {
  message?: InputMaybe<Scalars['String']>;
};

export type ImportResultErrorInput = {
  importResultId: Scalars['String'];
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ImportResultErrorFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type ImportResultErrorsLink = {
  __typename?: 'ImportResultErrorsLink';
  url: Scalars['String'];
};

export type ImportResultErrorsLinkInput = {
  importResultId: Scalars['String'];
};

export type ImportResultInput = {
  id: Scalars['String'];
};

export type ImportResultLog = {
  __typename?: 'ImportResultLog';
  code: ImportStepCodeEnum;
  endDate?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  status: ImportStepStatusEnum;
};

export type ImportStatistic = {
  __typename?: 'ImportStatistic';
  changed: Scalars['Int'];
  notChanged: Scalars['Int'];
  total: Scalars['Int'];
  type: ImportStatisticTypeEnum;
};

export enum ImportStatisticTypeEnum {
  Staff = 'STAFF',
  Student = 'STUDENT',
}

export enum ImportStatusEnum {
  Completed = 'COMPLETED',
  CompletedWithWarnings = 'COMPLETED_WITH_WARNINGS',
  Error = 'ERROR',
  InQueue = 'IN_QUEUE',
  Started = 'STARTED',
}

export enum ImportStepCodeEnum {
  ArchiveExtractor = 'ARCHIVE_EXTRACTOR',
  CourseImporter = 'COURSE_IMPORTER',
  CourseOfferingImporter = 'COURSE_OFFERING_IMPORTER',
  CsvAcademicSessionImporter = 'CSV_ACADEMIC_SESSION_IMPORTER',
  CsvClassImporter = 'CSV_CLASS_IMPORTER',
  CsvCourseImporter = 'CSV_COURSE_IMPORTER',
  CsvEnrollmentImporter = 'CSV_ENROLLMENT_IMPORTER',
  CsvOrganizationImporter = 'CSV_ORGANIZATION_IMPORTER',
  CsvUserImporter = 'CSV_USER_IMPORTER',
  DataExporter = 'DATA_EXPORTER',
  DataRemover = 'DATA_REMOVER',
  DistrictAdminImporter = 'DISTRICT_ADMIN_IMPORTER',
  EtlJob = 'ETL_JOB',
  Exporter = 'EXPORTER',
  ImportFinalizer = 'IMPORT_FINALIZER',
  ImportInitializer = 'IMPORT_INITIALIZER',
  Initializer = 'INITIALIZER',
  OldDataRemover = 'OLD_DATA_REMOVER',
  RestAcademicSessionImporter = 'REST_ACADEMIC_SESSION_IMPORTER',
  RestClassImporter = 'REST_CLASS_IMPORTER',
  RestCourseImporter = 'REST_COURSE_IMPORTER',
  RestEnrollmentImporter = 'REST_ENROLLMENT_IMPORTER',
  RestOrganizationImporter = 'REST_ORGANIZATION_IMPORTER',
  RestUserImporter = 'REST_USER_IMPORTER',
  UserImporter = 'USER_IMPORTER',
  SectionImporter = 'SECTION_IMPORTER',
  SchoolImporter = 'SCHOOL_IMPORTER',
  StaffImporter = 'STAFF_IMPORTER',
  StaffRoleImporter = 'STAFF_ROLE_IMPORTER',
  StaffSchoolImporter = 'STAFF_SCHOOL_IMPORTER',
  StaffSectionImporter = 'STAFF_SECTION_IMPORTER',
  StudentImporter = 'STUDENT_IMPORTER',
  StudentParentImporter = 'STUDENT_PARENT_IMPORTER',
  StudentSchoolImporter = 'STUDENT_SCHOOL_IMPORTER',
  StudentSectionImporter = 'STUDENT_SECTION_IMPORTER',
  TermImporter = 'TERM_IMPORTER',
  UserParentImporter = 'USER_PARENT_IMPORTER',
}

export enum ImportStepStatusEnum {
  InProcess = 'IN_PROCESS',
  Success = 'SUCCESS',
  Error = 'ERROR',
}

/** Initiates a UserSelection. */
export type InitiateUserSelectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Initiates a UserSelection. */
export type InitiateUserSelectionPayload = {
  __typename?: 'initiateUserSelectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userSelection?: Maybe<UserSelection>;
};

/** Object of Post Input Request Type */
export type InputPostRequest = {
  /** ID of selected school */
  currentSchoolId: Scalars['String'];
  /** District Id of author user */
  districtId?: InputMaybe<Scalars['String']>;
  /** Id of post */
  id?: InputMaybe<Scalars['String']>;
  /** Get answered / unanswered posts */
  isAnswered?: InputMaybe<Scalars['Boolean']>;
  /** Get hidden / unhidden posts */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** Offset */
  offset?: InputMaybe<Scalars['Int']>;
  /** School Id of author user */
  schoolId?: InputMaybe<Scalars['String']>;
  /** Size */
  size?: InputMaybe<Scalars['Int']>;
  /** Two character state code of author user */
  stateCode?: InputMaybe<Scalars['String']>;
  /** User Id of post author */
  userId?: InputMaybe<Scalars['String']>;
  /** Array of Wall Ids */
  wallIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Object of Input Request Type */
export type InputRequest = {
  /** Config for the request */
  config?: InputMaybe<Scalars['String']>;
  /** Mode Inline or Assess */
  mode?: InputMaybe<ModeEnum>;
  /** Reference Id to be provided in the request */
  referenceId?: InputMaybe<Scalars['String']>;
  /** Type Activity or Item */
  type?: InputMaybe<TypeEnum>;
};

export type Integration = {
  __typename?: 'Integration';
  config?: Maybe<IntegrationConfig>;
  districtId: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  gradeMap: Array<IntegrationGradeMap>;
  integration: IntegrationEnum;
  roleMap: Array<IntegrationRoleMap>;
  schoolMap: Array<IntegrationSchoolMap>;
  settings?: Maybe<IntegrationSettings>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<ImportStatusEnum>;
  active: Scalars['Boolean'];
  autoSync: Scalars['Boolean'];
};

export type IntegrationConfig = {
  __typename?: 'IntegrationConfig';
  apiMode?: Maybe<ApiModeEnum>;
  baseUrl?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  sshConfigured?: Maybe<Scalars['Boolean']>;
  sshKey?: Maybe<Scalars['String']>;
  tokenUrl?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type IntegrationConfigInput = {
  baseUrl?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  sshConfigured?: InputMaybe<Scalars['Boolean']>;
  sshKey?: InputMaybe<Scalars['String']>;
  apiMode?: InputMaybe<ApiModeEnum>;
  year?: InputMaybe<Scalars['Int']>;
  tokenUrl?: InputMaybe<Scalars['String']>;
};

export enum IntegrationEnum {
  Classlink = 'CLASSLINK',
  Clever = 'CLEVER',
  EdFi = 'ED_FI',
  OneRosterCsv = 'ONE_ROSTER_CSV',
  Skyward = 'SKYWARD',
}

export type IntegrationGradeMap = {
  __typename?: 'IntegrationGradeMap';
  externalId: Scalars['String'];
  internalId?: Maybe<InternalGradeLevelEnum>;
  name?: Maybe<Scalars['String']>;
};

export type IntegrationGradeMapInput = {
  externalId: Scalars['String'];
  internalId?: InputMaybe<InternalGradeLevelEnum>;
  name?: InputMaybe<Scalars['String']>;
};

export type IntegrationInput = {
  districtId: Scalars['String'];
  integration: IntegrationEnum;
  config?: InputMaybe<IntegrationConfigInput>;
  schoolMap?: InputMaybe<Array<IntegrationSchoolMapInput>>;
  gradeMap?: InputMaybe<Array<IntegrationGradeMapInput>>;
  roleMap?: InputMaybe<Array<IntegrationRoleMapInput>>;
  settings?: InputMaybe<IntegrationSettingsInput>;
  autoSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type IntegrationKeyInput = {
  districtId: Scalars['String'];
  integration: IntegrationEnum;
};

export type IntegrationPageConnection = {
  __typename?: 'IntegrationPageConnection';
  collection: Array<Integration>;
  paginationInfo?: Maybe<IntegrationPaginationInfo>;
};

export type IntegrationPaginationInfo = {
  __typename?: 'IntegrationPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type IntegrationRoleMap = {
  __typename?: 'IntegrationRoleMap';
  externalId: Scalars['String'];
  internalId?: Maybe<Scalars['String']>;
  mapToTitle?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  processRole?: Maybe<Scalars['Boolean']>;
};

export type IntegrationRoleMapInput = {
  externalId: Scalars['String'];
  internalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  processRole?: InputMaybe<Scalars['Boolean']>;
  mapToTitle?: InputMaybe<Scalars['Boolean']>;
};

export type IntegrationSchoolMap = {
  __typename?: 'IntegrationSchoolMap';
  externalId: Scalars['String'];
  internalId?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  type?: Maybe<OneRosterSchoolTypeEnum>;
  status?: Maybe<OneRosterSchoolStatusEnum>;
};

export type IntegrationSchoolMapInput = {
  externalId: Scalars['String'];
  internalId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OneRosterSchoolTypeEnum>;
  status?: InputMaybe<OneRosterSchoolStatusEnum>;
};

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  ignoreTermDates: Scalars['Boolean'];
  passwordOverwriting: Scalars['Boolean'];
  sisStaffIdField: OneRosterSisStaffIdFieldEnum;
  unlistedClassesDeactivation: Scalars['Boolean'];
  unlistedUsersDeactivation: Scalars['Boolean'];
  usernameAsDistrictUsername: Scalars['Boolean'];
};

export type IntegrationSettingsInput = {
  ignoreTermDates?: InputMaybe<Scalars['Boolean']>;
  passwordOverwriting?: InputMaybe<Scalars['Boolean']>;
  sisStaffIdField?: InputMaybe<OneRosterSisStaffIdFieldEnum>;
  unlistedClassesDeactivation?: InputMaybe<Scalars['Boolean']>;
  unlistedUsersDeactivation?: InputMaybe<Scalars['Boolean']>;
  usernameAsDistrictUsername?: InputMaybe<Scalars['Boolean']>;
};

export type IntegrationsInput = {
  districtId?: InputMaybe<Scalars['String']>;
};

export enum InternalFieldEnum {
  Email = 'EMAIL',
  ExternalId = 'EXTERNAL_ID',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  LmsId = 'LMS_ID',
  SisId = 'SIS_ID',
  StaffId = 'STAFF_ID',
  StateId = 'STATE_ID',
  Username = 'USERNAME',
}

export type InternalFieldInput = {
  value: InternalFieldEnum;
  name?: InputMaybe<InternalFieldEnum>;
};

export enum InternalGradeLevelEnum {
  PreK = 'PRE_K',
  K = 'K',
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4',
  Level_5 = 'LEVEL_5',
  Level_6 = 'LEVEL_6',
  Level_7 = 'LEVEL_7',
  Level_8 = 'LEVEL_8',
  Level_9 = 'LEVEL_9',
  Level_10 = 'LEVEL_10',
  Level_11 = 'LEVEL_11',
  Level_12 = 'LEVEL_12',
}

/** Invites a Parent. */
export type InviteParentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  studentId: Scalars['String'];
};

/** Invites a Parent. */
export type InviteParentPayload = {
  __typename?: 'inviteParentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  parent?: Maybe<InviteParentPayloadData>;
};

/** Invites a Parent. */
export type InviteParentPayloadData = Node & {
  __typename?: 'inviteParentPayloadData';
  id: Scalars['ID'];
};

/** Item Signed Request type */
export type ItemSignedRequest = SignedRequestInterface & {
  __typename?: 'ItemSignedRequest';
  items?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  renderingType?: Maybe<Scalars['String']>;
  signedRequest: Scalars['JSON'];
  state?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

/** Base Sign Request Input */
export type ItemSignRequestInput = {
  action?: InputMaybe<SignRequestActionInput>;
  config?: InputMaybe<Scalars['JSON']>;
  domain?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<Scalars['JSON']>>;
  name?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  renderingType?: InputMaybe<AssignmentLearnosityRenderingType>;
  schoolId?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<SignAssignmentServices>;
  sessionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssignmentLearnosityState>;
  type?: InputMaybe<AssignmentLearnosityType>;
};

export type ItemsSignRequestRequestInput = {
  items: Array<Scalars['String']>;
  /** JSON string */
  config?: InputMaybe<Scalars['String']>;
};

export type KarmaAward = Node & {
  __typename?: 'KarmaAward';
  _id: Scalars['Int'];
  created: Scalars['String'];
  districtId: Scalars['String'];
  id: Scalars['ID'];
  karma: Scalars['Int'];
  karmaTotal: Scalars['Int'];
  modified: Scalars['String'];
  queryTotal: Scalars['Int'];
  schoolId: Scalars['String'];
  schoolName: Scalars['String'];
  stateCode: Scalars['String'];
  subjectCode: Scalars['String'];
  user: Scalars['Iterable'];
  userId: Scalars['String'];
  wallId?: Maybe<Scalars['String']>;
  wallPost?: Maybe<Post>;
};

/** Page connection for KarmaAward. */
export type KarmaAwardPageConnection = {
  __typename?: 'KarmaAwardPageConnection';
  collection?: Maybe<Array<Maybe<KarmaAward>>>;
  paginationInfo: KarmaAwardPaginationInfo;
};

/** Information about the pagination. */
export type KarmaAwardPaginationInfo = {
  __typename?: 'KarmaAwardPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type KnowledgeTreeInput = {
  studentIdInput?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type KnowledgeTreePayload = {
  __typename?: 'KnowledgeTreePayload';
  edges: Array<EdgePayload>;
  standards: Array<StandardPayload>;
};

export enum LanguageEnum {
  En = 'en',
  Es = 'es',
}

export type LanguageFilePath = {
  __typename?: 'LanguageFilePath';
  languageCode: Scalars['ID'];
  filePath: Scalars['ID'];
};

export enum LanguageTagEnum {
  En = 'EN',
  Asl = 'ASL',
  Ht = 'HT',
  Pt = 'PT',
  Sp = 'SP',
}

export type LeaderDistrictAssignmentsFilter = {
  daId?: InputMaybe<Scalars['String']>;
  districtId: Scalars['String'];
  endDateFilter?: InputMaybe<DistrictAssignmentDateFilterInput>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  schoolIds?: InputMaybe<Array<Scalars['String']>>;
  startDateFilter?: InputMaybe<DistrictAssignmentDateFilterInput>;
};

export type LessonPayload = {
  __typename?: 'LessonPayload';
  lessonNo: Scalars['String'];
  lessonName: Scalars['String'];
  components: Array<ComponentPayload>;
};

/** LevelEnum type: LEVEL1, LEVEL2, LEVEL3, LEVEL4, LEVEL5, LEVEL6 */
export enum LevelEnumType {
  Level1 = 'LEVEL1',
  Level2 = 'LEVEL2',
  Level3 = 'LEVEL3',
  Level4 = 'LEVEL4',
  Level5 = 'LEVEL5',
  Level6 = 'LEVEL6',
}

export type ListContentInput = {
  currentSchoolId?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryEnum>;
};

export type ListContentPayload = {
  __typename?: 'ListContentPayload';
  course: Array<ListCoursePayload>;
};

export type ListCoursePayload = {
  __typename?: 'ListCoursePayload';
  data: Array<ListDataPayload>;
  course: Scalars['String'];
};

export type ListDataPayload = {
  __typename?: 'ListDataPayload';
  conceptName: Scalars['String'];
  conceptNumber: Scalars['String'];
  status: Scalars['Boolean'];
  topics: Array<TopicsPayload>;
};

export type ListMathInActionDataPayload = {
  __typename?: 'ListMathInActionDataPayload';
  id: Scalars['Int'];
  category?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  actionNumber?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ListMathInActionPayload = {
  __typename?: 'ListMathInActionPayload';
  data: Array<ListMathInActionDataPayload>;
};

export type ListTagDataPayload = {
  __typename?: 'ListTagDataPayload';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  projectTitle?: Maybe<Scalars['String']>;
};

export type ListTagProjectPayload = {
  __typename?: 'ListTagProjectPayload';
  data: Array<ListTagDataPayload>;
};

export type Lti = {
  __typename?: 'Lti';
  districtId: Scalars['String'];
  type: LtiTypeEnum;
  v1p1?: Maybe<LtiV1p1>;
  v1p3?: Maybe<LtiV1p3>;
  policies: Array<SsoPolicy>;
};

/** Attributes for creating LTI STEMscopes assignment */
export type LtiCreateInput = {
  assignmentSource: AssignmentSourceInput;
  learnosityReferenceId: Scalars['String'];
  name: Scalars['String'];
  schoolId?: InputMaybe<Scalars['String']>;
};

/** LTI Edgexl Assignment Object Type */
export type LtiEdgexlAssignmentType = {
  __typename?: 'LtiEdgexlAssignmentType';
  assignmentId?: Maybe<Scalars['String']>;
  learnosityReferenceId?: Maybe<Scalars['String']>;
};

/** Attributes for creating LTI MathNation EdgeXl assignment */
export type LtiEdgeXlCreateInput = {
  assignmentId: Scalars['String'];
  assignmentSource: AssignmentSourceInput;
  gradeLevel: Scalars['String'];
  learnosityReferenceId: Scalars['String'];
  ownerId: Scalars['String'];
  schoolId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type LtiInput = {
  ltiKey?: InputMaybe<LtiKeyInput>;
  v1p3?: InputMaybe<LtiV1p3Input>;
};

export type LtiKeyInput = {
  districtId: Scalars['String'];
  type: LtiTypeEnum;
};

export type LtiListInput = {
  districtId?: InputMaybe<Scalars['String']>;
};

export type LtiPageConnection = {
  __typename?: 'LtiPageConnection';
  collection: Array<Lti>;
  paginationInfo?: Maybe<LtiPaginationInfo>;
};

export type LtiPaginationInfo = {
  __typename?: 'LtiPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum LtiTypeEnum {
  CanvasV1P1 = 'CANVAS_V1P1',
  CanvasV1P3 = 'CANVAS_V1P3',
  ImsGlobalV1P3 = 'IMS_GLOBAL_V1P3',
  SafariMontageV1P1 = 'SAFARI_MONTAGE_V1P1',
  SafariMontageV1P3 = 'SAFARI_MONTAGE_V1P3',
  SchoologyV1P1 = 'SCHOOLOGY_V1P1',
  SchoologyV1P3 = 'SCHOOLOGY_V1P3',
}

export type LtiV1p1 = {
  __typename?: 'LtiV1p1';
  clientKey: Scalars['String'];
  clientSecret: Scalars['String'];
};

export type LtiV1p3 = {
  __typename?: 'LtiV1p3';
  deploymentId: Scalars['String'];
  jwksUrl?: Maybe<Scalars['String']>;
};

export type LtiV1p3Input = {
  deploymentId: Scalars['String'];
  jwksUrl?: InputMaybe<Scalars['String']>;
};

export type LtiWithPoliciesInput = {
  policies?: InputMaybe<Array<PolicyInput>>;
  ltiKey?: InputMaybe<LtiKeyInput>;
  v1p3?: InputMaybe<LtiV1p3Input>;
};

/** Make Available District Assignment Input */
export type MakeAvailableDistrictAssignmentInput = {
  assignmentId: Scalars['String'];
  availableDate: Scalars['ISO8601Date'];
};

/** Manage District Assignment input */
export type ManageDistrictAssignmentInput = {
  assignmentId: Scalars['String'];
  studentIds: Array<Scalars['String']>;
};

export type MathNationGrades = {
  __typename?: 'MathNationGrades';
  grades: Array<Scalars['String']>;
};

export type MathNationScope = {
  __typename?: 'MathNationScope';
  active: Scalars['String'];
  category: Scalars['String'];
  contentAudience: AudienceEnum;
  contentGroups?: Maybe<Array<Scalars['String']>>;
  contentLocation: Scalars['String'];
  created: Scalars['String'];
  displayName: Scalars['String'];
  grade: Scalars['String'];
  id: Scalars['String'];
  lastUpdated: Scalars['String'];
  metadata: Scalars['JSON'];
  projectIdentifiers?: Maybe<Scalars['JSON']>;
  projectType: Scalars['String'];
  units: Array<Scalars['JSON']>;
};

export type MathNationScopeFilter = {
  category?: InputMaybe<Scalars['String']>;
  contentAudience?: InputMaybe<AudienceEnum>;
  grade?: InputMaybe<Scalars['String']>;
};

export type MathNationScopes = {
  __typename?: 'MathNationScopes';
  collection?: Maybe<Array<SearchableMathNationScope>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MediaPostObject = {
  __typename?: 'MediaPostObject';
  fileKey: Scalars['String'];
  formAttributes: Scalars['String'];
  formInputs: Scalars['String'];
};

export enum MediaTypeEnum {
  MediaTypeAudio = 'MEDIA_TYPE_AUDIO',
  MediaTypeAudioMp4 = 'MEDIA_TYPE_AUDIO_MP4',
  MediaTypePdf = 'MEDIA_TYPE_PDF',
  MediaTypeVideo = 'MEDIA_TYPE_VIDEO',
  MediaTypeCaption = 'MEDIA_TYPE_CAPTION',
  MediaTypeCaptionSrt = 'MEDIA_TYPE_CAPTION_SRT',
}

/** Must be used for MathNation LTI 1.1 or 1.3 */
export type MnContentItem = {
  componentId?: InputMaybe<Scalars['String']>;
  componentView: ElementViewEnum;
  identifier?: InputMaybe<Scalars['String']>;
  lessonId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type MnContentItemLinkData = {
  __typename?: 'MnContentItemLinkData';
  fields: Scalars['JSON'];
  ltiVersion: Scalars['String'];
  url: Scalars['String'];
};

export type MnCoursework = Node & {
  __typename?: 'mnCoursework';
  _id: Scalars['String'];
  id: Scalars['ID'];
  /** A token used for paginating through results. Pass this token in subsequent requests to retrieve the next page of results. */
  nextToken: Scalars['String'];
  resultSetJson: Scalars['String'];
};

export type MnCourseworkDownloadReport = Node & {
  __typename?: 'mnCourseworkDownloadReport';
  _id: Scalars['String'];
  id: Scalars['ID'];
  signedUrl: Scalars['String'];
};

export type MnCourseworkOrderType = {
  studentName?: InputMaybe<SortEnum>;
};

/** Must be used for MathNation LTI 1.3 */
export type MnEdgexl = {
  assessmentId: Scalars['String'];
  title: Scalars['String'];
};

export type MnEdgeXlDownloadReport = Node & {
  __typename?: 'mnEdgeXLDownloadReport';
  _id: Scalars['String'];
  id: Scalars['ID'];
  signedUrl: Scalars['String'];
};

export type MnEdgeXlStandards = Node & {
  __typename?: 'mnEdgeXLStandards';
  _id: Scalars['String'];
  id: Scalars['ID'];
  /** A token used for paginating through results. Pass this token in subsequent requests to retrieve the next page of results. */
  nextToken: Scalars['String'];
  resultSetJson: Scalars['String'];
};

export type MnEdgeXlStandardsDownloadReport = Node & {
  __typename?: 'mnEdgeXLStandardsDownloadReport';
  _id: Scalars['String'];
  id: Scalars['ID'];
  signedUrl: Scalars['String'];
};

/** MathNation LTI Input */
export type MnLtiContent = {
  courseworkAssignmentInput?: InputMaybe<Array<MnContentItem>>;
  edgexlAssignmentInput?: InputMaybe<Array<MnEdgexl>>;
};

export type MnOnRamp = Node & {
  __typename?: 'mnOnRamp';
  _id: Scalars['String'];
  id: Scalars['ID'];
  /** A token used for paginating through results. Pass this token in subsequent requests to retrieve the next page of results. */
  nextToken: Scalars['String'];
  resultSetJson: Scalars['String'];
};

export type MnOnRampDownloadReport = Node & {
  __typename?: 'mnOnRampDownloadReport';
  _id: Scalars['String'];
  id: Scalars['ID'];
  signedUrl: Scalars['String'];
};

export type MnOnRampOrderType = {
  studentName?: InputMaybe<SortEnum>;
};

/** Success Object Type */
export type MnPersonalAssignment = {
  __typename?: 'MnPersonalAssignment';
  activityId?: Maybe<Scalars['String']>;
  sign?: Maybe<Scalars['String']>;
};

export enum MnPersonalAssignmentType {
  Cyu = 'CYU',
  Or = 'OR',
  Ss = 'SS',
  Ty = 'TY',
}

/** One of the mode either inline or assess */
export enum ModeEnum {
  /** Inline Mode */
  Inline = 'inline',
  /** Assess Mode */
  Assess = 'assess',
}

export type MoveVideoInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  fromMovedInput: FromMoveVideoInput;
  glossaryTerm?: InputMaybe<Scalars['String']>;
  groupType: VideoGroupEnum;
  k5?: InputMaybe<Scalars['Boolean']>;
  mediaType?: InputMaybe<MediaTypeEnum>;
  toMovedInput: ToMoveVideoInput;
  videoId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Archive assignments */
  archiveAssignments?: Maybe<Assignments>;
  /**
   * Creating Assignment
   * @deprecated Has been deprecated, use PutAssignment instead
   */
  createAssignment?: Maybe<Array<Assignment>>;
  /** Create Resource */
  createResource?: Maybe<Array<Resource>>;
  /** Get sign to start district assignment */
  daSignRequest?: Maybe<DistrictAssignmentSignRequestType>;
  /** Edit assignment */
  editAssignment?: Maybe<Success>;
  /** Edit stemscopes assignment */
  editStemscopesAssignment?: Maybe<Assignment>;
  /** Make Available District Assignment */
  makeAvailableDistrictAssignment?: Maybe<DistrictClassAssignmentType>;
  /** LTI. When a student opens the link, we must create or find the required activity and assignment */
  openLtiAssignmentLink?: Maybe<AssignmentUnion>;
  /** LTI. When a student opens the link, we must create or find the required activity and assignment */
  openLtiEdgexlAssignmentLink?: Maybe<AssignmentUnion>;
  /** Updating Activities share_results attribute */
  putActivitiesShareResults?: Maybe<Success>;
  /** Sign request */
  putAssignment?: Maybe<Array<AssignmentUnion>>;
  /** Updating District Student Assignments share_results attribute */
  putDistrictAssignmentsShareResults?: Maybe<DistrictStudentAssignmentsType>;
  /** PutDistrictStudentAssignments */
  putDistrictStudentAssignments?: Maybe<DistrictStudentAssignmentsType>;
  /** PutStudentAssignments */
  putStudentAssignments?: Maybe<StemscopesAssignment>;
  /** Reopen Assignment */
  reopenAssignment?: Maybe<Success>;
  /** Reopen District Assignment */
  reopenDistrictAssignment?: Maybe<DistrictStudentAssignmentsType>;
  /** Reset assignment */
  resetAssignment?: Maybe<Success>;
  /** Reset District Assignment */
  resetDistrictAssignment?: Maybe<DistrictStudentAssignmentsType>;
  /** Return assignment */
  returnAssignment?: Maybe<Success>;
  /** Return District Assignment */
  returnDistrictAssignment?: Maybe<DistrictStudentAssignmentsType>;
  /** Save Grading session */
  saveGradingSession?: Maybe<GradingSession>;
  /** Save students resources filter */
  saveStudentsResourcesFilters?: Maybe<StudentsResourcesSettings>;
  /** Sign Request. Add one of fragments: ReportSignedRequest, ItemSignedRequest */
  signRequest?: Maybe<SignedRequestUnion>;
  /** Start MN personal assignment */
  startMnPersonalAssignment?: Maybe<MnPersonalAssignment>;
  /** Reset reset and return statuses */
  startStemscopesAssignment?: Maybe<Success>;
  attachQuestionContainer: QuestionContainerPayload;
  controlAssessment: AssessmentPayload;
  controlContainer: AssessmentPayload;
  copyAssessment: AssessmentPayload;
  createAssessment: AssessmentPayload;
  createAssessmentPackageBox: AssessmentPackageBoxPayload;
  createQuestionContainer: QuestionContainerPayload;
  /** @deprecated Deprecated `$items` use `CreateSignRequestInput $input` instead */
  createSignRequest: SignRequestPayload;
  deleteAssessment: AssessmentPayload;
  shareAssessment: AssessmentPayload;
  updateAssessment: AssessmentPayload;
  updateQuestion: QuestionPayload;
  bulkUpdateContents: Array<Content>;
  createContentGroup?: Maybe<ContentGroupPayload>;
  createContentKeyword: ContentKeywordPayload;
  createContentTag: ContentTagPayload;
  createContentTagValue: ContentTagValuePayload;
  deleteContentKeyword: ContentKeywordPayload;
  deleteContentTag: ContentTagPayload;
  deleteContentTagValue: ContentTagValuePayload;
  updateContent: ContentPayload;
  updateContentGroup?: Maybe<ContentGroupPayload>;
  updateContentKeyword: ContentKeywordPayload;
  updateContentTag: ContentTagPayload;
  updateContentTagValue: ContentTagValuePayload;
  generateTcc: TccPackages;
  submitContentItemLinks: ContentItemLinkData;
  submitMnContentItemLinksV11: MnContentItemLinkData;
  submitMnContentItemLinksV13: ContentItemLinkData;
  /** A placeholder query used by thecodingmachine/graphqlite when there are no declared mutations. */
  dummyMutation?: Maybe<Scalars['String']>;
  createWidget: Widget;
  updateWidget: Widget;
  updateWidgets: Array<Maybe<Widget>>;
  deleteWidget: Widget;
  createAdoptionAccount: AdoptionAccountPayload;
  createAdoptionAccountsCsvPostObject: DemoImportCsvPostObjectPayload;
  createAdoptionEvent: AdoptionEventPayload;
  createAdoptionReviewer: AdoptionReviewerPayload;
  createAdoptionReviewersCsvPostObject: DemoImportCsvPostObjectPayload;
  createBulkUpdateAdoptionAccounts: BulkUpdatePayload;
  createBulkUpdateAdoptionReviewers: BulkUpdatePayload;
  createPreviewAccount: PreviewAccountPayload;
  createPreviewAccountsCsvPostObject: DemoImportCsvPostObjectPayload;
  createProductGroup: ProductGroupPayload;
  deleteAdoptionAccount: AdoptionAccountPayload;
  deleteAdoptionEvent: AdoptionEventPayload;
  deleteAdoptionReviewer: AdoptionReviewerPayload;
  deletePreviewAccount: PreviewAccountPayload;
  deleteProductGroup: ProductGroupPayload;
  resetPreviewAccountActivityPeriodEnd?: Maybe<Scalars['Void']>;
  updateAdoptionAccount: AdoptionAccountPayload;
  updateAdoptionEvent: AdoptionEventPayload;
  updateAdoptionReviewer: AdoptionReviewerPayload;
  updatePreviewAccount: PreviewAccountPayload;
  updatePreviewAccountTeacher: PreviewAccountTeacherPayload;
  updateProductGroup: ProductGroupPayload;
  addPermission: SuccessPayload;
  createAccessPolicy: AccessPolicyPayload;
  createRole: RolePayload;
  deleteAccessPolicy: AccessPolicyPayload;
  deleteRole: RolePayload;
  removePermission: SuccessPayload;
  updateAccessPolicy: AccessPolicyPayload;
  updateRole: RolePayload;
  scopeDocumentDownload: ScopeDocumentPayload;
  scopeDocumentExportRequest: ScopeDocumentPayload;
  scopePrintDownload: ScopePrintDownloadPayload;
  createImage: ImagePayload;
  createImageCategory: ImageCategoryPayload;
  createImageKeyword: ImageKeywordPayload;
  createImageTag: ImageTagPayload;
  createImageTagValue: ImageTagValuePayload;
  deleteImage: ImagePayload;
  deleteImageCategory: ImageCategoryPayload;
  deleteImageKeyword: ImageKeywordPayload;
  deleteImageTag: ImageTagPayload;
  deleteImageTagValue: ImageTagValuePayload;
  updateImage: ImagePayload;
  updateImageCategory: ImageCategoryPayload;
  updateImageKeyword: ImageKeywordPayload;
  updateImageTag: ImageTagPayload;
  updateImageTagValue: ImageTagValuePayload;
  createIntegration: Integration;
  deleteIntegration: Integration;
  extractOneRosterSchools: Array<OneRosterSchool>;
  forcePullIntegration: Integration;
  forceUploadOneRosterFile: Scalars['String'];
  pullIntegration: Integration;
  syncSchools: Integration;
  updateIntegration: Integration;
  uploadOneRosterFile: Scalars['String'];
  /** Creates a Calendar. */
  createCalendar?: Maybe<CreateCalendarPayload>;
  /** Creates a Entry. */
  createEntry?: Maybe<CreateEntryPayload>;
  /** Creates a PacingGuide. */
  createPacingGuide?: Maybe<CreatePacingGuidePayload>;
  /** Creates a ScopePlan. */
  createScopePlan?: Maybe<CreateScopePlanPayload>;
  /** Deletes a UserCalendar. */
  deleteUserCalendar?: Maybe<DeleteUserCalendarPayload>;
  /** Initiates a UserSelection. */
  initiateUserSelection?: Maybe<InitiateUserSelectionPayload>;
  /** Removes a Calendar. */
  removeCalendar?: Maybe<RemoveCalendarPayload>;
  /** Removes a Entry. */
  removeEntry?: Maybe<RemoveEntryPayload>;
  /** Removes a PacingGuide. */
  removePacingGuide?: Maybe<RemovePacingGuidePayload>;
  /** Removes a ScopePlan. */
  removeScopePlan?: Maybe<RemoveScopePlanPayload>;
  /** Shares a Calendar. */
  shareCalendar?: Maybe<ShareCalendarPayload>;
  /** ShareTemplates a PacingGuide. */
  shareTemplatePacingGuide?: Maybe<ShareTemplatePacingGuidePayload>;
  /** ShareTemplates a ScopePlan. */
  shareTemplateScopePlan?: Maybe<ShareTemplateScopePlanPayload>;
  /** Updates a Calendar. */
  updateCalendar?: Maybe<UpdateCalendarPayload>;
  /** Updates a DistrictSettingsLessonPlanner. */
  updateDistrictSettingsLessonPlanner?: Maybe<UpdateDistrictSettingsLessonPlannerPayload>;
  /** Updates a Entry. */
  updateEntry?: Maybe<UpdateEntryPayload>;
  /** Updates a PacingGuide. */
  updatePacingGuide?: Maybe<UpdatePacingGuidePayload>;
  /** Updates a PacingGuideScope. */
  updatePacingGuideScope?: Maybe<UpdatePacingGuideScopePayload>;
  /** Updates a ScopePlan. */
  updateScopePlan?: Maybe<UpdateScopePlanPayload>;
  /** Updates a ScopePlanScope. */
  updateScopePlanScope?: Maybe<UpdateScopePlanScopePayload>;
  /** Updates a UserCalendar. */
  updateUserCalendar?: Maybe<UpdateUserCalendarPayload>;
  /** Updates a UserSelection. */
  updateUserSelection?: Maybe<UpdateUserSelectionPayload>;
  createPasswordRecovery: Scalars['Boolean'];
  createPasswordRecoveryRequest: Scalars['Boolean'];
  registerAdoptionReviewer: RegisterAdoptionReviewerPayload;
  registerCommunityAccessMember: RegisterCommunityAccessMemberPayload;
  registerParent?: Maybe<PublicParent>;
  registerPreviewAccountTeacher: PublicPreviewAccountTeacher;
  /** Completes a DistrictSetupStatus. */
  completeDistrictSetupStatus?: Maybe<CompleteDistrictSetupStatusPayload>;
  /** Creates a District. */
  createDistrict?: Maybe<CreateDistrictPayload>;
  /** Creates a School. */
  createSchool?: Maybe<CreateSchoolPayload>;
  /** Deletes a District. */
  deleteDistrict?: Maybe<DeleteDistrictPayload>;
  /** Deletes a School. */
  deleteSchool?: Maybe<DeleteSchoolPayload>;
  /** Updates a AcademicPeriod. */
  updateAcademicPeriod?: Maybe<UpdateAcademicPeriodPayload>;
  /** Updates a District. */
  updateDistrict?: Maybe<UpdateDistrictPayload>;
  /** Updates a School. */
  updateSchool?: Maybe<UpdateSchoolPayload>;
  addStudentToClasses?: Maybe<AddStudentToClassesPayload>;
  addStudentsToClass?: Maybe<AddStudentsToClassPayload>;
  addStudentsToStudentSubgroup?: Maybe<AddStudentsToStudentSubgroupPayload>;
  createClass?: Maybe<CreateClassPayload>;
  deleteClass?: Maybe<DeleteClassPayload>;
  removeStudentFromClasses?: Maybe<RemoveStudentFromClassesPayload>;
  removeStudentsFromClass?: Maybe<RemoveStudentsFromClassPayload>;
  removeStudentsFromStudentSubgroup?: Maybe<RemoveStudentsFromStudentSubgroupPayload>;
  updateClass?: Maybe<UpdateClassPayload>;
  updateDistrictSettingsRoster?: Maybe<UpdateDistrictSettingsRosterPayload>;
  createProduct: ProductPayload;
  createSubscription: SubscriptionPayload;
  createSubscriptionPackage: SubscriptionPackagePayload;
  deleteProduct: ProductPayload;
  deleteSubscription: SubscriptionPayload;
  deleteSubscriptionPackage: SubscriptionPackagePayload;
  updateProduct: ProductPayload;
  updateSubscription: SubscriptionPayload;
  updateSubscriptionPackage: SubscriptionPackagePayload;
  createTeam: TeamPayload;
  updateTeam: TeamPayload;
  createQrcodeTemplate: QrcodeTemplate;
  createPdfAssessment: PdfAssessment;
  /** AddSchoolTos a Student. */
  addSchoolToStudent?: Maybe<AddSchoolToStudentPayload>;
  /** Cancels a Impersonation. */
  cancelImpersonation?: Maybe<CancelImpersonationPayload>;
  /** Creates a Impersonation. */
  createImpersonation?: Maybe<CreateImpersonationPayload>;
  /** Creates a PasswordChange. */
  createPasswordChange?: Maybe<CreatePasswordChangePayload>;
  /** Creates a User. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a UserExportRequest. */
  createUserExportRequest?: Maybe<CreateUserExportRequestPayload>;
  /**
   * Creates a UserRole.
   * @deprecated Use nested mutation
   */
  createUserRole?: Maybe<CreateUserRolePayload>;
  /**
   * Deletes a User.
   * @deprecated For QA use
   */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Invites a Parent. */
  inviteParent?: Maybe<InviteParentPayload>;
  /** ResetPasswordSetTimes a User. */
  resetPasswordSetTimeUser?: Maybe<ResetPasswordSetTimeUserPayload>;
  /** RestrictInvitations a Parent. */
  restrictInvitationParent?: Maybe<RestrictInvitationParentPayload>;
  /** Updates a DistrictSettingsUserManagement. */
  updateDistrictSettingsUserManagement?: Maybe<UpdateDistrictSettingsUserManagementPayload>;
  /** Updates a User. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** UpdateUserActivitys a User. */
  updateUserActivity?: Maybe<UpdateUserActivityPayload>;
  /**
   * Updates a UserRole.
   * @deprecated Use nested mutation
   */
  updateUserRole?: Maybe<UpdateUserRolePayload>;
  /** VerifyEmailss a Parent. */
  verifyEmailsParent?: Maybe<VerifyEmailsParentPayload>;
  addLinkedVideo: VideoPayload;
  addQuestionsToVideo: VideoPayload;
  createReaderLibrary: ReaderLibraryPayload;
  createStemscopesMediaPack: CreateStemscopesMediaPackPayload;
  createStemscopesMediaPostObject: StemscopesMediaPostObjectPayload;
  createStreamingVideoPostObject: VideoPostObjectPayload;
  createTutor: TutorPayload;
  createVideoPostObject: VideoPostObjectPayload;
  deleteReaderLibrary: ReaderLibraryPayload;
  deleteStemscopesMedia: StemscopesMediaPayload;
  deleteStemscopesMediaPack: DeleteStemscopesMediaPackPayload;
  deleteStreamingVideo: StreamingVideoPayload;
  deleteTutor: TutorPayload;
  deleteVideo: VideoPayload;
  moveVideo: VideoPayload;
  updateReaderLibrary: ReaderLibraryPayload;
  updateStemscopesMedia: StemscopesMediaPostObjectPayload;
  updateStemscopesMediaPack: UpdateStemscopesMediaPackPayload;
  updateStreamingVideo: VideoPostObjectPayload;
  updateTutor: TutorPayload;
  districtEnabled: ChatGptDistrictPayload;
  /** get the text and prepare the conversation */
  sendTextScienceBot: ScienceBotPayload;
  deleteNote: NotePayload;
  putNote: NotePayload;
  deleteContent: DeleteContentPayload;
  onrampDeleteTeacherAssignment: DeleteTeacherAssignmentPayload;
  /** Onramp Teacher Assignment */
  onrampStudentAssignmentIdUpdate: StudentAssignmentIdUpdatePayload;
  /** Onramp Teacher Assignment */
  onrampStudentAssignmentResponse: StudentResponsePayload;
  /** Onramp Teacher Assignment Status */
  onrampStudentAssignmentStatus: StudentAssignmentStatusPayload;
  /** Reset start up test */
  resetOnrampStartUp: ResetStudentStartupPayload;
  /** Creates a Post. */
  createPost?: Maybe<CreatePostPayload>;
  /** Creates a WallAgeControl. */
  createWallAgeControl?: Maybe<CreateWallAgeControlPayload>;
  /** Creates a WallPostPin. */
  createWallPostPin?: Maybe<CreateWallPostPinPayload>;
  /** Removes a Post. */
  removePost?: Maybe<RemovePostPayload>;
  /** ToggleVerifySchoolAges a WallAgeControl. */
  toggleVerifySchoolAge?: Maybe<ToggleVerifySchoolAgePayload>;
  /** Toggles a WallPostLike. */
  toggleWallPostLike?: Maybe<ToggleWallPostLikePayload>;
  /** Updates a Post. */
  updatePost?: Maybe<UpdatePostPayload>;
  createAiChat: AiChatPayload;
  updateDistrictSettingsKnowledgeBase: DistrictSettingsKnowledgeBase;
  createEmailTemplate: EmailTemplatePayload;
  updateEmailTemplate: EmailTemplatePayload;
  createLti: Lti;
  createLtiWithPolicies: Lti;
  createSso: Sso;
  createSsoWithPolicies: Sso;
  deleteLti: Lti;
  deleteSso: Sso;
  regenerateLtiV1p1Credentials: Lti;
  regenerateSsoCredentials: Sso;
  updateDistrictSettingsLogin: DistrictSettingsLogin;
  updateLti: Lti;
  updateLtiWithPolicies: Lti;
  updateSso: Sso;
  updateSsoWithPolicies: Sso;
  publishEvent: EventStatusPayload;
  updateOrCreateMathInAction: UpdateMathInActionPayload;
  updateStandardTags: UpdateStandardTagsPayload;
};

export type MutationArchiveAssignmentsArgs = {
  action: ArchiveAssignmentAction;
  assignmentIds: Array<Scalars['String']>;
};

export type MutationCreateAssignmentArgs = {
  params: CreateAssignmentInput;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type MutationCreateResourceArgs = {
  params: CreateResourceInput;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type MutationDaSignRequestArgs = {
  params: DistrictAssignmentSignRequestInput;
};

export type MutationEditAssignmentArgs = {
  assignmentParams: EditAssignmentInput;
};

export type MutationEditStemscopesAssignmentArgs = {
  assignmentParams: StemscopesEditInput;
};

export type MutationMakeAvailableDistrictAssignmentArgs = {
  params: MakeAvailableDistrictAssignmentInput;
};

export type MutationOpenLtiAssignmentLinkArgs = {
  assignmentId: Scalars['String'];
  assignmentParams: PutAssignmentInput;
  curriculumArea: Scalars['String'];
  gradeLevel: Scalars['String'];
  ownerId: Scalars['String'];
};

export type MutationOpenLtiEdgexlAssignmentLinkArgs = {
  assignmentParams: PutAssignmentInput;
};

export type MutationPutActivitiesShareResultsArgs = {
  params: PutActivitiesShareResultsInput;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type MutationPutAssignmentArgs = {
  assignmentParams: PutAssignmentInput;
};

export type MutationPutDistrictAssignmentsShareResultsArgs = {
  params: DistrictAssignmentsShareResultsInput;
};

export type MutationPutDistrictStudentAssignmentsArgs = {
  params: PutDistrictStudentAssignmentsInput;
};

export type MutationPutStudentAssignmentsArgs = {
  params: PutStudentAssignmentsInput;
};

export type MutationReopenAssignmentArgs = {
  sessionsParams: ReopenAssignmentInput;
};

export type MutationReopenDistrictAssignmentArgs = {
  params: ReopenDistrictAssignmentInput;
};

export type MutationResetAssignmentArgs = {
  sessionsParams: ResetAssignmentInput;
};

export type MutationResetDistrictAssignmentArgs = {
  params: ManageDistrictAssignmentInput;
};

export type MutationReturnAssignmentArgs = {
  sessionsParams: ReturnAssignmentInput;
};

export type MutationReturnDistrictAssignmentArgs = {
  params: ManageDistrictAssignmentInput;
};

export type MutationSaveGradingSessionArgs = {
  sessionsParams: Array<SaveGradingSessionInput>;
};

export type MutationSaveStudentsResourcesFiltersArgs = {
  studentsFilters: StudentResourcesFilterInput;
};

export type MutationSignRequestArgs = {
  params: SignRequestInput;
};

export type MutationStartMnPersonalAssignmentArgs = {
  assignmentParams: StartMnPersonalAssignmentInput;
  ltiAssignment?: InputMaybe<Scalars['String']>;
};

export type MutationStartStemscopesAssignmentArgs = {
  activityParams: ActivityParamsInput;
};

export type MutationAttachQuestionContainerArgs = {
  input: AttachQuestionContainerInput;
};

export type MutationControlAssessmentArgs = {
  input: ControlAssessmentInput;
};

export type MutationControlContainerArgs = {
  input: ControlContainerInput;
};

export type MutationCopyAssessmentArgs = {
  input: CopyAssessmentInput;
};

export type MutationCreateAssessmentArgs = {
  input: CreateAssessmentInput;
};

export type MutationCreateAssessmentPackageBoxArgs = {
  input: CreateAssessmentPackageBoxInput;
};

export type MutationCreateQuestionContainerArgs = {
  input: CreateQuestionContainerInput;
};

export type MutationCreateSignRequestArgs = {
  items?: InputMaybe<Array<Scalars['String']>>;
  input?: InputMaybe<CreateSignRequestInput>;
};

export type MutationDeleteAssessmentArgs = {
  input: DeleteAssessmentInput;
};

export type MutationShareAssessmentArgs = {
  input: ShareAssessmentInput;
};

export type MutationUpdateAssessmentArgs = {
  input: UpdateAssessmentInput;
};

export type MutationUpdateQuestionArgs = {
  input: UpdateQuestionInput;
};

export type MutationBulkUpdateContentsArgs = {
  input: BulkUpdateContentsInput;
};

export type MutationCreateContentGroupArgs = {
  input: CreateContentGroupInput;
};

export type MutationCreateContentKeywordArgs = {
  input?: InputMaybe<CreateContentKeywordInput>;
};

export type MutationCreateContentTagArgs = {
  input?: InputMaybe<CreateContentTagInput>;
};

export type MutationCreateContentTagValueArgs = {
  input?: InputMaybe<CreateContentTagValueInput>;
};

export type MutationDeleteContentKeywordArgs = {
  input?: InputMaybe<DeleteContentKeywordInput>;
};

export type MutationDeleteContentTagArgs = {
  input?: InputMaybe<DeleteContentTagInput>;
};

export type MutationDeleteContentTagValueArgs = {
  input?: InputMaybe<DeleteContentTagValueInput>;
};

export type MutationUpdateContentArgs = {
  input: ContentInput;
};

export type MutationUpdateContentGroupArgs = {
  input: UpdateContentGroupInput;
};

export type MutationUpdateContentKeywordArgs = {
  input?: InputMaybe<UpdateContentKeywordInput>;
};

export type MutationUpdateContentTagArgs = {
  input?: InputMaybe<UpdateContentTagInput>;
};

export type MutationUpdateContentTagValueArgs = {
  input?: InputMaybe<UpdateContentTagValueInput>;
};

export type MutationGenerateTccArgs = {
  contentGroupMapping?: InputMaybe<Array<ContentGroupMapping>>;
  contentGroups?: InputMaybe<Array<Scalars['String']>>;
  grades?: InputMaybe<Array<Scalars['String']>>;
  ltiConsumer?: InputMaybe<TccConsumerEnum>;
  productName: ProductNameEnum;
  schoolIds: Array<Scalars['String']>;
  version: TccVersionEnum;
};

export type MutationSubmitContentItemLinksArgs = {
  contentItems: Array<ContentItem>;
  schoolId: Scalars['String'];
};

export type MutationSubmitMnContentItemLinksV11Args = {
  mnContentItems: Array<MnContentItem>;
  schoolId: Scalars['String'];
};

export type MutationSubmitMnContentItemLinksV13Args = {
  mnLtiContentTypes: MnLtiContent;
  schoolId: Scalars['String'];
};

export type MutationCreateWidgetArgs = {
  input: CreateWidgetInput;
};

export type MutationUpdateWidgetArgs = {
  input: UpdateWidgetInput;
};

export type MutationUpdateWidgetsArgs = {
  input: Array<InputMaybe<UpdateWidgetInput>>;
};

export type MutationDeleteWidgetArgs = {
  input: DeleteWidgetInput;
};

export type MutationCreateAdoptionAccountArgs = {
  input: CreateAdoptionAccountInput;
};

export type MutationCreateAdoptionAccountsCsvPostObjectArgs = {
  input: AdoptionAccountsCsvPostObjectInput;
};

export type MutationCreateAdoptionEventArgs = {
  input: CreateAdoptionEventInput;
};

export type MutationCreateAdoptionReviewerArgs = {
  input: CreateAdoptionReviewerInput;
};

export type MutationCreateAdoptionReviewersCsvPostObjectArgs = {
  input: DemoImportCsvPostObjectInput;
};

export type MutationCreateBulkUpdateAdoptionAccountsArgs = {
  input: BulkUpdateAdoptionAccountsInput;
  selection: BulkSelectionInput;
  filter: AdoptionAccountFilterInput;
};

export type MutationCreateBulkUpdateAdoptionReviewersArgs = {
  input: BulkUpdateAdoptionReviewersInput;
  selection: BulkSelectionInput;
  filter: AdoptionReviewerFilterInput;
};

export type MutationCreatePreviewAccountArgs = {
  input: CreatePreviewAccountInput;
};

export type MutationCreatePreviewAccountsCsvPostObjectArgs = {
  input: DemoImportCsvPostObjectInput;
};

export type MutationCreateProductGroupArgs = {
  input: CreateProductGroupInput;
};

export type MutationDeleteAdoptionAccountArgs = {
  input: DeleteAdoptionAccountInput;
};

export type MutationDeleteAdoptionEventArgs = {
  input: DeleteAdoptionEventInput;
};

export type MutationDeleteAdoptionReviewerArgs = {
  input: DeleteAdoptionReviewerInput;
};

export type MutationDeletePreviewAccountArgs = {
  input: DeletePreviewAccountInput;
};

export type MutationDeleteProductGroupArgs = {
  input: DeleteProductGroupInput;
};

export type MutationResetPreviewAccountActivityPeriodEndArgs = {
  input: ResetPreviewAccountActivityPeriodEndInput;
};

export type MutationUpdateAdoptionAccountArgs = {
  input: UpdateAdoptionAccountInput;
};

export type MutationUpdateAdoptionEventArgs = {
  input: UpdateAdoptionEventInput;
};

export type MutationUpdateAdoptionReviewerArgs = {
  input: UpdateAdoptionReviewerInput;
};

export type MutationUpdatePreviewAccountArgs = {
  input: UpdatePreviewAccountInput;
};

export type MutationUpdatePreviewAccountTeacherArgs = {
  input: UpdatePreviewAccountTeacherInput;
};

export type MutationUpdateProductGroupArgs = {
  input: UpdateProductGroupInput;
};

export type MutationAddPermissionArgs = {
  input: AddPermissionInput;
};

export type MutationCreateAccessPolicyArgs = {
  input: CreateAccessPolicyInput;
};

export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

export type MutationDeleteAccessPolicyArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteRoleArgs = {
  id: Scalars['ID'];
};

export type MutationRemovePermissionArgs = {
  input: RemovePermissionInput;
};

export type MutationUpdateAccessPolicyArgs = {
  input: UpdateAccessPolicyInput;
};

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};

export type MutationScopeDocumentDownloadArgs = {
  input: ScopeDocumentInput;
};

export type MutationScopeDocumentExportRequestArgs = {
  input: ScopeDocumentInput;
};

export type MutationScopePrintDownloadArgs = {
  input: ScopePrintDownloadInput;
};

export type MutationCreateImageArgs = {
  input: CreateImageInput;
};

export type MutationCreateImageCategoryArgs = {
  input: CreateImageCategoryInput;
};

export type MutationCreateImageKeywordArgs = {
  input: CreateImageKeywordInput;
};

export type MutationCreateImageTagArgs = {
  input: CreateImageTagInput;
};

export type MutationCreateImageTagValueArgs = {
  input: CreateImageTagValueInput;
};

export type MutationDeleteImageArgs = {
  input: DeleteImageInput;
};

export type MutationDeleteImageCategoryArgs = {
  input: DeleteImageCategoryInput;
};

export type MutationDeleteImageKeywordArgs = {
  input: DeleteImageKeywordInput;
};

export type MutationDeleteImageTagArgs = {
  input: DeleteImageTagInput;
};

export type MutationDeleteImageTagValueArgs = {
  input: DeleteImageTagValueInput;
};

export type MutationUpdateImageArgs = {
  input: UpdateImageInput;
};

export type MutationUpdateImageCategoryArgs = {
  input: UpdateImageCategoryInput;
};

export type MutationUpdateImageKeywordArgs = {
  input: UpdateImageKeywordInput;
};

export type MutationUpdateImageTagArgs = {
  input: UpdateImageTagInput;
};

export type MutationUpdateImageTagValueArgs = {
  input: UpdateImageTagValueInput;
};

export type MutationCreateIntegrationArgs = {
  integration: IntegrationInput;
};

export type MutationDeleteIntegrationArgs = {
  integrationInput: IntegrationKeyInput;
};

export type MutationExtractOneRosterSchoolsArgs = {
  schoolsInput: ExtractOneRosterSchoolsInput;
};

export type MutationForcePullIntegrationArgs = {
  integrationInput: IntegrationKeyInput;
};

export type MutationForceUploadOneRosterFileArgs = {
  districtId: Scalars['String'];
  file: Scalars['Upload'];
};

export type MutationPullIntegrationArgs = {
  integrationInput: IntegrationKeyInput;
};

export type MutationSyncSchoolsArgs = {
  integrationInput: IntegrationKeyInput;
};

export type MutationUpdateIntegrationArgs = {
  integration: IntegrationInput;
};

export type MutationUploadOneRosterFileArgs = {
  districtId: Scalars['String'];
  file: Scalars['Upload'];
};

export type MutationCreateCalendarArgs = {
  input: CreateCalendarInput;
};

export type MutationCreateEntryArgs = {
  input: CreateEntryInput;
};

export type MutationCreatePacingGuideArgs = {
  input: CreatePacingGuideInput;
};

export type MutationCreateScopePlanArgs = {
  input: CreateScopePlanInput;
};

export type MutationDeleteUserCalendarArgs = {
  input: DeleteUserCalendarInput;
};

export type MutationInitiateUserSelectionArgs = {
  input: InitiateUserSelectionInput;
};

export type MutationRemoveCalendarArgs = {
  input: RemoveCalendarInput;
};

export type MutationRemoveEntryArgs = {
  input: RemoveEntryInput;
};

export type MutationRemovePacingGuideArgs = {
  input: RemovePacingGuideInput;
};

export type MutationRemoveScopePlanArgs = {
  input: RemoveScopePlanInput;
};

export type MutationShareCalendarArgs = {
  input: ShareCalendarInput;
};

export type MutationShareTemplatePacingGuideArgs = {
  input: ShareTemplatePacingGuideInput;
};

export type MutationShareTemplateScopePlanArgs = {
  input: ShareTemplateScopePlanInput;
};

export type MutationUpdateCalendarArgs = {
  input: UpdateCalendarInput;
};

export type MutationUpdateDistrictSettingsLessonPlannerArgs = {
  input: UpdateDistrictSettingsLessonPlannerInput;
};

export type MutationUpdateEntryArgs = {
  input: UpdateEntryInput;
};

export type MutationUpdatePacingGuideArgs = {
  input: UpdatePacingGuideInput;
};

export type MutationUpdatePacingGuideScopeArgs = {
  input: UpdatePacingGuideScopeInput;
};

export type MutationUpdateScopePlanArgs = {
  input: UpdateScopePlanInput;
};

export type MutationUpdateScopePlanScopeArgs = {
  input: UpdateScopePlanScopeInput;
};

export type MutationUpdateUserCalendarArgs = {
  input: UpdateUserCalendarInput;
};

export type MutationUpdateUserSelectionArgs = {
  input: UpdateUserSelectionInput;
};

export type MutationCreatePasswordRecoveryArgs = {
  input: PasswordRecoveryInput;
};

export type MutationCreatePasswordRecoveryRequestArgs = {
  input: PasswordRecoveryRequestInput;
};

export type MutationRegisterAdoptionReviewerArgs = {
  input: RegisterAdoptionReviewerInput;
};

export type MutationRegisterCommunityAccessMemberArgs = {
  input: RegisterCommunityAccessMemberInput;
};

export type MutationRegisterParentArgs = {
  input: RegisterParentInput;
};

export type MutationRegisterPreviewAccountTeacherArgs = {
  input: RegisterPreviewAccountTeacherInput;
};

export type MutationCompleteDistrictSetupStatusArgs = {
  input: CompleteDistrictSetupStatusInput;
};

export type MutationCreateDistrictArgs = {
  input: CreateDistrictInput;
};

export type MutationCreateSchoolArgs = {
  input: CreateSchoolInput;
};

export type MutationDeleteDistrictArgs = {
  input: DeleteDistrictInput;
};

export type MutationDeleteSchoolArgs = {
  input: DeleteSchoolInput;
};

export type MutationUpdateAcademicPeriodArgs = {
  input: UpdateAcademicPeriodInput;
};

export type MutationUpdateDistrictArgs = {
  input: UpdateDistrictInput;
};

export type MutationUpdateSchoolArgs = {
  input: UpdateSchoolInput;
};

export type MutationAddStudentToClassesArgs = {
  input: AddStudentToClassesInput;
};

export type MutationAddStudentsToClassArgs = {
  input: AddStudentsToClassInput;
};

export type MutationAddStudentsToStudentSubgroupArgs = {
  input: AddStudentsToStudentSubgroupInput;
};

export type MutationCreateClassArgs = {
  input: CreateClassInput;
};

export type MutationDeleteClassArgs = {
  input: DeleteClassInput;
};

export type MutationRemoveStudentFromClassesArgs = {
  input: RemoveStudentFromClassesInput;
};

export type MutationRemoveStudentsFromClassArgs = {
  input: RemoveStudentsFromClassInput;
};

export type MutationRemoveStudentsFromStudentSubgroupArgs = {
  input: RemoveStudentsFromStudentSubgroupInput;
};

export type MutationUpdateClassArgs = {
  input: UpdateClassInput;
};

export type MutationUpdateDistrictSettingsRosterArgs = {
  input: UpdateDistrictSettingsRosterInput;
};

export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};

export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};

export type MutationCreateSubscriptionPackageArgs = {
  createSubscriptionPackageInput: CreateSubscriptionPackageInput;
};

export type MutationDeleteProductArgs = {
  deleteProductInput: DeleteProductInput;
};

export type MutationDeleteSubscriptionArgs = {
  deleteSubscriptionInput: DeleteSubscriptionInput;
};

export type MutationDeleteSubscriptionPackageArgs = {
  deleteSubscriptionPackageInput: DeleteSubscriptionPackageInput;
};

export type MutationUpdateProductArgs = {
  updateProductInput: UpdateProductInput;
};

export type MutationUpdateSubscriptionArgs = {
  updateSubscriptionInput: UpdateSubscriptionInput;
};

export type MutationUpdateSubscriptionPackageArgs = {
  updateSubscriptionPackageInput: UpdateSubscriptionPackageInput;
};

export type MutationCreateTeamArgs = {
  createTeamInput: CreateTeamInput;
};

export type MutationUpdateTeamArgs = {
  updateTeamInput: UpdateTeamInput;
};

export type MutationCreateQrcodeTemplateArgs = {
  input: CreateQrcodeTemplateInput;
};

export type MutationCreatePdfAssessmentArgs = {
  input: CreatePdfAssessmentInput;
};

export type MutationAddSchoolToStudentArgs = {
  input: AddSchoolToStudentInput;
};

export type MutationCancelImpersonationArgs = {
  input: CancelImpersonationInput;
};

export type MutationCreateImpersonationArgs = {
  input: CreateImpersonationInput;
};

export type MutationCreatePasswordChangeArgs = {
  input: CreatePasswordChangeInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateUserExportRequestArgs = {
  input: CreateUserExportRequestInput;
};

export type MutationCreateUserRoleArgs = {
  input: CreateUserRoleInput;
};

export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

export type MutationInviteParentArgs = {
  input: InviteParentInput;
};

export type MutationResetPasswordSetTimeUserArgs = {
  input: ResetPasswordSetTimeUserInput;
};

export type MutationRestrictInvitationParentArgs = {
  input: RestrictInvitationParentInput;
};

export type MutationUpdateDistrictSettingsUserManagementArgs = {
  input: UpdateDistrictSettingsUserManagementInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserActivityArgs = {
  input: UpdateUserActivityInput;
};

export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

export type MutationVerifyEmailsParentArgs = {
  input: VerifyEmailsParentInput;
};

export type MutationAddLinkedVideoArgs = {
  input: AddLinkedVideoInput;
};

export type MutationAddQuestionsToVideoArgs = {
  input: AddQuestionsToVideoInput;
};

export type MutationCreateReaderLibraryArgs = {
  input: CreateReaderLibraryInput;
};

export type MutationCreateStemscopesMediaPackArgs = {
  input: CreateStemscopesMediaPackInput;
};

export type MutationCreateStemscopesMediaPostObjectArgs = {
  input: CreateStemscopesMediaPostObjectInput;
};

export type MutationCreateStreamingVideoPostObjectArgs = {
  input: CreateStreamingVideoPostObjectInput;
};

export type MutationCreateTutorArgs = {
  input: CreateTutorInput;
};

export type MutationCreateVideoPostObjectArgs = {
  input: CreateVideoPostObjectInput;
};

export type MutationDeleteReaderLibraryArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteStemscopesMediaArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteStemscopesMediaPackArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteStreamingVideoArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteTutorArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteVideoArgs = {
  input: DeleteVideoInput;
};

export type MutationMoveVideoArgs = {
  input: MoveVideoInput;
};

export type MutationUpdateReaderLibraryArgs = {
  input: UpdateReaderLibraryInput;
};

export type MutationUpdateStemscopesMediaArgs = {
  input: UpdateStemscopesMediaInput;
};

export type MutationUpdateStemscopesMediaPackArgs = {
  input: UpdateStemscopesMediaPackInput;
};

export type MutationUpdateStreamingVideoArgs = {
  input: UpdateStreamingVideoInput;
};

export type MutationUpdateTutorArgs = {
  input: UpdateTutorInput;
};

export type MutationDistrictEnabledArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type MutationSendTextScienceBotArgs = {
  conversationID?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type MutationDeleteNoteArgs = {
  id: Scalars['ID'];
};

export type MutationPutNoteArgs = {
  id: Scalars['ID'];
  type: NoteInputTypeEnum;
  data: Scalars['String'];
};

export type MutationDeleteContentArgs = {
  input: DeleteContentInput;
};

export type MutationOnrampDeleteTeacherAssignmentArgs = {
  input: DeleteTeacherAssignmentInput;
};

export type MutationOnrampStudentAssignmentIdUpdateArgs = {
  input: OnrampStudentAssignmentIdUpdateInput;
};

export type MutationOnrampStudentAssignmentResponseArgs = {
  input: OnrampStudentAssignmentResponseInput;
};

export type MutationOnrampStudentAssignmentStatusArgs = {
  input: OnrampAssignmentStatusInput;
};

export type MutationResetOnrampStartUpArgs = {
  input: ResetOnrampStartupTestInput;
};

export type MutationCreatePostArgs = {
  input: CreatePostInput;
};

export type MutationCreateWallAgeControlArgs = {
  input: CreateWallAgeControlInput;
};

export type MutationCreateWallPostPinArgs = {
  input: CreateWallPostPinInput;
};

export type MutationRemovePostArgs = {
  input: RemovePostInput;
};

export type MutationToggleVerifySchoolAgeArgs = {
  input: ToggleVerifySchoolAgeInput;
};

export type MutationToggleWallPostLikeArgs = {
  input: ToggleWallPostLikeInput;
};

export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};

export type MutationCreateAiChatArgs = {
  input: AiChatInput;
};

export type MutationUpdateDistrictSettingsKnowledgeBaseArgs = {
  input: DistrictSettingsInput;
};

export type MutationCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};

export type MutationUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
};

export type MutationCreateLtiArgs = {
  ltiInput: LtiInput;
};

export type MutationCreateLtiWithPoliciesArgs = {
  ltiInput: LtiWithPoliciesInput;
};

export type MutationCreateSsoArgs = {
  ssoInput: SsoInput;
};

export type MutationCreateSsoWithPoliciesArgs = {
  ssoInput: SsoWithPoliciesInput;
};

export type MutationDeleteLtiArgs = {
  ltiKeyInput: LtiKeyInput;
};

export type MutationDeleteSsoArgs = {
  ssoKeyInput: SsoKeyInput;
};

export type MutationRegenerateLtiV1p1CredentialsArgs = {
  ltiKeyInput: LtiKeyInput;
};

export type MutationRegenerateSsoCredentialsArgs = {
  ssoKeyInput: SsoKeyInput;
};

export type MutationUpdateDistrictSettingsLoginArgs = {
  districtSettingsInput: DistrictSettingsLoginInput;
};

export type MutationUpdateLtiArgs = {
  ltiInput: LtiInput;
};

export type MutationUpdateLtiWithPoliciesArgs = {
  ltiInput: LtiWithPoliciesInput;
};

export type MutationUpdateSsoArgs = {
  ssoInput: SsoInput;
};

export type MutationUpdateSsoWithPoliciesArgs = {
  ssoInput: SsoWithPoliciesInput;
};

export type MutationPublishEventArgs = {
  input: EventInput;
};

export type MutationUpdateOrCreateMathInActionArgs = {
  input: UpdateMathInActionInput;
};

export type MutationUpdateStandardTagsArgs = {
  input: UpdateStandardTagsInput;
};

export type NewDistrict = {
  __typename?: 'NewDistrict';
  city?: Maybe<Scalars['String']>;
  globalName: Scalars['String'];
  id: Scalars['String'];
  localName: Scalars['String'];
  ssoIntegrations: Array<SsoTypeEnum>;
  state: Scalars['String'];
  urlCode?: Maybe<Scalars['String']>;
};

export type NewDistrictPageConnection = {
  __typename?: 'NewDistrictPageConnection';
  collection: Array<NewDistrict>;
  paginationInfo?: Maybe<NewDistrictPaginationInfo>;
};

export type NewDistrictPaginationInfo = {
  __typename?: 'NewDistrictPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A node, according to the Relay specification. */
export type Node = {
  /** The id of this node. */
  id: Scalars['ID'];
};

export enum NoteInputTypeEnum {
  FreeResponse = 'FREE_RESPONSE',
  Goboard = 'GOBOARD',
  Checkbox = 'CHECKBOX',
  Radio = 'RADIO',
  Input = 'INPUT',
  Overlay = 'OVERLAY',
  ShortAnswer = 'SHORT_ANSWER',
  DesmosCalculator = 'DESMOS_CALCULATOR',
  DesmosUrl = 'DESMOS_URL',
  TextHighlight = 'TEXT_HIGHLIGHT',
}

export type NoteItemPayload = {
  __typename?: 'NoteItemPayload';
  data: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type NoteListInput = {
  /** For all students */
  studentIds?: InputMaybe<Array<Scalars['String']>>;
  /** For all responses */
  responseIds?: InputMaybe<Array<Scalars['String']>>;
};

export type NoteListItemCollection = {
  __typename?: 'NoteListItemCollection';
  items: Array<NoteListItemPayload>;
};

export type NoteListItemPayload = {
  __typename?: 'NoteListItemPayload';
  data: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
  studentId: Scalars['String'];
};

export type NoteListPayload = {
  __typename?: 'NoteListPayload';
  items: Array<NoteListItemPayload>;
};

export type NotePayload = {
  __typename?: 'NotePayload';
  item?: Maybe<NoteItemPayload>;
};

export type OneRosterSchool = {
  __typename?: 'OneRosterSchool';
  externalId: Scalars['String'];
  name: Scalars['String'];
  status: OneRosterSchoolStatusEnum;
  type?: Maybe<OneRosterSchoolTypeEnum>;
};

export enum OneRosterSchoolStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Tobedeleted = 'TOBEDELETED',
}

export enum OneRosterSchoolTypeEnum {
  Department = 'DEPARTMENT',
  District = 'DISTRICT',
  Local = 'LOCAL',
  National = 'NATIONAL',
  School = 'SCHOOL',
  State = 'STATE',
}

export enum OneRosterSisStaffIdFieldEnum {
  Identifier = 'IDENTIFIER',
  SourcedId = 'SOURCED_ID',
}

export type OnrampAssignmentStatusInput = {
  id?: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type OnrampQuestionContainerInput = {
  category: Scalars['String'];
  concept?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  standard?: InputMaybe<Scalars['String']>;
  topic: Scalars['String'];
};

/** OnRampReport type: Pathway / Startup / TeacherAssigned */
export enum OnRampReportTypeEnum {
  /** Pathway Type */
  Pathway = 'Pathway',
  /** Startup Type */
  Startup = 'Startup',
  /** TeacherAssigned Type */
  TeacherAssigned = 'TeacherAssigned',
}

export type OnrampStartupTestInput = {
  studentGrade?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type OnrampStatusPayload = {
  __typename?: 'OnrampStatusPayload';
  /** // More specific type hint for clarity */
  onrampStatus: Array<Array<Scalars['String']>>;
  assignmentIds: Array<Array<Scalars['String']>>;
};

export type OnrampStudentAssignmentIdUpdateInput = {
  id?: Scalars['Int'];
  learnosityAssignmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  learnositySessionId?: InputMaybe<Scalars['String']>;
};

export type OnrampStudentAssignmentInput = {
  typeInput?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type OnrampStudentAssignmentResponseInput = {
  id?: Scalars['Int'];
  learnosityAssignmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  learnositySessionId?: InputMaybe<Scalars['String']>;
};

export type OnrampStudentStatusInput = {
  studentIds: Array<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  districtId?: Maybe<Scalars['String']>;
  district: District;
  schools: Array<School>;
  subscriptionScope: SubscriptionScopeEnum;
  lineItems: Array<OrderLineItem>;
  active: Scalars['Boolean'];
  systemAdministratorEmail?: Maybe<Scalars['String']>;
  systemAdministratorName?: Maybe<Scalars['String']>;
};

export enum OrderByEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderByInput = {
  field: Scalars['String'];
  order: OrderByEnum;
};

export type OrderFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  id: Scalars['ID'];
  productId: Scalars['String'];
  product?: Maybe<Product>;
  quantity: Scalars['Int'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type OrderPageConnection = {
  __typename?: 'OrderPageConnection';
  collection: Array<Order>;
  paginationInfo?: Maybe<OrderPaginationInfo>;
};

export type OrderPaginationInfo = {
  __typename?: 'OrderPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Attributes for creating stemscopes other assignment */
export type OtherAssignmentInput = {
  otherAssignment?: InputMaybe<Scalars['Boolean']>;
  otherAssignmentScope?: InputMaybe<Scalars['String']>;
};

/** Owner Assignments Object Type */
export type OwnerAssignments = {
  __typename?: 'OwnerAssignments';
  assignments: Array<Assignment>;
  pageInfo?: Maybe<PageInfo>;
  studentAssignments: Array<StudentAssignment>;
};

export type PacingGuide = Node & {
  __typename?: 'PacingGuide';
  _id: Scalars['String'];
  assignedTo?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['String']>;
  calendarType?: Maybe<CalendarTypeEnum>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  curriculumArea?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  grade?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSelected?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pacingGuideId?: Maybe<Scalars['String']>;
  pacingGuideTemplateId?: Maybe<Scalars['String']>;
  pacingGuideType?: Maybe<PacingGuideTypeEnum>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopeEditable?: Maybe<Scalars['Boolean']>;
  scopes?: Maybe<PacingGuideScopePageConnection>;
  searchName?: Maybe<Scalars['String']>;
  selectedCalendar?: Maybe<Scalars['Iterable']>;
  sharedBy?: Maybe<Scalars['String']>;
  sharedData?: Maybe<Scalars['Iterable']>;
  sharedOption?: Maybe<Scalars['String']>;
  sharedType?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

export type PacingGuideScopesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<PacingGuideScopeFilter>>>;
};

export type PacingGuideFilter = {
  curriculumArea?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  pacingGuideType?: InputMaybe<PacingGuideTypeEnum>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PacingGuideFilter_Order = {
  name?: InputMaybe<SortEnum>;
};

/** Page connection for PacingGuide. */
export type PacingGuidePageConnection = {
  __typename?: 'PacingGuidePageConnection';
  collection?: Maybe<Array<Maybe<PacingGuide>>>;
  paginationInfo: PacingGuidePaginationInfo;
};

/** Information about the pagination. */
export type PacingGuidePaginationInfo = {
  __typename?: 'PacingGuidePaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PacingGuideScope = Node & {
  __typename?: 'PacingGuideScope';
  _id: Scalars['String'];
  calendarId?: Maybe<Scalars['String']>;
  calendarType?: Maybe<CalendarTypeEnum>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructionalDays?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pacingGuideId?: Maybe<Scalars['String']>;
  pacingGuideTemplateId?: Maybe<Scalars['String']>;
  pacingGuideType?: Maybe<PacingGuideTypeEnum>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopeId?: Maybe<Scalars['String']>;
  sharedBy?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  type: EntryTypeEnum;
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

export type PacingGuideScopeFilter = {
  pacingGuideId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Page connection for PacingGuideScope. */
export type PacingGuideScopePageConnection = {
  __typename?: 'PacingGuideScopePageConnection';
  collection?: Maybe<Array<Maybe<PacingGuideScope>>>;
  paginationInfo: PacingGuideScopePaginationInfo;
};

/** Information about the pagination. */
export type PacingGuideScopePaginationInfo = {
  __typename?: 'PacingGuideScopePaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Pacing Guide type: Individual / Team / Template */
export enum PacingGuideTypeEnum {
  /** Individual Type */
  Individual = 'Individual',
  /** Team Type */
  Team = 'Team',
  /** Template Type */
  Template = 'Template',
}

export type PageInfo = {
  __typename?: 'PageInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginationInfoPayload = {
  __typename?: 'PaginationInfoPayload';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Parent = Node & {
  __typename?: 'Parent';
  _id?: Maybe<Scalars['String']>;
  districtUuid: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  inviteCount: Scalars['Int'];
  inviteStatus: ParentInviteStatusEnum;
  invitedAt: Scalars['String'];
  parent?: Maybe<User>;
  student: User;
};

export enum ParentInviteStatusEnum {
  InviteSent = 'INVITE_SENT',
  Active = 'ACTIVE',
}

export type ParentStudent = Node & {
  __typename?: 'ParentStudent';
  /** @deprecated Used from the student property */
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Used from the student property */
  lastName?: Maybe<Scalars['String']>;
  student: Student;
  /** @deprecated Used from the student property */
  studentId: Scalars['String'];
};

export enum PasswordRecoveryApplication {
  MathNation = 'MathNation',
  StemScopes = 'StemScopes',
}

export type PasswordRecoveryInput = {
  districtActivation?: Scalars['Boolean'];
  newPassword: Scalars['String'];
  token: Scalars['String'];
};

export type PasswordRecoveryRequestInput = {
  application?: PasswordRecoveryApplication;
  email: Scalars['String'];
};

export type PasswordRecoveryToken = {
  __typename?: 'PasswordRecoveryToken';
  expired: Scalars['Boolean'];
};

export type Pdf = {
  __typename?: 'Pdf';
  url: Scalars['String'];
  groupIdentifier: Scalars['String'];
  id: Scalars['String'];
  fileName: Scalars['String'];
  entityId: Scalars['String'];
};

export type PdfAssessment = {
  __typename?: 'PdfAssessment';
  /** base64 representation of pdf or string representation of html */
  content: Scalars['String'];
};

export enum PermissionScope {
  Platform = 'Platform',
  District = 'District',
  School = 'School',
  Klass = 'Klass',
  User = 'User',
  Owner = 'Owner',
}

export type PlannerTeam = Node & {
  __typename?: 'PlannerTeam';
  _id: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Page connection for PlannerTeam. */
export type PlannerTeamPageConnection = {
  __typename?: 'PlannerTeamPageConnection';
  collection?: Maybe<Array<Maybe<PlannerTeam>>>;
  paginationInfo: PlannerTeamPaginationInfo;
};

/** Information about the pagination. */
export type PlannerTeamPaginationInfo = {
  __typename?: 'PlannerTeamPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PlatformAdminActivityPoolPayload = {
  __typename?: 'PlatformAdminActivityPoolPayload';
  items: Array<PlatformAdminQuestionItemPayload>;
  tags: Array<TagPayload>;
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type PlatformAdminAssessmentItemPayload = {
  __typename?: 'PlatformAdminAssessmentItemPayload';
  status: Scalars['String'];
  tags: Array<TagPayload>;
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UserPayload>;
  items: Array<Scalars['String']>;
};

export type PlatformAdminAssessmentPoolInput = {
  items: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Scalars['String']>;
};

export type PlatformAdminAssessmentPoolPayload = {
  __typename?: 'PlatformAdminAssessmentPoolPayload';
  list: Array<PlatformAdminAssessmentItemPayload>;
  next: Scalars['String'];
};

export type PlatformAdminAttachQuestionContainerInput = {
  id: Scalars['ID'];
  cyuQuestionContainerInput?: InputMaybe<CyuQuestionContainerInput>;
  edgexlQuestionContainerInput?: InputMaybe<EdgexlQuestionContainerInput>;
  onrampQuestionContainerInput?: InputMaybe<OnrampQuestionContainerInput>;
  ssQuestionContainerInput?: InputMaybe<SsQuestionContainerInput>;
  tyQuestionContainerInput?: InputMaybe<TyQuestionContainerInput>;
};

export type PlatformAdminControlAssessmentInput = {
  ids: Array<Scalars['String']>;
  schoolIds: Array<Scalars['String']>;
  action: ControlActionEnum;
};

export type PlatformAdminControlContainerInput = {
  action: ControlActionEnum;
};

export type PlatformAdminCreateQuestionContainerInput = {
  cyuQuestionContainerInput?: InputMaybe<CyuQuestionContainerInput>;
  edgexlQuestionContainerInput?: InputMaybe<EdgexlQuestionContainerInput>;
  onrampQuestionContainerInput?: InputMaybe<OnrampQuestionContainerInput>;
  ssQuestionContainerInput?: InputMaybe<SsQuestionContainerInput>;
  tyQuestionContainerInput?: InputMaybe<TyQuestionContainerInput>;
};

export type PlatformAdminQuestionInput = {
  signedRequest?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type PlatformAdminQuestionItemPayload = {
  __typename?: 'PlatformAdminQuestionItemPayload';
  questionId: Scalars['String'];
  questionType?: Maybe<Scalars['String']>;
  tags: Array<TagPayload>;
  id: Scalars['String'];
};

export type PlatformAdminQuestionPayload = {
  __typename?: 'PlatformAdminQuestionPayload';
  item?: Maybe<PlatformAdminQuestionItemPayload>;
  signedRequest: Scalars['String'];
};

export type PlatformAdminQuestionPoolInput = {
  domains?: InputMaybe<Array<Scalars['String']>>;
  lesson?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ProductEnum>;
  purpose?: InputMaybe<PurposeEnum>;
  topics?: InputMaybe<Array<Scalars['String']>>;
  concepts?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<EdgexlCategoryEnum>;
  grade?: InputMaybe<EdgexlGradeEnum>;
  standards?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Array<Scalars['String']>>;
  next?: InputMaybe<Scalars['String']>;
};

export type PlatformAdminQuestionPoolPayload = {
  __typename?: 'PlatformAdminQuestionPoolPayload';
  list: Array<PlatformAdminActivityPoolPayload>;
  next: Scalars['String'];
};

export type PlatformAdminQuestionsInput = {
  standards?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Scalars['String']>;
};

export type PlatformAdminQuestionsPayload = {
  __typename?: 'PlatformAdminQuestionsPayload';
  list: Array<PlatformAdminQuestionItemPayload>;
  next: Scalars['String'];
};

export type PlatformAdminUpdateAssessmentInput = {
  isRemove?: InputMaybe<Scalars['Boolean']>;
  items: Array<Scalars['String']>;
  id: Scalars['ID'];
};

export type PlatformAdminUpdateAssessmentPayload = {
  __typename?: 'PlatformAdminUpdateAssessmentPayload';
  item?: Maybe<PlatformAdminAssessmentItemPayload>;
};

export type PlatformAdminUpdateQuestionInput = {
  id: Scalars['ID'];
  standards?: InputMaybe<Array<Scalars['String']>>;
};

export type PolicyInput = {
  internalFields: Array<InternalFieldInput>;
  externalField?: InputMaybe<ExternalFieldEnum>;
  name: PolicyNameEnum;
  sequence: Scalars['Int'];
  userType: SsoUserTypeEnum;
};

export enum PolicyNameEnum {
  Configured = 'CONFIGURED',
  Email = 'EMAIL',
  Name = 'NAME',
  LmsId = 'LMS_ID',
  Username = 'USERNAME',
}

export type PoolEnumsPayload = {
  __typename?: 'PoolEnumsPayload';
  curriculumAreas: Array<Scalars['String']>;
  editions: Array<Scalars['String']>;
  grades: Array<Scalars['String']>;
  keywords: Array<Scalars['String']>;
  questionTypes: Array<Scalars['String']>;
  scopes: Array<Scalars['String']>;
  standards: Array<Scalars['String']>;
};

export type PoolQuestionTotalPayload = {
  __typename?: 'PoolQuestionTotalPayload';
  total: Scalars['Int'];
};

export type Post = Node & {
  __typename?: 'Post';
  _id: Scalars['Int'];
  comment: Scalars['String'];
  conversationId?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  districtId: Scalars['String'];
  documentKey?: Maybe<Scalars['String']>;
  documentPath?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isAnswered: Scalars['Boolean'];
  isBlocked: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isRobotAttempt: Scalars['Boolean'];
  isRobotFailed: Scalars['Boolean'];
  isStared: Scalars['Boolean'];
  isSticky: Scalars['Boolean'];
  isWelcomePost: Scalars['Boolean'];
  likedByCaller: Scalars['Boolean'];
  likes: Scalars['Iterable'];
  modified: Scalars['String'];
  parent?: Maybe<Post>;
  replies: Scalars['Iterable'];
  robotParent?: Maybe<Post>;
  robotReply?: Maybe<Post>;
  schoolId: Scalars['String'];
  schoolName: Scalars['String'];
  sessionId: Scalars['String'];
  stateCode: Scalars['String'];
  user: Scalars['Iterable'];
  userId: Scalars['String'];
  wallId: Scalars['String'];
  wallPostLikes?: Maybe<Array<Maybe<WallPostLike>>>;
  wallPostPin?: Maybe<WallPostPin>;
  wallPostReplies?: Maybe<PostPageConnection>;
};

export type PostWallPostRepliesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

/** Page connection for Post. */
export type PostPageConnection = {
  __typename?: 'PostPageConnection';
  collection?: Maybe<Array<Maybe<Post>>>;
  paginationInfo: PostPaginationInfo;
};

/** Information about the pagination. */
export type PostPaginationInfo = {
  __typename?: 'PostPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PreviewAccount = {
  __typename?: 'PreviewAccount';
  id: Scalars['ID'];
  accountExecutiveFirstName?: Maybe<Scalars['String']>;
  accountExecutiveLastName?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  activityPeriodEnd: Scalars['DateTime'];
  activityPeriodStart: Scalars['DateTime'];
  district: District;
  externalSystem?: Maybe<DemoExternalSystemEnum>;
  firstLoginDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  opportunity?: Maybe<Scalars['String']>;
  productGroups: Array<ProductGroup>;
  products: Array<Product>;
  registrationToken: Scalars['String'];
  school: School;
  state: StateEnum;
  subscriptionPackage: SubscriptionPackage;
  teachers: Array<PreviewAccountTeacher>;
};

export type PreviewAccountFilterInput = {
  activityPeriodStartFrom?: InputMaybe<Scalars['DateTime']>;
  activityPeriodStartTo?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateEnum>;
};

export type PreviewAccountImportRequest = {
  __typename?: 'PreviewAccountImportRequest';
  importLog: DemoImportLog;
  importLogId: Scalars['String'];
};

export type PreviewAccountOrderInput = {
  active?: InputMaybe<SortEnum>;
  activityPeriodEnd?: InputMaybe<SortEnum>;
  activityPeriodStart?: InputMaybe<SortEnum>;
  firstLoginDate?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
  state?: InputMaybe<SortEnum>;
};

export type PreviewAccountPageConnection = {
  __typename?: 'PreviewAccountPageConnection';
  collection: Array<PreviewAccount>;
  paginationInfo?: Maybe<PreviewAccountPaginationInfo>;
};

export type PreviewAccountPaginationInfo = {
  __typename?: 'PreviewAccountPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PreviewAccountPayload = {
  __typename?: 'PreviewAccountPayload';
  previewAccount: PreviewAccount;
};

export type PreviewAccountTeacher = {
  __typename?: 'PreviewAccountTeacher';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  previewAccount: PreviewAccount;
  user: User;
  userName: Scalars['String'];
};

export type PreviewAccountTeacherFilterInput = {
  previewAccountId?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type PreviewAccountTeacherOrderInput = {
  email?: InputMaybe<SortEnum>;
  firstName?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
  lastName?: InputMaybe<SortEnum>;
  username?: InputMaybe<SortEnum>;
};

export type PreviewAccountTeacherPageConnection = {
  __typename?: 'PreviewAccountTeacherPageConnection';
  collection: Array<PreviewAccountTeacher>;
  paginationInfo?: Maybe<PreviewAccountTeacherPaginationInfo>;
};

export type PreviewAccountTeacherPaginationInfo = {
  __typename?: 'PreviewAccountTeacherPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PreviewAccountTeacherPayload = {
  __typename?: 'PreviewAccountTeacherPayload';
  previewAccountTeacher: PreviewAccountTeacher;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID'];
  /** Use only for merging data! */
  _id: Scalars['ID'];
  sku: Scalars['String'];
  productType: ProductTypeEnum;
  description: Scalars['String'];
  scopeGroups: Array<ScopeGroup>;
  contentGroups: Array<ContentGroup>;
};

export enum ProductEnum {
  Mathnation = 'MATHNATION',
  Science = 'SCIENCE',
  Stemscopesmath = 'STEMSCOPESMATH',
}

export type ProductFilterInput = {
  contentGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<ProductTypeEnum>;
  scopeGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  sku?: InputMaybe<Scalars['String']>;
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products: Array<Product>;
};

export type ProductGroupFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type ProductGroupPageConnection = {
  __typename?: 'ProductGroupPageConnection';
  collection: Array<ProductGroup>;
  paginationInfo?: Maybe<ProductGroupPaginationInfo>;
};

export type ProductGroupPaginationInfo = {
  __typename?: 'ProductGroupPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductGroupPayload = {
  __typename?: 'ProductGroupPayload';
  productGroup: ProductGroup;
};

export enum ProductNameEnum {
  Mathnation = 'MATHNATION',
  Stemscopes = 'STEMSCOPES',
}

export type ProductPageConnection = {
  __typename?: 'ProductPageConnection';
  collection: Array<Product>;
  paginationInfo?: Maybe<ProductPaginationInfo>;
};

export type ProductPaginationInfo = {
  __typename?: 'ProductPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductPayload = {
  __typename?: 'ProductPayload';
  product: Product;
};

export enum ProductTypeEnum {
  MathNation = 'MathNation',
  StemScopes = 'StemScopes',
}

export type ProjectDetailsPayload = {
  __typename?: 'ProjectDetailsPayload';
  projectId: Scalars['String'];
  title: Scalars['String'];
  category: Scalars['String'];
  units: Array<UnitPayload>;
};

export type ProjectInput = {
  projectId?: InputMaybe<Scalars['Int']>;
};

export enum ProjectTypeEnum {
  DigitalNotebook = 'DigitalNotebook',
  HelpPage = 'HelpPage',
  Lesson = 'Lesson',
  MathNation = 'MathNation',
  Scope = 'Scope',
  Streaming = 'Streaming',
  TeacherResource = 'TeacherResource',
  DailyNumeracy = 'DailyNumeracy',
  FactFluency = 'FactFluency',
  HowTo = 'HowTo',
  Undefined = 'Undefined',
}

export type PublicAdoptionAccount = {
  __typename?: 'PublicAdoptionAccount';
  active: Scalars['Boolean'];
  districtId: Scalars['String'];
  name: Scalars['String'];
};

export type PublicAdoptionEvent = {
  __typename?: 'PublicAdoptionEvent';
  active: Scalars['Boolean'];
  uiCustomization?: Maybe<Scalars['String']>;
  adoptionAccounts: Array<PublicAdoptionAccount>;
};

export type PublicParent = {
  __typename?: 'PublicParent';
  districtId: Scalars['String'];
  id: Scalars['String'];
};

export type PublicPreviewAccount = {
  __typename?: 'PublicPreviewAccount';
  district: NewDistrict;
  id: Scalars['String'];
};

export type PublicPreviewAccountTeacher = {
  __typename?: 'PublicPreviewAccountTeacher';
  id: Scalars['String'];
  previewAccount: PublicPreviewAccount;
};

export enum PurposeEnum {
  Cyu = 'CYU',
  Edgexl = 'EDGEXL',
  Onramp = 'ONRAMP',
  Ss = 'SS',
  Stemscopes = 'STEMSCOPES',
  Ty = 'TY',
}

export type PurposeEnumInput = {
  editions?: InputMaybe<Array<Scalars['String']>>;
  curriculumAreas?: InputMaybe<Array<Scalars['String']>>;
  grades?: InputMaybe<Array<Scalars['String']>>;
  gradingTypes?: InputMaybe<Array<GradingTypeEnum>>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  purpose: PurposeEnum;
  questionBanks?: InputMaybe<Array<QuestionBankEnum>>;
  questionTypes?: InputMaybe<Array<Scalars['String']>>;
  scopeNames?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
};

/** Attributes for Activities share_results update */
export type PutActivitiesShareResultsInput = {
  assignmentId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  shareResults: ShareResults;
  studentIds: Array<Scalars['String']>;
};

/** Put Assignment Input */
export type PutAssignmentInput = {
  districtPutAssignmentInput?: InputMaybe<DistrictCreateInput>;
  edgexlPutAssignmentInput?: InputMaybe<EdgexlCreateInput>;
  ltiPutAssignmentInput?: InputMaybe<LtiCreateInput>;
  mnEdgexlPutAssignmentInput?: InputMaybe<LtiEdgeXlCreateInput>;
  putTeacherAssignmentInput?: InputMaybe<TeacherAssignmentsCreateInput>;
  stemscopesPutAssignmentInput?: InputMaybe<StemscopesCreateInput>;
};

/** PutDistrictStudentAssignmentsInput */
export type PutDistrictStudentAssignmentsInput = {
  assignmentId: Scalars['String'];
  newStudentIds: Array<Scalars['String']>;
};

/** PutStudentAssignmentsInput */
export type PutStudentAssignmentsInput = {
  assignees: AssignmentAssigneesInput;
  assignmentId: Scalars['String'];
};

/** Qrcode render types */
export enum QrcodeRenderEnum {
  Pdf = 'pdf',
  Html = 'html',
}

export type QrcodeTemplate = {
  __typename?: 'QrcodeTemplate';
  /** base64 representation of pdf or string representation of html */
  content: Scalars['String'];
};

export type QrcodeUserData = {
  /** teacher firstname and lastname */
  teacher: Scalars['String'];
  plainPassword?: InputMaybe<Scalars['String']>;
  qrcode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  assignment?: Maybe<Assignment>;
  assignments?: Maybe<Assignments>;
  baseDistrictAssignments?: Maybe<DistrictBaseAssignmentsType>;
  /** Return District Class Assignments and District Students Assignments for teacher */
  districtAssignments?: Maybe<DistrictClassAssignmentsType>;
  /** Return District Class Assignments and District Students Assignments for district leader */
  districtAssignmentsForLeader?: Maybe<DistrictClassAssignmentsType>;
  districtStudentAssignments?: Maybe<DistrictStudentAssignmentsType>;
  edgexlAssignment?: Maybe<EdgexlAssignmentType>;
  /** Return edgexl assignments */
  edgexlAssignments?: Maybe<EdgexlAssignmentsType>;
  edgexlAssignmentsProgress?: Maybe<EdgexlAssignmentsProgressInfoType>;
  edgexlStudentAssignments?: Maybe<EdgexlStudentAssignmentsType>;
  mnPersonalAssignmentAttempts?: Maybe<EdgexlAssignmentsProgressInfoType>;
  ownerAssignments?: Maybe<OwnerAssignments>;
  /** @deprecated Has been deprecated, use StudentStudentAssignments instead */
  studentNotebook?: Maybe<StudentAssignments>;
  studentNotebooks?: Maybe<StudentNotebooks>;
  studentResources?: Maybe<StudentResources>;
  studentResourcesFilters?: Maybe<StudentsResourcesSettings>;
  studentStudentAssignments?: Maybe<StudentAssignments>;
  teacherFeedback?: Maybe<TeacherFeedback>;
  teacherStudentAssignments?: Maybe<StudentAssignments>;
  assessment: AssessmentPayload;
  assessmentLeader: AssessmentPayload;
  assessmentPool: AssessmentPoolPayload;
  assessmentPoolEnums: AssessmentPoolEnumsPayload;
  assessmentPoolLeader: AssessmentPoolPayload;
  /** @deprecated Deprecated `$purpose` use `PurposeEnumInput $input` instead */
  poolEnums: PoolEnumsPayload;
  poolQuestionTotal: PoolQuestionTotalPayload;
  question: QuestionPayload;
  questionPool: QuestionPoolPayload;
  questionPoolLeader: QuestionPoolPayload;
  questions: QuestionsPayload;
  readContainer: ContainersVisibilityPayload;
  content?: Maybe<Content>;
  contentGroup?: Maybe<ContentGroup>;
  contentGroups: ContentGroupPageConnection;
  contentKeyword: ContentKeyword;
  contentKeywords: ContentKeywordPageConnection;
  contentTag: ContentTag;
  contentTagValue: ContentTagValue;
  contentTagValues: ContentTagValuePageConnection;
  contentTags: ContentTagPageConnection;
  contents: ContentPageConnection;
  /** Use only for merging data! */
  lookupContentKeywords: Array<ContentKeyword>;
  /** Use only for merging data! */
  lookupContentTagValues: Array<ContentTagValue>;
  tccPackageDownloadLink: DownloadTccPackage;
  tccPackages: TccPackages;
  tccPackagesCount: TccPackagesCount;
  baseScope?: Maybe<BaseScope>;
  curriculumAreas?: Maybe<CurriculumAreas>;
  digitalNotebookCovers?: Maybe<DigitalNotebookCovers>;
  elements?: Maybe<Elements>;
  grades?: Maybe<Grades>;
  helpPage: HelpPageStructure;
  howToScopes: Scopes;
  mnGrades?: Maybe<MathNationGrades>;
  mnScope?: Maybe<MathNationScope>;
  mnScopes: MathNationScopes;
  recentlyViewed?: Maybe<RecentlyViewed>;
  scope?: Maybe<Scope>;
  scopes: Scopes;
  streaming?: Maybe<Streaming>;
  streamingContentTypes?: Maybe<StreamingContentTypes>;
  streamingCurriculumAreas?: Maybe<StreamingCurriculumAreas>;
  streamingGrades?: Maybe<StreamingGrades>;
  streamingTags?: Maybe<StreamingTags>;
  streamingTopics?: Maybe<StreamingTopics>;
  streamings?: Maybe<Streamings>;
  teacherResource?: Maybe<TeacherResource>;
  teacherResources?: Maybe<TeacherResources>;
  topics?: Maybe<Topics>;
  widget: Widget;
  widgets: Array<Maybe<Widget>>;
  dashboardEmbedUrl: EmbedUrlResponse;
  dashboardEmbedUrlForAnonymousUser: EmbedUrlResponse;
  adoptionAccount: AdoptionAccount;
  adoptionAccountImportRequest: AdoptionAccountImportRequest;
  adoptionAccounts: AdoptionAccountPageConnection;
  adoptionEvent: AdoptionEvent;
  adoptionEvents: AdoptionEventPageConnection;
  adoptionReviewer: AdoptionReviewer;
  adoptionReviewerImportRequest: AdoptionReviewerImportRequest;
  adoptionReviewers: AdoptionReviewerPageConnection;
  demoImportLog: DemoImportLog;
  demoImportLogLatest: DemoImportLog;
  demoImportLogs: DemoImportLogPageConnection;
  previewAccount: PreviewAccount;
  previewAccountImportRequest: PreviewAccountImportRequest;
  previewAccountTeacher: PreviewAccountTeacher;
  previewAccountTeachers: PreviewAccountTeacherPageConnection;
  previewAccounts: PreviewAccountPageConnection;
  productGroup: ProductGroup;
  productGroups: ProductGroupPageConnection;
  node?: Maybe<Node>;
  accessPolicies: AccessPolicyPageConnection;
  accessPolicy: AccessPolicy;
  aclApplications: Array<AclApplication>;
  /** Use only for merging data! */
  lookupRoles: Array<Role>;
  role?: Maybe<Role>;
  roles: RolePageConnection;
  icon: Icon;
  icons: IconPageConnection;
  /** Use only for merging data! */
  lookupIcons: Array<Icon>;
  scopeDocumentExportStatus: ScopeDocumentItem;
  image: Image;
  imageCategories: ImageCategoryPageConnection;
  imageCategory: ImageCategory;
  imageFileUploadForm: ImageFileUploadForm;
  imageKeyword: ImageKeyword;
  imageKeywords: ImageKeywordPageConnection;
  imageTag: ImageTag;
  imageTagValue: ImageTagValue;
  imageTagValues: ImageTagValuePageConnection;
  imageTags: ImageTagPageConnection;
  images: ImagePageConnection;
  cleverSchools: Array<CleverSchool>;
  edfiGradeLevels: Array<EdfiGradeLevel>;
  edfiJobRoles: Array<EdfiJobRole>;
  edfiSchools: Array<EdfiSchool>;
  importResult: ImportResult;
  importResultErrors: ImportErrorPageConnection;
  importResultErrorsLink: ImportResultErrorsLink;
  importResults: Array<ImportResult>;
  integration?: Maybe<Integration>;
  integrations: Array<Integration>;
  integrationsPaginated: IntegrationPageConnection;
  oneRosterRestOauth2Schools: Array<OneRosterSchool>;
  oneRosterRestSchools: Array<OneRosterSchool>;
  /** @deprecated This is only for POC purpose, it will move to another microservice */
  getReport?: Maybe<Report>;
  getSignedRequests?: Maybe<Array<Maybe<SignedRequest>>>;
  calendar?: Maybe<Calendar>;
  calendarTemplate?: Maybe<Calendar>;
  calendarTemplates?: Maybe<CalendarPageConnection>;
  calendars?: Maybe<CalendarPageConnection>;
  districtSettingsLessonPlanner?: Maybe<DistrictSettingsLessonPlanner>;
  entries?: Maybe<EntryPageConnection>;
  entry?: Maybe<Entry>;
  pacingGuide?: Maybe<PacingGuide>;
  pacingGuideScope?: Maybe<PacingGuideScope>;
  pacingGuideScopes?: Maybe<PacingGuideScopePageConnection>;
  pacingGuideTemplate?: Maybe<PacingGuide>;
  pacingGuideTemplates?: Maybe<PacingGuidePageConnection>;
  pacingGuides?: Maybe<PacingGuidePageConnection>;
  plannerTeams?: Maybe<PlannerTeamPageConnection>;
  scopePlan?: Maybe<ScopePlan>;
  scopePlanScope?: Maybe<ScopePlanScope>;
  scopePlanScopes?: Maybe<ScopePlanScopePageConnection>;
  scopePlanTemplate?: Maybe<ScopePlan>;
  scopePlanTemplates?: Maybe<ScopePlanPageConnection>;
  scopePlans?: Maybe<ScopePlanPageConnection>;
  searchCalendar?: Maybe<Calendar>;
  userCalendar?: Maybe<UserCalendar>;
  userCalendars?: Maybe<UserCalendarPageConnection>;
  userSelection?: Maybe<UserSelection>;
  userSelections?: Maybe<UserSelectionPageConnection>;
  studentAssignmentsMock: StudentAssignmentMockPageConnection;
  publicDistrict: NewDistrict;
  newDistricts: NewDistrictPageConnection;
  passwordRecoveryToken?: Maybe<PasswordRecoveryToken>;
  previewAccountDistricts: NewDistrictPageConnection;
  publicAdoptionEvent: PublicAdoptionEvent;
  systemAdmins: SystemAdminPageConnection;
  academicPeriod?: Maybe<AcademicPeriod>;
  academicPeriods?: Maybe<Array<Maybe<AcademicPeriod>>>;
  district?: Maybe<District>;
  districtSetupStatus?: Maybe<DistrictSetupStatus>;
  districts?: Maybe<DistrictPageConnection>;
  lookupDistricts?: Maybe<Array<Maybe<District>>>;
  lookupSchools?: Maybe<Array<Maybe<School>>>;
  school?: Maybe<School>;
  schools?: Maybe<SchoolPageConnection>;
  applicationSettings?: Maybe<ApplicationSettings>;
  class?: Maybe<Class>;
  classes?: Maybe<ClassPageConnection>;
  districtSettingsRoster?: Maybe<DistrictSettingsRoster>;
  lookupRosterStudents?: Maybe<Array<Maybe<Student>>>;
  student?: Maybe<Student>;
  studentSubgroup?: Maybe<StudentSubgroup>;
  teacher?: Maybe<Teacher>;
  teacherStudents?: Maybe<StudentPageConnection>;
  teachers?: Maybe<TeacherPageConnection>;
  activeContentGroups: Array<ContentGroup>;
  activeContentGroupsWithSchools: Array<ContentGroupWithSchoolPayload>;
  /** Use only for merging data! */
  lookupProducts: Array<Product>;
  order: Order;
  orders: OrderPageConnection;
  product: Product;
  products: ProductPageConnection;
  subscription: Subscription;
  subscriptionPackage: SubscriptionPackage;
  subscriptionPackages: SubscriptionPackagePageConnection;
  subscriptions: SubscriptionPageConnection;
  team: Team;
  teams: TeamPageConnection;
  uptime: Scalars['Float'];
  translateTexts: Array<Scalars['String']>;
  districtSettingsUserManagement?: Maybe<DistrictSettingsUserManagement>;
  identifyUsers?: Maybe<Array<Maybe<User>>>;
  lookupStudents?: Maybe<Array<Maybe<Student>>>;
  lookupTeachers?: Maybe<Array<Maybe<Teacher>>>;
  lookupUsers?: Maybe<Array<Maybe<User>>>;
  parentStudents?: Maybe<Array<Maybe<ParentStudent>>>;
  parents?: Maybe<Array<Maybe<Parent>>>;
  user?: Maybe<User>;
  userExportRequest?: Maybe<UserExportRequest>;
  userRoles?: Maybe<UserRolePageConnection>;
  users?: Maybe<UserPageConnection>;
  downloadResource: DownloadPayload;
  readerLibraries: ReaderLibraryPageConnection;
  readerLibrary: ReaderLibraryPayload;
  stemscopesMedia: StemscopesMediaPayload;
  stemscopesMediaPack: ReadStemscopesMediaPackPayload;
  stemscopesMediaPacks: StemscopesMediaPackPageConnection;
  stemscopesMedias: StemscopesMediaPageConnection;
  streamingVideo: StreamingVideoPayload;
  streamingVideos: StreamingVideoPageConnection;
  tutor: TutorPayload;
  tutors: TutorPageConnection;
  video: VideoPayload;
  videos: UnionVideoPdfPageConnection;
  videosByGroup: UnionVideoPdfPageConnection;
  /** Init science Bot to get the conversation id */
  initScienceBot: ScienceBotPayload;
  /** Get all the conversation by ID */
  scienceBots: Array<ScienceBotPayload>;
  note: NotePayload;
  notes: NoteListPayload;
  academicStandards: AcademicStandardsPayload;
  adminKnowledgeTree: KnowledgeTreePayload;
  benchmarkList: BenchmarkObjectsPayload;
  createStandard: StandardsPayload;
  createTeacherAssignment: TeacherAssignmentPayload;
  deteleStandard: StandardDeletePayload;
  knowledgeTreeData: KnowledgeTreePayload;
  listContent: ListContentPayload;
  /** Onramp Continue Assignment */
  onrampContinueStudentAssignment: StudentAssignmentPayload;
  /** After complete StartUp, prepare progress */
  onrampNlStartUpCompleted: StudentResponsePayload;
  /** After complete StartUp, prepare progress */
  onrampStartUpCompleted: StudentResponsePayload;
  /** Init start up test */
  onrampStartUpTest: SignRequestStartUpPayload;
  /** Init start up test */
  onrampStartUpTestNL: SignRequestStartUpPayload;
  /** Onramp Teacher Assignment */
  onrampStudentAssignment: StudentAssignmentPayload;
  /** Onramp Student dashboard */
  onrampStudentDashboard: StudentPayload;
  onrampStudentStatus: OnrampStatusPayload;
  onrampTeacherAssignmentsList: TeacherAssignmentListPayload;
  standardList: StandardListPayload;
  standardsByName: Array<Standards>;
  standardsList: StandardsListResponse;
  /** Onramp Student Certificate */
  studentCertificate: StudentCertificatePayload;
  teacherStandardList: StandardListPayload;
  wallPostList: WallPostConnect;
  karmaAwards?: Maybe<KarmaAwardPageConnection>;
  posts?: Maybe<PostPageConnection>;
  s3UploadSignedUrl?: Maybe<S3UploadSignedUrl>;
  unfilteredPosts?: Maybe<PostPageConnection>;
  wallAgeControls?: Maybe<Array<Maybe<WallAgeControl>>>;
  wallControls?: Maybe<Array<Maybe<WallControl>>>;
  wallPostLikes?: Maybe<Array<Maybe<WallPostLike>>>;
  standards: Array<Standard>;
  aiChat: AiChatHistoryPayload;
  districtSettingsKnowledgeBase: DistrictSettingsKnowledgeBase;
  wallDisplayNameList: WallListConnect;
  emailTemplate: EmailTemplate;
  emailTemplateAttachmentUploadForm: EmailTemplateAttachmentUploadFormPayload;
  emailTemplateImageUploadForm: EmailTemplateImageUploadForm;
  emailTemplatePlaceholders: EmailTemplatePlaceholdersPayload;
  emailTemplates: EmailTemplatePageConnection;
  fromEmails: StringPageConnection;
  canvasConfig: CanvasConfig;
  canvasSsoConfig: CanvasSsoConfig;
  districtSettingsLogin: DistrictSettingsLogin;
  listLti: Array<Lti>;
  listLtiPaginated: LtiPageConnection;
  listSso: Array<Sso>;
  listSsoPaginated: SsoPageConnection;
  readLti: Lti;
  readSso: Sso;
  askChatbot?: Maybe<ChatbotResponse>;
  getQuestionHint?: Maybe<GetQuestionHintResponse>;
  generateQuestion?: Maybe<GenerateQuestionResponse>;
  /** A placeholder query used by thecodingmachine/graphqlite when there are no declared queries. */
  dummyQuery?: Maybe<Scalars['String']>;
  athenaDistricts?: Maybe<AthenaDistrictPageConnection>;
  mnCoursework?: Maybe<MnCoursework>;
  mnCourseworkDownloadReport?: Maybe<MnCourseworkDownloadReport>;
  mnEdgeXLDownloadReport?: Maybe<MnEdgeXlDownloadReport>;
  mnEdgeXLStandards?: Maybe<MnEdgeXlStandards>;
  mnEdgeXLStandardsDownloadReport?: Maybe<MnEdgeXlStandardsDownloadReport>;
  mnOnRamp?: Maybe<MnOnRamp>;
  mnOnRampDownloadReport?: Maybe<MnOnRampDownloadReport>;
  ssStandards?: Maybe<SsStandards>;
  ssStandardsDownloadReport?: Maybe<SsStandardsDownloadReport>;
  ssStandardsItems?: Maybe<Array<Maybe<SsStandardsItem>>>;
  displayProjectDetails: ProjectDetailsPayload;
  listMathInActionActivity: ListMathInActionPayload;
  listTagProjects: ListTagProjectPayload;
};

export type QueryAssignmentArgs = {
  id?: InputMaybe<Scalars['String']>;
  lti?: InputMaybe<Scalars['Boolean']>;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryAssignmentsArgs = {
  archiveStatus?: InputMaybe<ArchiveStatuses>;
  archived?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssignmentsFilter>;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryBaseDistrictAssignmentsArgs = {
  paginationInfo?: InputMaybe<DistrictAssignmentPageInfoInput>;
};

export type QueryDistrictAssignmentsArgs = {
  filter?: InputMaybe<DistrictAssignmentsFilter>;
};

export type QueryDistrictAssignmentsForLeaderArgs = {
  filter: LeaderDistrictAssignmentsFilter;
};

export type QueryDistrictStudentAssignmentsArgs = {
  classId?: InputMaybe<Scalars['String']>;
  schoolId: Scalars['String'];
  shareResults?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<StudentAssignmentStatus>;
  studentId?: InputMaybe<Scalars['String']>;
};

export type QueryEdgexlAssignmentArgs = {
  id: Scalars['String'];
};

export type QueryEdgexlAssignmentsArgs = {
  assessmentId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryEdgexlAssignmentsProgressArgs = {
  params: EdgexlAssignmentsProgressInfoInput;
  studentId?: InputMaybe<Scalars['String']>;
};

export type QueryEdgexlStudentAssignmentsArgs = {
  studentId: Scalars['String'];
};

export type QueryMnPersonalAssignmentAttemptsArgs = {
  assignmentSource: AssignmentSourceInput;
  assignmentType: MnPersonalAssignmentType;
  studentId?: InputMaybe<Scalars['String']>;
};

export type QueryOwnerAssignmentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  assignmentDateFilter?: InputMaybe<AssignmentDateFilterInput>;
  classId?: InputMaybe<Scalars['String']>;
  classIds?: InputMaybe<Array<Scalars['String']>>;
  endDateFilter?: InputMaybe<AssignmentDateFilterInput>;
  paginationInfo?: InputMaybe<StemscopesAssignmentPageInfoInput>;
  schoolId?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryStudentNotebookArgs = {
  classId: Scalars['String'];
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryStudentNotebooksArgs = {
  schoolId?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['String']>;
};

export type QueryStudentResourcesArgs = {
  filter?: InputMaybe<StudentResourcesFilter>;
  schoolId: Scalars['String'];
};

export type QueryStudentStudentAssignmentsArgs = {
  filter?: InputMaybe<StudentAssignmentsFilter>;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryTeacherFeedbackArgs = {
  sessionId: Scalars['String'];
};

export type QueryTeacherStudentAssignmentsArgs = {
  filter?: InputMaybe<StudentAssignmentsFilter>;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryAssessmentArgs = {
  input: AssessmentInput;
};

export type QueryAssessmentLeaderArgs = {
  input: AssessmentInput;
};

export type QueryAssessmentPoolArgs = {
  input: AssessmentPoolInput;
};

export type QueryAssessmentPoolEnumsArgs = {
  input?: InputMaybe<AssessmentPoolEnumsInput>;
};

export type QueryAssessmentPoolLeaderArgs = {
  input: AssessmentPoolInput;
};

export type QueryPoolEnumsArgs = {
  purpose?: InputMaybe<PurposeEnum>;
  input?: InputMaybe<PurposeEnumInput>;
};

export type QueryPoolQuestionTotalArgs = {
  purpose: PurposeEnum;
};

export type QueryQuestionArgs = {
  input: QuestionInput;
};

export type QueryQuestionPoolArgs = {
  input: QuestionPoolInput;
};

export type QueryQuestionPoolLeaderArgs = {
  input: QuestionPoolInput;
};

export type QueryQuestionsArgs = {
  input: QuestionsInput;
};

export type QueryContentArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type QueryContentGroupArgs = {
  id: Scalars['ID'];
};

export type QueryContentGroupsArgs = {
  filter?: InputMaybe<ContentGroupFilterInput>;
  order?: InputMaybe<ContentGroupOrderInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryContentKeywordArgs = {
  id: Scalars['ID'];
};

export type QueryContentKeywordsArgs = {
  filter?: InputMaybe<ContentKeywordFilterInput>;
  itemsPerPage: Scalars['Int'];
  order?: InputMaybe<ContentKeywordOrderInput>;
  page: Scalars['Int'];
};

export type QueryContentTagArgs = {
  id: Scalars['ID'];
};

export type QueryContentTagValueArgs = {
  id: Scalars['ID'];
};

export type QueryContentTagValuesArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<ContentTagValueFilterInput>;
};

export type QueryContentTagsArgs = {
  filter?: InputMaybe<ContentTagFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryContentsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryLookupContentKeywordsArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryLookupContentTagValuesArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryTccPackageDownloadLinkArgs = {
  id: Scalars['String'];
};

export type QueryTccPackagesArgs = {
  districtId: Scalars['String'];
  ltiConsumer: TccConsumerEnum;
};

export type QueryTccPackagesCountArgs = {
  districtId: Scalars['String'];
};

export type QueryBaseScopeArgs = {
  id: Scalars['String'];
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryCurriculumAreasArgs = {
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: Array<Scalars['String']>;
};

export type QueryDigitalNotebookCoversArgs = {
  filter?: InputMaybe<DigitalNotebookCoverFilter>;
};

export type QueryElementsArgs = {
  filter?: InputMaybe<ElementFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryGradesArgs = {
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: Array<Scalars['String']>;
  contentGroups?: Array<Scalars['String']>;
};

export type QueryHelpPageArgs = {
  input: HelpPageInput;
};

export type QueryHowToScopesArgs = {
  filter?: InputMaybe<ScopeFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: Array<Scalars['String']>;
};

export type QueryMnGradesArgs = {
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryMnScopeArgs = {
  id: Scalars['String'];
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryMnScopesArgs = {
  filter?: InputMaybe<MathNationScopeFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryRecentlyViewedArgs = {
  schoolId: Scalars['String'];
};

export type QueryScopeArgs = {
  id: Scalars['String'];
  schoolId?: InputMaybe<Scalars['String']>;
};

export type QueryScopesArgs = {
  filter?: InputMaybe<ScopeFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: Array<Scalars['String']>;
};

export type QueryStreamingArgs = {
  schoolId: Scalars['String'];
  id: Scalars['String'];
};

export type QueryStreamingContentTypesArgs = {
  schoolId: Scalars['String'];
};

export type QueryStreamingCurriculumAreasArgs = {
  schoolId: Scalars['String'];
};

export type QueryStreamingGradesArgs = {
  schoolId: Scalars['String'];
};

export type QueryStreamingTagsArgs = {
  schoolId: Scalars['String'];
};

export type QueryStreamingTopicsArgs = {
  schoolId: Scalars['String'];
};

export type QueryStreamingsArgs = {
  schoolId: Scalars['String'];
  filter?: InputMaybe<StreamingFilter>;
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type QueryTeacherResourceArgs = {
  id: Scalars['String'];
  schoolId: Scalars['String'];
};

export type QueryTeacherResourcesArgs = {
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: Array<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryTopicsArgs = {
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: Array<Scalars['String']>;
};

export type QueryWidgetArgs = {
  id: Scalars['String'];
};

export type QueryDashboardEmbedUrlArgs = {
  dashboardID: Scalars['String'];
  sheetID?: InputMaybe<Scalars['String']>;
  visualID?: InputMaybe<Scalars['String']>;
};

export type QueryDashboardEmbedUrlForAnonymousUserArgs = {
  dashboardID: Scalars['String'];
  sheetID?: InputMaybe<Scalars['String']>;
  visualID?: InputMaybe<Scalars['String']>;
};

export type QueryAdoptionAccountArgs = {
  id: Scalars['ID'];
};

export type QueryAdoptionAccountImportRequestArgs = {
  id: Scalars['String'];
};

export type QueryAdoptionAccountsArgs = {
  filter?: InputMaybe<AdoptionAccountFilterInput>;
  order?: InputMaybe<AdoptionAccountOrderInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryAdoptionEventArgs = {
  id: Scalars['ID'];
};

export type QueryAdoptionEventsArgs = {
  filter?: InputMaybe<AdoptionEventFilterInput>;
  order?: InputMaybe<AdoptionEventOrderInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryAdoptionReviewerArgs = {
  id: Scalars['ID'];
};

export type QueryAdoptionReviewerImportRequestArgs = {
  id: Scalars['String'];
};

export type QueryAdoptionReviewersArgs = {
  filter?: InputMaybe<AdoptionReviewerFilterInput>;
  order?: InputMaybe<AdoptionReviewerOrderInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryDemoImportLogArgs = {
  id: Scalars['ID'];
};

export type QueryDemoImportLogLatestArgs = {
  type: DemoImportLogTypeEnum;
  importItem?: InputMaybe<DemoImportItemEnum>;
};

export type QueryDemoImportLogsArgs = {
  type: DemoImportLogTypeEnum;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryPreviewAccountArgs = {
  id: Scalars['ID'];
};

export type QueryPreviewAccountImportRequestArgs = {
  id: Scalars['String'];
};

export type QueryPreviewAccountTeacherArgs = {
  id: Scalars['ID'];
};

export type QueryPreviewAccountTeachersArgs = {
  filter?: InputMaybe<PreviewAccountTeacherFilterInput>;
  itemsPerPage: Scalars['Int'];
  order?: InputMaybe<PreviewAccountTeacherOrderInput>;
  page: Scalars['Int'];
};

export type QueryPreviewAccountsArgs = {
  filter?: InputMaybe<PreviewAccountFilterInput>;
  order?: InputMaybe<PreviewAccountOrderInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryProductGroupArgs = {
  id: Scalars['ID'];
};

export type QueryProductGroupsArgs = {
  filter?: InputMaybe<ProductGroupFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryNodeArgs = {
  id: Scalars['ID'];
};

export type QueryAccessPoliciesArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryAccessPolicyArgs = {
  id: Scalars['ID'];
};

export type QueryLookupRolesArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryRoleArgs = {
  id: Scalars['ID'];
};

export type QueryRolesArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<RoleFilterInput>;
};

export type QueryIconArgs = {
  id: Scalars['ID'];
};

export type QueryIconsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<FilterIconInput>;
};

export type QueryLookupIconsArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryScopeDocumentExportStatusArgs = {
  id: Scalars['String'];
};

export type QueryImageArgs = {
  id: Scalars['ID'];
};

export type QueryImageCategoriesArgs = {
  filter?: InputMaybe<ImageCategoryFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryImageCategoryArgs = {
  id: Scalars['ID'];
};

export type QueryImageFileUploadFormArgs = {
  input: ReadImageFileUploadFormInput;
};

export type QueryImageKeywordArgs = {
  id: Scalars['ID'];
};

export type QueryImageKeywordsArgs = {
  filter?: InputMaybe<ImageKeywordFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryImageTagArgs = {
  id: Scalars['ID'];
};

export type QueryImageTagValueArgs = {
  id: Scalars['ID'];
};

export type QueryImageTagValuesArgs = {
  filter: ImageTagValueFilterInput;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryImageTagsArgs = {
  filter?: InputMaybe<ImageTagFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryImagesArgs = {
  filter?: InputMaybe<ImageFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  sort?: InputMaybe<ImageSortInput>;
};

export type QueryCleverSchoolsArgs = {
  districtId: Scalars['String'];
};

export type QueryEdfiGradeLevelsArgs = {
  configInput: IntegrationConfigInput;
};

export type QueryEdfiJobRolesArgs = {
  configInput: IntegrationConfigInput;
};

export type QueryEdfiSchoolsArgs = {
  configInput: IntegrationConfigInput;
};

export type QueryImportResultArgs = {
  input: ImportResultInput;
};

export type QueryImportResultErrorsArgs = {
  input: ImportResultErrorInput;
};

export type QueryImportResultErrorsLinkArgs = {
  input: ImportResultErrorsLinkInput;
};

export type QueryImportResultsArgs = {
  integrationInput?: InputMaybe<IntegrationKeyInput>;
};

export type QueryIntegrationArgs = {
  integrationInput: IntegrationKeyInput;
};

export type QueryIntegrationsArgs = {
  input?: InputMaybe<IntegrationsInput>;
};

export type QueryIntegrationsPaginatedArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  input?: InputMaybe<IntegrationsInput>;
};

export type QueryOneRosterRestOauth2SchoolsArgs = {
  configInput: IntegrationConfigInput;
};

export type QueryOneRosterRestSchoolsArgs = {
  configInput: IntegrationConfigInput;
};

export type QueryGetReportArgs = {
  containerId: Scalars['String'];
  activityId?: InputMaybe<Scalars['String']>;
  activities?: InputMaybe<Scalars['Iterable']>;
  users?: InputMaybe<Scalars['Iterable']>;
  itemOrders?: InputMaybe<Scalars['Iterable']>;
  userId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  displayUser?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
  sessionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetSignedRequestsArgs = {
  parameter?: InputMaybe<Array<InputMaybe<InputRequest>>>;
  view?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type QueryCalendarArgs = {
  id: Scalars['ID'];
};

export type QueryCalendarTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryCalendarTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CalendarFilter_Order>>>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<InputMaybe<CalendarTemplateFilter>>>;
};

export type QueryCalendarsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CalendarFilter_Order>>>;
  calendarId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  teamId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<CalendarFilter>>>;
};

export type QueryEntriesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<EntryTypeEnum>;
  filter?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
};

export type QueryEntryArgs = {
  id: Scalars['ID'];
};

export type QueryPacingGuideArgs = {
  id: Scalars['ID'];
};

export type QueryPacingGuideScopeArgs = {
  id: Scalars['ID'];
};

export type QueryPacingGuideScopesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<PacingGuideScopeFilter>>>;
};

export type QueryPacingGuideTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryPacingGuideTemplatesArgs = {
  name?: InputMaybe<Scalars['String']>;
  curriculumAreas?: InputMaybe<Scalars['Iterable']>;
  grades?: InputMaybe<Scalars['Iterable']>;
  sharedType?: InputMaybe<Scalars['String']>;
  pacingGuideType?: InputMaybe<PacingGuideTypeEnum>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

export type QueryPacingGuidesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  curriculumArea?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PacingGuideFilter_Order>>>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  pacingGuideType?: InputMaybe<PacingGuideTypeEnum>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<PacingGuideFilter>>>;
};

export type QueryPlannerTeamsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type QueryScopePlanArgs = {
  id: Scalars['ID'];
};

export type QueryScopePlanScopeArgs = {
  id: Scalars['ID'];
};

export type QueryScopePlanScopesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  scopePlanId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<ScopePlanScopeFilter>>>;
};

export type QueryScopePlanTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryScopePlanTemplatesArgs = {
  name?: InputMaybe<Scalars['String']>;
  curriculumAreas?: InputMaybe<Scalars['Iterable']>;
  grades?: InputMaybe<Scalars['Iterable']>;
  scopePlanType?: InputMaybe<ScopePlanTypeEnum>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

export type QueryScopePlansArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  curriculumArea?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ScopePlanFilter_Order>>>;
  scopePlanId?: InputMaybe<Scalars['String']>;
  scopePlanType?: InputMaybe<ScopePlanTypeEnum>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<ScopePlanFilter>>>;
};

export type QuerySearchCalendarArgs = {
  calendarType?: InputMaybe<CalendarTypeEnum>;
  calendarName?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
};

export type QueryUserCalendarArgs = {
  id: Scalars['ID'];
};

export type QueryUserCalendarsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UserCalendarFilter_Order>>>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<UserCalendarFilter>>>;
};

export type QueryUserSelectionArgs = {
  id: Scalars['ID'];
};

export type QueryUserSelectionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type QueryStudentAssignmentsMockArgs = {
  classId: Scalars['String'];
};

export type QueryPublicDistrictArgs = {
  id: Scalars['ID'];
};

export type QueryNewDistrictsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateEnum>;
};

export type QueryPasswordRecoveryTokenArgs = {
  id: Scalars['ID'];
};

export type QueryPreviewAccountDistrictsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryPublicAdoptionEventArgs = {
  urlCode: Scalars['String'];
};

export type QuerySystemAdminsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  districtUuid: Scalars['String'];
};

export type QueryAcademicPeriodArgs = {
  id: Scalars['ID'];
};

export type QueryAcademicPeriodsArgs = {
  districtId?: InputMaybe<Scalars['String']>;
};

export type QueryDistrictArgs = {
  id: Scalars['ID'];
};

export type QueryDistrictsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<DistrictFilter_Order>>>;
  id?: InputMaybe<Scalars['String']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateEnum>;
  filter?: InputMaybe<Array<InputMaybe<DistrictFilter>>>;
};

export type QueryLookupDistrictsArgs = {
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryLookupSchoolsArgs = {
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QuerySchoolArgs = {
  id: Scalars['ID'];
};

export type QuerySchoolsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  currentRoleId?: InputMaybe<Scalars['String']>;
  districtName?: InputMaybe<Scalars['String']>;
  districtState?: InputMaybe<StateEnum>;
  districtId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SchoolFilter_Order>>>;
  filter?: InputMaybe<Array<InputMaybe<SchoolFilter>>>;
};

export type QueryClassArgs = {
  id: Scalars['ID'];
};

export type QueryClassesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<ClassFilter>>>;
  order?: InputMaybe<Array<InputMaybe<ClassFilter_Order>>>;
};

export type QueryLookupRosterStudentsArgs = {
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryStudentArgs = {
  id: Scalars['ID'];
};

export type QueryStudentSubgroupArgs = {
  id: Scalars['ID'];
};

export type QueryTeacherArgs = {
  id: Scalars['ID'];
};

export type QueryTeacherStudentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<TeacherStudentFilter>>>;
  order?: InputMaybe<Array<InputMaybe<StudentFilter_Order>>>;
};

export type QueryTeachersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<TeacherFilter>>>;
};

export type QueryActiveContentGroupsArgs = {
  filter?: InputMaybe<ContentGroupFilterInput>;
};

export type QueryLookupProductsArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryOrderArgs = {
  id: Scalars['ID'];
};

export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryProductArgs = {
  id: Scalars['ID'];
};

export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};

export type QuerySubscriptionPackageArgs = {
  id: Scalars['ID'];
};

export type QuerySubscriptionPackagesArgs = {
  filter?: InputMaybe<SubscriptionPackageFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QuerySubscriptionsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryTeamArgs = {
  id: Scalars['ID'];
};

export type QueryTeamsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<FilterTeamInput>;
};

export type QueryTranslateTextsArgs = {
  texts?: InputMaybe<Array<Scalars['String']>>;
  languageCode: Scalars['String'];
  service?: InputMaybe<TranslationService>;
};

export type QueryIdentifyUsersArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  lmsId?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<InputMaybe<IdentifyUserFilter>>>;
};

export type QueryLookupStudentsArgs = {
  id_list: Array<InputMaybe<Scalars['String']>>;
};

export type QueryLookupTeachersArgs = {
  id_list: Array<InputMaybe<Scalars['String']>>;
};

export type QueryLookupUsersArgs = {
  id_list: Array<InputMaybe<Scalars['String']>>;
};

export type QueryParentsArgs = {
  studentId: Scalars['String'];
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUserExportRequestArgs = {
  id: Scalars['ID'];
};

export type QueryUserRolesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type QueryUsersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  classesArchived?: InputMaybe<Scalars['Boolean']>;
  classesCurriculumArea?: InputMaybe<Scalars['String']>;
  classesGradeOrCourse?: InputMaybe<Scalars['String']>;
  classesId?: InputMaybe<Scalars['String']>;
  classesLanguage?: InputMaybe<Scalars['String']>;
  classesName?: InputMaybe<Scalars['String']>;
  curriculumArea?: InputMaybe<CurriculumAreaEnum>;
  districtId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  excludeCurrent?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Array<InputMaybe<UserFilter_Exclude>>>;
  externalSystemName?: InputMaybe<ExternalSystemNameEnum>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameOrUsername?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<GradeLevelFilterEnum>;
  highestRoleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lmsId?: InputMaybe<Scalars['String']>;
  rolesId?: InputMaybe<Scalars['String']>;
  schoolsId?: InputMaybe<Scalars['String']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sisId?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  subgroupsId?: InputMaybe<Scalars['String']>;
  subgroupsName?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UserFilter_Order>>>;
  type?: InputMaybe<UserTypeEnum>;
  purpose?: InputMaybe<UserPurposeEnum>;
  username?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<InputMaybe<UserFilter>>>;
};

export type QueryDownloadResourceArgs = {
  input: ResourceDownloadInput;
};

export type QueryReaderLibrariesArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<ReaderLibraryFilterInput>;
  sort?: InputMaybe<ReaderLibrarySortInput>;
};

export type QueryReaderLibraryArgs = {
  id: Scalars['ID'];
};

export type QueryStemscopesMediaArgs = {
  id: Scalars['ID'];
};

export type QueryStemscopesMediaPackArgs = {
  id: Scalars['ID'];
};

export type QueryStemscopesMediaPacksArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<StemscopesMediaPackFilterInput>;
};

export type QueryStemscopesMediasArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<StemscopesMediaFilterInput>;
};

export type QueryStreamingVideoArgs = {
  id: Scalars['ID'];
};

export type QueryStreamingVideosArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<StreamingVideoFilterInput>;
};

export type QueryTutorArgs = {
  id: Scalars['ID'];
};

export type QueryTutorsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<TutorFilterInput>;
};

export type QueryVideoArgs = {
  id: Scalars['ID'];
};

export type QueryVideosArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter: VideoFilterInput;
  sort?: InputMaybe<VideoSortInput>;
};

export type QueryVideosByGroupArgs = {
  input: VideoByGroupInput;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryScienceBotsArgs = {
  id: Scalars['String'];
};

export type QueryNoteArgs = {
  id: Scalars['ID'];
};

export type QueryNotesArgs = {
  input: NoteListInput;
};

export type QueryAcademicStandardsArgs = {
  input: AcademicStandardInput;
};

export type QueryAdminKnowledgeTreeArgs = {
  input: AdminKnowledgeTreeInput;
};

export type QueryBenchmarkListArgs = {
  input: BenchmarkInput;
};

export type QueryCreateStandardArgs = {
  input: StandardsInput;
};

export type QueryCreateTeacherAssignmentArgs = {
  input: TeacherAssignmentInput;
};

export type QueryDeteleStandardArgs = {
  input: StandardDeleteInput;
};

export type QueryKnowledgeTreeDataArgs = {
  input: KnowledgeTreeInput;
};

export type QueryListContentArgs = {
  input: ListContentInput;
};

export type QueryOnrampContinueStudentAssignmentArgs = {
  input: OnrampStudentAssignmentInput;
};

export type QueryOnrampNlStartUpCompletedArgs = {
  currentSchoolId: Scalars['String'];
};

export type QueryOnrampStartUpCompletedArgs = {
  currentSchoolId: Scalars['String'];
};

export type QueryOnrampStartUpTestArgs = {
  input: OnrampStartupTestInput;
};

export type QueryOnrampStartUpTestNlArgs = {
  input: OnrampStartupTestInput;
};

export type QueryOnrampStudentAssignmentArgs = {
  input: OnrampStudentAssignmentInput;
};

export type QueryOnrampStudentDashboardArgs = {
  currentSchoolId: Scalars['String'];
};

export type QueryOnrampStudentStatusArgs = {
  input: OnrampStudentStatusInput;
};

export type QueryOnrampTeacherAssignmentsListArgs = {
  input: TeacherAssignmentListInput;
};

export type QueryStandardListArgs = {
  input: StandardListInput;
};

export type QueryStandardsByNameArgs = {
  standardNames: Array<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type QueryStandardsListArgs = {
  input: StandardsListInput;
};

export type QueryStudentCertificateArgs = {
  input: StudentCertificateInput;
};

export type QueryTeacherStandardListArgs = {
  input: StandardListInput;
};

export type QueryKarmaAwardsArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  timeRange?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  currentSchoolId: Scalars['String'];
};

export type QueryPostsArgs = {
  parameter?: InputMaybe<InputPostRequest>;
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type QueryS3UploadSignedUrlArgs = {
  wallId: Scalars['String'];
  currentSchoolId: Scalars['String'];
  fileName: Scalars['String'];
};

export type QueryUnfilteredPostsArgs = {
  parameter?: InputMaybe<UnfilteredInputPostRequest>;
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type QueryWallAgeControlsArgs = {
  classId: Scalars['String'];
  currentSchoolId: Scalars['String'];
};

export type QueryWallControlsArgs = {
  currentSchoolId: Scalars['String'];
};

export type QueryWallPostLikesArgs = {
  currentSchoolId: Scalars['String'];
};

export type QueryStandardsArgs = {
  state: Scalars['String'];
  subject: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  parentIds?: InputMaybe<Array<Scalars['String']>>;
  onlyRoot?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEmailTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryEmailTemplateAttachmentUploadFormArgs = {
  input: ReadEmailTemplateAttachmentUploadFormInput;
};

export type QueryEmailTemplateImageUploadFormArgs = {
  input: ReadEmailTemplateImageUploadFormInput;
};

export type QueryEmailTemplatePlaceholdersArgs = {
  type: EmailTemplateTypeEnum;
};

export type QueryEmailTemplatesArgs = {
  filter?: InputMaybe<EmailTemplateFilterInput>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryFromEmailsArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type QueryCanvasConfigArgs = {
  districtInput: DistrictInput;
};

export type QueryCanvasSsoConfigArgs = {
  districtInput: DistrictInput;
};

export type QueryListLtiArgs = {
  listInput?: InputMaybe<LtiListInput>;
};

export type QueryListLtiPaginatedArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  listInput?: InputMaybe<LtiListInput>;
};

export type QueryListSsoArgs = {
  listInput?: InputMaybe<SsoListInput>;
};

export type QueryListSsoPaginatedArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  listInput?: InputMaybe<SsoListInput>;
};

export type QueryReadLtiArgs = {
  ltiKeyInput: LtiKeyInput;
};

export type QueryReadSsoArgs = {
  ssoKeyInput: SsoKeyInput;
};

export type QueryAskChatbotArgs = {
  userId: Scalars['String'];
  query: Scalars['String'];
  threadId?: InputMaybe<Scalars['String']>;
};

export type QueryGetQuestionHintArgs = {
  question: Scalars['String'];
  options?: InputMaybe<Scalars['String']>;
  correctOption?: InputMaybe<Scalars['String']>;
};

export type QueryGenerateQuestionArgs = {
  question: Scalars['String'];
  options?: InputMaybe<Scalars['String']>;
};

export type QueryAthenaDistrictsArgs = {
  filter?: InputMaybe<DistrictFilter>;
  order?: InputMaybe<DistrictSort>;
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type QueryMnCourseworkArgs = {
  category?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teacherId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<MnCourseworkOrderType>;
};

export type QueryMnCourseworkDownloadReportArgs = {
  category?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teacherId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<MnCourseworkOrderType>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type QueryMnEdgeXlDownloadReportArgs = {
  assignmentId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type QueryMnEdgeXlStandardsArgs = {
  assignmentId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelEnumType>;
  nextToken?: InputMaybe<Scalars['String']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryMnEdgeXlStandardsDownloadReportArgs = {
  assignmentId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelEnumType>;
  nextToken?: InputMaybe<Scalars['String']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryMnOnRampArgs = {
  classId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  reportType?: InputMaybe<OnRampReportTypeEnum>;
  state?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order?: InputMaybe<MnOnRampOrderType>;
};

export type QueryMnOnRampDownloadReportArgs = {
  classId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<OnRampReportTypeEnum>;
  state?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<MnOnRampOrderType>;
};

export type QuerySsStandardsArgs = {
  aggregateBy?: InputMaybe<SsStandardsAggregationTypeEnum>;
  assignmentId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  districtAssessmentId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelEnumType>;
  nextToken?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<SsStandardsSort>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  schoolId?: InputMaybe<Scalars['String']>;
  standards?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['String']>;
};

export type QuerySsStandardsDownloadReportArgs = {
  aggregateBy?: InputMaybe<SsStandardsAggregationTypeEnum>;
  assignmentId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  districtAssessmentId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelEnumType>;
  order?: InputMaybe<SsStandardsSort>;
  schoolId?: InputMaybe<Scalars['String']>;
  standards?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['String']>;
};

export type QuerySsStandardsItemsArgs = {
  filter?: InputMaybe<SsStandardsItemFilter>;
};

export type QueryDisplayProjectDetailsArgs = {
  input: ProjectInput;
};

export enum QuestionBankEnum {
  Teacher = 'TEACHER',
  District = 'DISTRICT',
  Extra = 'EXTRA',
}

export type QuestionContainerPayload = {
  __typename?: 'QuestionContainerPayload';
  statusPayload?: Maybe<StatusPayload>;
};

export type QuestionInput = {
  platformAdminInput?: InputMaybe<PlatformAdminQuestionInput>;
};

export type QuestionPayload = {
  __typename?: 'QuestionPayload';
  platformAdminPayload?: Maybe<PlatformAdminQuestionPayload>;
};

export type QuestionPool = {
  __typename?: 'QuestionPool';
  categories: Array<Scalars['String']>;
  curriculumAreas: Array<Scalars['String']>;
  gradeLessons: Array<Scalars['String']>;
  grades: Array<Scalars['String']>;
  grading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lessons: Array<Scalars['String']>;
  editions: Array<Scalars['String']>;
  questionTypes: Array<Scalars['String']>;
  scopes: Array<Scalars['String']>;
  standards: Array<Scalars['String']>;
  units: Array<Scalars['String']>;
};

export type QuestionPoolInput = {
  edgexlInput?: InputMaybe<EdgexlQuestionPoolInput>;
  platformAdminInput?: InputMaybe<PlatformAdminQuestionPoolInput>;
  stemscopesInput?: InputMaybe<StemscopesQuestionPoolInput>;
};

export type QuestionPoolPageConnection = {
  __typename?: 'QuestionPoolPageConnection';
  collection: Array<QuestionPool>;
  paginationInfo?: Maybe<QuestionPoolPaginationInfo>;
};

export type QuestionPoolPaginationInfo = {
  __typename?: 'QuestionPoolPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QuestionPoolPayload = {
  __typename?: 'QuestionPoolPayload';
  impEdgexlPayload?: Maybe<QuestionPoolPageConnection>;
  impStemscopesPayload?: Maybe<QuestionPoolPageConnection>;
  platformAdminPayload?: Maybe<PlatformAdminQuestionPoolPayload>;
};

export type QuestionsInput = {
  platformAdminInput?: InputMaybe<PlatformAdminQuestionsInput>;
};

export type QuestionsPayload = {
  __typename?: 'QuestionsPayload';
  platformAdminPayload?: Maybe<PlatformAdminQuestionsPayload>;
};

export type ReadEmailTemplateAttachmentUploadFormInput = {
  fileNames: Array<Scalars['String']>;
};

export type ReadEmailTemplateImageUploadFormInput = {
  fileName: Scalars['String'];
};

export type ReaderLibrary = {
  __typename?: 'ReaderLibrary';
  description: Scalars['String'];
  enPdfFile: Scalars['String'];
  esPdfFile: Scalars['String'];
  id: Scalars['String'];
  pdfFile: Scalars['String'];
  title: Scalars['String'];
  keywords: Array<ContentKeyword>;
  tagValues: Array<ContentTagValue>;
};

export type ReaderLibraryFilterInput = {
  title?: InputMaybe<Scalars['String']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
  tagValueIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ReaderLibraryPageConnection = {
  __typename?: 'ReaderLibraryPageConnection';
  collection: Array<ReaderLibrary>;
  paginationInfo?: Maybe<ReaderLibraryPaginationInfo>;
};

export type ReaderLibraryPaginationInfo = {
  __typename?: 'ReaderLibraryPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ReaderLibraryPayload = {
  __typename?: 'ReaderLibraryPayload';
  readerLibrary: ReaderLibrary;
};

export type ReaderLibrarySortInput = {
  title?: InputMaybe<SortEnum>;
};

export type ReadImageFileUploadFormInput = {
  fileName: Scalars['String'];
};

export type ReadStemscopesMediaPackPayload = {
  __typename?: 'ReadStemscopesMediaPackPayload';
  pack: StemscopesMediaPack;
  items: Array<StemscopesMedia>;
};

export type RecentlyViewed = {
  __typename?: 'RecentlyViewed';
  displayedNames?: Maybe<Array<Scalars['String']>>;
  objectIds: Array<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
};

export type RegisterAdoptionReviewerInput = {
  plainPassword: Scalars['String'];
  registrationToken: Scalars['String'];
  username: Scalars['String'];
};

export type RegisterAdoptionReviewerPayload = {
  __typename?: 'RegisterAdoptionReviewerPayload';
  districtName: Scalars['String'];
  eventUrlCode: Scalars['String'];
};

export type RegisterCommunityAccessMemberInput = {
  communityRegistrationToken: Scalars['String'];
  plainPassword: Scalars['String'];
  username: Scalars['String'];
};

export type RegisterCommunityAccessMemberPayload = {
  __typename?: 'RegisterCommunityAccessMemberPayload';
  districtName: Scalars['String'];
  eventUrlCode: Scalars['String'];
};

export type RegisterParentInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  username: Scalars['String'];
  plainPassword: Scalars['String'];
  registrationToken: Scalars['String'];
};

export type RegisterPreviewAccountTeacherInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  plainPassword: Scalars['String'];
  registrationToken: Scalars['String'];
  username: Scalars['String'];
};

/** Removes a Calendar. */
export type RemoveCalendarInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Removes a Calendar. */
export type RemoveCalendarPayload = {
  __typename?: 'removeCalendarPayload';
  calendar?: Maybe<Calendar>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a Entry. */
export type RemoveEntryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Removes a Entry. */
export type RemoveEntryPayload = {
  __typename?: 'removeEntryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
};

/** Removes a PacingGuide. */
export type RemovePacingGuideInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Removes a PacingGuide. */
export type RemovePacingGuidePayload = {
  __typename?: 'removePacingGuidePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pacingGuide?: Maybe<PacingGuide>;
};

export type RemovePermissionInput = {
  id: Scalars['ID'];
  scopedPermission: ScopedPermissionInput;
};

/** Removes a Post. */
export type RemovePostInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  id: Scalars['String'];
};

/** Removes a Post. */
export type RemovePostPayload = {
  __typename?: 'removePostPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
};

/** Removes a ScopePlan. */
export type RemoveScopePlanInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
};

/** Removes a ScopePlan. */
export type RemoveScopePlanPayload = {
  __typename?: 'removeScopePlanPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  scopePlan?: Maybe<ScopePlan>;
};

export type RemoveStudentFromClassesInput = {
  classesIds: Scalars['Iterable'];
  studentId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RemoveStudentFromClassesPayload = {
  __typename?: 'removeStudentFromClassesPayload';
  classes?: Maybe<Classes>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveStudentsFromClassInput = {
  classId: Scalars['String'];
  studentIds: Scalars['Iterable'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RemoveStudentsFromClassPayload = {
  __typename?: 'removeStudentsFromClassPayload';
  class?: Maybe<Class>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveStudentsFromStudentSubgroupInput = {
  studentIds: Scalars['Iterable'];
  subgroupId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RemoveStudentsFromStudentSubgroupPayload = {
  __typename?: 'removeStudentsFromStudentSubgroupPayload';
  studentSubgroup?: Maybe<StudentSubgroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Reopen assignment input */
export type ReopenAssignmentInput = {
  assignmentId: Scalars['String'];
  endDate: Scalars['ISO8601Date'];
  notes: Scalars['String'];
  studentIds: Array<Scalars['String']>;
};

/** Reopen District Assignment input */
export type ReopenDistrictAssignmentInput = {
  assignmentId: Scalars['String'];
  reopenDate: Scalars['ISO8601Date'];
  studentIds: Array<Scalars['String']>;
};

export type Report = Node & {
  __typename?: 'Report';
  _id: Scalars['String'];
  id: Scalars['ID'];
  signedRequest: Scalars['String'];
};

/** Report Signed Request type */
export type ReportSignedRequest = SignedRequestInterface & {
  __typename?: 'ReportSignedRequest';
  items?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  renderingType?: Maybe<Scalars['String']>;
  signedRequest: Scalars['JSON'];
  state?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

/** Report Sign Request Input */
export type ReportSignRequestInput = {
  domain?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<Scalars['String']>>;
  referenceId?: InputMaybe<Scalars['String']>;
  renderingType?: InputMaybe<AssignmentLearnosityRenderingType>;
  /** Data for field "reports" in sign */
  reports: Scalars['JSON'];
  schoolId?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<SignAssignmentServices>;
  sessionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssignmentLearnosityState>;
  studentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AssignmentLearnosityType>;
};

/** Reset assignment input */
export type ResetAssignmentInput = {
  assignmentId: Scalars['String'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  notes?: InputMaybe<Scalars['String']>;
  studentIds: Array<Scalars['String']>;
};

export type ResetOnrampStartupTestInput = {
  studentIds: Array<Scalars['String']>;
  studentGrade: Scalars['String'];
  currentSchoolId: Scalars['String'];
};

/** ResetPasswordSetTimes a User. */
export type ResetPasswordSetTimeUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  passwordSetTime?: InputMaybe<Scalars['DateTime']>;
  userIds: Scalars['Iterable'];
};

/** ResetPasswordSetTimes a User. */
export type ResetPasswordSetTimeUserPayload = {
  __typename?: 'resetPasswordSetTimeUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ResetPreviewAccountActivityPeriodEndInput = {
  activityPeriodEnd?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ResetStudentStartupPayload = {
  __typename?: 'ResetStudentStartupPayload';
  status: Scalars['String'];
};

/** Resource Object Type */
export type Resource = {
  __typename?: 'Resource';
  classId: Scalars['String'];
  labels?: Maybe<Array<Scalars['String']>>;
  learnosityReferenceId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  originLearnosityId?: Maybe<Scalars['String']>;
  ownerId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceSource: ResourceSource;
  schoolId?: Maybe<Scalars['String']>;
  status: AssignmentStatus;
  studentIds?: Maybe<Array<Scalars['String']>>;
  subgroupIds?: Maybe<Array<Scalars['String']>>;
};

export type ResourceDownloadInput = {
  category: VideoGroupEnum;
  courseType?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  mediaType?: MediaTypeEnum;
  resourceIds?: Array<Scalars['String']>;
  videoIndex?: InputMaybe<Scalars['String']>;
};

/** ResourceSource Object Type */
export type ResourceSource = {
  __typename?: 'ResourceSource';
  element?: Maybe<Element>;
};

/** ResourceSourceInput */
export type ResourceSourceInput = {
  element?: InputMaybe<ElementInput>;
};

export type ResponseFeedback = {
  __typename?: 'ResponseFeedback';
  feedback: Scalars['String'];
  responseId: Scalars['String'];
};

/** Response feedback input */
export type ResponseFeedbackInput = {
  feedback: Scalars['String'];
  responseId: Scalars['String'];
};

/** RestrictInvitations a Parent. */
export type RestrictInvitationParentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  parentId: Scalars['String'];
  studentId: Scalars['String'];
};

/** RestrictInvitations a Parent. */
export type RestrictInvitationParentPayload = {
  __typename?: 'restrictInvitationParentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  parent?: Maybe<RestrictInvitationParentPayloadData>;
};

/** RestrictInvitations a Parent. */
export type RestrictInvitationParentPayloadData = Node & {
  __typename?: 'restrictInvitationParentPayloadData';
  id: Scalars['ID'];
};

/** Return assignment input */
export type ReturnAssignmentInput = {
  assignmentId: Scalars['String'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  notes: Scalars['String'];
  studentIds: Array<Scalars['String']>;
};

/** Use only for merging data! */
export type Role = Node & {
  __typename?: 'Role';
  code?: Maybe<RoleCodeEnum>;
  id: Scalars['ID'];
  name: Scalars['String'];
  policies: Array<AccessPolicy>;
  category?: Maybe<RoleCategoryEnum>;
  _id: Scalars['String'];
};

export enum RoleCategoryEnum {
  District = 'District',
  Platform = 'Platform',
  Technical = 'Technical',
}

export enum RoleCodeEnum {
  Adoptions = 'Adoptions',
  AdoptionReviewer = 'AdoptionReviewer',
  CampusCurriculumLeader = 'CampusCurriculumLeader',
  CampusLeader = 'CampusLeader',
  Community = 'Community',
  ContentAuthor = 'ContentAuthor',
  ContentReviewer = 'ContentReviewer',
  CustomerSupport = 'CustomerSupport',
  DistrictAdmin = 'DistrictAdmin',
  DistrictCurriculumLeader = 'DistrictCurriculumLeader',
  DistrictLeader = 'DistrictLeader',
  Finance = 'Finance',
  Parent = 'Parent',
  PlatformAdmin = 'PlatformAdmin',
  Student = 'Student',
  SchoolAdmin = 'SchoolAdmin',
  SystemAdmin = 'SystemAdmin',
  Teacher = 'Teacher',
  WallWatcher = 'WallWatcher',
}

export type RoleFilterInput = {
  categories?: Array<RoleCategoryEnum>;
};

export type RolePageConnection = {
  __typename?: 'RolePageConnection';
  collection: Array<Role>;
  paginationInfo?: Maybe<RolePaginationInfo>;
};

export type RolePaginationInfo = {
  __typename?: 'RolePaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RolePayload = {
  __typename?: 'RolePayload';
  role: Role;
};

export type S3UploadSignedUrl = Node & {
  __typename?: 's3UploadSignedUrl';
  _id: Scalars['String'];
  formAttributes: Scalars['Iterable'];
  formInputs: Scalars['Iterable'];
  id: Scalars['ID'];
};

/** Save grading session input */
export type SaveGradingSessionInput = {
  responseFeedbacks?: InputMaybe<Array<ResponseFeedbackInput>>;
  responses?: InputMaybe<Array<Scalars['JSON']>>;
  sessionId: Scalars['String'];
  userId: Scalars['String'];
};

export type School = Node & {
  __typename?: 'School';
  id: Scalars['ID'];
  /** Use only for merging data! */
  _id: Scalars['ID'];
  city?: Maybe<Scalars['String']>;
  district: District;
  districtId: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<Scalars['String']>;
  globalName: Scalars['String'];
  localName: Scalars['String'];
  mathNationId?: Maybe<Scalars['String']>;
  /** @deprecated The field has been renamed to globalName */
  name: Scalars['String'];
  ncesId?: Maybe<Scalars['String']>;
  sisId?: Maybe<Scalars['String']>;
};

export type SchoolFilter = {
  city?: InputMaybe<Scalars['String']>;
  currentRoleId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  districtName?: InputMaybe<Scalars['String']>;
  districtState?: InputMaybe<StateEnum>;
  id?: InputMaybe<Scalars['String']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SchoolFilter_Order>>>;
};

export type SchoolFilter_Order = {
  city?: InputMaybe<SortEnum>;
  district_globalName?: InputMaybe<SortEnum>;
  district_state?: InputMaybe<SortEnum>;
  globalName?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
};

export type SchoolGradeLevels = {
  __typename?: 'SchoolGradeLevels';
  gradeLevels?: Maybe<Array<Scalars['String']>>;
  schoolId?: Maybe<Scalars['String']>;
};

export type SchoolGradeLevelsInput = {
  gradeLevels: Array<Scalars['String']>;
  schoolId: Scalars['String'];
};

/** Page connection for School. */
export type SchoolPageConnection = {
  __typename?: 'SchoolPageConnection';
  collection?: Maybe<Array<Maybe<School>>>;
  paginationInfo: SchoolPaginationInfo;
};

/** Information about the pagination. */
export type SchoolPaginationInfo = {
  __typename?: 'SchoolPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ScienceBotPayload = {
  __typename?: 'ScienceBotPayload';
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type Scope = {
  __typename?: 'Scope';
  active?: Maybe<Scalars['Boolean']>;
  banner: Scalars['String'];
  contentGroups: Array<Scalars['String']>;
  contentLocation: Scalars['String'];
  created: Scalars['String'];
  displayName: Scalars['String'];
  editionName: Scalars['String'];
  elementTitles: Array<Scalars['String']>;
  home: Scalars['JSON'];
  id: Scalars['String'];
  image: Scalars['String'];
  internalName: Scalars['String'];
  lastUpdated: Scalars['String'];
  launchUrl: Scalars['String'];
  metadata: Scalars['JSON'];
  platform: Scalars['String'];
  positionNumber: Scalars['Int'];
  projectId: Scalars['String'];
  projectType: Scalars['String'];
  sections: Array<Scalars['JSON']>;
  state: Scalars['String'];
  tags: Array<Scalars['String']>;
  taxonomy: Array<Scalars['JSON']>;
  version: Scalars['Int'];
};

export enum ScopeDocumentExportStatusEnum {
  Completed = 'Completed',
  Error = 'Error',
  InQueue = 'InQueue',
  InProcess = 'InProcess',
}

export type ScopeDocumentInput = {
  /** Type of the document */
  docType?: InputMaybe<DocTypeEnum>;
  /** Name of the Element */
  headerName?: InputMaybe<Scalars['String']>;
  /** Icon - Base64 encoded string */
  headerIcon?: InputMaybe<Scalars['String']>;
  /** Path of the source file used for converting as Inline Css */
  filePath?: Scalars['String'];
  /** Raw HTML content of a entire page */
  html?: InputMaybe<Scalars['String']>;
  /** Css for the page to be applied as Inline Css */
  iframes: Array<Scalars['ID']>;
  /** Footer of page */
  footer?: InputMaybe<Scalars['String']>;
};

export type ScopeDocumentItem = {
  __typename?: 'ScopeDocumentItem';
  docType?: Maybe<DocTypeEnum>;
  headerName: Scalars['String'];
  headerIcon: Scalars['String'];
  filePath: Scalars['String'];
  html: Scalars['String'];
  inlineCssContent: Scalars['String'];
  docxFilePath: Scalars['String'];
  footer: Scalars['String'];
  status: ScopeDocumentExportStatusEnum;
  id: Scalars['ID'];
  iframes: Array<Scalars['String']>;
};

export type ScopeDocumentPayload = {
  __typename?: 'ScopeDocumentPayload';
  scopeDocumentItem: ScopeDocumentItem;
};

export type ScopedPermission = {
  __typename?: 'ScopedPermission';
  permission: Scalars['String'];
  scope: PermissionScope;
};

export type ScopedPermissionInput = {
  permission: Scalars['String'];
  scope: PermissionScope;
};

export type ScopeFilter = {
  curriculumArea?: InputMaybe<Array<Scalars['String']>>;
  editionName?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['String']>>;
  instructionalDays?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Array<Scalars['String']>>;
  contentGroups?: InputMaybe<Array<Scalars['String']>>;
};

export type ScopeGroup = {
  __typename?: 'ScopeGroup';
  id: Scalars['ID'];
  /** Use only for merging data! */
  _id: Scalars['ID'];
};

export type ScopePlan = Node & {
  __typename?: 'ScopePlan';
  _id: Scalars['String'];
  approachType?: Maybe<ScopePlanApproachEnum>;
  assignedTo?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['String']>;
  calendarType?: Maybe<CalendarTypeEnum>;
  classSize?: Maybe<Scalars['Int']>;
  classTime?: Maybe<Scalars['Int']>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  curriculumArea?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  grade?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSelected?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pacingGuideId?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopePlanId?: Maybe<Scalars['String']>;
  scopePlanType?: Maybe<ScopePlanTypeEnum>;
  scopes?: Maybe<ScopePlanScopePageConnection>;
  searchName?: Maybe<Scalars['String']>;
  sharedBy?: Maybe<Scalars['String']>;
  sharedData?: Maybe<Scalars['Iterable']>;
  sharedOption?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  teacherExp?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

export type ScopePlanScopesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  scopePlanId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<ScopePlanScopeFilter>>>;
};

/** Scope Plan type: Adaptive / Traditional */
export enum ScopePlanApproachEnum {
  /** Adaptive Type */
  Adaptive = 'Adaptive',
  /** Traditional Type */
  Traditional = 'Traditional',
}

export type ScopePlanFilter = {
  curriculumArea?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopePlanId?: InputMaybe<Scalars['String']>;
  scopePlanType?: InputMaybe<ScopePlanTypeEnum>;
  teamId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ScopePlanFilter_Order = {
  name?: InputMaybe<SortEnum>;
};

/** Page connection for ScopePlan. */
export type ScopePlanPageConnection = {
  __typename?: 'ScopePlanPageConnection';
  collection?: Maybe<Array<Maybe<ScopePlan>>>;
  paginationInfo: ScopePlanPaginationInfo;
};

/** Information about the pagination. */
export type ScopePlanPaginationInfo = {
  __typename?: 'ScopePlanPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ScopePlanScope = Node & {
  __typename?: 'ScopePlanScope';
  _id: Scalars['String'];
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  elements?: Maybe<Scalars['Iterable']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructionalDays?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopeId?: Maybe<Scalars['String']>;
  scopePlanId?: Maybe<Scalars['String']>;
  sharedBy?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  type: EntryTypeEnum;
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

/** Actions: Add / Remove */
export enum ScopePlanScopeElementActionTypeEnum {
  /** Action Type Add */
  Add = 'Add',
  /** Action Type Remove */
  Remove = 'Remove',
}

export type ScopePlanScopeFilter = {
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeId?: InputMaybe<Scalars['String']>;
  scopePlanId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Page connection for ScopePlanScope. */
export type ScopePlanScopePageConnection = {
  __typename?: 'ScopePlanScopePageConnection';
  collection?: Maybe<Array<Maybe<ScopePlanScope>>>;
  paginationInfo: ScopePlanScopePaginationInfo;
};

/** Information about the pagination. */
export type ScopePlanScopePaginationInfo = {
  __typename?: 'ScopePlanScopePaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Scope Plan type: Individual / Team / Template */
export enum ScopePlanTypeEnum {
  /** Individual Type */
  Individual = 'Individual',
  /** Team Type */
  Team = 'Team',
  /** Template Type */
  Template = 'Template',
}

export type ScopePrintDownloadInput = {
  /** Id of the scope which user tries to print/download */
  scopeId?: Scalars['String'];
  /** Type of the request */
  eventType?: InputMaybe<ScopePrintDownloadTypeEnum>;
};

export type ScopePrintDownloadPayload = {
  __typename?: 'ScopePrintDownloadPayload';
  scopeId: Scalars['String'];
};

export enum ScopePrintDownloadTypeEnum {
  Print = 'Print',
  Download = 'Download',
}

export type Scopes = {
  __typename?: 'Scopes';
  collection: Array<SearchableScope>;
  pageInfo: PageInfo;
};

export type SearchableElement = {
  __typename?: 'SearchableElement';
  contentGroups: Array<Scalars['String']>;
  curriculumArea?: Maybe<Scalars['String']>;
  editionName: Scalars['String'];
  elementFiles?: Maybe<Array<Scalars['JSON']>>;
  gradeLevel?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metadata: Scalars['JSON'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  projectType: Scalars['String'];
  resourceDefault: Scalars['Boolean'];
  scopeId: Scalars['String'];
  scopeName: Scalars['String'];
  sectionId: Scalars['String'];
  sectionName: Scalars['String'];
  sectionType: Scalars['String'];
  studentView?: Maybe<Array<Scalars['JSON']>>;
  teacherView?: Maybe<Array<Scalars['JSON']>>;
};

export type SearchableMathNationScope = {
  __typename?: 'SearchableMathNationScope';
  category: Scalars['String'];
  contentAudience: AudienceEnum;
  contentGroups?: Maybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  grade: Scalars['String'];
  id: Scalars['String'];
  projectIdentifiers?: Maybe<Scalars['JSON']>;
  projectTitles?: Maybe<Scalars['JSON']>;
};

export type SearchableScope = {
  __typename?: 'SearchableScope';
  contentGroups: Array<Scalars['String']>;
  displayName: Scalars['String'];
  editionName: Scalars['String'];
  elementTaxonomy?: Maybe<Array<Scalars['JSON']>>;
  elementTitles: Array<Scalars['String']>;
  id: Scalars['String'];
  image: Scalars['String'];
  internalName: Scalars['String'];
  metadata: Scalars['JSON'];
  positionNumber: Scalars['Int'];
  projectId: Scalars['String'];
  projectType: Scalars['String'];
  sections: Array<Scalars['JSON']>;
  taxonomy: Array<Scalars['JSON']>;
};

export type SearchableTeacherResource = {
  __typename?: 'SearchableTeacherResource';
  contentGroups: Array<Scalars['String']>;
  displayName: Scalars['String'];
  elementTitles: Array<Scalars['String']>;
  id: Scalars['String'];
  internalName: Scalars['String'];
  metadata: Scalars['JSON'];
  positionNumber: Scalars['Int'];
  projectId: Scalars['String'];
  projectType: Scalars['String'];
  sectionTitles: Array<Scalars['JSON']>;
};

export enum SectionEnum {
  Tg = 'TG',
  Sg = 'SG',
  Vi = 'VI',
}

export enum SetupStatusEnum {
  Activated = 'activated',
  Completed = 'completed',
  NotStarted = 'notStarted',
}

export type ShareAssessmentInput = {
  edgexlInput?: InputMaybe<EdgexlShareAssessmentInput>;
  stemscopesInput?: InputMaybe<StemscopesShareAssessmentInput>;
};

/** Shares a Calendar. */
export type ShareCalendarInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  shareType: Scalars['String'];
  userIds: Scalars['Iterable'];
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Shares a Calendar. */
export type ShareCalendarPayload = {
  __typename?: 'shareCalendarPayload';
  calendar?: Maybe<Calendar>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum ShareResults {
  Disabled = 'DISABLED',
  WithoutCorrectAnswers = 'WITHOUT_CORRECT_ANSWERS',
  WithCorrectAnswers = 'WITH_CORRECT_ANSWERS',
}

/** ShareTemplates a PacingGuide. */
export type ShareTemplatePacingGuideInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  sharedData: Scalars['Iterable'];
  sharedOption: Scalars['String'];
  sharedType: Scalars['String'];
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** ShareTemplates a PacingGuide. */
export type ShareTemplatePacingGuidePayload = {
  __typename?: 'shareTemplatePacingGuidePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pacingGuide?: Maybe<PacingGuide>;
};

/** ShareTemplates a ScopePlan. */
export type ShareTemplateScopePlanInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  sharedData: Scalars['Iterable'];
  sharedOption: Scalars['String'];
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** ShareTemplates a ScopePlan. */
export type ShareTemplateScopePlanPayload = {
  __typename?: 'shareTemplateScopePlanPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  scopePlan?: Maybe<ScopePlan>;
};

export enum SignAssignmentServices {
  Assess = 'assess',
  Author = 'author',
  Data = 'data',
  Events = 'events',
  Items = 'items',
  Questions = 'questions',
  Reports = 'reports',
}

export type SignedRequest = Node & {
  __typename?: 'SignedRequest';
  _id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  mode: Scalars['String'];
  referenceId: Scalars['String'];
  signedRequest: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

/** Signed Request Interface */
export type SignedRequestInterface = {
  items?: Maybe<Array<Scalars['String']>>;
  referenceId?: Maybe<Scalars['String']>;
  renderingType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Signed Request Union */
export type SignedRequestUnion = ItemSignedRequest | ReportSignedRequest;

/** Action for sign */
export type SignRequestActionInput = {
  startNewAttempt: Scalars['Boolean'];
};

/** Sign Request Input */
export type SignRequestInput = {
  itemSignedRequestInput?: InputMaybe<ItemSignRequestInput>;
  reportSignedRequestInput?: InputMaybe<ReportSignRequestInput>;
};

export type SignRequestPayload = {
  __typename?: 'SignRequestPayload';
  signedRequest: Scalars['String'];
};

export type SignRequestStartUpPayload = {
  __typename?: 'SignRequestStartUpPayload';
  subject: Scalars['String'];
  startupCompleted: Scalars['Boolean'];
  signedRequest: Scalars['String'];
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Sort type: ASC / DESC */
export enum SortEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SortEnumMissingLast {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SortFieldEnum {
  Created = 'CREATED',
  Updated = 'UPDATED',
}

export type SortInput = {
  direction: SortDirectionEnum;
  field: SortFieldEnum;
};

export type Sso = {
  __typename?: 'Sso';
  districtId: Scalars['String'];
  oauth?: Maybe<SsoOauth>;
  saml?: Maybe<SsoSaml>;
  type: SsoTypeEnum;
  policies: Array<SsoPolicy>;
};

export type SsoInput = {
  oauth?: InputMaybe<SsoOauthInput>;
  saml?: InputMaybe<SsoSamlInput>;
  ssoKey: SsoKeyInput;
};

export type SsoKeyInput = {
  districtId: Scalars['String'];
  type: SsoTypeEnum;
};

export type SsoListInput = {
  districtId?: InputMaybe<Scalars['String']>;
};

export type SsoOauth = {
  __typename?: 'SsoOauth';
  baseUrl?: Maybe<Scalars['String']>;
  clientId: Scalars['String'];
  clientSecret?: Maybe<Scalars['String']>;
};

export type SsoOauthInput = {
  clientId: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  baseUrl?: InputMaybe<Scalars['String']>;
};

export type SsoPageConnection = {
  __typename?: 'SsoPageConnection';
  collection: Array<Sso>;
  paginationInfo?: Maybe<SsoPaginationInfo>;
};

export type SsoPaginationInfo = {
  __typename?: 'SsoPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SsoPolicy = {
  __typename?: 'SsoPolicy';
  externalField?: Maybe<ExternalFieldEnum>;
  internalFields: Array<SsoPolicyInternalField>;
  name: PolicyNameEnum;
  sequence: Scalars['Int'];
  userType: SsoUserTypeEnum;
};

export type SsoPolicyInternalField = {
  __typename?: 'SsoPolicyInternalField';
  name?: Maybe<InternalFieldEnum>;
  value: InternalFieldEnum;
};

export type SsoSaml = {
  __typename?: 'SsoSaml';
  idpEntityId: Scalars['String'];
  idpSingleSingOnUrl: Scalars['String'];
  idpSingleLogoutUrl: Scalars['String'];
  idpX509Cert: Scalars['String'];
};

export type SsoSamlInput = {
  idpEntityId: Scalars['String'];
  idpSingleSingOnUrl: Scalars['String'];
  idpSingleLogoutUrl: Scalars['String'];
  idpX509Cert: Scalars['String'];
};

export enum SsoTypeEnum {
  Oauth2Canvas = 'OAUTH2_CANVAS',
  Oauth2Classlink = 'OAUTH2_CLASSLINK',
  Oauth2Clever = 'OAUTH2_CLEVER',
  Oauth2MiDataHub = 'OAUTH2_MI_DATA_HUB',
  OauthCanvas = 'OAUTH_CANVAS',
  SamlClasslink = 'SAML_CLASSLINK',
  SamlGoogle = 'SAML_GOOGLE',
  SamlMicrosoft = 'SAML_MICROSOFT',
}

export enum SsoUserTypeEnum {
  Parent = 'PARENT',
  Staff = 'STAFF',
  Student = 'STUDENT',
}

export type SsoWithPoliciesInput = {
  policies?: InputMaybe<Array<PolicyInput>>;
  oauth?: InputMaybe<SsoOauthInput>;
  saml?: InputMaybe<SsoSamlInput>;
  ssoKey: SsoKeyInput;
};

export type SsQuestionContainerInput = {
  category: Scalars['String'];
  grade: Scalars['String'];
  lesson: Scalars['String'];
  unit: Scalars['String'];
};

export type SsStandards = Node & {
  __typename?: 'ssStandards';
  _id: Scalars['String'];
  id: Scalars['ID'];
  /** A token used for paginating through results. Pass this token in subsequent requests to retrieve the next page of results. */
  nextToken: Scalars['String'];
  resultSetJson: Scalars['String'];
};

/** SsStandardsAggregation type: District, Grade, School, Student, Teacher */
export enum SsStandardsAggregationTypeEnum {
  /** Aggregate by District */
  District = 'District',
  /** Aggregate by Grade */
  Grade = 'Grade',
  /** Aggregate by School */
  School = 'School',
  /** Aggregate by Student */
  Student = 'Student',
  /** Aggregate by Teacher */
  Teacher = 'Teacher',
}

export type SsStandardsDownloadReport = Node & {
  __typename?: 'ssStandardsDownloadReport';
  _id: Scalars['String'];
  id: Scalars['ID'];
  signedUrl: Scalars['String'];
};

export type SsStandardsItem = Node & {
  __typename?: 'ssStandardsItem';
  id: Scalars['ID'];
  standard: Scalars['String'];
};

/** Contains types to be used for filtering. */
export type SsStandardsItemFilter = {
  /** Filter by assignment id */
  assignmentId?: InputMaybe<Scalars['String']>;
  /** Filter by class id(s) with an array */
  classIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by teacher id(s) with an array */
  teacherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** SsStandardsSort type: districtName, gradeLevel, schoolName, studentName, teacherName by ASC or DESC */
export type SsStandardsSort = {
  /** sort by districtName asc or desc */
  districtName?: InputMaybe<SortEnum>;
  /** sort by gradeLevel asc or desc */
  gradeLevel?: InputMaybe<SortEnum>;
  /** sort by schoolName asc or desc */
  schoolName?: InputMaybe<SortEnum>;
  /** sort by studentName asc or desc */
  studentName?: InputMaybe<SortEnum>;
  /** sort by teacherName asc or desc */
  teacherName?: InputMaybe<SortEnum>;
};

export type Standard = {
  __typename?: 'Standard';
  id: Scalars['String'];
  state: Scalars['String'];
  grade: Scalars['String'];
  standard: Scalars['String'];
  sourceDocument: Scalars['String'];
  subject: Scalars['String'];
  parent: Scalars['String'];
  description: Scalars['String'];
  itemsBack?: Maybe<Array<Scalars['String']>>;
  itemsForward?: Maybe<Array<Scalars['String']>>;
  hasNoKids?: Maybe<Scalars['Boolean']>;
};

export type StandardDeleteInput = {
  standardId: Scalars['String'];
  currentSchoolId: Scalars['String'];
};

export type StandardDeletePayload = {
  __typename?: 'StandardDeletePayload';
  standardId?: Maybe<Scalars['String']>;
  response: Scalars['String'];
  status: Scalars['Boolean'];
};

export type StandardListInput = {
  domainInput?: InputMaybe<Scalars['String']>;
  gradeInput?: InputMaybe<Scalars['String']>;
  standardInput?: InputMaybe<Scalars['String']>;
  currentSchoolId?: InputMaybe<Scalars['String']>;
  isPlatformAdmin?: Scalars['Boolean'];
};

export type StandardListPayload = {
  __typename?: 'StandardListPayload';
  standards: Scalars['String'];
};

export type StandardPayload = {
  __typename?: 'StandardPayload';
  color: Scalars['String'];
  desc: Scalars['String'];
  id: Scalars['Int'];
  xCoordinate: Scalars['Int'];
  yCoordinate: Scalars['Int'];
  standard: Scalars['String'];
};

export type Standards = {
  __typename?: 'Standards';
  description?: Maybe<Scalars['String']>;
  standard?: Maybe<Scalars['String']>;
  standardId: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type StandardsInput = {
  description?: InputMaybe<Scalars['String']>;
  standard: Scalars['String'];
  state: Scalars['String'];
  subject: Scalars['String'];
  currentSchoolId: Scalars['String'];
};

export type StandardsListInput = {
  state: Scalars['String'];
  subject: Scalars['String'];
};

export type StandardsListResponse = {
  __typename?: 'StandardsListResponse';
  data: Array<StandardsPayload>;
  total: Scalars['Int'];
};

export type StandardsPayload = {
  __typename?: 'StandardsPayload';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  response?: Maybe<Scalars['String']>;
  standard: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
};

/** Params for CYU/SS/TY Assignments */
export type StartMnPersonalAssignmentInput = {
  assignmentSource: AssignmentSourceInput;
  assignmentType: MnPersonalAssignmentType;
  devDomain?: InputMaybe<Scalars['String']>;
  signItem: ItemSignRequestInput;
};

export enum StateEnum {
  Al = 'AL',
  Ak = 'AK',
  Az = 'AZ',
  Ar = 'AR',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY',
}

export enum StatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type StatusPayload = {
  __typename?: 'StatusPayload';
  success: Scalars['Boolean'];
};

export type StemscopesAssessmentInput = {
  field: FieldEnum;
  value: Scalars['String'];
  currentSchoolId: Scalars['String'];
};

export type StemscopesAssessmentItemPayload = {
  __typename?: 'StemscopesAssessmentItemPayload';
  isArchived?: Maybe<Scalars['Boolean']>;
  isAssigned?: Maybe<Scalars['Boolean']>;
  isEdited?: Maybe<Scalars['Boolean']>;
  isPrintable?: Maybe<Scalars['Boolean']>;
  isShared?: Maybe<Scalars['Boolean']>;
  activityType: ActivityTypeEnum;
  createdAt: Scalars['String'];
  curriculumArea?: Maybe<Scalars['String']>;
  deliveries: Array<DeliveryEnum>;
  grade?: Maybe<Scalars['String']>;
  hasManuallyGradedQuestions?: Maybe<Scalars['Boolean']>;
  hiddenForSchool: Scalars['Boolean'];
  library?: Maybe<StemscopesLibraryEnum>;
  status: Scalars['String'];
  subPurpose?: Maybe<SubPurposeEnum>;
  teams: Array<Scalars['String']>;
  updatedAt: Scalars['String'];
  usersViewOnlyIds: Array<Scalars['String']>;
  id: Scalars['String'];
  createdBy?: Maybe<UserPayload>;
  title?: Maybe<Scalars['String']>;
  standards: Array<Scalars['String']>;
  items: Array<Scalars['String']>;
};

export type StemscopesAssessmentPackageBoxItemPayload = {
  __typename?: 'StemscopesAssessmentPackageBoxItemPayload';
  assessments: Array<Scalars['String']>;
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type StemscopesAssessmentPackageBoxPayload = {
  __typename?: 'StemscopesAssessmentPackageBoxPayload';
  item?: Maybe<StemscopesAssessmentPackageBoxItemPayload>;
};

export type StemscopesAssessmentPayload = {
  __typename?: 'StemscopesAssessmentPayload';
  item?: Maybe<StemscopesAssessmentItemPayload>;
};

export type StemscopesAssessmentPoolInput = {
  curriculumAreas?: InputMaybe<Array<Scalars['String']>>;
  grades?: InputMaybe<Array<Scalars['String']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  libraries: Array<StemscopesLibraryEnum>;
  sortInput?: InputMaybe<StemscopesAssessmentPoolSortInput>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  currentSchoolId: Scalars['String'];
};

export type StemscopesAssessmentPoolPayload = {
  __typename?: 'StemscopesAssessmentPoolPayload';
  list: Array<StemscopesAssessmentItemPayload>;
  paginationInfo: PaginationInfoPayload;
};

export type StemscopesAssessmentPoolSortInput = {
  curriculumArea?: InputMaybe<SortEnum>;
  grade?: InputMaybe<SortEnum>;
  title?: InputMaybe<SortEnum>;
};

/** StemscopesAssignment Object Type */
export type StemscopesAssignment = {
  __typename?: 'StemscopesAssignment';
  /** @deprecated Has been deprecated, use Types::AssignmentSourceType instead */
  assessmentId?: Maybe<Scalars['String']>;
  assignmentId: Scalars['String'];
  assignmentListId: Scalars['String'];
  assignmentSource: AssignmentSource;
  calculator?: Maybe<Calculator>;
  canBePaused?: Maybe<Scalars['Boolean']>;
  classId: Scalars['String'];
  endDate: Scalars['ISO8601Date'];
  immediatelyShareResults?: Maybe<ImmediatelyShareResults>;
  labels?: Maybe<Array<Scalars['String']>>;
  lateTurnIn?: Maybe<Scalars['Boolean']>;
  learnosityReferenceId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  originLearnosityId?: Maybe<Scalars['String']>;
  ownerId: Scalars['String'];
  releaseFeedback?: Maybe<Scalars['Boolean']>;
  schoolId?: Maybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
  status: AssignmentStatus;
  studentAssignments?: Maybe<Array<StudentAssignment>>;
  studentIds?: Maybe<Array<Scalars['String']>>;
  subgroupIds?: Maybe<Array<Scalars['String']>>;
};

/** Assignment page info input */
export type StemscopesAssignmentPageInfoInput = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type StemscopesCopyAssessmentInput = {
  id: Scalars['ID'];
  currentSchoolId: Scalars['String'];
};

export type StemscopesCreateAssessmentInput = {
  deliveries: Array<DeliveryEnum>;
  isArchived?: Scalars['Boolean'];
  isAssigned?: Scalars['Boolean'];
  isVisible?: Scalars['Boolean'];
  items?: InputMaybe<Array<Scalars['String']>>;
  library: StemscopesLibraryEnum;
  teams?: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type StemscopesCreateAssessmentPackageBoxInput = {
  assessments?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

/** Attributes for creating stemscopes assignment */
export type StemscopesCreateInput = {
  assignmentSource: AssignmentSourceInput;
  calculator?: InputMaybe<CalculatorInput>;
  canBePaused?: InputMaybe<Scalars['Boolean']>;
  classOtherAssignments?: InputMaybe<Array<ClassOtherAssignment>>;
  classes: Array<AssignmentClassInput>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  immediatelyShareResults?: InputMaybe<ImmediatelyShareResults>;
  labels: Array<Scalars['String']>;
  lateTurnIn: Scalars['Boolean'];
  learnosityReferenceId: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  releaseFeedback: Scalars['Boolean'];
  schoolId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type StemscopesDeleteAssessmentInput = {
  id: Scalars['ID'];
  currentSchoolId: Scalars['String'];
};

/** Attributes for editing stemscopes assignment */
export type StemscopesEditInput = {
  assignmentId: Scalars['String'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export enum StemscopesLibraryEnum {
  Individual = 'INDIVIDUAL',
  Team = 'TEAM',
  District = 'DISTRICT',
  Campus = 'CAMPUS',
  Shared = 'SHARED',
  Benchmark = 'BENCHMARK',
}

export type StemscopesMedia = {
  __typename?: 'StemscopesMedia';
  area: StemscopesVideoAreaEnum;
  id: Scalars['String'];
  language: LanguageEnum;
  quality?: Maybe<VideoQualityEnum>;
  title: Scalars['String'];
  type: MediaTypeEnum;
  uniquePackTitle?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  subtitlesSrtFormat: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  status: VideoProcessStatusEnum;
  keywords: Array<ContentKeyword>;
};

export type StemscopesMediaFilterInput = {
  area?: InputMaybe<StemscopesVideoAreaEnum>;
  title?: InputMaybe<Scalars['String']>;
};

export type StemscopesMediaPack = {
  __typename?: 'StemscopesMediaPack';
  area: StemscopesVideoAreaEnum;
  id: Scalars['String'];
  title: Scalars['String'];
  uniqueItemTitles?: Maybe<Array<Scalars['String']>>;
};

export type StemscopesMediaPackFilterInput = {
  area?: InputMaybe<StemscopesVideoAreaEnum>;
  title?: InputMaybe<Scalars['String']>;
};

export type StemscopesMediaPackPageConnection = {
  __typename?: 'StemscopesMediaPackPageConnection';
  collection: Array<StemscopesMediaPack>;
  paginationInfo?: Maybe<StemscopesMediaPackPaginationInfo>;
};

export type StemscopesMediaPackPaginationInfo = {
  __typename?: 'StemscopesMediaPackPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StemscopesMediaPageConnection = {
  __typename?: 'StemscopesMediaPageConnection';
  collection: Array<StemscopesMedia>;
  paginationInfo?: Maybe<StemscopesMediaPaginationInfo>;
};

export type StemscopesMediaPaginationInfo = {
  __typename?: 'StemscopesMediaPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StemscopesMediaPayload = {
  __typename?: 'StemscopesMediaPayload';
  media: StemscopesMedia;
};

export type StemscopesMediaPostObjectPayload = {
  __typename?: 'StemscopesMediaPostObjectPayload';
  subtitlesPostObject?: Maybe<MediaPostObject>;
  videoPostObject: MediaPostObject;
};

export type StemscopesQuestionPoolInput = {
  assessmentId?: InputMaybe<Scalars['String']>;
  curriculumAreas?: InputMaybe<Array<Scalars['String']>>;
  deliveries?: InputMaybe<Array<DeliveryEnum>>;
  editions?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  grades?: InputMaybe<Array<Scalars['String']>>;
  gradingTypes?: InputMaybe<Array<GradingTypeEnum>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  questionBanks?: InputMaybe<Array<QuestionBankEnum>>;
  questionTypes?: InputMaybe<Array<Scalars['String']>>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  standards?: InputMaybe<Array<Scalars['String']>>;
};

export type StemscopesShareAssessmentInput = {
  isViewOnly: Scalars['Boolean'];
  userIds: Array<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  id: Scalars['ID'];
};

export type StemscopesUpdateAssessmentInput = {
  id: Scalars['ID'];
  deliveries: Array<DeliveryEnum>;
  isArchived?: Scalars['Boolean'];
  isAssigned?: Scalars['Boolean'];
  isVisible?: Scalars['Boolean'];
  items?: InputMaybe<Array<Scalars['String']>>;
  library: StemscopesLibraryEnum;
  teams?: Array<Scalars['String']>;
  title: Scalars['String'];
};

export enum StemscopesVideoAreaEnum {
  Science = 'Science',
  Math = 'Math',
}

export type Streaming = {
  __typename?: 'Streaming';
  contentGroups?: Maybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  coverImage: Scalars['String'];
  curriculumArea?: Maybe<Scalars['String']>;
  grades?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  metadata: Scalars['JSON'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  studentView?: Maybe<Scalars['JSON']>;
  tags?: Maybe<Array<Scalars['String']>>;
  teacherView?: Maybe<Scalars['JSON']>;
  topic?: Maybe<Scalars['String']>;
};

export type StreamingContentTypes = {
  __typename?: 'StreamingContentTypes';
  contentTypes?: Maybe<Array<Scalars['String']>>;
};

export type StreamingCurriculumAreas = {
  __typename?: 'StreamingCurriculumAreas';
  curriculumAreas?: Maybe<Array<Scalars['String']>>;
};

export type StreamingFilter = {
  contentTypes?: InputMaybe<Array<Scalars['String']>>;
  topics?: InputMaybe<Array<Scalars['String']>>;
  curriculumAreas?: InputMaybe<Array<Scalars['String']>>;
  grades?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type StreamingGrades = {
  __typename?: 'StreamingGrades';
  grades?: Maybe<Array<Scalars['String']>>;
};

export type Streamings = {
  __typename?: 'Streamings';
  collection?: Maybe<Array<Streaming>>;
  pageInfo?: Maybe<PageInfo>;
};

export type StreamingTags = {
  __typename?: 'StreamingTags';
  tags?: Maybe<Array<Scalars['String']>>;
};

export type StreamingTopics = {
  __typename?: 'StreamingTopics';
  topics?: Maybe<Array<Scalars['String']>>;
};

export type StreamingVideo = {
  __typename?: 'StreamingVideo';
  date?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  language: LanguageEnum;
  quality?: Maybe<VideoQualityEnum>;
  title: Scalars['String'];
  type: MediaTypeEnum;
  url: Scalars['String'];
  active: Scalars['Boolean'];
  keywords: Array<ContentKeyword>;
};

export type StreamingVideoFilterInput = {
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type StreamingVideoPageConnection = {
  __typename?: 'StreamingVideoPageConnection';
  collection: Array<StreamingVideo>;
  paginationInfo?: Maybe<StreamingVideoPaginationInfo>;
};

export type StreamingVideoPaginationInfo = {
  __typename?: 'StreamingVideoPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StreamingVideoPayload = {
  __typename?: 'StreamingVideoPayload';
  video: StreamingVideo;
};

export type StringPageConnection = {
  __typename?: 'StringPageConnection';
  collection: Array<Scalars['String']>;
  paginationInfo?: Maybe<StringPaginationInfo>;
};

export type StringPaginationInfo = {
  __typename?: 'StringPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Student = Node & {
  __typename?: 'Student';
  id: Scalars['ID'];
  _id: Scalars['String'];
  classStudents?: Maybe<ClassStudentPageConnection>;
  schools?: Maybe<StudentSchoolPageConnection>;
  subgroups: StudentSubgroupPageConnection;
  classes?: Maybe<ClassPageConnection>;
  active: Scalars['Boolean'];
  authenticationToken?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUsername?: Maybe<Scalars['String']>;
  curriculumAreas?: Maybe<Scalars['Iterable']>;
  district?: Maybe<District>;
  /** @deprecated Used from Session User */
  districtUuid: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSystemName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<GradeLevelEnum>;
  importId?: Maybe<Scalars['String']>;
  inactivityReason?: Maybe<UserInactivityReasonEnum>;
  language: LanguageEnum;
  lastName?: Maybe<Scalars['String']>;
  lmsId?: Maybe<Scalars['String']>;
  manualMaintenance?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  plainPassword?: Maybe<Scalars['String']>;
  preferences?: Maybe<Scalars['String']>;
  purpose?: Maybe<UserPurposeEnum>;
  sisId?: Maybe<Scalars['String']>;
  staffId?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
  type: UserTypeEnum;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByUsername?: Maybe<Scalars['String']>;
  userRoles?: Maybe<UserRolePageConnection>;
  username: Scalars['String'];
};

export type StudentClassStudentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type StudentSchoolsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type StudentSubgroupsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type StudentClassesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<ClassFilter>>>;
};

export type StudentUserRolesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

/** Student Assignment Object Type */
export type StudentAssignment = {
  __typename?: 'StudentAssignment';
  activityTemplateId?: Maybe<Scalars['String']>;
  answers?: Maybe<Scalars['JSON']>;
  archived?: Maybe<Scalars['Boolean']>;
  assessmentId?: Maybe<Scalars['String']>;
  assignmentId: Scalars['String'];
  assignmentSource?: Maybe<AssignmentSource>;
  classId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  endDate?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lateTurnIn: Scalars['Boolean'];
  learnosityReferenceId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  originLearnosityId?: Maybe<Scalars['String']>;
  otherAssignmentScope?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  quantileScore?: Maybe<Scalars['String']>;
  randomizeQuestionsOrder?: Maybe<Scalars['Boolean']>;
  releaseFeedback: Scalars['Boolean'];
  reopenedAt?: Maybe<Scalars['ISO8601DateTime']>;
  resetted?: Maybe<Scalars['Boolean']>;
  returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
  sessionId?: Maybe<Scalars['String']>;
  shareResults?: Maybe<ShareResults>;
  startDate?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: StudentAssignmentStatus;
  studentId: Scalars['String'];
  studentNotes?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type StudentAssignmentIdUpdatePayload = {
  __typename?: 'StudentAssignmentIdUpdatePayload';
  status: Scalars['String'];
};

export type StudentAssignmentMock = {
  __typename?: 'StudentAssignmentMock';
  assignmentId: Scalars['String'];
  name: Scalars['String'];
  completedAt: Scalars['ISO8601DateTime'];
  grade: Scalars['Int'];
  startedAt: Scalars['ISO8601DateTime'];
  status: StudentAssignmentStatusEnumMock;
  submittedAt: Scalars['ISO8601DateTime'];
  endDate: Scalars['ISO8601DateTime'];
  startDate: Scalars['ISO8601DateTime'];
  saId: Scalars['String'];
};

export type StudentAssignmentMockPageConnection = {
  __typename?: 'StudentAssignmentMockPageConnection';
  collection: Array<StudentAssignmentMock>;
  paginationInfo?: Maybe<StudentAssignmentMockPaginationInfo>;
};

export type StudentAssignmentMockPaginationInfo = {
  __typename?: 'StudentAssignmentMockPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StudentAssignmentPayload = {
  __typename?: 'StudentAssignmentPayload';
  assignment_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  gdst?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Student Assignments collection object Type */
export type StudentAssignments = {
  __typename?: 'StudentAssignments';
  collection?: Maybe<Array<StudentAssignment>>;
  pageInfo?: Maybe<PageInfo>;
};

export type StudentAssignmentsFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  assignmentId?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['String']>;
  otherAssignment?: InputMaybe<Scalars['Boolean']>;
  otherAssignmentScope?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StudentAssignmentStatus>;
  studentId?: InputMaybe<Scalars['String']>;
  studentShareResults?: InputMaybe<Scalars['Boolean']>;
};

export enum StudentAssignmentStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Started = 'STARTED',
  Submitted = 'SUBMITTED',
}

export enum StudentAssignmentStatusEnumMock {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Started = 'STARTED',
}

export type StudentAssignmentStatusPayload = {
  __typename?: 'StudentAssignmentStatusPayload';
  status: Scalars['String'];
};

export type StudentCertificateInput = {
  studentId?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type StudentCertificatePayload = {
  __typename?: 'StudentCertificatePayload';
  path?: Maybe<Scalars['String']>;
};

export type StudentCompletedTopicPayload = {
  __typename?: 'StudentCompletedTopicPayload';
  assignmentId: Scalars['String'];
  domainName: Scalars['String'];
  domainNo: Scalars['String'];
  gdst: Scalars['String'];
  status: Scalars['String'];
  topic: Scalars['String'];
};

export type StudentFilter_Order = {
  className?: InputMaybe<SortEnum>;
  fullName?: InputMaybe<SortEnum>;
  firstName?: InputMaybe<SortEnum>;
  lastName?: InputMaybe<SortEnum>;
};

/** Student Notebook Object Type */
export type StudentNotebook = {
  __typename?: 'StudentNotebook';
  classId: Scalars['String'];
  scopeIds?: Maybe<Array<Scalars['String']>>;
};

/** Student Notebooks collection Object Type */
export type StudentNotebooks = {
  __typename?: 'StudentNotebooks';
  collection?: Maybe<Array<StudentNotebook>>;
  pageInfo?: Maybe<PageInfo>;
};

export type StudentPageConnection = {
  __typename?: 'StudentPageConnection';
  collection?: Maybe<Array<Maybe<Student>>>;
  paginationInfo: StudentPaginationInfo;
};

export type StudentPaginationInfo = {
  __typename?: 'StudentPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type StudentPayload = {
  __typename?: 'StudentPayload';
  itemReferenceIds: Array<Scalars['String']>;
  learnosityActivityId: Scalars['String'];
  learnosityAssignmentId: Scalars['String'];
  sessionId: Scalars['String'];
  studentCompletedTopics: Array<StudentCompletedTopicPayload>;
  studentProgress: Array<StudentProgressPayload>;
  continueNextGrade: Scalars['Boolean'];
  isRedirect: Scalars['Boolean'];
  assessmentCount?: Maybe<Scalars['Int']>;
  startupCompleteDate?: Maybe<Scalars['String']>;
  startupIsReview: Scalars['Boolean'];
  startupStatus?: Maybe<Scalars['String']>;
  studentPathwayCount: Scalars['Int'];
};

export type StudentProgressPayload = {
  __typename?: 'StudentProgressPayload';
  code: Scalars['String'];
  domain: Scalars['String'];
  topic: Scalars['String'];
};

/** StudentResource Object Type */
export type StudentResource = {
  __typename?: 'StudentResource';
  classId?: Maybe<Scalars['String']>;
  learnosityReferenceId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  originLearnosityId?: Maybe<Scalars['String']>;
  ownerId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceSource?: Maybe<ResourceSource>;
  schoolId?: Maybe<Scalars['String']>;
  srGrade?: Maybe<Scalars['String']>;
  srId: Scalars['String'];
  srStatus: StudentResourceStatus;
  studentId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** StudentResources Object Type */
export type StudentResources = {
  __typename?: 'StudentResources';
  collection?: Maybe<Array<StudentResource>>;
  defaultElements?: Maybe<Array<DefaultElement>>;
  pageInfo?: Maybe<PageInfo>;
};

export type StudentResourcesFilter = {
  classId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
};

/** Params to save student resources filter */
export type StudentResourcesFilterInput = {
  gradeLevelsByGrade?: InputMaybe<GradeLevelsByGradeInput>;
  individual?: InputMaybe<Scalars['Boolean']>;
};

/** Student resources filter object */
export type StudentResourcesSettings = {
  __typename?: 'StudentResourcesSettings';
  gradeLevelsByGrade?: Maybe<GradeLevelsByGrade>;
  individual?: Maybe<Scalars['Boolean']>;
  schoolId?: Maybe<Scalars['String']>;
};

export enum StudentResourceStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Started = 'STARTED',
}

export type StudentResponsePayload = {
  __typename?: 'StudentResponsePayload';
  response: Scalars['String'];
  status: Scalars['String'];
};

export type StudentSchool = {
  __typename?: 'StudentSchool';
  schoolId: Scalars['String'];
  student: Student;
};

export type StudentSchoolPageConnection = {
  __typename?: 'StudentSchoolPageConnection';
  collection?: Maybe<Array<Maybe<StudentSchool>>>;
  paginationInfo: StudentSchoolPaginationInfo;
};

export type StudentSchoolPaginationInfo = {
  __typename?: 'StudentSchoolPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Student resources filters collection */
export type StudentsResourcesSettings = {
  __typename?: 'StudentsResourcesSettings';
  collection?: Maybe<Array<StudentResourcesSettings>>;
};

export type StudentSubgroup = {
  __typename?: 'StudentSubgroup';
  id: Scalars['ID'];
  _id: Scalars['String'];
  name: Scalars['String'];
  students?: Maybe<StudentPageConnection>;
  teachers?: Maybe<TeacherPageConnection>;
};

export type StudentSubgroupStudentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type StudentSubgroupTeachersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type StudentSubgroupPageConnection = {
  __typename?: 'StudentSubgroupPageConnection';
  collection?: Maybe<Array<Maybe<StudentSubgroup>>>;
  paginationInfo: StudentSubgroupPaginationInfo;
};

export type StudentSubgroupPaginationInfo = {
  __typename?: 'StudentSubgroupPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type SubjectPayload = {
  __typename?: 'SubjectPayload';
  id: Scalars['String'];
};

export enum SubPurposeEnum {
  StemscopesMath = 'STEMSCOPES_MATH',
  StemscopesScience = 'STEMSCOPES_SCIENCE',
}

export type Subscription = {
  __typename?: 'Subscription';
  id: Scalars['ID'];
  products: Array<Product>;
  dateStart: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
  quantity: Scalars['Int'];
};

export type SubscriptionPackage = {
  __typename?: 'SubscriptionPackage';
  id: Scalars['ID'];
  /** Use only for merging data! */
  _id: Scalars['ID'];
  schools: Array<School>;
  scope: SubscriptionScopeEnum;
  subscriptions: Array<Subscription>;
};

export type SubscriptionPackageFilterInput = {
  districtId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  schoolIds?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<Scalars['String']>;
};

export type SubscriptionPackagePageConnection = {
  __typename?: 'SubscriptionPackagePageConnection';
  collection: Array<SubscriptionPackage>;
  paginationInfo?: Maybe<SubscriptionPackagePaginationInfo>;
};

export type SubscriptionPackagePaginationInfo = {
  __typename?: 'SubscriptionPackagePaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SubscriptionPackagePayload = {
  __typename?: 'SubscriptionPackagePayload';
  subscriptionPackage: SubscriptionPackage;
};

export type SubscriptionPageConnection = {
  __typename?: 'SubscriptionPageConnection';
  collection: Array<Subscription>;
  paginationInfo?: Maybe<SubscriptionPaginationInfo>;
};

export type SubscriptionPaginationInfo = {
  __typename?: 'SubscriptionPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  subscription: Subscription;
};

export enum SubscriptionScopeEnum {
  School = 'School',
  District = 'District',
}

/** Success Object Type */
export type Success = {
  __typename?: 'Success';
  success?: Maybe<Scalars['Boolean']>;
};

export type SuccessPayload = {
  __typename?: 'SuccessPayload';
  isSuccess: Scalars['Boolean'];
};

export type SystemAdmin = {
  __typename?: 'SystemAdmin';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type SystemAdminPageConnection = {
  __typename?: 'SystemAdminPageConnection';
  collection: Array<SystemAdmin>;
  paginationInfo?: Maybe<SystemAdminPaginationInfo>;
};

export type SystemAdminPaginationInfo = {
  __typename?: 'SystemAdminPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TagPayload = {
  __typename?: 'TagPayload';
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum TccConsumerEnum {
  Canvas = 'CANVAS',
  Infinitecampus = 'INFINITECAMPUS',
  Itslearning = 'ITSLEARNING',
  Safarimontage = 'SAFARIMONTAGE',
  Schoology = 'SCHOOLOGY',
}

export type TccPackage = {
  __typename?: 'TccPackage';
  bucketName?: Maybe<Scalars['String']>;
  consumer?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  contentItems?: Maybe<Array<Scalars['String']>>;
  districtId?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

export type TccPackages = {
  __typename?: 'TccPackages';
  collection: Array<TccPackage>;
  packageInfo: Scalars['String'];
};

export type TccPackagesCount = {
  __typename?: 'TccPackagesCount';
  collection: Array<Scalars['JSON']>;
};

export enum TccVersionEnum {
  Version_11 = 'VERSION_11',
  Version_12 = 'VERSION_12',
  Version_13 = 'VERSION_13',
}

export type Teacher = Node & {
  __typename?: 'Teacher';
  id: Scalars['ID'];
  _id: Scalars['String'];
  orderListStudents?: Maybe<Scalars['String']>;
  classStudents?: Maybe<ClassTeacherPageConnection>;
  schools?: Maybe<TeacherSchoolPageConnection>;
  subgroups?: Maybe<StudentSubgroupPageConnection>;
  active: Scalars['Boolean'];
  authenticationToken?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUsername?: Maybe<Scalars['String']>;
  curriculumAreas?: Maybe<Scalars['Iterable']>;
  district?: Maybe<District>;
  /** @deprecated Used from Session User */
  districtUuid: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSystemName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<GradeLevelEnum>;
  importId?: Maybe<Scalars['String']>;
  inactivityReason?: Maybe<UserInactivityReasonEnum>;
  language: LanguageEnum;
  lastName?: Maybe<Scalars['String']>;
  lmsId?: Maybe<Scalars['String']>;
  manualMaintenance?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  plainPassword?: Maybe<Scalars['String']>;
  preferences?: Maybe<Scalars['String']>;
  purpose?: Maybe<UserPurposeEnum>;
  sisId?: Maybe<Scalars['String']>;
  staffId?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
  type: UserTypeEnum;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByUsername?: Maybe<Scalars['String']>;
  userRoles?: Maybe<UserRolePageConnection>;
  username: Scalars['String'];
};

export type TeacherClassStudentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type TeacherSchoolsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type TeacherSubgroupsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type TeacherUserRolesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type TeacherAssignmentInput = {
  class: Scalars['String'];
  students: Array<Scalars['String']>;
  topicIds: Array<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type TeacherAssignmentListInput = {
  /** The list of ordering criteria. */
  orderBy: Array<OrderByInput>;
  /** The number of items per page. */
  pageCount: Scalars['Int'];
  /** The page number. */
  pageNo: Scalars['Int'];
  /** The list of student IDs. */
  students: Array<Scalars['String']>;
  currentSchoolId: Scalars['String'];
};

export type TeacherAssignmentListPayload = {
  __typename?: 'TeacherAssignmentListPayload';
  data: Array<AssignmentDataPayload>;
  total: Scalars['Int'];
};

export type TeacherAssignmentPayload = {
  __typename?: 'TeacherAssignmentPayload';
  response: Scalars['String'];
};

/** Attributes for creating teacher assignments */
export type TeacherAssignmentsCreateInput = {
  assignmentSource: AssignmentSourceInput;
  calculator?: InputMaybe<CalculatorInput>;
  canBePaused?: InputMaybe<Scalars['Boolean']>;
  classes: Array<AssignmentClassInput>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  immediatelyShareResults?: InputMaybe<ImmediatelyShareResults>;
  labels: Array<Scalars['String']>;
  lateTurnIn: Scalars['Boolean'];
  learnosityReferenceId: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  randomizeQuestionsOrder?: InputMaybe<Scalars['Boolean']>;
  releaseFeedback: Scalars['Boolean'];
  schoolId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type TeacherDistrictAssignmentsFilter = {
  classId?: InputMaybe<Scalars['String']>;
  /** Provide active classes here */
  classIds?: InputMaybe<Array<Scalars['String']>>;
  daId?: InputMaybe<Scalars['String']>;
  schoolId: Scalars['String'];
};

export type TeacherFeedback = {
  __typename?: 'TeacherFeedback';
  responseFeedbacks?: Maybe<Array<ResponseFeedback>>;
  sessionId: Scalars['String'];
  teacherId: Scalars['String'];
};

export type TeacherFilter = {
  schoolId?: InputMaybe<Scalars['String']>;
};

export type TeacherPageConnection = {
  __typename?: 'TeacherPageConnection';
  collection?: Maybe<Array<Maybe<Teacher>>>;
  paginationInfo: TeacherPaginationInfo;
};

export type TeacherPaginationInfo = {
  __typename?: 'TeacherPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type TeacherResource = {
  __typename?: 'TeacherResource';
  active: Scalars['Boolean'];
  contentGroups: Array<Scalars['String']>;
  contentLocation: Scalars['String'];
  created: Scalars['String'];
  displayName: Scalars['String'];
  editionName: Scalars['String'];
  elementTitles: Array<Scalars['String']>;
  id: Scalars['String'];
  internalName: Scalars['String'];
  lastUpdated: Scalars['String'];
  metadata: Scalars['JSON'];
  positionNumber: Scalars['Int'];
  projectId: Scalars['String'];
  projectType: Scalars['String'];
  sectionTitles: Array<Scalars['JSON']>;
  sections: Array<Scalars['JSON']>;
  state: Scalars['String'];
  version: Scalars['Int'];
};

export type TeacherResources = {
  __typename?: 'TeacherResources';
  collection?: Maybe<Array<SearchableTeacherResource>>;
  pageInfo?: Maybe<PageInfo>;
};

export type TeacherSchool = {
  __typename?: 'TeacherSchool';
  schoolId: Scalars['String'];
  teacher: Teacher;
};

export type TeacherSchoolPageConnection = {
  __typename?: 'TeacherSchoolPageConnection';
  collection?: Maybe<Array<Maybe<TeacherSchool>>>;
  paginationInfo: TeacherSchoolPaginationInfo;
};

export type TeacherSchoolPaginationInfo = {
  __typename?: 'TeacherSchoolPaginationInfo';
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type TeacherStudentFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  classIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullName?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  studentHasArchivedClasses?: InputMaybe<Scalars['Boolean']>;
  teachersId?: InputMaybe<Scalars['String']>;
};

export type Team = {
  __typename?: 'Team';
  archived: Scalars['Boolean'];
  context: TeamContextEnum;
  district?: Maybe<District>;
  id: Scalars['ID'];
  members: Array<User>;
  name: Scalars['String'];
  /** @deprecated Use creator */
  owner: User;
  creator: User;
  state?: Maybe<StateEnum>;
};

export enum TeamContextEnum {
  Calendar = 'calendar',
  StemscopesAssessment = 'stemscopesAssessment',
}

export type TeamPageConnection = {
  __typename?: 'TeamPageConnection';
  collection: Array<Team>;
  paginationInfo?: Maybe<TeamPaginationInfo>;
};

export type TeamPaginationInfo = {
  __typename?: 'TeamPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TeamPayload = {
  __typename?: 'TeamPayload';
  team: Team;
};

/** ToggleVerifySchoolAges a WallAgeControl. */
export type ToggleVerifySchoolAgeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  isVerified: Scalars['Boolean'];
  schoolId: Scalars['String'];
};

/** ToggleVerifySchoolAges a WallAgeControl. */
export type ToggleVerifySchoolAgePayload = {
  __typename?: 'toggleVerifySchoolAgePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  wallAgeControl?: Maybe<WallAgeControl>;
};

/** Toggles a WallPostLike. */
export type ToggleWallPostLikeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  wallPostId: Scalars['String'];
};

/** Toggles a WallPostLike. */
export type ToggleWallPostLikePayload = {
  __typename?: 'toggleWallPostLikePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  wallPostLike?: Maybe<WallPostLike>;
};

export type ToMoveVideoInput = {
  groupIdentifier: Scalars['String'];
  tutorId?: InputMaybe<Scalars['String']>;
  videoIndex?: InputMaybe<Scalars['String']>;
};

export type Topics = {
  __typename?: 'Topics';
  topics: Array<Scalars['String']>;
};

export type TopicsPayload = {
  __typename?: 'TopicsPayload';
  topicNumber: Scalars['String'];
  topicName: Scalars['String'];
  status: Scalars['String'];
};

export enum TranslationService {
  AwsTranslate = 'AwsTranslate',
  GoogleGemini = 'GoogleGemini',
}

export type Tutor = {
  __typename?: 'Tutor';
  bioText: Scalars['String'];
  bioVideo: Scalars['String'];
  depthScale: Scalars['Int'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  initialTag: LanguageTagEnum;
  languageTag: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  mainProfilePhoto: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  profilePhoto: Scalars['String'];
  videos: VideoPageConnection;
};

export type TutorVideosArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type TutorFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type TutorPageConnection = {
  __typename?: 'TutorPageConnection';
  collection: Array<Tutor>;
  paginationInfo?: Maybe<TutorPaginationInfo>;
};

export type TutorPaginationInfo = {
  __typename?: 'TutorPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TutorPayload = {
  __typename?: 'TutorPayload';
  tutor: Tutor;
};

export enum TypeEnum {
  /** Item Type */
  Items = 'items',
  /** Activity Type */
  Activities = 'activities',
}

export type TyQuestionContainerInput = {
  category: Scalars['String'];
  grade: Scalars['String'];
  unit: Scalars['String'];
};

/** Object of Post Input Request Type */
export type UnfilteredInputPostRequest = {
  /** Text to search posts by content, firstname or lastname */
  comment?: InputMaybe<Scalars['String']>;
  /** ID of selected school */
  currentSchoolId: Scalars['String'];
  /** Id of post */
  id?: InputMaybe<Scalars['String']>;
  /** Get hidden / unhidden posts */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** Offset */
  offset?: InputMaybe<Scalars['Int']>;
  /** Size */
  size?: InputMaybe<Scalars['Int']>;
  /** User Id of post author */
  userId?: InputMaybe<Scalars['String']>;
  /** Array of Wall Ids */
  wallIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UnionVideoPdf = Video | Pdf;

export type UnionVideoPdfPageConnection = {
  __typename?: 'UnionVideoPdfPageConnection';
  collection: Array<UnionVideoPdf>;
  paginationInfo?: Maybe<UnionVideoPdfPaginationInfo>;
};

export type UnionVideoPdfPaginationInfo = {
  __typename?: 'UnionVideoPdfPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UnitPayload = {
  __typename?: 'UnitPayload';
  unitNo: Scalars['String'];
  unitName: Scalars['String'];
  lessons: Array<LessonPayload>;
};

/** Updates a AcademicPeriod. */
export type UpdateAcademicPeriodInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  eoyConfig?: InputMaybe<EoyConfigNestedInput>;
  eoyPeriod?: InputMaybe<DatePeriodNestedInput>;
  id: Scalars['ID'];
  schoolYear?: InputMaybe<DatePeriodNestedInput>;
};

/** Updates a AcademicPeriod. */
export type UpdateAcademicPeriodPayload = {
  __typename?: 'updateAcademicPeriodPayload';
  academicPeriod?: Maybe<AcademicPeriod>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateAccessPolicyInput = {
  applications?: InputMaybe<Array<ApplicationInput>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<ScopedPermissionInput>>;
};

export type UpdateAdoptionAccountInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  communityAccess?: InputMaybe<UpdateCommunityAccessInput>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateEnum>;
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateAdoptionEventInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<AdoptionEventCategoryEnum>;
  gradeAndActivities?: InputMaybe<
    Array<InputMaybe<AdoptionEventGradeAndActivityInput>>
  >;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  uiCustomization?: InputMaybe<Scalars['String']>;
  urlCode?: InputMaybe<Scalars['String']>;
  productGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateAdoptionReviewerInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  multiSession?: InputMaybe<Scalars['Boolean']>;
  plainPassword?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdoptionReviewerTypeEnum>;
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateAssessmentInput = {
  edgexlInput?: InputMaybe<EdgexlUpdateAssessmentInput>;
  platformAdminInput?: InputMaybe<PlatformAdminUpdateAssessmentInput>;
  stemscopesInput?: InputMaybe<StemscopesUpdateAssessmentInput>;
};

/** Updates a Calendar. */
export type UpdateCalendarInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstDayOfSchool?: InputMaybe<Scalars['Iterable']>;
  gradingPeriods?: InputMaybe<Scalars['Iterable']>;
  holidays?: InputMaybe<Scalars['Iterable']>;
  id: Scalars['String'];
  lastDayOfSchool?: InputMaybe<Scalars['Iterable']>;
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Updates a Calendar. */
export type UpdateCalendarPayload = {
  __typename?: 'updateCalendarPayload';
  calendar?: Maybe<Calendar>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateClassInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  classTeachers?: InputMaybe<Array<InputMaybe<UpdateClassTeacherNestedInput>>>;
  curriculumArea?: InputMaybe<CurriculumAreaEnum>;
  gradeOrCourse?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  lmsId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatusEnum>;
  subgroups?: InputMaybe<Array<InputMaybe<UpdateStudentSubgroupNestedInput>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateClassPayload = {
  __typename?: 'updateClassPayload';
  class?: Maybe<Class>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateClassTeacherNestedInput = {
  _id?: InputMaybe<Scalars['String']>;
  accesses?: InputMaybe<Array<InputMaybe<AccessesEnum>>>;
  id?: InputMaybe<Scalars['ID']>;
  mainTeacher?: InputMaybe<Scalars['Boolean']>;
  orderListStudents?: InputMaybe<Scalars['String']>;
  subgroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateCommunityAccessInput = {
  accessToAnswerKeys?: InputMaybe<Scalars['Boolean']>;
  accessToStudentContent?: InputMaybe<Scalars['Boolean']>;
  accessToTeacherContent?: InputMaybe<Scalars['Boolean']>;
  accessToTests?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  beginDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateContentGroupInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  contents?: InputMaybe<Array<ContentIdInput>>;
  id: Scalars['ID'];
};

export type UpdateContentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type UpdateContentKeywordInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateContentTagInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateContentTagValueInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Updates a District. */
export type UpdateDistrictInput = {
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<Scalars['String']>;
  globalName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  localName?: InputMaybe<Scalars['String']>;
  mathNationId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateEnum>;
};

/** Updates a District. */
export type UpdateDistrictPayload = {
  __typename?: 'updateDistrictPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
};

/** Updates a DistrictSettingsLessonPlanner. */
export type UpdateDistrictSettingsLessonPlannerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teacherCanUseAiAssistedLessonPlan?: InputMaybe<Scalars['Boolean']>;
};

/** Updates a DistrictSettingsLessonPlanner. */
export type UpdateDistrictSettingsLessonPlannerPayload = {
  __typename?: 'updateDistrictSettingsLessonPlannerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  districtSettingsLessonPlanner?: Maybe<UpdateDistrictSettingsLessonPlannerPayloadData>;
};

/** Updates a DistrictSettingsLessonPlanner. */
export type UpdateDistrictSettingsLessonPlannerPayloadData = Node & {
  __typename?: 'updateDistrictSettingsLessonPlannerPayloadData';
  id: Scalars['ID'];
  teacherCanUseAiAssistedLessonPlan?: Maybe<Scalars['Boolean']>;
};

export type UpdateDistrictSettingsRosterInput = {
  teacherCanAddAdditionalTeacher?: InputMaybe<Scalars['Boolean']>;
  teacherCanCreateClasses?: InputMaybe<Scalars['Boolean']>;
  teacherCanEditClassRoster?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateDistrictSettingsRosterPayload = {
  __typename?: 'updateDistrictSettingsRosterPayload';
  districtSettingsRoster?: Maybe<DistrictSettingsRoster>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Updates a DistrictSettingsUserManagement. */
export type UpdateDistrictSettingsUserManagementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teacherCanCreateStudents?: InputMaybe<Scalars['Boolean']>;
  teacherCanEditStudentPassword?: InputMaybe<Scalars['Boolean']>;
  teacherCanImpersonateStudents?: InputMaybe<Scalars['Boolean']>;
};

/** Updates a DistrictSettingsUserManagement. */
export type UpdateDistrictSettingsUserManagementPayload = {
  __typename?: 'updateDistrictSettingsUserManagementPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  districtSettingsUserManagement?: Maybe<UpdateDistrictSettingsUserManagementPayloadData>;
};

/** Updates a DistrictSettingsUserManagement. */
export type UpdateDistrictSettingsUserManagementPayloadData = Node & {
  __typename?: 'updateDistrictSettingsUserManagementPayloadData';
  id: Scalars['ID'];
  teacherCanCreateStudents?: Maybe<Scalars['Boolean']>;
  teacherCanEditStudentPassword?: Maybe<Scalars['Boolean']>;
  teacherCanImpersonateStudents?: Maybe<Scalars['Boolean']>;
};

export type UpdateEmailTemplateInput = {
  attachments?: InputMaybe<Array<InputMaybe<EmailTemplateAttachmentInput>>>;
  body?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EmailTemplateTypeEnum>;
};

/** Updates a Entry. */
export type UpdateEntryInput = {
  calendarId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  startDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EntryTypeEnum>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Updates a Entry. */
export type UpdateEntryPayload = {
  __typename?: 'updateEntryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
};

export type UpdateImageCategoryInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
};

export type UpdateImageFileInput = {
  id?: InputMaybe<Scalars['ID']>;
  originalFileName: Scalars['String'];
  path: Scalars['String'];
};

export type UpdateImageInput = {
  altText?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  files: Array<UpdateImageFileInput>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  tagAssociations?: InputMaybe<Array<ImageTagAssociationInput>>;
  contentTagValueIds?: InputMaybe<Array<Scalars['ID']>>;
  contentKeywordIds?: InputMaybe<Array<Scalars['ID']>>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateImageKeywordInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateImageTagInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateImageTagValueInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateMathInActionInput = {
  category?: InputMaybe<CategoryEnum>;
  course?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<SectionEnum>;
  actionNumber?: InputMaybe<Scalars['String']>;
  subjectName?: InputMaybe<Scalars['String']>;
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMathInActionPayload = {
  __typename?: 'UpdateMathInActionPayload';
  status: Scalars['String'];
};

/** Updates a PacingGuide. */
export type UpdatePacingGuideInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  selectedCalendar?: InputMaybe<Scalars['Iterable']>;
  startDate?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Updates a PacingGuide. */
export type UpdatePacingGuidePayload = {
  __typename?: 'updatePacingGuidePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pacingGuide?: Maybe<PacingGuide>;
};

/** Updates a PacingGuideScope. */
export type UpdatePacingGuideScopeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pacingGuideId: Scalars['String'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  scopes: Scalars['Iterable'];
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Updates a PacingGuideScope. */
export type UpdatePacingGuideScopePayload = {
  __typename?: 'updatePacingGuideScopePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pacingGuideScope?: Maybe<PacingGuideScope>;
};

/** Updates a Post. */
export type UpdatePostInput = {
  answer?: InputMaybe<Scalars['Int']>;
  blocked?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  currentSchoolId: Scalars['String'];
  documentKey?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isSticky?: InputMaybe<Scalars['Int']>;
  stared?: InputMaybe<Scalars['Int']>;
  welcome?: InputMaybe<Scalars['Int']>;
};

/** Updates a Post. */
export type UpdatePostPayload = {
  __typename?: 'updatePostPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
};

export type UpdatePreviewAccountInput = {
  accountExecutiveFirstName?: InputMaybe<Scalars['String']>;
  accountExecutiveLastName?: InputMaybe<Scalars['String']>;
  activityPeriodEnd?: InputMaybe<Scalars['DateTime']>;
  activityPeriodStart?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  opportunity?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateEnum>;
  productGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdatePreviewAccountTeacherInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  plainPassword?: InputMaybe<Scalars['String']>;
};

export type UpdateProductGroupInput = {
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateProductInput = {
  contentGroups?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  productType?: InputMaybe<ProductTypeEnum>;
  scopeGroups?: InputMaybe<Array<Scalars['ID']>>;
  sku?: InputMaybe<Scalars['String']>;
};

export type UpdateQuestionInput = {
  platformAdminInput?: InputMaybe<PlatformAdminUpdateQuestionInput>;
};

export type UpdateReaderLibraryInput = {
  description?: InputMaybe<Scalars['String']>;
  enPdfFile?: InputMaybe<Scalars['Upload']>;
  esPdfFile?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
  tagValueIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Array<Scalars['String']>>;
};

/** Updates a School. */
export type UpdateSchoolInput = {
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<Scalars['String']>;
  globalName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  localName?: InputMaybe<Scalars['String']>;
  mathNationId?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
};

/** Updates a School. */
export type UpdateSchoolPayload = {
  __typename?: 'updateSchoolPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  school?: Maybe<School>;
};

/** Updates a ScopePlan. */
export type UpdateScopePlanInput = {
  approachType?: InputMaybe<ScopePlanApproachEnum>;
  classSize?: InputMaybe<Scalars['Int']>;
  classTime?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  scopes?: InputMaybe<Scalars['Iterable']>;
  scopesText?: InputMaybe<Scalars['String']>;
  teacherExp?: InputMaybe<Scalars['Int']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Updates a ScopePlan. */
export type UpdateScopePlanPayload = {
  __typename?: 'updateScopePlanPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  scopePlan?: Maybe<ScopePlan>;
};

/** Updates a ScopePlanScope. */
export type UpdateScopePlanScopeInput = {
  action: ScopePlanScopeElementActionTypeEnum;
  clientMutationId?: InputMaybe<Scalars['String']>;
  elements: Scalars['Iterable'];
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  scopeId: Scalars['String'];
  scopePlanId: Scalars['String'];
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version: Scalars['Int'];
};

/** Updates a ScopePlanScope. */
export type UpdateScopePlanScopePayload = {
  __typename?: 'updateScopePlanScopePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  scopePlanScope?: Maybe<ScopePlanScope>;
};

export type UpdateStandardTagsInput = {
  lessonNumber?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  standard?: InputMaybe<Array<Scalars['String']>>;
  tag?: InputMaybe<Array<Scalars['String']>>;
  unitNumber?: InputMaybe<Scalars['String']>;
  mnIdentifier?: InputMaybe<Scalars['String']>;
};

export type UpdateStandardTagsPayload = {
  __typename?: 'UpdateStandardTagsPayload';
  status: Scalars['String'];
};

export type UpdateStemscopesMediaInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  subtitlesSrtFormat?: InputMaybe<Scalars['Boolean']>;
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateStemscopesMediaPackInput = {
  id: Scalars['ID'];
  items: Array<UpdateStemscopesMediaInput>;
};

export type UpdateStemscopesMediaPackPayload = {
  __typename?: 'UpdateStemscopesMediaPackPayload';
  pack: StemscopesMediaPack;
  items: Array<StemscopesMediaPostObjectPayload>;
};

export type UpdateStreamingVideoInput = {
  active?: Scalars['Boolean'];
  date?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  keywordIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateStudentSubgroupNestedInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  teacherIds?: InputMaybe<Scalars['Iterable']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateSubscriptionInput = {
  dateEnd?: InputMaybe<Scalars['DateTime']>;
  dateStart?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateSubscriptionPackageInput = {
  id?: InputMaybe<Scalars['ID']>;
  districtId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<Scalars['ID']>>;
  scope?: InputMaybe<SubscriptionScopeEnum>;
  subscriptionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateTeamInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** User IDs */
  members?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTutorInput = {
  bioText?: InputMaybe<Scalars['String']>;
  bioVideo?: InputMaybe<Scalars['Upload']>;
  depthScale?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  initialTag?: InputMaybe<LanguageTagEnum>;
  lastName?: InputMaybe<Scalars['String']>;
  mainProfilePhoto?: InputMaybe<Scalars['Upload']>;
  order?: InputMaybe<Scalars['Int']>;
  profilePhoto?: InputMaybe<Scalars['Upload']>;
};

/** UpdateUserActivitys a User. */
export type UpdateUserActivityInput = {
  active: Scalars['Boolean'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  userIds: Scalars['Iterable'];
};

/** UpdateUserActivitys a User. */
export type UpdateUserActivityPayload = {
  __typename?: 'updateUserActivityPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Updates a UserCalendar. */
export type UpdateUserCalendarInput = {
  assignedTo?: InputMaybe<Scalars['String']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarTemplateId?: InputMaybe<Scalars['String']>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createTime?: InputMaybe<Scalars['String']>;
  creator?: InputMaybe<Scalars['String']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  eventId?: InputMaybe<Scalars['String']>;
  eventTemplateId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pacingGuideId?: InputMaybe<Scalars['String']>;
  pacingGuideTemplateId?: InputMaybe<Scalars['String']>;
  pacingGuideType?: InputMaybe<PacingGuideTypeEnum>;
  pk?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  scopePlanId?: InputMaybe<Scalars['String']>;
  scopePlanType?: InputMaybe<ScopePlanTypeEnum>;
  sharedBy?: InputMaybe<Scalars['String']>;
  sk?: InputMaybe<Scalars['String']>;
  updateTime?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UsersTypeEnum>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Updates a UserCalendar. */
export type UpdateUserCalendarPayload = {
  __typename?: 'updateUserCalendarPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userCalendar?: Maybe<UserCalendar>;
};

/** Updates a User. */
export type UpdateUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  curriculumAreas?: InputMaybe<Scalars['Iterable']>;
  districtUuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<GradeLevelEnum>;
  id: Scalars['ID'];
  language?: InputMaybe<LanguageEnum>;
  lastName?: InputMaybe<Scalars['String']>;
  lmsId?: InputMaybe<Scalars['String']>;
  manualMaintenance?: InputMaybe<Scalars['Boolean']>;
  middleName?: InputMaybe<Scalars['String']>;
  plainPassword?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  sisId?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  userRoles?: InputMaybe<Array<InputMaybe<UpdateUserRoleNestedInput>>>;
  userRolesExplicitDelete?: InputMaybe<
    Array<InputMaybe<UpdateUserRoleNestedInput>>
  >;
  username?: InputMaybe<Scalars['String']>;
};

/** Updates a User. */
export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Updates a UserRole. */
export type UpdateUserRoleInput = {
  allSchoolsAccess?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  roleId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
};

/** Updates a UserRole. */
export type UpdateUserRoleNestedInput = {
  _delete?: InputMaybe<Scalars['Boolean']>;
  allSchoolsAccess?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
};

/** Updates a UserRole. */
export type UpdateUserRolePayload = {
  __typename?: 'updateUserRolePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userRole?: Maybe<UserRole>;
};

/** Updates a UserSelection. */
export type UpdateUserSelectionInput = {
  calendarSettingsPopup?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationCalendar?: InputMaybe<Scalars['Iterable']>;
  notificationPacingGuide?: InputMaybe<Scalars['Iterable']>;
  schoolIds?: InputMaybe<Scalars['Iterable']>;
  selectedCalendar?: InputMaybe<Scalars['Iterable']>;
  selectedPacingGuide?: InputMaybe<Scalars['Iterable']>;
  selectedScopePlan?: InputMaybe<Scalars['Iterable']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Scalars['Iterable']>;
  version?: InputMaybe<Scalars['Int']>;
  viewMode?: InputMaybe<ViewModeEnum>;
};

/** Updates a UserSelection. */
export type UpdateUserSelectionPayload = {
  __typename?: 'updateUserSelectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  userSelection?: Maybe<UserSelection>;
};

export type UpdateWidgetInput = {
  x?: InputMaybe<Scalars['Int']>;
  y?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
  h?: InputMaybe<Scalars['Int']>;
  i: Scalars['String'];
  id: Scalars['String'];
  collapsed?: InputMaybe<Scalars['Boolean']>;
  expandedH?: InputMaybe<Scalars['Int']>;
  expandedW?: InputMaybe<Scalars['Int']>;
  minH?: InputMaybe<Scalars['Int']>;
  minW?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<WidgetType>;
  config?: InputMaybe<Scalars['JSONObject']>;
};

export type User = Node & {
  __typename?: 'User';
  id: Scalars['ID'];
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  authenticationToken?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUsername?: Maybe<Scalars['String']>;
  curriculumAreas?: Maybe<Scalars['Iterable']>;
  district?: Maybe<District>;
  /** @deprecated Used from Session User */
  districtUuid: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSystemName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<GradeLevelEnum>;
  importId?: Maybe<Scalars['String']>;
  inactivityReason?: Maybe<UserInactivityReasonEnum>;
  language: LanguageEnum;
  lastName?: Maybe<Scalars['String']>;
  lmsId?: Maybe<Scalars['String']>;
  manualMaintenance?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  plainPassword?: Maybe<Scalars['String']>;
  preferences?: Maybe<Scalars['String']>;
  purpose?: Maybe<UserPurposeEnum>;
  sisId?: Maybe<Scalars['String']>;
  staffId?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
  type: UserTypeEnum;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByUsername?: Maybe<Scalars['String']>;
  userRoles?: Maybe<UserRolePageConnection>;
  username: Scalars['String'];
};

export type UserUserRolesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type UserCalendar = Node & {
  __typename?: 'UserCalendar';
  _id: Scalars['String'];
  assignedTo?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['String']>;
  calendarTemplateId?: Maybe<Scalars['String']>;
  calendarType?: Maybe<CalendarTypeEnum>;
  calendars?: Maybe<CalendarPageConnection>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  editable: Scalars['Boolean'];
  eventId?: Maybe<Scalars['String']>;
  eventTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  isSelected?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pacingGuideId?: Maybe<Scalars['String']>;
  pacingGuideTemplateId?: Maybe<Scalars['String']>;
  pacingGuideType?: Maybe<PacingGuideTypeEnum>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  scopePlanId?: Maybe<Scalars['String']>;
  scopePlanType?: Maybe<ScopePlanTypeEnum>;
  sharedBy?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  updateTime?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userSelection: UserSelection;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
};

export type UserCalendarCalendarsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CalendarFilter_Order>>>;
  calendarId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  teamId?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<CalendarFilter>>>;
};

export type UserCalendarFilter = {
  accessType?: InputMaybe<Scalars['String']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  name?: InputMaybe<Scalars['String']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UserCalendarFilter_Order = {
  name?: InputMaybe<SortEnum>;
};

/** Page connection for UserCalendar. */
export type UserCalendarPageConnection = {
  __typename?: 'UserCalendarPageConnection';
  collection?: Maybe<Array<Maybe<UserCalendar>>>;
  paginationInfo: UserCalendarPaginationInfo;
};

/** Information about the pagination. */
export type UserCalendarPaginationInfo = {
  __typename?: 'UserCalendarPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type UserExportRequest = Node & {
  __typename?: 'UserExportRequest';
  _id: Scalars['String'];
  downloadLink?: Maybe<Scalars['String']>;
  filters: Scalars['Iterable'];
  id: Scalars['ID'];
  status: UserExportRequestStatusEnum;
};

export enum UserExportRequestStatusEnum {
  Completed = 'completed',
  Error = 'error',
  InQueue = 'in_queue',
  InProcess = 'in_process',
}

export type UserFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  classesArchived?: InputMaybe<Scalars['Boolean']>;
  classesCurriculumArea?: InputMaybe<Scalars['String']>;
  classesGradeOrCourse?: InputMaybe<Scalars['String']>;
  classesId?: InputMaybe<Scalars['String']>;
  classesLanguage?: InputMaybe<Scalars['String']>;
  classesName?: InputMaybe<Scalars['String']>;
  curriculumArea?: InputMaybe<CurriculumAreaEnum>;
  districtId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  exclude?: InputMaybe<Array<InputMaybe<UserFilter_Exclude>>>;
  excludeCurrent?: InputMaybe<Scalars['Boolean']>;
  externalSystemName?: InputMaybe<ExternalSystemNameEnum>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameOrUsername?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<GradeLevelFilterEnum>;
  highestRoleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  lmsId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UserFilter_Order>>>;
  purpose?: InputMaybe<UserPurposeEnum>;
  rolesId?: InputMaybe<Scalars['String']>;
  schoolsId?: InputMaybe<Scalars['String']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sisId?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  subgroupsId?: InputMaybe<Scalars['String']>;
  subgroupsName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserTypeEnum>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserFilter_Exclude = {
  id?: InputMaybe<Scalars['Iterable']>;
};

export type UserFilter_Order = {
  active?: InputMaybe<SortEnum>;
  email?: InputMaybe<SortEnum>;
  firstName?: InputMaybe<SortEnum>;
  gradeLevel?: InputMaybe<SortEnum>;
  id?: InputMaybe<SortEnum>;
  lastName?: InputMaybe<SortEnum>;
  username?: InputMaybe<SortEnum>;
};

export enum UserInactivityReasonEnum {
  AdoptionAccountDeactivatedManually = 'ADOPTION_ACCOUNT_DEACTIVATED_MANUALLY',
  AdoptionAccountHasExpired = 'ADOPTION_ACCOUNT_HAS_EXPIRED',
  AdoptionAccountHasNoProducts = 'ADOPTION_ACCOUNT_HAS_NO_PRODUCTS',
  AdoptionAccountPeriodHasNotStarted = 'ADOPTION_ACCOUNT_PERIOD_HAS_NOT_STARTED',
  PreviewAccountHasExpired = 'PREVIEW_ACCOUNT_HAS_EXPIRED',
  PreviewAccountHasNoProducts = 'PREVIEW_ACCOUNT_HAS_NO_PRODUCTS',
  PreviewAccountPeriodHasNotStarted = 'PREVIEW_ACCOUNT_PERIOD_HAS_NOT_STARTED',
  PreviewAccountSelfRegistrationRequired = 'PREVIEW_ACCOUNT_SELF_REGISTRATION_REQUIRED',
}

/** Page connection for User. */
export type UserPageConnection = {
  __typename?: 'UserPageConnection';
  collection?: Maybe<Array<Maybe<User>>>;
  paginationInfo: UserPaginationInfo;
};

/** Information about the pagination. */
export type UserPaginationInfo = {
  __typename?: 'UserPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  id: Scalars['String'];
};

export enum UserPurposeEnum {
  AdoptionReviewer = 'adoption_reviewer',
  CommunityAccessMember = 'community_access_member',
  PreviewAccount = 'preview_account',
  Regular = 'regular',
}

export type UserRole = Node & {
  __typename?: 'UserRole';
  allSchoolsAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  role: Role;
  /** @deprecated Use the Role property instead */
  roleId: Scalars['String'];
  schoolIds: Scalars['Iterable'];
};

/** Page connection for UserRole. */
export type UserRolePageConnection = {
  __typename?: 'UserRolePageConnection';
  collection?: Maybe<Array<Maybe<UserRole>>>;
  paginationInfo: UserRolePaginationInfo;
};

/** Information about the pagination. */
export type UserRolePaginationInfo = {
  __typename?: 'UserRolePaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type UserSelection = Node & {
  __typename?: 'UserSelection';
  _id: Scalars['String'];
  calendarSettingsPopup?: Maybe<Scalars['Boolean']>;
  createTime?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notificationCalendar?: Maybe<Scalars['Iterable']>;
  notificationPacingGuide?: Maybe<Scalars['Iterable']>;
  pk: Scalars['String'];
  schoolIds?: Maybe<Scalars['Iterable']>;
  selectedCalendar?: Maybe<Scalars['Iterable']>;
  selectedPacingGuide?: Maybe<Scalars['Iterable']>;
  selectedScopePlan?: Maybe<Scalars['Iterable']>;
  sharedBy?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
  updateTime?: Maybe<Scalars['String']>;
  userCalendars?: Maybe<UserCalendarPageConnection>;
  userId?: Maybe<Scalars['String']>;
  userRoleCode?: Maybe<Scalars['String']>;
  userType?: Maybe<UsersTypeEnum>;
  version?: Maybe<Scalars['Int']>;
  viewMode?: Maybe<ViewModeEnum>;
};

export type UserSelectionUserCalendarsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UserCalendarFilter_Order>>>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarType?: InputMaybe<CalendarTypeEnum>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userRoleCode?: InputMaybe<Scalars['String']>;
  userTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Array<InputMaybe<UserCalendarFilter>>>;
};

/** Page connection for UserSelection. */
export type UserSelectionPageConnection = {
  __typename?: 'UserSelectionPageConnection';
  collection?: Maybe<Array<Maybe<UserSelection>>>;
  paginationInfo: UserSelectionPaginationInfo;
};

/** Information about the pagination. */
export type UserSelectionPaginationInfo = {
  __typename?: 'UserSelectionPaginationInfo';
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** User type: Individual / Team */
export enum UsersTypeEnum {
  /** Individual Type */
  Individual = 'Individual',
  /** Team Type */
  Team = 'Team',
}

export enum UserTypeEnum {
  Admin = 'admin',
  Parent = 'parent',
  Staff = 'staff',
  Student = 'student',
  Other = 'other',
}

/** VerifyEmailss a Parent. */
export type VerifyEmailsParentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  districtId: Scalars['String'];
  emails: Array<Scalars['String']>;
};

/** VerifyEmailss a Parent. */
export type VerifyEmailsParentPayload = {
  __typename?: 'verifyEmailsParentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  parent?: Maybe<VerifyEmailsParentPayloadData>;
};

/** VerifyEmailss a Parent. */
export type VerifyEmailsParentPayloadData = Node & {
  __typename?: 'verifyEmailsParentPayloadData';
  id: Scalars['ID'];
  results: Scalars['Iterable'];
};

export type Video = {
  __typename?: 'Video';
  description?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  glossaryTerm?: Maybe<Scalars['String']>;
  groupIdentifier: Scalars['String'];
  id: Scalars['String'];
  linkedVideos: UnionVideoPdfPageConnection;
  mnIdentifier?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  processStatus: VideoProcessStatusEnum;
  questionList: Array<Scalars['String']>;
  spriteUrl?: Maybe<Scalars['String']>;
  streamUrl: Scalars['String'];
  subtitlesUrl?: Maybe<Scalars['String']>;
  thumbnailSize?: Maybe<Scalars['String']>;
  tutor?: Maybe<Tutor>;
  videoIndex?: Maybe<Scalars['String']>;
  videoUrl: Scalars['String'];
  active: Scalars['Boolean'];
  glossary: Scalars['Boolean'];
  k5: Scalars['Boolean'];
  keywords: Array<ContentKeyword>;
};

export type VideoLinkedVideosArgs = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type VideoByGroupInput = {
  groupIdentifier: Scalars['String'];
  groupType: VideoGroupEnum;
  mediaType?: MediaTypeEnum;
  videoIndex?: InputMaybe<Scalars['String']>;
};

export type VideoFilterInput = {
  /** For all videos */
  active?: InputMaybe<Scalars['Boolean']>;
  /** For Coursework videos */
  category?: InputMaybe<Scalars['String']>;
  /** For OnRamp videos */
  course?: InputMaybe<Scalars['String']>;
  /** For OnRamp videos */
  domain?: InputMaybe<Scalars['String']>;
  /** For Coursework videos */
  excludeLesson?: InputMaybe<Scalars['String']>;
  /** For Coursework videos */
  glossary?: InputMaybe<Scalars['Boolean']>;
  /** For Coursework videos */
  glossaryCondition?: GlossaryFilterConditionEnum;
  /** For Coursework videos */
  glossaryTerm?: InputMaybe<Scalars['String']>;
  /** For Coursework videos */
  grade?: InputMaybe<Scalars['String']>;
  /** For all videos */
  id?: InputMaybe<Scalars['String']>;
  /** For Glossary videos */
  k5?: InputMaybe<Scalars['Boolean']>;
  /** For Coursework videos */
  lesson?: InputMaybe<Scalars['String']>;
  /** For Coursework videos */
  mnComponent?: InputMaybe<Scalars['String']>;
  /** For all videos */
  processStatus?: InputMaybe<VideoProcessStatusEnum>;
  /** For all videos */
  projectType?: InputMaybe<Scalars['String']>;
  /** Add the language code */
  language?: InputMaybe<Scalars['String']>;
  /** For all videos */
  purpose: VideoGroupEnum;
  /** For OnRamp videos */
  standard?: InputMaybe<Scalars['String']>;
  /** For OnRamp NL videos/pdfs */
  concept?: InputMaybe<Scalars['String']>;
  /** For OnRamp videos */
  topic?: InputMaybe<Scalars['String']>;
  /** For all videos */
  tutorIds?: InputMaybe<Array<Scalars['String']>>;
  /** For OnRamp videos */
  type?: InputMaybe<Scalars['String']>;
  /** For Coursework videos */
  unit?: InputMaybe<Scalars['String']>;
  /** For Coursework videos */
  videoIndex?: InputMaybe<Scalars['String']>;
  /** Get the resource type in MN downloadable */
  resourceType?: InputMaybe<Scalars['String']>;
  /** For Math In Action Subject */
  maSubject?: InputMaybe<Scalars['String']>;
  /** For Math In Action Type */
  maType?: InputMaybe<Scalars['String']>;
  /** Standard alignment state added */
  state?: InputMaybe<Scalars['String']>;
  /** Assessment Type */
  assessmentType?: InputMaybe<Scalars['String']>;
  /** Resource Id's For all videos */
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum VideoGroupEnum {
  ContentGroup = 'ContentGroup',
  OnRampGroup = 'OnRampGroup',
  QuestionGroup = 'QuestionGroup',
  WithoutGroup = 'WithoutGroup',
  StemscopesGroup = 'StemscopesGroup',
  StreamingGroup = 'StreamingGroup',
  GlossaryGroup = 'GlossaryGroup',
  CourseworkGroup = 'CourseworkGroup',
}

export type VideoPageConnection = {
  __typename?: 'VideoPageConnection';
  collection: Array<Video>;
  paginationInfo?: Maybe<VideoPaginationInfo>;
};

export type VideoPaginationInfo = {
  __typename?: 'VideoPaginationInfo';
  itemsPerPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VideoPayload = {
  __typename?: 'VideoPayload';
  video: UnionVideoPdf;
};

export type VideoPostObjectPayload = {
  __typename?: 'VideoPostObjectPayload';
  fileKey: Scalars['String'];
  formAttributes: Scalars['String'];
  formInputs: Scalars['String'];
  id: Scalars['String'];
};

export enum VideoProcessStatusEnum {
  Uploading = 'Uploading',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum VideoQualityEnum {
  Hd = 'HD',
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW',
  ExtraLow = 'EXTRA_LOW',
}

export type VideoSortInput = {
  glossaryTerm?: InputMaybe<SortEnum>;
};

/** ViewMode type: Day, Week or Month */
export enum ViewModeEnum {
  /** Day View Mode */
  Day = 'Day',
  /** Week View Mode */
  Week = 'Week',
  /** Month View Mode */
  Month = 'Month',
}

export type VisibilityPayload = {
  __typename?: 'VisibilityPayload';
  isVisible: Scalars['Boolean'];
};

export type WallAgeControl = Node & {
  __typename?: 'WallAgeControl';
  _id: Scalars['Int'];
  created: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  modified: Scalars['String'];
  schoolId?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  verifiedByTeacherId?: Maybe<Scalars['String']>;
};

export type WallControl = Node & {
  __typename?: 'WallControl';
  _id: Scalars['Int'];
  created: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  modified: Scalars['String'];
  name: Scalars['String'];
  stateCode: Scalars['String'];
  subjectCode: Scalars['String'];
  wallId: Scalars['String'];
};

export type WallList = {
  __typename?: 'wallList';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type WallListConnect = {
  __typename?: 'wallListConnect';
  collection: Array<WallList>;
};

export type WallPostConnect = {
  __typename?: 'wallPostConnect';
  collection: Array<WallPosts>;
};

export type WallPostLike = Node & {
  __typename?: 'WallPostLike';
  _id: Scalars['Int'];
  created: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  modified: Scalars['String'];
  userId: Scalars['String'];
  wallPost: Post;
};

export type WallPostPin = Node & {
  __typename?: 'WallPostPin';
  _id: Scalars['Int'];
  created: Scalars['String'];
  endTime: Scalars['String'];
  id: Scalars['ID'];
  modified: Scalars['String'];
  userId: Scalars['String'];
  wallPost?: Maybe<Post>;
};

export type WallPosts = Node & {
  __typename?: 'wallPosts';
  _id: Scalars['String'];
  id: Scalars['ID'];
  postId: Scalars['String'];
  wallId: Scalars['Int'];
  content: Scalars['String'];
  timeStamp: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isStickPost: Scalars['Boolean'];
  isWelcomePost: Scalars['Boolean'];
  answered: Scalars['Boolean'];
  likesCount: Scalars['Int'];
  mediaKey: Scalars['String'];
  documentKey: Scalars['String'];
  equationEditorKey: Scalars['String'];
  gBoardKey: Scalars['String'];
  user: WallUser;
  likes?: Maybe<Array<Scalars['String']>>;
  replies?: Maybe<Array<WallReply>>;
  retired?: Maybe<Scalars['Int']>;
};

export type WallReply = {
  __typename?: 'wallReply';
  postId?: Maybe<Scalars['String']>;
  user?: Maybe<WallUser>;
  content?: Maybe<Scalars['String']>;
  documentKey?: Maybe<Scalars['String']>;
  mediaKey?: Maybe<Scalars['String']>;
  gBoardKey?: Maybe<Scalars['String']>;
  equationEditorKey?: Maybe<Scalars['String']>;
  likesCount?: Maybe<Scalars['Int']>;
  likes?: Maybe<Array<Maybe<Scalars['String']>>>;
  timeStamp?: Maybe<Scalars['Int']>;
};

export type WallUser = {
  __typename?: 'wallUser';
  username?: Maybe<Scalars['String']>;
  districtId?: Maybe<Scalars['String']>;
  schoolIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Widget = {
  __typename?: 'Widget';
  x: Scalars['Int'];
  y: Scalars['Int'];
  w: Scalars['Int'];
  h: Scalars['Int'];
  i: Scalars['String'];
  id: Scalars['String'];
  collapsed: Scalars['Boolean'];
  expandedH: Scalars['Int'];
  expandedW: Scalars['Int'];
  minH: Scalars['Int'];
  minW: Scalars['Int'];
  type: WidgetType;
  config?: Maybe<Scalars['JSONObject']>;
};

export enum WidgetType {
  /** Calendar */
  Calendar = 'Calendar',
  /** Week at a Glance */
  WeekAtAGlance = 'WeekAtAGlance',
  /** Assignment */
  Assignment = 'Assignment',
  /** Report */
  Report = 'Report',
  /** Live View */
  LiveView = 'LiveView',
  /** To Do List */
  ToDoList = 'ToDoList',
  /** Countdown */
  Countdown = 'Countdown',
  /** Shortcut */
  Shortcut = 'Shortcut',
}

export type CreateAdoptionEventMutationVariables = Exact<{
  input: CreateAdoptionEventInput;
}>;

export type CreateAdoptionEventMutation = {
  __typename?: 'Mutation';
  createAdoptionEvent: {
    __typename?: 'AdoptionEventPayload';
    adoptionEvent: { __typename?: 'AdoptionEvent'; id: string; name: string };
  };
};

export type CreateAdoptionReviewerMutationVariables = Exact<{
  input: CreateAdoptionReviewerInput;
}>;

export type CreateAdoptionReviewerMutation = {
  __typename?: 'Mutation';
  createAdoptionReviewer: {
    __typename?: 'AdoptionReviewerPayload';
    adoptionReviewer: { __typename?: 'AdoptionReviewer'; id: string };
  };
};

export type CreateAdoptionAccountMutationVariables = Exact<{
  input: CreateAdoptionAccountInput;
}>;

export type CreateAdoptionAccountMutation = {
  __typename?: 'Mutation';
  createAdoptionAccount: {
    __typename?: 'AdoptionAccountPayload';
    adoptionAccount: {
      __typename?: 'AdoptionAccount';
      id: string;
      name: string;
    };
  };
};

export type GetAdoptionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdoptionAccountQuery = {
  __typename?: 'Query';
  adoptionAccount: {
    __typename?: 'AdoptionAccount';
    id: string;
    name: string;
    state: StateEnum;
    active: boolean;
    registrationToken: string;
    beginDate?: any | null;
    expirationDate?: any | null;
    communityRegistrationToken: string;
    adoptionEvent: {
      __typename?: 'AdoptionEvent';
      id: string;
      name: string;
      category: AdoptionEventCategoryEnum;
      beginDate?: any | null;
      expirationDate?: any | null;
      urlCode: string;
    };
    communityAccess?: {
      __typename?: 'CommunityAccess';
      id: string;
      active: boolean;
      beginDate?: any | null;
      expirationDate?: any | null;
      accessToAnswerKeys: boolean;
      accessToStudentContent: boolean;
      accessToTeacherContent: boolean;
      accessToTests: boolean;
    } | null;
  };
};

export type GetAdoptionAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AdoptionAccountFilterInput>;
  order?: InputMaybe<AdoptionAccountOrderInput>;
}>;

export type GetAdoptionAccountsQuery = {
  __typename?: 'Query';
  adoptionAccounts: {
    __typename?: 'AdoptionAccountPageConnection';
    collection: Array<{
      __typename?: 'AdoptionAccount';
      active: boolean;
      id: string;
      name: string;
      registrationToken: string;
      state: StateEnum;
      beginDate?: any | null;
      expirationDate?: any | null;
      district: { __typename?: 'District'; globalName: string };
      reviewers: Array<{ __typename?: 'AdoptionReviewer'; id: string }>;
      adoptionEvent: {
        __typename?: 'AdoptionEvent';
        id: string;
        name: string;
        urlCode: string;
        category: AdoptionEventCategoryEnum;
      };
      communityAccess?: {
        __typename?: 'CommunityAccess';
        active: boolean;
      } | null;
    }>;
    paginationInfo?: {
      __typename?: 'AdoptionAccountPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetAdoptionAccountsOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AdoptionAccountFilterInput>;
  order?: InputMaybe<AdoptionAccountOrderInput>;
}>;

export type GetAdoptionAccountsOptionsQuery = {
  __typename?: 'Query';
  adoptionAccounts: {
    __typename?: 'AdoptionAccountPageConnection';
    collection: Array<{
      __typename?: 'AdoptionAccount';
      id: string;
      name: string;
    }>;
  };
};

export type GetAdoptionEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AdoptionEventFilterInput>;
  order?: InputMaybe<AdoptionEventOrderInput>;
}>;

export type GetAdoptionEventsQuery = {
  __typename?: 'Query';
  adoptionEvents: {
    __typename?: 'AdoptionEventPageConnection';
    collection: Array<{
      __typename?: 'AdoptionEvent';
      id: string;
      active: boolean;
      beginDate?: any | null;
      category: AdoptionEventCategoryEnum;
      expirationDate?: any | null;
      name: string;
      urlCode: string;
      productGroups: Array<{
        __typename?: 'ProductGroup';
        name: string;
        id: string;
      }>;
      products: Array<{ __typename?: 'Product'; sku: string; id: string }>;
    }>;
    paginationInfo?: {
      __typename?: 'AdoptionEventPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetAdoptionEventsTotalCountQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
}>;

export type GetAdoptionEventsTotalCountQuery = {
  __typename?: 'Query';
  adoptionEvents: {
    __typename?: 'AdoptionEventPageConnection';
    paginationInfo?: {
      __typename?: 'AdoptionEventPaginationInfo';
      totalCount?: number | null;
    } | null;
  };
};

export type GetAdoptionReviewersQueryVariables = Exact<{
  filter?: InputMaybe<AdoptionReviewerFilterInput>;
  itemsPerPage: Scalars['Int'];
  order?: InputMaybe<AdoptionReviewerOrderInput>;
  page: Scalars['Int'];
}>;

export type GetAdoptionReviewersQuery = {
  __typename?: 'Query';
  adoptionReviewers: {
    __typename?: 'AdoptionReviewerPageConnection';
    collection: Array<{
      __typename?: 'AdoptionReviewer';
      id: string;
      beginDate?: any | null;
      expirationDate?: any | null;
      type: AdoptionReviewerTypeEnum;
      multiSession: boolean;
      adoptionAccount: {
        __typename?: 'AdoptionAccount';
        id: string;
        name: string;
      };
      user: { __typename?: 'User'; username: string; active: boolean };
    }>;
    paginationInfo?: {
      __typename?: 'AdoptionReviewerPaginationInfo';
      lastPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type GetAdoptionReviewersPaginationInfoQueryVariables = Exact<{
  filter?: InputMaybe<AdoptionReviewerFilterInput>;
  itemsPerPage?: Scalars['Int'];
  page?: Scalars['Int'];
}>;

export type GetAdoptionReviewersPaginationInfoQuery = {
  __typename?: 'Query';
  adoptionReviewers: {
    __typename?: 'AdoptionReviewerPageConnection';
    paginationInfo?: {
      __typename?: 'AdoptionReviewerPaginationInfo';
      totalCount?: number | null;
    } | null;
  };
};

export type GetAdoptionReviewerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdoptionReviewerQuery = {
  __typename?: 'Query';
  adoptionReviewer: {
    __typename?: 'AdoptionReviewer';
    id: string;
    beginDate?: any | null;
    expirationDate?: any | null;
    type: AdoptionReviewerTypeEnum;
    multiSession: boolean;
    adoptionAccount: {
      __typename?: 'AdoptionAccount';
      id: string;
      name: string;
      state: StateEnum;
    };
    user: {
      __typename?: 'User';
      id: string;
      username: string;
      active: boolean;
      plainPassword?: string | null;
    };
  };
};

export type GetElementsForEventQueryVariables = Exact<{
  filter?: InputMaybe<ElementFilter>;
}>;

export type GetElementsForEventQuery = {
  __typename?: 'Query';
  elements?: {
    __typename?: 'Elements';
    collection?: Array<{
      __typename?: 'SearchableElement';
      projectId: string;
      scopeId: string;
      id: string;
      sectionId: string;
      scopeName: string;
      sectionName: string;
      name: string;
      studentView?: Array<any> | null;
    }> | null;
  } | null;
};

export type GetAdoptionEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdoptionEventQuery = {
  __typename?: 'Query';
  adoptionEvent: {
    __typename?: 'AdoptionEvent';
    id: string;
    name: string;
    category: AdoptionEventCategoryEnum;
    beginDate?: any | null;
    expirationDate?: any | null;
    active: boolean;
    urlCode: string;
    uiCustomization?: string | null;
    gradeAndActivities: Array<{
      __typename?: 'GradeAndActivity';
      grade: string;
      activities: Array<string>;
    }>;
    products: Array<{ __typename?: 'Product'; id: string }>;
    productGroups: Array<{ __typename?: 'ProductGroup'; id: string }>;
  };
};

export type GetAdoptionEventWithAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdoptionEventWithAccountsQuery = {
  __typename?: 'Query';
  adoptionEvent: {
    __typename?: 'AdoptionEvent';
    id: string;
    name: string;
    beginDate?: any | null;
    expirationDate?: any | null;
    adoptionAccounts: Array<{
      __typename?: 'AdoptionAccount';
      id: string;
      name: string;
      state: StateEnum;
      beginDate?: any | null;
      expirationDate?: any | null;
      active: boolean;
    }>;
  };
};

export type GetGradesForEventQueryVariables = Exact<{
  contentGroups?: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetGradesForEventQuery = {
  __typename?: 'Query';
  grades?: { __typename?: 'Grades'; grades: Array<string> } | null;
};

export type UpdateAdoptionEventMutationVariables = Exact<{
  input: UpdateAdoptionEventInput;
}>;

export type UpdateAdoptionEventMutation = {
  __typename?: 'Mutation';
  updateAdoptionEvent: {
    __typename?: 'AdoptionEventPayload';
    adoptionEvent: {
      __typename?: 'AdoptionEvent';
      id: string;
      name: string;
      category: AdoptionEventCategoryEnum;
      beginDate?: any | null;
      expirationDate?: any | null;
      active: boolean;
      urlCode: string;
      uiCustomization?: string | null;
      products: Array<{ __typename?: 'Product'; id: string }>;
      productGroups: Array<{ __typename?: 'ProductGroup'; id: string }>;
      gradeAndActivities: Array<{
        __typename?: 'GradeAndActivity';
        grade: string;
        activities: Array<string>;
      }>;
    };
  };
};

export type UpdateAdoptionAccountMutationVariables = Exact<{
  input: UpdateAdoptionAccountInput;
}>;

export type UpdateAdoptionAccountMutation = {
  __typename?: 'Mutation';
  updateAdoptionAccount: {
    __typename?: 'AdoptionAccountPayload';
    adoptionAccount: {
      __typename?: 'AdoptionAccount';
      id: string;
      name: string;
      state: StateEnum;
      active: boolean;
    };
  };
};

export type GetListContentQueryVariables = Exact<{
  input: ListContentInput;
}>;

export type GetListContentQuery = {
  __typename?: 'Query';
  listContent: {
    __typename?: 'ListContentPayload';
    course: Array<{
      __typename?: 'ListCoursePayload';
      course: string;
      data: Array<{
        __typename?: 'ListDataPayload';
        conceptName: string;
        conceptNumber: string;
        status: boolean;
        topics: Array<{
          __typename?: 'TopicsPayload';
          status: string;
          topicName: string;
          topicNumber: string;
        }>;
      }>;
    }>;
  };
};

export type GetUploadStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetUploadStatusQuery = {
  __typename?: 'Query';
  adoptionReviewerImportRequest: {
    __typename?: 'AdoptionReviewerImportRequest';
    importLog: {
      __typename?: 'DemoImportLog';
      message: DemoImportLogMessageEnum;
    };
  };
};

export type UploadAdoptionReviewersMutationVariables = Exact<{
  input: DemoImportCsvPostObjectInput;
}>;

export type UploadAdoptionReviewersMutation = {
  __typename?: 'Mutation';
  createAdoptionReviewersCsvPostObject: {
    __typename?: 'DemoImportCsvPostObjectPayload';
    fileKey: string;
    formAttributes: string;
    formInputs: string;
    importRequestId: string;
    importItem: DemoImportItemEnum;
  };
};

export type BulkUpdateContentsMutationVariables = Exact<{
  input: BulkUpdateContentsInput;
}>;

export type BulkUpdateContentsMutation = {
  __typename?: 'Mutation';
  bulkUpdateContents: Array<{
    __typename?: 'Content';
    id: string;
    projectId?: string | null;
    name?: string | null;
    active: boolean;
    projectType: ProjectTypeEnum;
  }>;
};

export type GetContentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
}>;

export type GetContentsQuery = {
  __typename?: 'Query';
  contents: {
    __typename?: 'ContentPageConnection';
    collection: Array<{
      __typename?: 'Content';
      active: boolean;
      id: string;
      name?: string | null;
      projectId?: string | null;
      projectType: ProjectTypeEnum;
      grade?: string | null;
      editionName?: string | null;
      position?: number | null;
    }>;
    paginationInfo?: {
      __typename?: 'ContentPaginationInfo';
      lastPage?: number | null;
      itemsPerPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type BulkUpdateAdoptionAccountsMutationVariables = Exact<{
  input: BulkUpdateAdoptionAccountsInput;
  selection: BulkSelectionInput;
  filter: AdoptionAccountFilterInput;
}>;

export type BulkUpdateAdoptionAccountsMutation = {
  __typename?: 'Mutation';
  createBulkUpdateAdoptionAccounts: {
    __typename?: 'BulkUpdatePayload';
    id: string;
  };
};

export type GetContentGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ContentGroupFilterInput>;
  sorting?: InputMaybe<ContentGroupOrderInput>;
}>;

export type GetContentGroupsQuery = {
  __typename?: 'Query';
  contentGroups: {
    __typename?: 'ContentGroupPageConnection';
    collection: Array<{
      __typename?: 'ContentGroup';
      active: boolean;
      id: string;
      contents: Array<{
        __typename?: 'Content';
        active: boolean;
        id: string;
        name?: string | null;
        projectId?: string | null;
        projectType: ProjectTypeEnum;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'ContentGroupPaginationInfo';
      itemsPerPage?: number | null;
      lastPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type UpdateAdoptionReviewerMutationVariables = Exact<{
  input: UpdateAdoptionReviewerInput;
}>;

export type UpdateAdoptionReviewerMutation = {
  __typename?: 'Mutation';
  updateAdoptionReviewer: {
    __typename?: 'AdoptionReviewerPayload';
    adoptionReviewer: { __typename?: 'AdoptionReviewer'; id: string };
  };
};

export type CreateContentGroupMutationVariables = Exact<{
  input: CreateContentGroupInput;
}>;

export type CreateContentGroupMutation = {
  __typename?: 'Mutation';
  createContentGroup?: {
    __typename?: 'ContentGroupPayload';
    contentGroup: { __typename?: 'ContentGroup'; id: string };
  } | null;
};

export type GetContentGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetContentGroupQuery = {
  __typename?: 'Query';
  contentGroup?: {
    __typename?: 'ContentGroup';
    active: boolean;
    id: string;
    contents: Array<{
      __typename?: 'Content';
      active: boolean;
      id: string;
      name?: string | null;
      projectId?: string | null;
      projectType: ProjectTypeEnum;
      position?: number | null;
      grade?: string | null;
    }>;
  } | null;
};

export type UpdateContentGroupMutationVariables = Exact<{
  input: UpdateContentGroupInput;
}>;

export type UpdateContentGroupMutation = {
  __typename?: 'Mutation';
  updateContentGroup?: {
    __typename?: 'ContentGroupPayload';
    contentGroup: {
      __typename?: 'ContentGroup';
      active: boolean;
      id: string;
      contents: Array<{
        __typename?: 'Content';
        active: boolean;
        id: string;
        name?: string | null;
        projectId?: string | null;
        projectType: ProjectTypeEnum;
        position?: number | null;
        grade?: string | null;
      }>;
    };
  } | null;
};

export type GetDistrictQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetDistrictQuery = {
  __typename?: 'Query';
  district?: {
    __typename?: 'District';
    id: string;
    globalName: string;
    localName: string;
    state: StateEnum;
    city?: string | null;
    ncesId?: string | null;
    mathNationId?: string | null;
  } | null;
};

export type GetEmailPlaceholdersQueryVariables = Exact<{
  type: EmailTemplateTypeEnum;
}>;

export type GetEmailPlaceholdersQuery = {
  __typename?: 'Query';
  emailTemplatePlaceholders: {
    __typename?: 'EmailTemplatePlaceholdersPayload';
    collection: Array<{
      __typename?: 'EmailTemplatePlaceholder';
      code: EmailTemplatePlaceholderEnum;
      exampleValue: string;
    }>;
  };
};

export type UpdateDistrictMutationVariables = Exact<{
  input: UpdateDistrictInput;
}>;

export type UpdateDistrictMutation = {
  __typename?: 'Mutation';
  updateDistrict?: {
    __typename?: 'updateDistrictPayload';
    clientMutationId?: string | null;
    district?: {
      __typename?: 'District';
      globalName: string;
      id: string;
      localName: string;
      state: StateEnum;
      city?: string | null;
    } | null;
  } | null;
};

export type GetEmailTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<EmailTemplateFilterInput>;
}>;

export type GetEmailTemplatesQuery = {
  __typename?: 'Query';
  emailTemplates: {
    __typename?: 'EmailTemplatePageConnection';
    collection: Array<{
      __typename?: 'EmailTemplate';
      id: string;
      body: string;
      description?: string | null;
      subject: string;
      type: EmailTemplateTypeEnum;
    }>;
    paginationInfo?: {
      __typename?: 'EmailTemplatePaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type CreateEmailTemplateMutationVariables = Exact<{
  input: CreateEmailTemplateInput;
}>;

export type CreateEmailTemplateMutation = {
  __typename?: 'Mutation';
  createEmailTemplate: {
    __typename?: 'EmailTemplatePayload';
    emailTemplate: {
      __typename?: 'EmailTemplate';
      id: string;
      body: string;
      description?: string | null;
      fromEmail?: string | null;
      fromName?: string | null;
      subject: string;
      type: EmailTemplateTypeEnum;
    };
  };
};

export type GetAthenaDistrictsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<DistrictSort>;
  filter?: InputMaybe<DistrictFilter>;
}>;

export type GetAthenaDistrictsQuery = {
  __typename?: 'Query';
  athenaDistricts?: {
    __typename?: 'athenaDistrictPageConnection';
    collection?: Array<{
      __typename?: 'athenaDistrict';
      _id: string;
      globalName: string;
      state: string;
      source: DistrictSourceEnum;
      mathnationId?: string | null;
    } | null> | null;
    paginationInfo: {
      __typename?: 'athenaDistrictPaginationInfo';
      totalCount: number;
      lastPage: number;
      itemsPerPage: number;
    };
  } | null;
};

export type UpdateEmailTemplateMutationVariables = Exact<{
  input: UpdateEmailTemplateInput;
}>;

export type UpdateEmailTemplateMutation = {
  __typename?: 'Mutation';
  updateEmailTemplate: {
    __typename?: 'EmailTemplatePayload';
    emailTemplate: {
      __typename?: 'EmailTemplate';
      id: string;
      body: string;
      description?: string | null;
      fromEmail?: string | null;
      fromName?: string | null;
      subject: string;
      type: EmailTemplateTypeEnum;
    };
  };
};

export type GetFromEmailsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
}>;

export type GetFromEmailsQuery = {
  __typename?: 'Query';
  fromEmails: {
    __typename?: 'StringPageConnection';
    collection: Array<string>;
  };
};

export type GetEmailImageUploadFormQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;

export type GetEmailImageUploadFormQuery = {
  __typename?: 'Query';
  emailTemplateImageUploadForm: {
    __typename?: 'EmailTemplateImageUploadForm';
    fileKey: string;
    formAttributes: string;
    formInputs: string;
    imageUrl: string;
  };
};

export type UpdateContentMutationVariables = Exact<{
  input: ContentInput;
}>;

export type UpdateContentMutation = {
  __typename?: 'Mutation';
  updateContent: { __typename?: 'ContentPayload'; status: string };
};

export type DeleteContentMutationVariables = Exact<{
  input: DeleteContentInput;
}>;

export type DeleteContentMutation = {
  __typename?: 'Mutation';
  deleteContent: { __typename?: 'DeleteContentPayload'; status: string };
};

export type ListContentQueryVariables = Exact<{
  input: ListContentInput;
}>;

export type ListContentQuery = {
  __typename?: 'Query';
  listContent: {
    __typename?: 'ListContentPayload';
    course: Array<{
      __typename?: 'ListCoursePayload';
      course: string;
      data: Array<{
        __typename?: 'ListDataPayload';
        conceptName: string;
        conceptNumber: string;
        status: boolean;
        topics: Array<{
          __typename?: 'TopicsPayload';
          status: string;
          topicName: string;
          topicNumber: string;
        }>;
      }>;
    }>;
  };
};

export type GetEmailTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetEmailTemplateQuery = {
  __typename?: 'Query';
  emailTemplate: {
    __typename?: 'EmailTemplate';
    id: string;
    body: string;
    source: string;
    description?: string | null;
    fromEmail?: string | null;
    fromName?: string | null;
    subject: string;
    type: EmailTemplateTypeEnum;
    attachments: Array<{
      __typename?: 'EmailTemplateAttachment';
      id: string;
      originalFileName: string;
      path: string;
    }>;
  };
};

export type GetAttachmentsFormQueryVariables = Exact<{
  fileNames: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetAttachmentsFormQuery = {
  __typename?: 'Query';
  emailTemplateAttachmentUploadForm: {
    __typename?: 'EmailTemplateAttachmentUploadFormPayload';
    collection: Array<{
      __typename?: 'EmailTemplateAttachmentUploadForm';
      id: string;
      fileName: string;
      formAttributes: string;
      formInputs: string;
    }>;
  };
};

export type CreateContentTagMutationVariables = Exact<{
  input: CreateContentTagInput;
}>;

export type CreateContentTagMutation = {
  __typename?: 'Mutation';
  createContentTag: {
    __typename?: 'ContentTagPayload';
    tag: { __typename?: 'ContentTag'; id: string; name: string };
  };
};

export type UpdateContentTagMutationVariables = Exact<{
  input: UpdateContentTagInput;
}>;

export type UpdateContentTagMutation = {
  __typename?: 'Mutation';
  updateContentTag: {
    __typename?: 'ContentTagPayload';
    tag: { __typename?: 'ContentTag'; id: string; name: string };
  };
};

export type CreateContentTagValueMutationVariables = Exact<{
  input: CreateContentTagValueInput;
}>;

export type CreateContentTagValueMutation = {
  __typename?: 'Mutation';
  createContentTagValue: {
    __typename?: 'ContentTagValuePayload';
    tagValue: { __typename?: 'ContentTagValue'; id: string; name: string };
  };
};

export type DeleteImageMutationVariables = Exact<{
  input: DeleteImageInput;
}>;

export type DeleteImageMutation = {
  __typename?: 'Mutation';
  deleteImage: { __typename?: 'ImagePayload'; image: { __typename: 'Image' } };
};

export type GetContentTagValuesQueryVariables = Exact<{
  page: Scalars['Int'];
  itemsPerPage?: Scalars['Int'];
  filter?: InputMaybe<ContentTagValueFilterInput>;
}>;

export type GetContentTagValuesQuery = {
  __typename?: 'Query';
  contentTagValues: {
    __typename?: 'ContentTagValuePageConnection';
    collection: Array<{
      __typename?: 'ContentTagValue';
      id: string;
      name: string;
      tag: { __typename?: 'ContentTag'; id: string; name: string };
    }>;
    paginationInfo?: {
      __typename?: 'ContentTagValuePaginationInfo';
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type CreateImageMutationVariables = Exact<{
  input: CreateImageInput;
}>;

export type CreateImageMutation = {
  __typename?: 'Mutation';
  createImage: {
    __typename?: 'ImagePayload';
    image: { __typename?: 'Image'; id: string; name: string };
  };
};

export type GetImageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetImageQuery = {
  __typename?: 'Query';
  image: {
    __typename?: 'Image';
    altText?: string | null;
    createdAt: any;
    id: string;
    name: string;
    updatedAt?: any | null;
    contentTagValues?: Array<{
      __typename?: 'ContentTagValue';
      name: string;
      id: string;
      tag: { __typename?: 'ContentTag'; name: string; id: string };
    }> | null;
    contentKeywords?: Array<{
      __typename?: 'ContentKeyword';
      id: string;
      name: string;
    }> | null;
    files: Array<{
      __typename?: 'ImageFile';
      createdAt: any;
      updatedAt?: any | null;
      id: string;
      height?: number | null;
      language?: LanguageEnum | null;
      mimeType?: string | null;
      originalFileName: string;
      path: string;
      size?: number | null;
      width?: number | null;
      processed: boolean;
      sha256: string;
    }>;
  };
};

export type GetContentTagsQueryVariables = Exact<{
  itemsPerPage?: Scalars['Int'];
  page?: Scalars['Int'];
  filter?: InputMaybe<ContentTagFilterInput>;
}>;

export type GetContentTagsQuery = {
  __typename?: 'Query';
  contentTags: {
    __typename?: 'ContentTagPageConnection';
    collection: Array<{ __typename?: 'ContentTag'; id: string; name: string }>;
    paginationInfo?: {
      __typename?: 'ContentTagPaginationInfo';
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetImagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ImageFilterInput>;
  sorting?: InputMaybe<ImageSortInput>;
}>;

export type GetImagesQuery = {
  __typename?: 'Query';
  images: {
    __typename?: 'ImagePageConnection';
    collection: Array<{
      __typename?: 'Image';
      altText?: string | null;
      createdAt: any;
      id: string;
      name: string;
      updatedAt?: any | null;
      contentTagValues?: Array<{
        __typename?: 'ContentTagValue';
        name: string;
        id: string;
        tag: { __typename?: 'ContentTag'; name: string; id: string };
      }> | null;
      contentKeywords?: Array<{
        __typename?: 'ContentKeyword';
        id: string;
        name: string;
      }> | null;
      files: Array<{
        __typename?: 'ImageFile';
        createdAt: any;
        updatedAt?: any | null;
        id: string;
        language?: LanguageEnum | null;
        originalFileName: string;
        path: string;
        processed: boolean;
        width?: number | null;
        height?: number | null;
        size?: number | null;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'ImagePaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type CreateContentKeywordMutationVariables = Exact<{
  input: CreateContentKeywordInput;
}>;

export type CreateContentKeywordMutation = {
  __typename?: 'Mutation';
  createContentKeyword: {
    __typename?: 'ContentKeywordPayload';
    keyword: { __typename?: 'ContentKeyword'; id: string; name: string };
  };
};

export type UpdateContentKeywordMutationVariables = Exact<{
  input: UpdateContentKeywordInput;
}>;

export type UpdateContentKeywordMutation = {
  __typename?: 'Mutation';
  updateContentKeyword: {
    __typename?: 'ContentKeywordPayload';
    keyword: { __typename?: 'ContentKeyword'; id: string; name: string };
  };
};

export type GetContentKeywordsQueryVariables = Exact<{
  itemsPerPage?: Scalars['Int'];
  page?: Scalars['Int'];
  sorting?: InputMaybe<ContentKeywordOrderInput>;
  filter?: InputMaybe<ContentKeywordFilterInput>;
}>;

export type GetContentKeywordsQuery = {
  __typename?: 'Query';
  contentKeywords: {
    __typename?: 'ContentKeywordPageConnection';
    collection: Array<{
      __typename?: 'ContentKeyword';
      id: string;
      name: string;
    }>;
    paginationInfo?: {
      __typename?: 'ContentKeywordPaginationInfo';
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type ListMathInActionActivityQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListMathInActionActivityQuery = {
  __typename?: 'Query';
  listMathInActionActivity: {
    __typename?: 'ListMathInActionPayload';
    data: Array<{
      __typename?: 'ListMathInActionDataPayload';
      actionNumber?: string | null;
      category?: string | null;
      course?: string | null;
      id: number;
      section?: string | null;
      status?: boolean | null;
      subjectName?: string | null;
    }>;
  };
};

export type UpdateOrCreateMathInActionMutationVariables = Exact<{
  category: CategoryEnum;
  course: Scalars['String'];
  forceUpdate: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  section: SectionEnum;
  subjectName: Scalars['String'];
  actionNumber: Scalars['String'];
}>;

export type UpdateOrCreateMathInActionMutation = {
  __typename?: 'Mutation';
  updateOrCreateMathInAction: {
    __typename?: 'UpdateMathInActionPayload';
    status: string;
  };
};

export type UpdateImageMutationVariables = Exact<{
  input: UpdateImageInput;
}>;

export type UpdateImageMutation = {
  __typename?: 'Mutation';
  updateImage: {
    __typename?: 'ImagePayload';
    image: {
      __typename?: 'Image';
      altText?: string | null;
      createdAt: any;
      id: string;
      name: string;
      updatedAt?: any | null;
      contentTagValues?: Array<{
        __typename?: 'ContentTagValue';
        name: string;
        id: string;
        tag: { __typename?: 'ContentTag'; name: string; id: string };
      }> | null;
      contentKeywords?: Array<{
        __typename?: 'ContentKeyword';
        id: string;
        name: string;
      }> | null;
      files: Array<{
        __typename?: 'ImageFile';
        createdAt: any;
        updatedAt?: any | null;
        id: string;
        height?: number | null;
        language?: LanguageEnum | null;
        mimeType?: string | null;
        originalFileName: string;
        path: string;
        size?: number | null;
        width?: number | null;
        processed: boolean;
        sha256: string;
      }>;
    };
  };
};

export type GetImagesFormQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;

export type GetImagesFormQuery = {
  __typename?: 'Query';
  imageFileUploadForm: {
    __typename?: 'ImageFileUploadForm';
    fileKey: string;
    formAttributes: string;
    formInputs: string;
    imageUrl: string;
  };
};

export type UpdateContentTagValueMutationVariables = Exact<{
  input: UpdateContentTagValueInput;
}>;

export type UpdateContentTagValueMutation = {
  __typename?: 'Mutation';
  updateContentTagValue: {
    __typename?: 'ContentTagValuePayload';
    tagValue: { __typename?: 'ContentTagValue'; id: string; name: string };
  };
};

export type GetReaderLibrariesQueryVariables = Exact<{
  filter?: InputMaybe<ReaderLibraryFilterInput>;
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  sorting?: InputMaybe<ReaderLibrarySortInput>;
}>;

export type GetReaderLibrariesQuery = {
  __typename?: 'Query';
  readerLibraries: {
    __typename?: 'ReaderLibraryPageConnection';
    collection: Array<{
      __typename?: 'ReaderLibrary';
      description: string;
      id: string;
      enPdfFile: string;
      esPdfFile: string;
      title: string;
      keywords: Array<{
        __typename?: 'ContentKeyword';
        _id: string;
        id: string;
        name: string;
      }>;
      tagValues: Array<{
        __typename?: 'ContentTagValue';
        _id: string;
        id: string;
        name: string;
        tag: { __typename?: 'ContentTag'; id: string; name: string };
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'ReaderLibraryPaginationInfo';
      lastPage?: number | null;
      itemsPerPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type GetReaderLibraryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReaderLibraryQuery = {
  __typename?: 'Query';
  readerLibrary: {
    __typename?: 'ReaderLibraryPayload';
    readerLibrary: {
      __typename?: 'ReaderLibrary';
      description: string;
      id: string;
      enPdfFile: string;
      esPdfFile: string;
      title: string;
      keywords: Array<{
        __typename?: 'ContentKeyword';
        id: string;
        name: string;
      }>;
      tagValues: Array<{
        __typename?: 'ContentTagValue';
        id: string;
        name: string;
        tag: { __typename?: 'ContentTag'; id: string; name: string };
      }>;
    };
  };
};

export type CreateReaderLibraryMutationVariables = Exact<{
  input: CreateReaderLibraryInput;
}>;

export type CreateReaderLibraryMutation = {
  __typename?: 'Mutation';
  createReaderLibrary: {
    __typename?: 'ReaderLibraryPayload';
    readerLibrary: { __typename: 'ReaderLibrary'; id: string };
  };
};

export type UpdateReaderLibraryMutationVariables = Exact<{
  input: UpdateReaderLibraryInput;
}>;

export type UpdateReaderLibraryMutation = {
  __typename?: 'Mutation';
  updateReaderLibrary: {
    __typename?: 'ReaderLibraryPayload';
    readerLibrary: {
      __typename?: 'ReaderLibrary';
      description: string;
      id: string;
      enPdfFile: string;
      esPdfFile: string;
      title: string;
      keywords: Array<{
        __typename?: 'ContentKeyword';
        id: string;
        name: string;
      }>;
      tagValues: Array<{
        __typename?: 'ContentTagValue';
        id: string;
        name: string;
        tag: { __typename?: 'ContentTag'; id: string; name: string };
      }>;
    };
  };
};

export type DeleteReaderLibraryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteReaderLibraryMutation = {
  __typename?: 'Mutation';
  deleteReaderLibrary: {
    __typename: 'ReaderLibraryPayload';
    readerLibrary: { __typename: 'ReaderLibrary'; id: string };
  };
};

export type CreatePreviewAccountMutationVariables = Exact<{
  input: CreatePreviewAccountInput;
}>;

export type CreatePreviewAccountMutation = {
  __typename?: 'Mutation';
  createPreviewAccount: {
    __typename?: 'PreviewAccountPayload';
    previewAccount: { __typename?: 'PreviewAccount'; id: string };
  };
};

export type GetLatestPreviewAccountImportLogQueryVariables = Exact<{
  type: DemoImportLogTypeEnum;
}>;

export type GetLatestPreviewAccountImportLogQuery = {
  __typename?: 'Query';
  demoImportLogLatest: {
    __typename?: 'DemoImportLog';
    importStart: any;
    importEnd?: any | null;
    importSucceeded: boolean;
    message: DemoImportLogMessageEnum;
    errors: Array<{
      __typename?: 'DemoImportLogError';
      field: string;
      value: string;
    }>;
  };
};

export type GetImageCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ImageCategoryFilterInput>;
}>;

export type GetImageCategoriesQuery = {
  __typename?: 'Query';
  imageCategories: {
    __typename?: 'ImageCategoryPageConnection';
    collection: Array<{
      __typename?: 'ImageCategory';
      id: string;
      name: string;
      children: Array<{
        __typename?: 'ImageCategory';
        id: string;
        name: string;
      }>;
      path: Array<{
        __typename?: 'ImageCategoryPathPart';
        id: string;
        name: string;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'ImageCategoryPaginationInfo';
      totalCount?: number | null;
    } | null;
  };
};

export type GetPreviewAccountTeacherQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetPreviewAccountTeacherQuery = {
  __typename?: 'Query';
  previewAccountTeacher: {
    __typename?: 'PreviewAccountTeacher';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    previewAccount: {
      __typename?: 'PreviewAccount';
      id: string;
      activityPeriodEnd: any;
      activityPeriodStart: any;
      state: StateEnum;
      products: Array<{ __typename?: 'Product'; productType: ProductTypeEnum }>;
    };
    user: {
      __typename?: 'User';
      active: boolean;
      username: string;
      inactivityReason?: UserInactivityReasonEnum | null;
      plainPassword?: string | null;
    };
  };
};

export type UpdatePreviewAccountMutationVariables = Exact<{
  input: UpdatePreviewAccountInput;
}>;

export type UpdatePreviewAccountMutation = {
  __typename?: 'Mutation';
  updatePreviewAccount: {
    __typename?: 'PreviewAccountPayload';
    previewAccount: { __typename?: 'PreviewAccount'; id: string };
  };
};

export type GetPublicPreviewAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<StateEnum>;
}>;

export type GetPublicPreviewAccountsQuery = {
  __typename?: 'Query';
  previewAccounts: {
    __typename?: 'PreviewAccountPageConnection';
    collection: Array<{
      __typename?: 'PreviewAccount';
      id: string;
      name: string;
      district: { __typename?: 'District'; id: string };
    }>;
    paginationInfo?: {
      __typename?: 'PreviewAccountPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetPreviewAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetPreviewAccountQuery = {
  __typename?: 'Query';
  previewAccount: {
    __typename?: 'PreviewAccount';
    id: string;
    activityPeriodStart: any;
    activityPeriodEnd: any;
    state: StateEnum;
    registrationToken: string;
    opportunity?: string | null;
    accountExecutiveFirstName?: string | null;
    accountExecutiveLastName?: string | null;
    externalSystem?: DemoExternalSystemEnum | null;
    products: Array<{
      __typename?: 'Product';
      id: string;
      productType: ProductTypeEnum;
    }>;
    productGroups: Array<{ __typename?: 'ProductGroup'; id: string }>;
  };
};

export type UpdatePreviewAccountTeacherMutationVariables = Exact<{
  input: UpdatePreviewAccountTeacherInput;
}>;

export type UpdatePreviewAccountTeacherMutation = {
  __typename?: 'Mutation';
  updatePreviewAccountTeacher: {
    __typename?: 'PreviewAccountTeacherPayload';
    previewAccountTeacher: { __typename?: 'PreviewAccountTeacher'; id: string };
  };
};

export type UploadPreviewAccountsCsvMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;

export type UploadPreviewAccountsCsvMutation = {
  __typename?: 'Mutation';
  createPreviewAccountsCsvPostObject: {
    __typename?: 'DemoImportCsvPostObjectPayload';
    fileKey: string;
    formAttributes: string;
    formInputs: string;
  };
};

export type CreateDistrictMutationVariables = Exact<{
  input: CreateDistrictInput;
}>;

export type CreateDistrictMutation = {
  __typename?: 'Mutation';
  createDistrict?: {
    __typename?: 'createDistrictPayload';
    clientMutationId?: string | null;
    district?: {
      __typename?: 'District';
      globalName: string;
      id: string;
      localName: string;
      state: StateEnum;
      city?: string | null;
    } | null;
  } | null;
};

export type GetProductGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetProductGroupQuery = {
  __typename?: 'Query';
  productGroup: {
    __typename?: 'ProductGroup';
    name: string;
    key?: string | null;
    products: Array<{ __typename?: 'Product'; id: string }>;
  };
};

export type UpdateProductGroupMutationVariables = Exact<{
  input: UpdateProductGroupInput;
}>;

export type UpdateProductGroupMutation = {
  __typename?: 'Mutation';
  updateProductGroup: {
    __typename?: 'ProductGroupPayload';
    productGroup: { __typename?: 'ProductGroup'; id: string; name: string };
  };
};

export type CreateProductGroupMutationVariables = Exact<{
  input: CreateProductGroupInput;
}>;

export type CreateProductGroupMutation = {
  __typename?: 'Mutation';
  createProductGroup: {
    __typename?: 'ProductGroupPayload';
    productGroup: {
      __typename?: 'ProductGroup';
      id: string;
      name: string;
      key?: string | null;
    };
  };
};

export type GetPreviewAccountTeachersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PreviewAccountTeacherFilterInput>;
}>;

export type GetPreviewAccountTeachersQuery = {
  __typename?: 'Query';
  previewAccountTeachers: {
    __typename?: 'PreviewAccountTeacherPageConnection';
    collection: Array<{
      __typename?: 'PreviewAccountTeacher';
      id: string;
      email: string;
      firstName: string;
      lastName: string;
      user: {
        __typename?: 'User';
        active: boolean;
        username: string;
        inactivityReason?: UserInactivityReasonEnum | null;
      };
      previewAccount: {
        __typename?: 'PreviewAccount';
        id: string;
        state: StateEnum;
      };
    }>;
    paginationInfo?: {
      __typename?: 'PreviewAccountTeacherPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetPreviewAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PreviewAccountFilterInput>;
  order?: InputMaybe<PreviewAccountOrderInput>;
}>;

export type GetPreviewAccountsQuery = {
  __typename?: 'Query';
  previewAccounts: {
    __typename?: 'PreviewAccountPageConnection';
    collection: Array<{
      __typename?: 'PreviewAccount';
      id: string;
      active: boolean;
      activityPeriodStart: any;
      activityPeriodEnd: any;
      firstLoginDate?: any | null;
      registrationToken: string;
      state: StateEnum;
      district: {
        __typename?: 'District';
        id: string;
        localName: string;
        state: StateEnum;
      };
      products: Array<{
        __typename?: 'Product';
        id: string;
        description: string;
        productType: ProductTypeEnum;
      }>;
      productGroups: Array<{
        __typename?: 'ProductGroup';
        id: string;
        name: string;
        products: Array<{
          __typename?: 'Product';
          productType: ProductTypeEnum;
        }>;
      }>;
      teachers: Array<{
        __typename?: 'PreviewAccountTeacher';
        id: string;
        email: string;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'PreviewAccountPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetProductQuery = {
  __typename?: 'Query';
  product: {
    __typename?: 'Product';
    id: string;
    sku: string;
    productType: ProductTypeEnum;
    description: string;
    scopeGroups: Array<{ __typename?: 'ScopeGroup'; _id: string; id: string }>;
    contentGroups: Array<{
      __typename?: 'ContentGroup';
      id: string;
      _id: string;
    }>;
  };
};

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;

export type CreateProductMutation = {
  __typename?: 'Mutation';
  createProduct: {
    __typename?: 'ProductPayload';
    product: {
      __typename?: 'Product';
      id: string;
      sku: string;
      description: string;
    };
  };
};

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;

export type UpdateProductMutation = {
  __typename?: 'Mutation';
  updateProduct: {
    __typename?: 'ProductPayload';
    product: {
      __typename?: 'Product';
      id: string;
      sku: string;
      productType: ProductTypeEnum;
      description: string;
      scopeGroups: Array<{
        __typename?: 'ScopeGroup';
        _id: string;
        id: string;
      }>;
      contentGroups: Array<{
        __typename?: 'ContentGroup';
        id: string;
        _id: string;
      }>;
    };
  };
};

export type GetProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductFilterInput>;
}>;

export type GetProductsQuery = {
  __typename?: 'Query';
  products: {
    __typename?: 'ProductPageConnection';
    collection: Array<{
      __typename?: 'Product';
      id: string;
      sku: string;
      productType: ProductTypeEnum;
      description: string;
      scopeGroups: Array<{
        __typename?: 'ScopeGroup';
        _id: string;
        id: string;
      }>;
      contentGroups: Array<{
        __typename?: 'ContentGroup';
        _id: string;
        id: string;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'ProductPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetActivitiesByItemQueryVariables = Exact<{
  input: AssessmentPoolInput;
}>;

export type GetActivitiesByItemQuery = {
  __typename?: 'Query';
  assessmentPool: {
    __typename?: 'AssessmentPoolPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminAssessmentPoolPayload';
      list: Array<{
        __typename?: 'PlatformAdminAssessmentItemPayload';
        id: string;
        title?: string | null;
        tags: Array<{ __typename?: 'TagPayload'; name: string; value: string }>;
      }>;
    } | null;
  };
};

export type AttachQuestionContainerMutationVariables = Exact<{
  input: AttachQuestionContainerInput;
}>;

export type AttachQuestionContainerMutation = {
  __typename?: 'Mutation';
  attachQuestionContainer: {
    __typename?: 'QuestionContainerPayload';
    statusPayload?: { __typename?: 'StatusPayload'; success: boolean } | null;
  };
};

export type AssessmentQuestionListQueryVariables = Exact<{
  lesson?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<PurposeEnum>;
  category?: InputMaybe<EdgexlCategoryEnum>;
  grade?: InputMaybe<EdgexlGradeEnum>;
  standards?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  units?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  topics?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  concepts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type AssessmentQuestionListQuery = {
  __typename?: 'Query';
  questionPool: {
    __typename?: 'QuestionPoolPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminQuestionPoolPayload';
      next: string;
      list: Array<{
        __typename?: 'PlatformAdminActivityPoolPayload';
        id: string;
        title?: string | null;
        items: Array<{
          __typename?: 'PlatformAdminQuestionItemPayload';
          id: string;
          questionType?: string | null;
          tags: Array<{
            __typename?: 'TagPayload';
            name: string;
            value: string;
          }>;
        }>;
        tags: Array<{ __typename?: 'TagPayload'; name: string; value: string }>;
      }>;
    } | null;
  };
};

export type GetAssessmentQuestionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAssessmentQuestionQuery = {
  __typename?: 'Query';
  question: {
    __typename?: 'QuestionPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminQuestionPayload';
      item?: {
        __typename?: 'PlatformAdminQuestionItemPayload';
        id: string;
        tags: Array<{ __typename?: 'TagPayload'; name: string; value: string }>;
      } | null;
    } | null;
  };
};

export type UpdateQuestionMutationVariables = Exact<{
  input: UpdateQuestionInput;
}>;

export type UpdateQuestionMutation = {
  __typename?: 'Mutation';
  updateQuestion: {
    __typename: 'QuestionPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminQuestionPayload';
      signedRequest: string;
      item?: {
        __typename?: 'PlatformAdminQuestionItemPayload';
        id: string;
        questionId: string;
        tags: Array<{ __typename?: 'TagPayload'; name: string; value: string }>;
      } | null;
    } | null;
  };
};

export type GetQuestionDetailQueryVariables = Exact<{
  input: QuestionInput;
}>;

export type GetQuestionDetailQuery = {
  __typename?: 'Query';
  question: {
    __typename?: 'QuestionPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminQuestionPayload';
      signedRequest: string;
    } | null;
  };
};

export type CreateActivityMutationVariables = Exact<{
  input: CreateQuestionContainerInput;
}>;

export type CreateActivityMutation = {
  __typename?: 'Mutation';
  createQuestionContainer: {
    __typename?: 'QuestionContainerPayload';
    statusPayload?: { __typename?: 'StatusPayload'; success: boolean } | null;
  };
};

export type GetItemTitleQueryVariables = Exact<{
  filter?: InputMaybe<MathNationScopeFilter>;
}>;

export type GetItemTitleQuery = {
  __typename?: 'Query';
  mnScopes: {
    __typename?: 'MathNationScopes';
    collection?: Array<{
      __typename?: 'SearchableMathNationScope';
      id: string;
      category: string;
      grade: string;
      displayName: string;
      contentAudience: AudienceEnum;
      projectTitles?: any | null;
    }> | null;
  };
};

export type CreateSignRequestMutationVariables = Exact<{
  input?: InputMaybe<CreateSignRequestInput>;
}>;

export type CreateSignRequestMutation = {
  __typename?: 'Mutation';
  createSignRequest: {
    __typename?: 'SignRequestPayload';
    signedRequest: string;
  };
};

export type GetKnowledgeTreeDataQueryVariables = Exact<{
  input: AdminKnowledgeTreeInput;
}>;

export type GetKnowledgeTreeDataQuery = {
  __typename?: 'Query';
  adminKnowledgeTree: {
    __typename?: 'KnowledgeTreePayload';
    standards: Array<{
      __typename?: 'StandardPayload';
      color: string;
      xCoordinate: number;
      id: number;
      desc: string;
      yCoordinate: number;
      standard: string;
    }>;
    edges: Array<{ __typename?: 'EdgePayload'; from: number; to: number }>;
  };
};

export type UpdateActivityItemMutationVariables = Exact<{
  input: UpdateAssessmentInput;
}>;

export type UpdateActivityItemMutation = {
  __typename?: 'Mutation';
  updateAssessment: {
    __typename?: 'AssessmentPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminUpdateAssessmentPayload';
      item?: {
        __typename?: 'PlatformAdminAssessmentItemPayload';
        id: string;
        items: Array<string>;
        title?: string | null;
      } | null;
    } | null;
  };
};

export type GetStudentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
}>;

export type GetStudentsQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserPageConnection';
    collection?: Array<{
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null> | null;
    paginationInfo: {
      __typename?: 'UserPaginationInfo';
      totalCount: number;
      lastPage: number;
    };
  } | null;
};

export type GetAllSchoolsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllSchoolsQuery = {
  __typename?: 'Query';
  schools?: {
    __typename?: 'SchoolPageConnection';
    collection?: Array<{
      __typename?: 'School';
      _id: string;
      globalName: string;
    } | null> | null;
  } | null;
};

export type StartImpersonationMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type StartImpersonationMutation = {
  __typename?: 'Mutation';
  createImpersonation?: {
    __typename?: 'createImpersonationPayload';
    impersonation?: {
      __typename?: 'createImpersonationPayloadData';
      user?: {
        __typename?: 'createUserNestedPayload';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CreateSchoolMutationVariables = Exact<{
  input: CreateSchoolInput;
}>;

export type CreateSchoolMutation = {
  __typename?: 'Mutation';
  createSchool?: {
    __typename?: 'createSchoolPayload';
    clientMutationId?: string | null;
    school?: {
      __typename?: 'School';
      globalName: string;
      id: string;
      _id: string;
      localName: string;
      districtId: string;
      city?: string | null;
    } | null;
  } | null;
};

export type GetStandardsQuestionsQueryVariables = Exact<{
  input: QuestionsInput;
}>;

export type GetStandardsQuestionsQuery = {
  __typename?: 'Query';
  questions: {
    __typename?: 'QuestionsPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminQuestionsPayload';
      list: Array<{
        __typename?: 'PlatformAdminQuestionItemPayload';
        id: string;
        questionId: string;
        tags: Array<{ __typename?: 'TagPayload'; name: string; value: string }>;
      }>;
    } | null;
  };
};

export type GetSchoolQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetSchoolQuery = {
  __typename?: 'Query';
  school?: {
    __typename?: 'School';
    globalName: string;
    id: string;
    localName: string;
    districtId: string;
    city?: string | null;
    ncesId?: string | null;
    mathNationId?: string | null;
    district: { __typename?: 'District'; _id: string; globalName: string };
  } | null;
};

export type GetSchoolsAdminQueryVariables = Exact<{
  id_list?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  districtId?: InputMaybe<Scalars['String']>;
}>;

export type GetSchoolsAdminQuery = {
  __typename?: 'Query';
  schools?: {
    __typename?: 'SchoolPageConnection';
    collection?: Array<{
      __typename?: 'School';
      globalName: string;
      id: string;
      _id: string;
      name: string;
    } | null> | null;
  } | null;
};

export type UpdateSchoolMutationVariables = Exact<{
  input: UpdateSchoolInput;
}>;

export type UpdateSchoolMutation = {
  __typename?: 'Mutation';
  updateSchool?: {
    __typename?: 'updateSchoolPayload';
    clientMutationId?: string | null;
    school?: {
      __typename?: 'School';
      globalName: string;
      id: string;
      localName: string;
      districtId: string;
      city?: string | null;
      district: { __typename?: 'District'; _id: string; globalName: string };
    } | null;
  } | null;
};

export type GetSchoolsListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<
    Array<InputMaybe<SchoolFilter_Order>> | InputMaybe<SchoolFilter_Order>
  >;
  filter?: InputMaybe<
    Array<InputMaybe<SchoolFilter>> | InputMaybe<SchoolFilter>
  >;
}>;

export type GetSchoolsListQuery = {
  __typename?: 'Query';
  schools?: {
    __typename?: 'SchoolPageConnection';
    collection?: Array<{
      __typename?: 'School';
      globalName: string;
      localName: string;
      id: string;
      _id: string;
      city?: string | null;
      name: string;
      mathNationId?: string | null;
      district: {
        __typename?: 'District';
        globalName: string;
        state: StateEnum;
        id: string;
      };
    } | null> | null;
    paginationInfo: {
      __typename?: 'SchoolPaginationInfo';
      totalCount: number;
      lastPage: number;
      itemsPerPage: number;
    };
  } | null;
};

export type GetStandardsListQueryVariables = Exact<{
  input: StandardListInput;
}>;

export type GetStandardsListQuery = {
  __typename?: 'Query';
  standardList: { __typename?: 'StandardListPayload'; standards: string };
};

export type GetAllStandardsListQueryVariables = Exact<{
  input: StandardsListInput;
}>;

export type GetAllStandardsListQuery = {
  __typename?: 'Query';
  standardsList: {
    __typename?: 'StandardsListResponse';
    total: number;
    data: Array<{
      __typename?: 'StandardsPayload';
      description?: string | null;
      id?: number | null;
      response?: string | null;
      standard: string;
      state?: string | null;
      status: boolean;
      subject?: string | null;
    }>;
  };
};

export type CreateStandardQueryVariables = Exact<{
  input: StandardsInput;
}>;

export type CreateStandardQuery = {
  __typename?: 'Query';
  createStandard: {
    __typename?: 'StandardsPayload';
    description?: string | null;
    id?: number | null;
    response?: string | null;
    standard: string;
    state?: string | null;
    status: boolean;
    subject?: string | null;
  };
};

export type DeleteStandardQueryVariables = Exact<{
  input: StandardDeleteInput;
}>;

export type DeleteStandardQuery = {
  __typename?: 'Query';
  deteleStandard: {
    __typename?: 'StandardDeletePayload';
    response: string;
    standardId?: string | null;
    status: boolean;
  };
};

export type UpdateSubscriptionPackageMutationVariables = Exact<{
  updateSubscriptionPackageInput: UpdateSubscriptionPackageInput;
}>;

export type UpdateSubscriptionPackageMutation = {
  __typename?: 'Mutation';
  updateSubscriptionPackage: {
    __typename?: 'SubscriptionPackagePayload';
    subscriptionPackage: {
      __typename?: 'SubscriptionPackage';
      id: string;
      schools: Array<{
        __typename?: 'School';
        globalName: string;
        district: { __typename?: 'District'; globalName: string };
      }>;
    };
  };
};

export type GetSubscriptionPackageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetSubscriptionPackageQuery = {
  __typename?: 'Query';
  subscriptionPackage: {
    __typename?: 'SubscriptionPackage';
    id: string;
    scope: SubscriptionScopeEnum;
    schools: Array<{
      __typename?: 'School';
      _id: string;
      localName: string;
      globalName: string;
      district: {
        __typename?: 'District';
        id: string;
        _id: string;
        state: StateEnum;
        localName: string;
        globalName: string;
      };
    }>;
    subscriptions: Array<{
      __typename?: 'Subscription';
      id: string;
      dateEnd: any;
      dateStart: any;
      quantity: number;
      products: Array<{
        __typename?: 'Product';
        id: string;
        sku: string;
        description: string;
      }>;
    }>;
  };
};

export type CreateSubscriptionMutationVariables = Exact<{
  createSubscriptionInput: CreateSubscriptionInput;
}>;

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation';
  createSubscription: {
    __typename?: 'SubscriptionPayload';
    subscription: { __typename?: 'Subscription'; id: string };
  };
};

export type CreateSubscriptionPackageMutationVariables = Exact<{
  createSubscriptionPackageInput: CreateSubscriptionPackageInput;
}>;

export type CreateSubscriptionPackageMutation = {
  __typename?: 'Mutation';
  createSubscriptionPackage: {
    __typename?: 'SubscriptionPackagePayload';
    subscriptionPackage: {
      __typename?: 'SubscriptionPackage';
      id: string;
      schools: Array<{
        __typename?: 'School';
        globalName: string;
        district: { __typename?: 'District'; globalName: string };
      }>;
    };
  };
};

export type UpdateSubscriptionMutationVariables = Exact<{
  updateSubscriptionInput: UpdateSubscriptionInput;
}>;

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation';
  updateSubscription: {
    __typename?: 'SubscriptionPayload';
    subscription: { __typename?: 'Subscription'; id: string };
  };
};

export type ListTagProjectsQueryVariables = Exact<{ [key: string]: never }>;

export type ListTagProjectsQuery = {
  __typename?: 'Query';
  listTagProjects: {
    __typename?: 'ListTagProjectPayload';
    data: Array<{
      __typename?: 'ListTagDataPayload';
      id: number;
      category?: string | null;
      name?: string | null;
      projectTitle?: string | null;
    }>;
  };
};

export type UpdateStandardTagsMutationVariables = Exact<{
  input: UpdateStandardTagsInput;
}>;

export type UpdateStandardTagsMutation = {
  __typename?: 'Mutation';
  updateStandardTags: {
    __typename?: 'UpdateStandardTagsPayload';
    status: string;
  };
};

export type CheckStaffOnExistenceQueryVariables = Exact<{
  staffId?: InputMaybe<Scalars['String']>;
  withStaffId: Scalars['Boolean'];
  withLmsId: Scalars['Boolean'];
  lmsId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
}>;

export type CheckStaffOnExistenceQuery = {
  __typename?: 'Query';
  usersByStaffId?: {
    __typename?: 'UserPageConnection';
    collection?: Array<{ __typename?: 'User'; id: string } | null> | null;
  } | null;
  usersByLmsId?: {
    __typename?: 'UserPageConnection';
    collection?: Array<{ __typename?: 'User'; id: string } | null> | null;
  } | null;
};

export type GetProductGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductGroupFilterInput>;
}>;

export type GetProductGroupsQuery = {
  __typename?: 'Query';
  productGroups: {
    __typename?: 'ProductGroupPageConnection';
    collection: Array<{
      __typename?: 'ProductGroup';
      id: string;
      key?: string | null;
      name: string;
      products: Array<{
        __typename?: 'Product';
        id: string;
        productType: ProductTypeEnum;
        contentGroups: Array<{
          __typename?: 'ContentGroup';
          _id: string;
          id: string;
        }>;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'ProductGroupPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
  products: {
    __typename?: 'ProductPageConnection';
    collection: Array<{
      __typename?: 'Product';
      id: string;
      sku: string;
      productType: ProductTypeEnum;
      description: string;
      scopeGroups: Array<{
        __typename?: 'ScopeGroup';
        _id: string;
        id: string;
      }>;
      contentGroups: Array<{
        __typename?: 'ContentGroup';
        _id: string;
        id: string;
      }>;
    }>;
  };
};

export type CreateReviewerMutationVariables = Exact<{
  input: CreateAdoptionReviewerInput;
}>;

export type CreateReviewerMutation = {
  __typename?: 'Mutation';
  createAdoptionReviewer: {
    __typename?: 'AdoptionReviewerPayload';
    adoptionReviewer: {
      __typename?: 'AdoptionReviewer';
      id: string;
      user: { __typename?: 'User'; username: string };
    };
  };
};

export type GetAllTutorsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllTutorsQuery = {
  __typename?: 'Query';
  tutors: {
    __typename?: 'TutorPageConnection';
    collection: Array<{
      __typename?: 'Tutor';
      id: string;
      firstName: string;
      lastName?: string | null;
    }>;
  };
};

export type AddQuestionsToVideoMutationVariables = Exact<{
  input: AddQuestionsToVideoInput;
}>;

export type AddQuestionsToVideoMutation = {
  __typename?: 'Mutation';
  addQuestionsToVideo: {
    __typename?: 'VideoPayload';
    video: { __typename?: 'Video'; id: string } | { __typename?: 'Pdf' };
  };
};

export type UploadVideoMutationVariables = Exact<{
  fileName: Scalars['String'];
  groupIdentifier?: InputMaybe<Scalars['String']>;
  groupType: VideoGroupEnum;
  userId?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['String']>;
  forceCreate: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  glossaryTerm?: InputMaybe<Scalars['String']>;
  mediaType?: InputMaybe<MediaTypeEnum>;
  k5?: InputMaybe<Scalars['Boolean']>;
}>;

export type UploadVideoMutation = {
  __typename?: 'Mutation';
  createVideoPostObject: {
    __typename?: 'VideoPostObjectPayload';
    id: string;
    fileKey: string;
    formAttributes: string;
    formInputs: string;
  };
};

export type GetVideosListQueryVariables = Exact<{
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  filter: VideoFilterInput;
}>;

export type GetVideosListQuery = {
  __typename?: 'Query';
  videos: {
    __typename?: 'UnionVideoPdfPageConnection';
    collection: Array<
      | {
          __typename?: 'Video';
          id: string;
          fileName: string;
          mnIdentifier?: string | null;
          videoIndex?: string | null;
          active: boolean;
          groupIdentifier: string;
          questionList: Array<string>;
          videoUrl: string;
          spriteUrl?: string | null;
          subtitlesUrl?: string | null;
          processStatus: VideoProcessStatusEnum;
          description?: string | null;
          glossary: boolean;
          glossaryTerm?: string | null;
          k5: boolean;
          tutor?: {
            __typename?: 'Tutor';
            id: string;
            firstName: string;
            lastName?: string | null;
            initialTag: LanguageTagEnum;
          } | null;
        }
      | {
          __typename?: 'Pdf';
          id: string;
          url: string;
          groupIdentifier: string;
          fileName: string;
          entityId: string;
        }
    >;
    paginationInfo?: {
      __typename?: 'UnionVideoPdfPaginationInfo';
      lastPage?: number | null;
      itemsPerPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type MoveVideoMutationVariables = Exact<{
  fromMovedInput: FromMoveVideoInput;
  toMovedInput: ToMoveVideoInput;
  groupType: VideoGroupEnum;
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  glossaryTerm?: InputMaybe<Scalars['String']>;
  mediaType?: InputMaybe<MediaTypeEnum>;
  k5?: InputMaybe<Scalars['Boolean']>;
  videoId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type MoveVideoMutation = {
  __typename?: 'Mutation';
  moveVideo: {
    __typename?: 'VideoPayload';
    video:
      | { __typename?: 'Video'; mnIdentifier?: string | null; id: string }
      | { __typename?: 'Pdf'; id: string };
  };
};

export type DeleteVideoMutationVariables = Exact<{
  videoIndex?: InputMaybe<Scalars['String']>;
  groupIdentifier: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  groupType: VideoGroupEnum;
  mediaType?: InputMaybe<MediaTypeEnum>;
}>;

export type DeleteVideoMutation = {
  __typename?: 'Mutation';
  deleteVideo: {
    __typename?: 'VideoPayload';
    video:
      | { __typename?: 'Video'; id: string }
      | { __typename?: 'Pdf'; id: string };
  };
};

export type GetQuestionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetQuestionQuery = {
  __typename?: 'Query';
  question: {
    __typename?: 'QuestionPayload';
    platformAdminPayload?: {
      __typename?: 'PlatformAdminQuestionPayload';
      item?: {
        __typename?: 'PlatformAdminQuestionItemPayload';
        id: string;
        questionId: string;
      } | null;
    } | null;
  };
};

export type PreviewQuestionMutationVariables = Exact<{
  items: Array<Scalars['String']> | Scalars['String'];
}>;

export type PreviewQuestionMutation = {
  __typename?: 'Mutation';
  createSignRequest: {
    __typename?: 'SignRequestPayload';
    signedRequest: string;
  };
};

export type UploadStemscopesVideoMutationVariables = Exact<{
  input: CreateStemscopesMediaPostObjectInput;
}>;

export type UploadStemscopesVideoMutation = {
  __typename?: 'Mutation';
  createStemscopesMediaPostObject: {
    __typename?: 'StemscopesMediaPostObjectPayload';
    videoPostObject: {
      __typename?: 'MediaPostObject';
      formInputs: string;
      fileKey: string;
      formAttributes: string;
    };
    subtitlesPostObject?: {
      __typename?: 'MediaPostObject';
      formInputs: string;
      fileKey: string;
      formAttributes: string;
    } | null;
  };
};

export type GetStemscopesMediasQueryVariables = Exact<{
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  filter: StemscopesMediaFilterInput;
}>;

export type GetStemscopesMediasQuery = {
  __typename?: 'Query';
  stemscopesMedias: {
    __typename?: 'StemscopesMediaPageConnection';
    collection: Array<{
      __typename?: 'StemscopesMedia';
      id: string;
      quality?: VideoQualityEnum | null;
      language: LanguageEnum;
      title: string;
      url?: string | null;
      active: boolean;
      type: MediaTypeEnum;
      subtitlesSrtFormat: boolean;
      area: StemscopesVideoAreaEnum;
      status: VideoProcessStatusEnum;
      createdAt: any;
    }>;
    paginationInfo?: {
      __typename?: 'StemscopesMediaPaginationInfo';
      lastPage?: number | null;
      itemsPerPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type UpdateStemscopesMediaMutationVariables = Exact<{
  input: UpdateStemscopesMediaInput;
}>;

export type UpdateStemscopesMediaMutation = {
  __typename?: 'Mutation';
  updateStemscopesMedia: {
    __typename?: 'StemscopesMediaPostObjectPayload';
    videoPostObject: {
      __typename?: 'MediaPostObject';
      formInputs: string;
      fileKey: string;
      formAttributes: string;
    };
    subtitlesPostObject?: {
      __typename?: 'MediaPostObject';
      formInputs: string;
      fileKey: string;
      formAttributes: string;
    } | null;
  };
};

export type DeleteStemscopesMediaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteStemscopesMediaMutation = {
  __typename?: 'Mutation';
  deleteStemscopesMedia: {
    __typename?: 'StemscopesMediaPayload';
    media: { __typename?: 'StemscopesMedia'; id: string };
  };
};

export type UploadStreamingVideoMutationVariables = Exact<{
  input: CreateStreamingVideoPostObjectInput;
}>;

export type UploadStreamingVideoMutation = {
  __typename?: 'Mutation';
  createStreamingVideoPostObject: {
    __typename?: 'VideoPostObjectPayload';
    id: string;
    fileKey: string;
    formAttributes: string;
    formInputs: string;
  };
};

export type GetStreamingVideosQueryVariables = Exact<{
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  filter?: InputMaybe<StreamingVideoFilterInput>;
}>;

export type GetStreamingVideosQuery = {
  __typename?: 'Query';
  streamingVideos: {
    __typename?: 'StreamingVideoPageConnection';
    collection: Array<{
      __typename?: 'StreamingVideo';
      id: string;
      quality?: VideoQualityEnum | null;
      language: LanguageEnum;
      title: string;
      url: string;
      active: boolean;
      type: MediaTypeEnum;
      duration?: string | null;
      date?: string | null;
    }>;
    paginationInfo?: {
      __typename?: 'StreamingVideoPaginationInfo';
      lastPage?: number | null;
      itemsPerPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type UpdateStreamingVideoMutationVariables = Exact<{
  input: UpdateStreamingVideoInput;
}>;

export type UpdateStreamingVideoMutation = {
  __typename?: 'Mutation';
  updateStreamingVideo: {
    __typename?: 'VideoPostObjectPayload';
    id: string;
    formInputs: string;
    fileKey: string;
    formAttributes: string;
  };
};

export type DeleteStreamingVideoMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteStreamingVideoMutation = {
  __typename?: 'Mutation';
  deleteStreamingVideo: {
    __typename?: 'StreamingVideoPayload';
    video: { __typename?: 'StreamingVideo'; id: string };
  };
};

export type AddLinkedVideoMutationVariables = Exact<{
  input: AddLinkedVideoInput;
}>;

export type AddLinkedVideoMutation = {
  __typename?: 'Mutation';
  addLinkedVideo: {
    __typename?: 'VideoPayload';
    video: { __typename?: 'Video'; id: string } | { __typename?: 'Pdf' };
  };
};

export type GetLinkedVideosForVideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetLinkedVideosForVideoQuery = {
  __typename?: 'Query';
  video: {
    __typename?: 'VideoPayload';
    video:
      | {
          __typename?: 'Video';
          linkedVideos: {
            __typename?: 'UnionVideoPdfPageConnection';
            collection: Array<
              | {
                  __typename?: 'Video';
                  id: string;
                  mnIdentifier?: string | null;
                  groupIdentifier: string;
                  videoIndex?: string | null;
                  glossaryTerm?: string | null;
                  k5: boolean;
                  tutor?: { __typename?: 'Tutor'; id: string } | null;
                }
              | { __typename?: 'Pdf' }
            >;
          };
        }
      | { __typename?: 'Pdf' };
  };
};

export type GetSubscriptionPackagesQueryVariables = Exact<{
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  filter?: InputMaybe<SubscriptionPackageFilterInput>;
}>;

export type GetSubscriptionPackagesQuery = {
  __typename?: 'Query';
  subscriptionPackages: {
    __typename?: 'SubscriptionPackagePageConnection';
    collection: Array<{
      __typename?: 'SubscriptionPackage';
      id: string;
      schools: Array<{
        __typename?: 'School';
        localName: string;
        globalName: string;
        district: {
          __typename?: 'District';
          state: StateEnum;
          localName: string;
          globalName: string;
        };
      }>;
      subscriptions: Array<{
        __typename?: 'Subscription';
        products: Array<{ __typename?: 'Product'; sku: string }>;
      }>;
    }>;
    paginationInfo?: {
      __typename?: 'SubscriptionPackagePaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetReviewerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReviewerQuery = {
  __typename?: 'Query';
  adoptionReviewer: {
    __typename?: 'AdoptionReviewer';
    id: string;
    beginDate?: any | null;
    expirationDate?: any | null;
    type: AdoptionReviewerTypeEnum;
    multiSession: boolean;
    adoptionAccount: {
      __typename?: 'AdoptionAccount';
      id: string;
      name: string;
      state: StateEnum;
      adoptionEvent: {
        __typename?: 'AdoptionEvent';
        name: string;
        id: string;
        expirationDate?: any | null;
        beginDate?: any | null;
      };
    };
    user: {
      __typename?: 'User';
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      middleName?: string | null;
      plainPassword?: string | null;
      active: boolean;
      username: string;
      userRoles?: {
        __typename?: 'UserRolePageConnection';
        collection?: Array<{
          __typename?: 'UserRole';
          id: string;
          roleId: string;
        } | null> | null;
      } | null;
    };
  };
};

export type GetRoleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetRoleQuery = {
  __typename?: 'Query';
  role?: { __typename?: 'Role'; code?: RoleCodeEnum | null } | null;
};

export type GetTutorsQueryVariables = Exact<{
  page: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
}>;

export type GetTutorsQuery = {
  __typename?: 'Query';
  tutors: {
    __typename?: 'TutorPageConnection';
    collection: Array<{
      __typename?: 'Tutor';
      id: string;
      bioText: string;
      bioVideo: string;
      depthScale: number;
      firstName: string;
      lastName?: string | null;
      initialTag: LanguageTagEnum;
      order?: number | null;
      mainProfilePhoto: string;
      profilePhoto: string;
    }>;
    paginationInfo?: {
      __typename?: 'TutorPaginationInfo';
      lastPage?: number | null;
      itemsPerPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
};

export type GetTutorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetTutorQuery = {
  __typename?: 'Query';
  tutor: {
    __typename?: 'TutorPayload';
    tutor: {
      __typename?: 'Tutor';
      id: string;
      bioText: string;
      bioVideo: string;
      depthScale: number;
      firstName: string;
      lastName?: string | null;
      initialTag: LanguageTagEnum;
      order?: number | null;
      mainProfilePhoto: string;
      profilePhoto: string;
    };
  };
};

export type CreateTutorMutationVariables = Exact<{
  input: CreateTutorInput;
}>;

export type CreateTutorMutation = {
  __typename?: 'Mutation';
  createTutor: {
    __typename?: 'TutorPayload';
    tutor: { __typename?: 'Tutor'; id: string };
  };
};

export type UpdateTutorMutationVariables = Exact<{
  input: UpdateTutorInput;
}>;

export type UpdateTutorMutation = {
  __typename?: 'Mutation';
  updateTutor: {
    __typename?: 'TutorPayload';
    tutor: { __typename?: 'Tutor'; id: string };
  };
};

export type DeleteTutorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteTutorMutation = {
  __typename?: 'Mutation';
  deleteTutor: {
    __typename?: 'TutorPayload';
    tutor: { __typename?: 'Tutor'; id: string };
  };
};

export type GetUsersQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  sorting?: InputMaybe<
    Array<InputMaybe<UserFilter_Order>> | InputMaybe<UserFilter_Order>
  >;
  filter?: InputMaybe<Array<InputMaybe<UserFilter>> | InputMaybe<UserFilter>>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserPageConnection';
    collection?: Array<{
      __typename?: 'User';
      _id: string;
      id: string;
      preferences?: string | null;
      username: string;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      stateId?: string | null;
      externalSystemName?: string | null;
      email?: string | null;
      active: boolean;
      userRoles?: {
        __typename?: 'UserRolePageConnection';
        collection?: Array<{
          __typename?: 'UserRole';
          schoolIds: any;
          role: {
            __typename?: 'Role';
            code?: RoleCodeEnum | null;
            _id: string;
            id: string;
            name: string;
          };
        } | null> | null;
      } | null;
      district?: {
        __typename?: 'District';
        id: string;
        _id: string;
        localName: string;
        globalName: string;
        state: StateEnum;
      } | null;
    } | null> | null;
    paginationInfo: {
      __typename?: 'UserPaginationInfo';
      totalCount: number;
      lastPage: number;
      itemsPerPage: number;
    };
  } | null;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    active: boolean;
    type: UserTypeEnum;
    username: string;
    plainPassword?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    gradeLevel?: GradeLevelEnum | null;
    districtUuid: string;
    language: LanguageEnum;
    staffId?: string | null;
    stateId?: string | null;
    sisId?: string | null;
    externalId?: string | null;
    externalSystemName?: string | null;
    curriculumAreas?: any | null;
    createdAt: string;
    createdByUsername?: string | null;
    updatedAt?: string | null;
    updatedByUsername?: string | null;
    manualMaintenance?: boolean | null;
    district?: {
      __typename?: 'District';
      _id: string;
      globalName: string;
    } | null;
    userRoles?: {
      __typename?: 'UserRolePageConnection';
      collection?: Array<{
        __typename?: 'UserRole';
        id: string;
        roleId: string;
        schoolIds: any;
        allSchoolsAccess: boolean;
      } | null> | null;
    } | null;
  } | null;
};

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserRolesQuery = {
  __typename?: 'Query';
  roles: {
    __typename?: 'RolePageConnection';
    collection: Array<{
      __typename?: 'Role';
      id: string;
      name: string;
      code?: RoleCodeEnum | null;
    }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser?: {
    __typename?: 'createUserPayload';
    clientMutationId?: string | null;
    user?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'updateUserPayload';
    clientMutationId?: string | null;
    user?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type GetSchoolsQueryVariables = Exact<{
  id_list?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  districtId?: InputMaybe<Scalars['String']>;
}>;

export type GetSchoolsQuery = {
  __typename?: 'Query';
  schools?: {
    __typename?: 'SchoolPageConnection';
    collection?: Array<{
      __typename?: 'School';
      globalName: string;
      id: string;
      _id: string;
      name: string;
      district: {
        __typename?: 'District';
        globalName: string;
        state: StateEnum;
      };
    } | null> | null;
  } | null;
};

export type ApplicationSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicationSettingsQuery = {
  __typename?: 'Query';
  applicationSettings?: {
    __typename?: 'ApplicationSettings';
    value: any;
    id: string;
  } | null;
};

export type CheckStudentOnExistenceQueryVariables = Exact<{
  sisId?: InputMaybe<Scalars['String']>;
  withSisId: Scalars['Boolean'];
  withStateId: Scalars['Boolean'];
  stateId?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['String']>;
}>;

export type CheckStudentOnExistenceQuery = {
  __typename?: 'Query';
  usersBySisId?: {
    __typename?: 'UserPageConnection';
    collection?: Array<{
      __typename?: 'User';
      id: string;
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
      userRoles?: {
        __typename?: 'UserRolePageConnection';
        collection?: Array<{
          __typename?: 'UserRole';
          schoolIds: any;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
  usersByStateId?: {
    __typename?: 'UserPageConnection';
    collection?: Array<{
      __typename?: 'User';
      id: string;
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
      userRoles?: {
        __typename?: 'UserRolePageConnection';
        collection?: Array<{
          __typename?: 'UserRole';
          schoolIds: any;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetReviewersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AdoptionReviewerFilterInput>;
}>;

export type GetReviewersQuery = {
  __typename?: 'Query';
  adoptionReviewers: {
    __typename?: 'AdoptionReviewerPageConnection';
    collection: Array<{
      __typename?: 'AdoptionReviewer';
      id: string;
      active: boolean;
      beginDate?: any | null;
      expirationDate?: any | null;
      type: AdoptionReviewerTypeEnum;
      multiSession: boolean;
      adoptionAccount: {
        __typename?: 'AdoptionAccount';
        id: string;
        name: string;
        adoptionEvent: {
          __typename?: 'AdoptionEvent';
          name: string;
          id: string;
        };
      };
      user: {
        __typename?: 'User';
        id: string;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        plainPassword?: string | null;
        active: boolean;
        username: string;
        userRoles?: {
          __typename?: 'UserRolePageConnection';
          collection?: Array<{
            __typename?: 'UserRole';
            role: {
              __typename?: 'Role';
              id: string;
              code?: RoleCodeEnum | null;
            };
          } | null> | null;
        } | null;
      };
    }>;
    paginationInfo?: {
      __typename?: 'AdoptionReviewerPaginationInfo';
      itemsPerPage?: number | null;
      totalCount?: number | null;
      lastPage?: number | null;
    } | null;
  };
};

export type GetAdoptionReviewersWithTotalCountQueryVariables = Exact<{
  filter?: InputMaybe<AdoptionReviewerFilterInput>;
  itemsPerPage: Scalars['Int'];
  order?: InputMaybe<AdoptionReviewerOrderInput>;
  page: Scalars['Int'];
}>;

export type GetAdoptionReviewersWithTotalCountQuery = {
  __typename?: 'Query';
  reviewersData: {
    __typename?: 'AdoptionReviewerPageConnection';
    collection: Array<{
      __typename?: 'AdoptionReviewer';
      id: string;
      active: boolean;
      beginDate?: any | null;
      expirationDate?: any | null;
      type: AdoptionReviewerTypeEnum;
      multiSession: boolean;
      adoptionAccount: {
        __typename?: 'AdoptionAccount';
        id: string;
        name: string;
        adoptionEvent: {
          __typename?: 'AdoptionEvent';
          name: string;
          id: string;
        };
      };
      user: {
        __typename?: 'User';
        id: string;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        plainPassword?: string | null;
        active: boolean;
        username: string;
        userRoles?: {
          __typename?: 'UserRolePageConnection';
          collection?: Array<{
            __typename?: 'UserRole';
            role: {
              __typename?: 'Role';
              id: string;
              code?: RoleCodeEnum | null;
            };
          } | null> | null;
        } | null;
      };
    }>;
    paginationInfo?: {
      __typename?: 'AdoptionReviewerPaginationInfo';
      lastPage?: number | null;
      totalCount?: number | null;
    } | null;
  };
  reviewersPaginationInfo: {
    __typename?: 'AdoptionReviewerPageConnection';
    paginationInfo?: {
      __typename?: 'AdoptionReviewerPaginationInfo';
      totalCount?: number | null;
    } | null;
  };
};

export type UpdateReviewerMutationVariables = Exact<{
  input: UpdateAdoptionReviewerInput;
}>;

export type UpdateReviewerMutation = {
  __typename?: 'Mutation';
  updateAdoptionReviewer: {
    __typename?: 'AdoptionReviewerPayload';
    adoptionReviewer: {
      __typename?: 'AdoptionReviewer';
      id: string;
      user: { __typename?: 'User'; username: string };
    };
  };
};

export const CreateAdoptionEventDocument = gql`
  mutation createAdoptionEvent($input: CreateAdoptionEventInput!) {
    createAdoptionEvent(input: $input) {
      adoptionEvent {
        id
        name
      }
    }
  }
`;
export type CreateAdoptionEventMutationFn = Apollo.MutationFunction<
  CreateAdoptionEventMutation,
  CreateAdoptionEventMutationVariables
>;

/**
 * __useCreateAdoptionEventMutation__
 *
 * To run a mutation, you first call `useCreateAdoptionEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdoptionEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdoptionEventMutation, { data, loading, error }] = useCreateAdoptionEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdoptionEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdoptionEventMutation,
    CreateAdoptionEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAdoptionEventMutation,
    CreateAdoptionEventMutationVariables
  >(CreateAdoptionEventDocument, options);
}
export type CreateAdoptionEventMutationHookResult = ReturnType<
  typeof useCreateAdoptionEventMutation
>;
export type CreateAdoptionEventMutationResult =
  Apollo.MutationResult<CreateAdoptionEventMutation>;
export type CreateAdoptionEventMutationOptions = Apollo.BaseMutationOptions<
  CreateAdoptionEventMutation,
  CreateAdoptionEventMutationVariables
>;
export const CreateAdoptionReviewerDocument = gql`
  mutation createAdoptionReviewer($input: CreateAdoptionReviewerInput!) {
    createAdoptionReviewer(input: $input) {
      adoptionReviewer {
        id
      }
    }
  }
`;
export type CreateAdoptionReviewerMutationFn = Apollo.MutationFunction<
  CreateAdoptionReviewerMutation,
  CreateAdoptionReviewerMutationVariables
>;

/**
 * __useCreateAdoptionReviewerMutation__
 *
 * To run a mutation, you first call `useCreateAdoptionReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdoptionReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdoptionReviewerMutation, { data, loading, error }] = useCreateAdoptionReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdoptionReviewerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdoptionReviewerMutation,
    CreateAdoptionReviewerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAdoptionReviewerMutation,
    CreateAdoptionReviewerMutationVariables
  >(CreateAdoptionReviewerDocument, options);
}
export type CreateAdoptionReviewerMutationHookResult = ReturnType<
  typeof useCreateAdoptionReviewerMutation
>;
export type CreateAdoptionReviewerMutationResult =
  Apollo.MutationResult<CreateAdoptionReviewerMutation>;
export type CreateAdoptionReviewerMutationOptions = Apollo.BaseMutationOptions<
  CreateAdoptionReviewerMutation,
  CreateAdoptionReviewerMutationVariables
>;
export const CreateAdoptionAccountDocument = gql`
  mutation createAdoptionAccount($input: CreateAdoptionAccountInput!) {
    createAdoptionAccount(input: $input) {
      adoptionAccount {
        id
        name
      }
    }
  }
`;
export type CreateAdoptionAccountMutationFn = Apollo.MutationFunction<
  CreateAdoptionAccountMutation,
  CreateAdoptionAccountMutationVariables
>;

/**
 * __useCreateAdoptionAccountMutation__
 *
 * To run a mutation, you first call `useCreateAdoptionAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdoptionAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdoptionAccountMutation, { data, loading, error }] = useCreateAdoptionAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdoptionAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdoptionAccountMutation,
    CreateAdoptionAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAdoptionAccountMutation,
    CreateAdoptionAccountMutationVariables
  >(CreateAdoptionAccountDocument, options);
}
export type CreateAdoptionAccountMutationHookResult = ReturnType<
  typeof useCreateAdoptionAccountMutation
>;
export type CreateAdoptionAccountMutationResult =
  Apollo.MutationResult<CreateAdoptionAccountMutation>;
export type CreateAdoptionAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateAdoptionAccountMutation,
  CreateAdoptionAccountMutationVariables
>;
export const GetAdoptionAccountDocument = gql`
  query getAdoptionAccount($id: ID!) {
    adoptionAccount(id: $id) {
      id
      name
      state
      active
      registrationToken
      beginDate
      expirationDate
      adoptionEvent {
        id
        name
        category
        beginDate
        expirationDate
        urlCode
      }
      communityAccess {
        id
        active
        beginDate
        expirationDate
        accessToAnswerKeys
        accessToStudentContent
        accessToTeacherContent
        accessToTests
      }
      communityRegistrationToken
    }
  }
`;

/**
 * __useGetAdoptionAccountQuery__
 *
 * To run a query within a React component, call `useGetAdoptionAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdoptionAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdoptionAccountQuery,
    GetAdoptionAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionAccountQuery,
    GetAdoptionAccountQueryVariables
  >(GetAdoptionAccountDocument, options);
}
export function useGetAdoptionAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionAccountQuery,
    GetAdoptionAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionAccountQuery,
    GetAdoptionAccountQueryVariables
  >(GetAdoptionAccountDocument, options);
}
export type GetAdoptionAccountQueryHookResult = ReturnType<
  typeof useGetAdoptionAccountQuery
>;
export type GetAdoptionAccountLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionAccountLazyQuery
>;
export type GetAdoptionAccountQueryResult = Apollo.QueryResult<
  GetAdoptionAccountQuery,
  GetAdoptionAccountQueryVariables
>;
export const GetAdoptionAccountsDocument = gql`
  query getAdoptionAccounts(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: AdoptionAccountFilterInput
    $order: AdoptionAccountOrderInput
  ) {
    adoptionAccounts(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      order: $order
    ) {
      collection {
        active
        district {
          globalName
        }
        id
        name
        registrationToken
        reviewers {
          id
        }
        state
        beginDate
        expirationDate
        adoptionEvent {
          id
          name
          urlCode
          category
        }
        communityAccess {
          active
        }
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetAdoptionAccountsQuery__
 *
 * To run a query within a React component, call `useGetAdoptionAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionAccountsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAdoptionAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdoptionAccountsQuery,
    GetAdoptionAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionAccountsQuery,
    GetAdoptionAccountsQueryVariables
  >(GetAdoptionAccountsDocument, options);
}
export function useGetAdoptionAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionAccountsQuery,
    GetAdoptionAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionAccountsQuery,
    GetAdoptionAccountsQueryVariables
  >(GetAdoptionAccountsDocument, options);
}
export type GetAdoptionAccountsQueryHookResult = ReturnType<
  typeof useGetAdoptionAccountsQuery
>;
export type GetAdoptionAccountsLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionAccountsLazyQuery
>;
export type GetAdoptionAccountsQueryResult = Apollo.QueryResult<
  GetAdoptionAccountsQuery,
  GetAdoptionAccountsQueryVariables
>;
export const GetAdoptionAccountsOptionsDocument = gql`
  query getAdoptionAccountsOptions(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: AdoptionAccountFilterInput
    $order: AdoptionAccountOrderInput
  ) {
    adoptionAccounts(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      order: $order
    ) {
      collection {
        id
        name
      }
    }
  }
`;

/**
 * __useGetAdoptionAccountsOptionsQuery__
 *
 * To run a query within a React component, call `useGetAdoptionAccountsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionAccountsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionAccountsOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAdoptionAccountsOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdoptionAccountsOptionsQuery,
    GetAdoptionAccountsOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionAccountsOptionsQuery,
    GetAdoptionAccountsOptionsQueryVariables
  >(GetAdoptionAccountsOptionsDocument, options);
}
export function useGetAdoptionAccountsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionAccountsOptionsQuery,
    GetAdoptionAccountsOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionAccountsOptionsQuery,
    GetAdoptionAccountsOptionsQueryVariables
  >(GetAdoptionAccountsOptionsDocument, options);
}
export type GetAdoptionAccountsOptionsQueryHookResult = ReturnType<
  typeof useGetAdoptionAccountsOptionsQuery
>;
export type GetAdoptionAccountsOptionsLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionAccountsOptionsLazyQuery
>;
export type GetAdoptionAccountsOptionsQueryResult = Apollo.QueryResult<
  GetAdoptionAccountsOptionsQuery,
  GetAdoptionAccountsOptionsQueryVariables
>;
export const GetAdoptionEventsDocument = gql`
  query getAdoptionEvents(
    $page: Int = 1
    $itemsPerPage: Int = 30
    $filter: AdoptionEventFilterInput
    $order: AdoptionEventOrderInput
  ) {
    adoptionEvents(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      order: $order
    ) {
      collection {
        id
        active
        beginDate
        category
        expirationDate
        name
        productGroups {
          name
          id
        }
        products {
          sku
          id
        }
        urlCode
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetAdoptionEventsQuery__
 *
 * To run a query within a React component, call `useGetAdoptionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAdoptionEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdoptionEventsQuery,
    GetAdoptionEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionEventsQuery,
    GetAdoptionEventsQueryVariables
  >(GetAdoptionEventsDocument, options);
}
export function useGetAdoptionEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionEventsQuery,
    GetAdoptionEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionEventsQuery,
    GetAdoptionEventsQueryVariables
  >(GetAdoptionEventsDocument, options);
}
export type GetAdoptionEventsQueryHookResult = ReturnType<
  typeof useGetAdoptionEventsQuery
>;
export type GetAdoptionEventsLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionEventsLazyQuery
>;
export type GetAdoptionEventsQueryResult = Apollo.QueryResult<
  GetAdoptionEventsQuery,
  GetAdoptionEventsQueryVariables
>;
export const GetAdoptionEventsTotalCountDocument = gql`
  query getAdoptionEventsTotalCount($page: Int = 1, $itemsPerPage: Int = 999) {
    adoptionEvents(page: $page, itemsPerPage: $itemsPerPage) {
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetAdoptionEventsTotalCountQuery__
 *
 * To run a query within a React component, call `useGetAdoptionEventsTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionEventsTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionEventsTotalCountQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetAdoptionEventsTotalCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdoptionEventsTotalCountQuery,
    GetAdoptionEventsTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionEventsTotalCountQuery,
    GetAdoptionEventsTotalCountQueryVariables
  >(GetAdoptionEventsTotalCountDocument, options);
}
export function useGetAdoptionEventsTotalCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionEventsTotalCountQuery,
    GetAdoptionEventsTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionEventsTotalCountQuery,
    GetAdoptionEventsTotalCountQueryVariables
  >(GetAdoptionEventsTotalCountDocument, options);
}
export type GetAdoptionEventsTotalCountQueryHookResult = ReturnType<
  typeof useGetAdoptionEventsTotalCountQuery
>;
export type GetAdoptionEventsTotalCountLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionEventsTotalCountLazyQuery
>;
export type GetAdoptionEventsTotalCountQueryResult = Apollo.QueryResult<
  GetAdoptionEventsTotalCountQuery,
  GetAdoptionEventsTotalCountQueryVariables
>;
export const GetAdoptionReviewersDocument = gql`
  query getAdoptionReviewers(
    $filter: AdoptionReviewerFilterInput
    $itemsPerPage: Int!
    $order: AdoptionReviewerOrderInput = null
    $page: Int!
  ) {
    adoptionReviewers(
      filter: $filter
      itemsPerPage: $itemsPerPage
      order: $order
      page: $page
    ) {
      collection {
        id
        beginDate
        expirationDate
        adoptionAccount {
          id
          name
        }
        user {
          username
          active
        }
        type
        multiSession
      }
      paginationInfo {
        lastPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetAdoptionReviewersQuery__
 *
 * To run a query within a React component, call `useGetAdoptionReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionReviewersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAdoptionReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdoptionReviewersQuery,
    GetAdoptionReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionReviewersQuery,
    GetAdoptionReviewersQueryVariables
  >(GetAdoptionReviewersDocument, options);
}
export function useGetAdoptionReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionReviewersQuery,
    GetAdoptionReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionReviewersQuery,
    GetAdoptionReviewersQueryVariables
  >(GetAdoptionReviewersDocument, options);
}
export type GetAdoptionReviewersQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewersQuery
>;
export type GetAdoptionReviewersLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewersLazyQuery
>;
export type GetAdoptionReviewersQueryResult = Apollo.QueryResult<
  GetAdoptionReviewersQuery,
  GetAdoptionReviewersQueryVariables
>;
export const GetAdoptionReviewersPaginationInfoDocument = gql`
  query getAdoptionReviewersPaginationInfo(
    $filter: AdoptionReviewerFilterInput
    $itemsPerPage: Int! = 0
    $page: Int! = 1
  ) {
    adoptionReviewers(
      filter: $filter
      itemsPerPage: $itemsPerPage
      page: $page
    ) {
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetAdoptionReviewersPaginationInfoQuery__
 *
 * To run a query within a React component, call `useGetAdoptionReviewersPaginationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionReviewersPaginationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionReviewersPaginationInfoQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAdoptionReviewersPaginationInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdoptionReviewersPaginationInfoQuery,
    GetAdoptionReviewersPaginationInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionReviewersPaginationInfoQuery,
    GetAdoptionReviewersPaginationInfoQueryVariables
  >(GetAdoptionReviewersPaginationInfoDocument, options);
}
export function useGetAdoptionReviewersPaginationInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionReviewersPaginationInfoQuery,
    GetAdoptionReviewersPaginationInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionReviewersPaginationInfoQuery,
    GetAdoptionReviewersPaginationInfoQueryVariables
  >(GetAdoptionReviewersPaginationInfoDocument, options);
}
export type GetAdoptionReviewersPaginationInfoQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewersPaginationInfoQuery
>;
export type GetAdoptionReviewersPaginationInfoLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewersPaginationInfoLazyQuery
>;
export type GetAdoptionReviewersPaginationInfoQueryResult = Apollo.QueryResult<
  GetAdoptionReviewersPaginationInfoQuery,
  GetAdoptionReviewersPaginationInfoQueryVariables
>;
export const GetAdoptionReviewerDocument = gql`
  query getAdoptionReviewer($id: ID!) {
    adoptionReviewer(id: $id) {
      id
      beginDate
      expirationDate
      adoptionAccount {
        id
        name
        state
      }
      user {
        id
        username
        active
        plainPassword
      }
      type
      multiSession
    }
  }
`;

/**
 * __useGetAdoptionReviewerQuery__
 *
 * To run a query within a React component, call `useGetAdoptionReviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionReviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionReviewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdoptionReviewerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdoptionReviewerQuery,
    GetAdoptionReviewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionReviewerQuery,
    GetAdoptionReviewerQueryVariables
  >(GetAdoptionReviewerDocument, options);
}
export function useGetAdoptionReviewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionReviewerQuery,
    GetAdoptionReviewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionReviewerQuery,
    GetAdoptionReviewerQueryVariables
  >(GetAdoptionReviewerDocument, options);
}
export type GetAdoptionReviewerQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewerQuery
>;
export type GetAdoptionReviewerLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewerLazyQuery
>;
export type GetAdoptionReviewerQueryResult = Apollo.QueryResult<
  GetAdoptionReviewerQuery,
  GetAdoptionReviewerQueryVariables
>;
export const GetElementsForEventDocument = gql`
  query getElementsForEvent($filter: ElementFilter) {
    elements(filter: $filter) {
      collection {
        projectId
        scopeId
        id
        sectionId
        scopeName
        sectionName
        name
        studentView
      }
    }
  }
`;

/**
 * __useGetElementsForEventQuery__
 *
 * To run a query within a React component, call `useGetElementsForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetElementsForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetElementsForEventQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetElementsForEventQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetElementsForEventQuery,
    GetElementsForEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetElementsForEventQuery,
    GetElementsForEventQueryVariables
  >(GetElementsForEventDocument, options);
}
export function useGetElementsForEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetElementsForEventQuery,
    GetElementsForEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetElementsForEventQuery,
    GetElementsForEventQueryVariables
  >(GetElementsForEventDocument, options);
}
export type GetElementsForEventQueryHookResult = ReturnType<
  typeof useGetElementsForEventQuery
>;
export type GetElementsForEventLazyQueryHookResult = ReturnType<
  typeof useGetElementsForEventLazyQuery
>;
export type GetElementsForEventQueryResult = Apollo.QueryResult<
  GetElementsForEventQuery,
  GetElementsForEventQueryVariables
>;
export const GetAdoptionEventDocument = gql`
  query getAdoptionEvent($id: ID!) {
    adoptionEvent(id: $id) {
      id
      name
      category
      beginDate
      expirationDate
      active
      urlCode
      uiCustomization
      gradeAndActivities {
        grade
        activities
      }
      products {
        id
      }
      productGroups {
        id
      }
    }
  }
`;

/**
 * __useGetAdoptionEventQuery__
 *
 * To run a query within a React component, call `useGetAdoptionEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdoptionEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdoptionEventQuery,
    GetAdoptionEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdoptionEventQuery, GetAdoptionEventQueryVariables>(
    GetAdoptionEventDocument,
    options
  );
}
export function useGetAdoptionEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionEventQuery,
    GetAdoptionEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionEventQuery,
    GetAdoptionEventQueryVariables
  >(GetAdoptionEventDocument, options);
}
export type GetAdoptionEventQueryHookResult = ReturnType<
  typeof useGetAdoptionEventQuery
>;
export type GetAdoptionEventLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionEventLazyQuery
>;
export type GetAdoptionEventQueryResult = Apollo.QueryResult<
  GetAdoptionEventQuery,
  GetAdoptionEventQueryVariables
>;
export const GetAdoptionEventWithAccountsDocument = gql`
  query getAdoptionEventWithAccounts($id: ID!) {
    adoptionEvent(id: $id) {
      id
      name
      beginDate
      expirationDate
      adoptionAccounts {
        id
        name
        state
        beginDate
        expirationDate
        active
      }
    }
  }
`;

/**
 * __useGetAdoptionEventWithAccountsQuery__
 *
 * To run a query within a React component, call `useGetAdoptionEventWithAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionEventWithAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionEventWithAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdoptionEventWithAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdoptionEventWithAccountsQuery,
    GetAdoptionEventWithAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionEventWithAccountsQuery,
    GetAdoptionEventWithAccountsQueryVariables
  >(GetAdoptionEventWithAccountsDocument, options);
}
export function useGetAdoptionEventWithAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionEventWithAccountsQuery,
    GetAdoptionEventWithAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionEventWithAccountsQuery,
    GetAdoptionEventWithAccountsQueryVariables
  >(GetAdoptionEventWithAccountsDocument, options);
}
export type GetAdoptionEventWithAccountsQueryHookResult = ReturnType<
  typeof useGetAdoptionEventWithAccountsQuery
>;
export type GetAdoptionEventWithAccountsLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionEventWithAccountsLazyQuery
>;
export type GetAdoptionEventWithAccountsQueryResult = Apollo.QueryResult<
  GetAdoptionEventWithAccountsQuery,
  GetAdoptionEventWithAccountsQueryVariables
>;
export const GetGradesForEventDocument = gql`
  query getGradesForEvent($contentGroups: [String!]! = []) {
    grades(contentGroups: $contentGroups) {
      grades
    }
  }
`;

/**
 * __useGetGradesForEventQuery__
 *
 * To run a query within a React component, call `useGetGradesForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradesForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradesForEventQuery({
 *   variables: {
 *      contentGroups: // value for 'contentGroups'
 *   },
 * });
 */
export function useGetGradesForEventQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGradesForEventQuery,
    GetGradesForEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGradesForEventQuery,
    GetGradesForEventQueryVariables
  >(GetGradesForEventDocument, options);
}
export function useGetGradesForEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGradesForEventQuery,
    GetGradesForEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGradesForEventQuery,
    GetGradesForEventQueryVariables
  >(GetGradesForEventDocument, options);
}
export type GetGradesForEventQueryHookResult = ReturnType<
  typeof useGetGradesForEventQuery
>;
export type GetGradesForEventLazyQueryHookResult = ReturnType<
  typeof useGetGradesForEventLazyQuery
>;
export type GetGradesForEventQueryResult = Apollo.QueryResult<
  GetGradesForEventQuery,
  GetGradesForEventQueryVariables
>;
export const UpdateAdoptionEventDocument = gql`
  mutation updateAdoptionEvent($input: UpdateAdoptionEventInput!) {
    updateAdoptionEvent(input: $input) {
      adoptionEvent {
        id
        name
        category
        beginDate
        expirationDate
        active
        urlCode
        uiCustomization
        products {
          id
        }
        productGroups {
          id
        }
        gradeAndActivities {
          grade
          activities
        }
      }
    }
  }
`;
export type UpdateAdoptionEventMutationFn = Apollo.MutationFunction<
  UpdateAdoptionEventMutation,
  UpdateAdoptionEventMutationVariables
>;

/**
 * __useUpdateAdoptionEventMutation__
 *
 * To run a mutation, you first call `useUpdateAdoptionEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdoptionEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdoptionEventMutation, { data, loading, error }] = useUpdateAdoptionEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdoptionEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdoptionEventMutation,
    UpdateAdoptionEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdoptionEventMutation,
    UpdateAdoptionEventMutationVariables
  >(UpdateAdoptionEventDocument, options);
}
export type UpdateAdoptionEventMutationHookResult = ReturnType<
  typeof useUpdateAdoptionEventMutation
>;
export type UpdateAdoptionEventMutationResult =
  Apollo.MutationResult<UpdateAdoptionEventMutation>;
export type UpdateAdoptionEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdoptionEventMutation,
  UpdateAdoptionEventMutationVariables
>;
export const UpdateAdoptionAccountDocument = gql`
  mutation updateAdoptionAccount($input: UpdateAdoptionAccountInput!) {
    updateAdoptionAccount(input: $input) {
      adoptionAccount {
        id
        name
        state
        active
      }
    }
  }
`;
export type UpdateAdoptionAccountMutationFn = Apollo.MutationFunction<
  UpdateAdoptionAccountMutation,
  UpdateAdoptionAccountMutationVariables
>;

/**
 * __useUpdateAdoptionAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAdoptionAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdoptionAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdoptionAccountMutation, { data, loading, error }] = useUpdateAdoptionAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdoptionAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdoptionAccountMutation,
    UpdateAdoptionAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdoptionAccountMutation,
    UpdateAdoptionAccountMutationVariables
  >(UpdateAdoptionAccountDocument, options);
}
export type UpdateAdoptionAccountMutationHookResult = ReturnType<
  typeof useUpdateAdoptionAccountMutation
>;
export type UpdateAdoptionAccountMutationResult =
  Apollo.MutationResult<UpdateAdoptionAccountMutation>;
export type UpdateAdoptionAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdoptionAccountMutation,
  UpdateAdoptionAccountMutationVariables
>;
export const GetListContentDocument = gql`
  query getListContent($input: ListContentInput!) {
    listContent(input: $input) {
      course {
        course
        data {
          conceptName
          conceptNumber
          status
          topics {
            status
            topicName
            topicNumber
          }
        }
      }
    }
  }
`;

/**
 * __useGetListContentQuery__
 *
 * To run a query within a React component, call `useGetListContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetListContentQuery,
    GetListContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetListContentQuery, GetListContentQueryVariables>(
    GetListContentDocument,
    options
  );
}
export function useGetListContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListContentQuery,
    GetListContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetListContentQuery, GetListContentQueryVariables>(
    GetListContentDocument,
    options
  );
}
export type GetListContentQueryHookResult = ReturnType<
  typeof useGetListContentQuery
>;
export type GetListContentLazyQueryHookResult = ReturnType<
  typeof useGetListContentLazyQuery
>;
export type GetListContentQueryResult = Apollo.QueryResult<
  GetListContentQuery,
  GetListContentQueryVariables
>;
export const GetUploadStatusDocument = gql`
  query getUploadStatus($id: String!) {
    adoptionReviewerImportRequest(id: $id) {
      importLog {
        message
      }
    }
  }
`;

/**
 * __useGetUploadStatusQuery__
 *
 * To run a query within a React component, call `useGetUploadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUploadStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUploadStatusQuery,
    GetUploadStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUploadStatusQuery, GetUploadStatusQueryVariables>(
    GetUploadStatusDocument,
    options
  );
}
export function useGetUploadStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUploadStatusQuery,
    GetUploadStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUploadStatusQuery,
    GetUploadStatusQueryVariables
  >(GetUploadStatusDocument, options);
}
export type GetUploadStatusQueryHookResult = ReturnType<
  typeof useGetUploadStatusQuery
>;
export type GetUploadStatusLazyQueryHookResult = ReturnType<
  typeof useGetUploadStatusLazyQuery
>;
export type GetUploadStatusQueryResult = Apollo.QueryResult<
  GetUploadStatusQuery,
  GetUploadStatusQueryVariables
>;
export const UploadAdoptionReviewersDocument = gql`
  mutation uploadAdoptionReviewers($input: DemoImportCsvPostObjectInput!) {
    createAdoptionReviewersCsvPostObject(input: $input) {
      fileKey
      formAttributes
      formInputs
      importRequestId
      importItem
    }
  }
`;
export type UploadAdoptionReviewersMutationFn = Apollo.MutationFunction<
  UploadAdoptionReviewersMutation,
  UploadAdoptionReviewersMutationVariables
>;

/**
 * __useUploadAdoptionReviewersMutation__
 *
 * To run a mutation, you first call `useUploadAdoptionReviewersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdoptionReviewersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdoptionReviewersMutation, { data, loading, error }] = useUploadAdoptionReviewersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAdoptionReviewersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAdoptionReviewersMutation,
    UploadAdoptionReviewersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadAdoptionReviewersMutation,
    UploadAdoptionReviewersMutationVariables
  >(UploadAdoptionReviewersDocument, options);
}
export type UploadAdoptionReviewersMutationHookResult = ReturnType<
  typeof useUploadAdoptionReviewersMutation
>;
export type UploadAdoptionReviewersMutationResult =
  Apollo.MutationResult<UploadAdoptionReviewersMutation>;
export type UploadAdoptionReviewersMutationOptions = Apollo.BaseMutationOptions<
  UploadAdoptionReviewersMutation,
  UploadAdoptionReviewersMutationVariables
>;
export const BulkUpdateContentsDocument = gql`
  mutation bulkUpdateContents($input: BulkUpdateContentsInput!) {
    bulkUpdateContents(input: $input) {
      id
      projectId
      name
      active
      projectId
      projectType
    }
  }
`;
export type BulkUpdateContentsMutationFn = Apollo.MutationFunction<
  BulkUpdateContentsMutation,
  BulkUpdateContentsMutationVariables
>;

/**
 * __useBulkUpdateContentsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateContentsMutation, { data, loading, error }] = useBulkUpdateContentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateContentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateContentsMutation,
    BulkUpdateContentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkUpdateContentsMutation,
    BulkUpdateContentsMutationVariables
  >(BulkUpdateContentsDocument, options);
}
export type BulkUpdateContentsMutationHookResult = ReturnType<
  typeof useBulkUpdateContentsMutation
>;
export type BulkUpdateContentsMutationResult =
  Apollo.MutationResult<BulkUpdateContentsMutation>;
export type BulkUpdateContentsMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateContentsMutation,
  BulkUpdateContentsMutationVariables
>;
export const GetContentsDocument = gql`
  query getContents($page: Int = 1, $itemsPerPage: Int = 10000) {
    contents(itemsPerPage: $itemsPerPage, page: $page) {
      collection {
        active
        id
        name
        projectId
        projectType
        grade
        editionName
        position
      }
      paginationInfo {
        lastPage
        itemsPerPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetContentsQuery__
 *
 * To run a query within a React component, call `useGetContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetContentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContentsQuery,
    GetContentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContentsQuery, GetContentsQueryVariables>(
    GetContentsDocument,
    options
  );
}
export function useGetContentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentsQuery,
    GetContentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContentsQuery, GetContentsQueryVariables>(
    GetContentsDocument,
    options
  );
}
export type GetContentsQueryHookResult = ReturnType<typeof useGetContentsQuery>;
export type GetContentsLazyQueryHookResult = ReturnType<
  typeof useGetContentsLazyQuery
>;
export type GetContentsQueryResult = Apollo.QueryResult<
  GetContentsQuery,
  GetContentsQueryVariables
>;
export const BulkUpdateAdoptionAccountsDocument = gql`
  mutation bulkUpdateAdoptionAccounts(
    $input: BulkUpdateAdoptionAccountsInput!
    $selection: BulkSelectionInput!
    $filter: AdoptionAccountFilterInput!
  ) {
    createBulkUpdateAdoptionAccounts(
      input: $input
      selection: $selection
      filter: $filter
    ) {
      id
    }
  }
`;
export type BulkUpdateAdoptionAccountsMutationFn = Apollo.MutationFunction<
  BulkUpdateAdoptionAccountsMutation,
  BulkUpdateAdoptionAccountsMutationVariables
>;

/**
 * __useBulkUpdateAdoptionAccountsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAdoptionAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAdoptionAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateAdoptionAccountsMutation, { data, loading, error }] = useBulkUpdateAdoptionAccountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      selection: // value for 'selection'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBulkUpdateAdoptionAccountsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateAdoptionAccountsMutation,
    BulkUpdateAdoptionAccountsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkUpdateAdoptionAccountsMutation,
    BulkUpdateAdoptionAccountsMutationVariables
  >(BulkUpdateAdoptionAccountsDocument, options);
}
export type BulkUpdateAdoptionAccountsMutationHookResult = ReturnType<
  typeof useBulkUpdateAdoptionAccountsMutation
>;
export type BulkUpdateAdoptionAccountsMutationResult =
  Apollo.MutationResult<BulkUpdateAdoptionAccountsMutation>;
export type BulkUpdateAdoptionAccountsMutationOptions =
  Apollo.BaseMutationOptions<
    BulkUpdateAdoptionAccountsMutation,
    BulkUpdateAdoptionAccountsMutationVariables
  >;
export const GetContentGroupsDocument = gql`
  query getContentGroups(
    $page: Int = 1
    $itemsPerPage: Int = 1000
    $filter: ContentGroupFilterInput
    $sorting: ContentGroupOrderInput
  ) {
    contentGroups(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      order: $sorting
    ) {
      collection {
        active
        id
        contents {
          active
          id
          name
          projectId
          projectType
        }
      }
      paginationInfo {
        itemsPerPage
        lastPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetContentGroupsQuery__
 *
 * To run a query within a React component, call `useGetContentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetContentGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContentGroupsQuery,
    GetContentGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContentGroupsQuery, GetContentGroupsQueryVariables>(
    GetContentGroupsDocument,
    options
  );
}
export function useGetContentGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentGroupsQuery,
    GetContentGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContentGroupsQuery,
    GetContentGroupsQueryVariables
  >(GetContentGroupsDocument, options);
}
export type GetContentGroupsQueryHookResult = ReturnType<
  typeof useGetContentGroupsQuery
>;
export type GetContentGroupsLazyQueryHookResult = ReturnType<
  typeof useGetContentGroupsLazyQuery
>;
export type GetContentGroupsQueryResult = Apollo.QueryResult<
  GetContentGroupsQuery,
  GetContentGroupsQueryVariables
>;
export const UpdateAdoptionReviewerDocument = gql`
  mutation updateAdoptionReviewer($input: UpdateAdoptionReviewerInput!) {
    updateAdoptionReviewer(input: $input) {
      adoptionReviewer {
        id
      }
    }
  }
`;
export type UpdateAdoptionReviewerMutationFn = Apollo.MutationFunction<
  UpdateAdoptionReviewerMutation,
  UpdateAdoptionReviewerMutationVariables
>;

/**
 * __useUpdateAdoptionReviewerMutation__
 *
 * To run a mutation, you first call `useUpdateAdoptionReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdoptionReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdoptionReviewerMutation, { data, loading, error }] = useUpdateAdoptionReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdoptionReviewerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdoptionReviewerMutation,
    UpdateAdoptionReviewerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdoptionReviewerMutation,
    UpdateAdoptionReviewerMutationVariables
  >(UpdateAdoptionReviewerDocument, options);
}
export type UpdateAdoptionReviewerMutationHookResult = ReturnType<
  typeof useUpdateAdoptionReviewerMutation
>;
export type UpdateAdoptionReviewerMutationResult =
  Apollo.MutationResult<UpdateAdoptionReviewerMutation>;
export type UpdateAdoptionReviewerMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdoptionReviewerMutation,
  UpdateAdoptionReviewerMutationVariables
>;
export const CreateContentGroupDocument = gql`
  mutation createContentGroup($input: CreateContentGroupInput!) {
    createContentGroup(input: $input) {
      contentGroup {
        id
      }
    }
  }
`;
export type CreateContentGroupMutationFn = Apollo.MutationFunction<
  CreateContentGroupMutation,
  CreateContentGroupMutationVariables
>;

/**
 * __useCreateContentGroupMutation__
 *
 * To run a mutation, you first call `useCreateContentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentGroupMutation, { data, loading, error }] = useCreateContentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContentGroupMutation,
    CreateContentGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContentGroupMutation,
    CreateContentGroupMutationVariables
  >(CreateContentGroupDocument, options);
}
export type CreateContentGroupMutationHookResult = ReturnType<
  typeof useCreateContentGroupMutation
>;
export type CreateContentGroupMutationResult =
  Apollo.MutationResult<CreateContentGroupMutation>;
export type CreateContentGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateContentGroupMutation,
  CreateContentGroupMutationVariables
>;
export const GetContentGroupDocument = gql`
  query getContentGroup($id: ID!) {
    contentGroup(id: $id) {
      active
      id
      contents {
        active
        id
        name
        projectId
        projectType
        position
        grade
      }
    }
  }
`;

/**
 * __useGetContentGroupQuery__
 *
 * To run a query within a React component, call `useGetContentGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContentGroupQuery,
    GetContentGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContentGroupQuery, GetContentGroupQueryVariables>(
    GetContentGroupDocument,
    options
  );
}
export function useGetContentGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentGroupQuery,
    GetContentGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContentGroupQuery,
    GetContentGroupQueryVariables
  >(GetContentGroupDocument, options);
}
export type GetContentGroupQueryHookResult = ReturnType<
  typeof useGetContentGroupQuery
>;
export type GetContentGroupLazyQueryHookResult = ReturnType<
  typeof useGetContentGroupLazyQuery
>;
export type GetContentGroupQueryResult = Apollo.QueryResult<
  GetContentGroupQuery,
  GetContentGroupQueryVariables
>;
export const UpdateContentGroupDocument = gql`
  mutation updateContentGroup($input: UpdateContentGroupInput!) {
    updateContentGroup(input: $input) {
      contentGroup {
        active
        id
        contents {
          active
          id
          name
          projectId
          projectType
          position
          grade
        }
      }
    }
  }
`;
export type UpdateContentGroupMutationFn = Apollo.MutationFunction<
  UpdateContentGroupMutation,
  UpdateContentGroupMutationVariables
>;

/**
 * __useUpdateContentGroupMutation__
 *
 * To run a mutation, you first call `useUpdateContentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentGroupMutation, { data, loading, error }] = useUpdateContentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContentGroupMutation,
    UpdateContentGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContentGroupMutation,
    UpdateContentGroupMutationVariables
  >(UpdateContentGroupDocument, options);
}
export type UpdateContentGroupMutationHookResult = ReturnType<
  typeof useUpdateContentGroupMutation
>;
export type UpdateContentGroupMutationResult =
  Apollo.MutationResult<UpdateContentGroupMutation>;
export type UpdateContentGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateContentGroupMutation,
  UpdateContentGroupMutationVariables
>;
export const GetDistrictDocument = gql`
  query getDistrict($id: ID!) {
    district(id: $id) {
      id
      globalName
      localName
      state
      city
      ncesId
      mathNationId
    }
  }
`;

/**
 * __useGetDistrictQuery__
 *
 * To run a query within a React component, call `useGetDistrictQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDistrictQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDistrictQuery,
    GetDistrictQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDistrictQuery, GetDistrictQueryVariables>(
    GetDistrictDocument,
    options
  );
}
export function useGetDistrictLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDistrictQuery,
    GetDistrictQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDistrictQuery, GetDistrictQueryVariables>(
    GetDistrictDocument,
    options
  );
}
export type GetDistrictQueryHookResult = ReturnType<typeof useGetDistrictQuery>;
export type GetDistrictLazyQueryHookResult = ReturnType<
  typeof useGetDistrictLazyQuery
>;
export type GetDistrictQueryResult = Apollo.QueryResult<
  GetDistrictQuery,
  GetDistrictQueryVariables
>;
export const GetEmailPlaceholdersDocument = gql`
  query getEmailPlaceholders($type: EmailTemplateTypeEnum!) {
    emailTemplatePlaceholders(type: $type) {
      collection {
        code
        exampleValue
      }
    }
  }
`;

/**
 * __useGetEmailPlaceholdersQuery__
 *
 * To run a query within a React component, call `useGetEmailPlaceholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailPlaceholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailPlaceholdersQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetEmailPlaceholdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmailPlaceholdersQuery,
    GetEmailPlaceholdersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmailPlaceholdersQuery,
    GetEmailPlaceholdersQueryVariables
  >(GetEmailPlaceholdersDocument, options);
}
export function useGetEmailPlaceholdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailPlaceholdersQuery,
    GetEmailPlaceholdersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmailPlaceholdersQuery,
    GetEmailPlaceholdersQueryVariables
  >(GetEmailPlaceholdersDocument, options);
}
export type GetEmailPlaceholdersQueryHookResult = ReturnType<
  typeof useGetEmailPlaceholdersQuery
>;
export type GetEmailPlaceholdersLazyQueryHookResult = ReturnType<
  typeof useGetEmailPlaceholdersLazyQuery
>;
export type GetEmailPlaceholdersQueryResult = Apollo.QueryResult<
  GetEmailPlaceholdersQuery,
  GetEmailPlaceholdersQueryVariables
>;
export const UpdateDistrictDocument = gql`
  mutation updateDistrict($input: updateDistrictInput!) {
    updateDistrict(input: $input) {
      district {
        globalName
        id
        localName
        state
        city
      }
      clientMutationId
    }
  }
`;
export type UpdateDistrictMutationFn = Apollo.MutationFunction<
  UpdateDistrictMutation,
  UpdateDistrictMutationVariables
>;

/**
 * __useUpdateDistrictMutation__
 *
 * To run a mutation, you first call `useUpdateDistrictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistrictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistrictMutation, { data, loading, error }] = useUpdateDistrictMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistrictMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDistrictMutation,
    UpdateDistrictMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDistrictMutation,
    UpdateDistrictMutationVariables
  >(UpdateDistrictDocument, options);
}
export type UpdateDistrictMutationHookResult = ReturnType<
  typeof useUpdateDistrictMutation
>;
export type UpdateDistrictMutationResult =
  Apollo.MutationResult<UpdateDistrictMutation>;
export type UpdateDistrictMutationOptions = Apollo.BaseMutationOptions<
  UpdateDistrictMutation,
  UpdateDistrictMutationVariables
>;
export const GetEmailTemplatesDocument = gql`
  query getEmailTemplates(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: EmailTemplateFilterInput
  ) {
    emailTemplates(page: $page, itemsPerPage: $itemsPerPage, filter: $filter) {
      collection {
        id
        body
        description
        subject
        type
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmailTemplatesQuery,
    GetEmailTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmailTemplatesQuery,
    GetEmailTemplatesQueryVariables
  >(GetEmailTemplatesDocument, options);
}
export function useGetEmailTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailTemplatesQuery,
    GetEmailTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmailTemplatesQuery,
    GetEmailTemplatesQueryVariables
  >(GetEmailTemplatesDocument, options);
}
export type GetEmailTemplatesQueryHookResult = ReturnType<
  typeof useGetEmailTemplatesQuery
>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetEmailTemplatesLazyQuery
>;
export type GetEmailTemplatesQueryResult = Apollo.QueryResult<
  GetEmailTemplatesQuery,
  GetEmailTemplatesQueryVariables
>;
export const CreateEmailTemplateDocument = gql`
  mutation createEmailTemplate($input: CreateEmailTemplateInput!) {
    createEmailTemplate(input: $input) {
      emailTemplate {
        id
        body
        description
        fromEmail
        fromName
        subject
        type
      }
    }
  }
`;
export type CreateEmailTemplateMutationFn = Apollo.MutationFunction<
  CreateEmailTemplateMutation,
  CreateEmailTemplateMutationVariables
>;

/**
 * __useCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateMutation, { data, loading, error }] = useCreateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEmailTemplateMutation,
    CreateEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEmailTemplateMutation,
    CreateEmailTemplateMutationVariables
  >(CreateEmailTemplateDocument, options);
}
export type CreateEmailTemplateMutationHookResult = ReturnType<
  typeof useCreateEmailTemplateMutation
>;
export type CreateEmailTemplateMutationResult =
  Apollo.MutationResult<CreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateEmailTemplateMutation,
  CreateEmailTemplateMutationVariables
>;
export const GetAthenaDistrictsDocument = gql`
  query getAthenaDistricts(
    $page: Int
    $perPage: Int
    $sorting: DistrictSort
    $filter: DistrictFilter
  ) {
    athenaDistricts(
      page: $page
      itemsPerPage: $perPage
      order: $sorting
      filter: $filter
    ) {
      collection {
        _id
        globalName
        state
        source
        mathnationId
      }
      paginationInfo {
        totalCount
        lastPage
        itemsPerPage
      }
    }
  }
`;

/**
 * __useGetAthenaDistrictsQuery__
 *
 * To run a query within a React component, call `useGetAthenaDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaDistrictsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAthenaDistrictsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAthenaDistrictsQuery,
    GetAthenaDistrictsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAthenaDistrictsQuery,
    GetAthenaDistrictsQueryVariables
  >(GetAthenaDistrictsDocument, options);
}
export function useGetAthenaDistrictsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAthenaDistrictsQuery,
    GetAthenaDistrictsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAthenaDistrictsQuery,
    GetAthenaDistrictsQueryVariables
  >(GetAthenaDistrictsDocument, options);
}
export type GetAthenaDistrictsQueryHookResult = ReturnType<
  typeof useGetAthenaDistrictsQuery
>;
export type GetAthenaDistrictsLazyQueryHookResult = ReturnType<
  typeof useGetAthenaDistrictsLazyQuery
>;
export type GetAthenaDistrictsQueryResult = Apollo.QueryResult<
  GetAthenaDistrictsQuery,
  GetAthenaDistrictsQueryVariables
>;
export const UpdateEmailTemplateDocument = gql`
  mutation updateEmailTemplate($input: UpdateEmailTemplateInput!) {
    updateEmailTemplate(input: $input) {
      emailTemplate {
        id
        body
        description
        fromEmail
        fromName
        subject
        type
      }
    }
  }
`;
export type UpdateEmailTemplateMutationFn = Apollo.MutationFunction<
  UpdateEmailTemplateMutation,
  UpdateEmailTemplateMutationVariables
>;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateMutation, { data, loading, error }] = useUpdateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmailTemplateMutation,
    UpdateEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEmailTemplateMutation,
    UpdateEmailTemplateMutationVariables
  >(UpdateEmailTemplateDocument, options);
}
export type UpdateEmailTemplateMutationHookResult = ReturnType<
  typeof useUpdateEmailTemplateMutation
>;
export type UpdateEmailTemplateMutationResult =
  Apollo.MutationResult<UpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmailTemplateMutation,
  UpdateEmailTemplateMutationVariables
>;
export const GetFromEmailsDocument = gql`
  query getFromEmails($page: Int = 1, $itemsPerPage: Int = 100) {
    fromEmails(page: $page, itemsPerPage: $itemsPerPage) {
      collection
    }
  }
`;

/**
 * __useGetFromEmailsQuery__
 *
 * To run a query within a React component, call `useGetFromEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFromEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFromEmailsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetFromEmailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFromEmailsQuery,
    GetFromEmailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFromEmailsQuery, GetFromEmailsQueryVariables>(
    GetFromEmailsDocument,
    options
  );
}
export function useGetFromEmailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFromEmailsQuery,
    GetFromEmailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFromEmailsQuery, GetFromEmailsQueryVariables>(
    GetFromEmailsDocument,
    options
  );
}
export type GetFromEmailsQueryHookResult = ReturnType<
  typeof useGetFromEmailsQuery
>;
export type GetFromEmailsLazyQueryHookResult = ReturnType<
  typeof useGetFromEmailsLazyQuery
>;
export type GetFromEmailsQueryResult = Apollo.QueryResult<
  GetFromEmailsQuery,
  GetFromEmailsQueryVariables
>;
export const GetEmailImageUploadFormDocument = gql`
  query getEmailImageUploadForm($fileName: String!) {
    emailTemplateImageUploadForm(input: { fileName: $fileName }) {
      fileKey
      formAttributes
      formInputs
      imageUrl
    }
  }
`;

/**
 * __useGetEmailImageUploadFormQuery__
 *
 * To run a query within a React component, call `useGetEmailImageUploadFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailImageUploadFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailImageUploadFormQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetEmailImageUploadFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmailImageUploadFormQuery,
    GetEmailImageUploadFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmailImageUploadFormQuery,
    GetEmailImageUploadFormQueryVariables
  >(GetEmailImageUploadFormDocument, options);
}
export function useGetEmailImageUploadFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailImageUploadFormQuery,
    GetEmailImageUploadFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmailImageUploadFormQuery,
    GetEmailImageUploadFormQueryVariables
  >(GetEmailImageUploadFormDocument, options);
}
export type GetEmailImageUploadFormQueryHookResult = ReturnType<
  typeof useGetEmailImageUploadFormQuery
>;
export type GetEmailImageUploadFormLazyQueryHookResult = ReturnType<
  typeof useGetEmailImageUploadFormLazyQuery
>;
export type GetEmailImageUploadFormQueryResult = Apollo.QueryResult<
  GetEmailImageUploadFormQuery,
  GetEmailImageUploadFormQueryVariables
>;
export const UpdateContentDocument = gql`
  mutation updateContent($input: ContentInput!) {
    updateContent(input: $input) {
      status
    }
  }
`;
export type UpdateContentMutationFn = Apollo.MutationFunction<
  UpdateContentMutation,
  UpdateContentMutationVariables
>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContentMutation,
    UpdateContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContentMutation,
    UpdateContentMutationVariables
  >(UpdateContentDocument, options);
}
export type UpdateContentMutationHookResult = ReturnType<
  typeof useUpdateContentMutation
>;
export type UpdateContentMutationResult =
  Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<
  UpdateContentMutation,
  UpdateContentMutationVariables
>;
export const DeleteContentDocument = gql`
  mutation deleteContent($input: DeleteContentInput!) {
    deleteContent(input: $input) {
      status
    }
  }
`;
export type DeleteContentMutationFn = Apollo.MutationFunction<
  DeleteContentMutation,
  DeleteContentMutationVariables
>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContentMutation,
    DeleteContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteContentMutation,
    DeleteContentMutationVariables
  >(DeleteContentDocument, options);
}
export type DeleteContentMutationHookResult = ReturnType<
  typeof useDeleteContentMutation
>;
export type DeleteContentMutationResult =
  Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<
  DeleteContentMutation,
  DeleteContentMutationVariables
>;
export const ListContentDocument = gql`
  query listContent($input: ListContentInput!) {
    listContent(input: $input) {
      course {
        course
        data {
          conceptName
          conceptNumber
          status
          topics {
            status
            topicName
            topicNumber
          }
        }
      }
    }
  }
`;

/**
 * __useListContentQuery__
 *
 * To run a query within a React component, call `useListContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListContentQuery,
    ListContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListContentQuery, ListContentQueryVariables>(
    ListContentDocument,
    options
  );
}
export function useListContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListContentQuery,
    ListContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListContentQuery, ListContentQueryVariables>(
    ListContentDocument,
    options
  );
}
export type ListContentQueryHookResult = ReturnType<typeof useListContentQuery>;
export type ListContentLazyQueryHookResult = ReturnType<
  typeof useListContentLazyQuery
>;
export type ListContentQueryResult = Apollo.QueryResult<
  ListContentQuery,
  ListContentQueryVariables
>;
export const GetEmailTemplateDocument = gql`
  query getEmailTemplate($id: ID!) {
    emailTemplate(id: $id) {
      id
      body
      source
      description
      fromEmail
      fromName
      subject
      type
      attachments {
        id
        originalFileName
        path
      }
    }
  }
`;

/**
 * __useGetEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmailTemplateQuery,
    GetEmailTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(
    GetEmailTemplateDocument,
    options
  );
}
export function useGetEmailTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailTemplateQuery,
    GetEmailTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmailTemplateQuery,
    GetEmailTemplateQueryVariables
  >(GetEmailTemplateDocument, options);
}
export type GetEmailTemplateQueryHookResult = ReturnType<
  typeof useGetEmailTemplateQuery
>;
export type GetEmailTemplateLazyQueryHookResult = ReturnType<
  typeof useGetEmailTemplateLazyQuery
>;
export type GetEmailTemplateQueryResult = Apollo.QueryResult<
  GetEmailTemplateQuery,
  GetEmailTemplateQueryVariables
>;
export const GetAttachmentsFormDocument = gql`
  query getAttachmentsForm($fileNames: [String!]!) {
    emailTemplateAttachmentUploadForm(input: { fileNames: $fileNames }) {
      collection {
        id
        fileName
        formAttributes
        formInputs
      }
    }
  }
`;

/**
 * __useGetAttachmentsFormQuery__
 *
 * To run a query within a React component, call `useGetAttachmentsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentsFormQuery({
 *   variables: {
 *      fileNames: // value for 'fileNames'
 *   },
 * });
 */
export function useGetAttachmentsFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAttachmentsFormQuery,
    GetAttachmentsFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAttachmentsFormQuery,
    GetAttachmentsFormQueryVariables
  >(GetAttachmentsFormDocument, options);
}
export function useGetAttachmentsFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAttachmentsFormQuery,
    GetAttachmentsFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAttachmentsFormQuery,
    GetAttachmentsFormQueryVariables
  >(GetAttachmentsFormDocument, options);
}
export type GetAttachmentsFormQueryHookResult = ReturnType<
  typeof useGetAttachmentsFormQuery
>;
export type GetAttachmentsFormLazyQueryHookResult = ReturnType<
  typeof useGetAttachmentsFormLazyQuery
>;
export type GetAttachmentsFormQueryResult = Apollo.QueryResult<
  GetAttachmentsFormQuery,
  GetAttachmentsFormQueryVariables
>;
export const CreateContentTagDocument = gql`
  mutation createContentTag($input: CreateContentTagInput!) {
    createContentTag(input: $input) {
      tag {
        id
        name
      }
    }
  }
`;
export type CreateContentTagMutationFn = Apollo.MutationFunction<
  CreateContentTagMutation,
  CreateContentTagMutationVariables
>;

/**
 * __useCreateContentTagMutation__
 *
 * To run a mutation, you first call `useCreateContentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentTagMutation, { data, loading, error }] = useCreateContentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContentTagMutation,
    CreateContentTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContentTagMutation,
    CreateContentTagMutationVariables
  >(CreateContentTagDocument, options);
}
export type CreateContentTagMutationHookResult = ReturnType<
  typeof useCreateContentTagMutation
>;
export type CreateContentTagMutationResult =
  Apollo.MutationResult<CreateContentTagMutation>;
export type CreateContentTagMutationOptions = Apollo.BaseMutationOptions<
  CreateContentTagMutation,
  CreateContentTagMutationVariables
>;
export const UpdateContentTagDocument = gql`
  mutation updateContentTag($input: UpdateContentTagInput!) {
    updateContentTag(input: $input) {
      tag {
        id
        name
      }
    }
  }
`;
export type UpdateContentTagMutationFn = Apollo.MutationFunction<
  UpdateContentTagMutation,
  UpdateContentTagMutationVariables
>;

/**
 * __useUpdateContentTagMutation__
 *
 * To run a mutation, you first call `useUpdateContentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentTagMutation, { data, loading, error }] = useUpdateContentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContentTagMutation,
    UpdateContentTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContentTagMutation,
    UpdateContentTagMutationVariables
  >(UpdateContentTagDocument, options);
}
export type UpdateContentTagMutationHookResult = ReturnType<
  typeof useUpdateContentTagMutation
>;
export type UpdateContentTagMutationResult =
  Apollo.MutationResult<UpdateContentTagMutation>;
export type UpdateContentTagMutationOptions = Apollo.BaseMutationOptions<
  UpdateContentTagMutation,
  UpdateContentTagMutationVariables
>;
export const CreateContentTagValueDocument = gql`
  mutation createContentTagValue($input: CreateContentTagValueInput!) {
    createContentTagValue(input: $input) {
      tagValue {
        id
        name
      }
    }
  }
`;
export type CreateContentTagValueMutationFn = Apollo.MutationFunction<
  CreateContentTagValueMutation,
  CreateContentTagValueMutationVariables
>;

/**
 * __useCreateContentTagValueMutation__
 *
 * To run a mutation, you first call `useCreateContentTagValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentTagValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentTagValueMutation, { data, loading, error }] = useCreateContentTagValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentTagValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContentTagValueMutation,
    CreateContentTagValueMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContentTagValueMutation,
    CreateContentTagValueMutationVariables
  >(CreateContentTagValueDocument, options);
}
export type CreateContentTagValueMutationHookResult = ReturnType<
  typeof useCreateContentTagValueMutation
>;
export type CreateContentTagValueMutationResult =
  Apollo.MutationResult<CreateContentTagValueMutation>;
export type CreateContentTagValueMutationOptions = Apollo.BaseMutationOptions<
  CreateContentTagValueMutation,
  CreateContentTagValueMutationVariables
>;
export const DeleteImageDocument = gql`
  mutation deleteImage($input: DeleteImageInput!) {
    deleteImage(input: $input) {
      image {
        __typename
      }
    }
  }
`;
export type DeleteImageMutationFn = Apollo.MutationFunction<
  DeleteImageMutation,
  DeleteImageMutationVariables
>;

/**
 * __useDeleteImageMutation__
 *
 * To run a mutation, you first call `useDeleteImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageMutation, { data, loading, error }] = useDeleteImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteImageMutation,
    DeleteImageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteImageMutation, DeleteImageMutationVariables>(
    DeleteImageDocument,
    options
  );
}
export type DeleteImageMutationHookResult = ReturnType<
  typeof useDeleteImageMutation
>;
export type DeleteImageMutationResult =
  Apollo.MutationResult<DeleteImageMutation>;
export type DeleteImageMutationOptions = Apollo.BaseMutationOptions<
  DeleteImageMutation,
  DeleteImageMutationVariables
>;
export const GetContentTagValuesDocument = gql`
  query getContentTagValues(
    $page: Int!
    $itemsPerPage: Int! = 30
    $filter: ContentTagValueFilterInput
  ) {
    contentTagValues(
      itemsPerPage: $itemsPerPage
      page: $page
      filter: $filter
    ) {
      collection {
        id
        name
        tag {
          id
          name
        }
      }
      paginationInfo {
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetContentTagValuesQuery__
 *
 * To run a query within a React component, call `useGetContentTagValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentTagValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentTagValuesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetContentTagValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContentTagValuesQuery,
    GetContentTagValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContentTagValuesQuery,
    GetContentTagValuesQueryVariables
  >(GetContentTagValuesDocument, options);
}
export function useGetContentTagValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentTagValuesQuery,
    GetContentTagValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContentTagValuesQuery,
    GetContentTagValuesQueryVariables
  >(GetContentTagValuesDocument, options);
}
export type GetContentTagValuesQueryHookResult = ReturnType<
  typeof useGetContentTagValuesQuery
>;
export type GetContentTagValuesLazyQueryHookResult = ReturnType<
  typeof useGetContentTagValuesLazyQuery
>;
export type GetContentTagValuesQueryResult = Apollo.QueryResult<
  GetContentTagValuesQuery,
  GetContentTagValuesQueryVariables
>;
export const CreateImageDocument = gql`
  mutation createImage($input: CreateImageInput!) {
    createImage(input: $input) {
      image {
        id
        name
      }
    }
  }
`;
export type CreateImageMutationFn = Apollo.MutationFunction<
  CreateImageMutation,
  CreateImageMutationVariables
>;

/**
 * __useCreateImageMutation__
 *
 * To run a mutation, you first call `useCreateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageMutation, { data, loading, error }] = useCreateImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateImageMutation,
    CreateImageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateImageMutation, CreateImageMutationVariables>(
    CreateImageDocument,
    options
  );
}
export type CreateImageMutationHookResult = ReturnType<
  typeof useCreateImageMutation
>;
export type CreateImageMutationResult =
  Apollo.MutationResult<CreateImageMutation>;
export type CreateImageMutationOptions = Apollo.BaseMutationOptions<
  CreateImageMutation,
  CreateImageMutationVariables
>;
export const GetImageDocument = gql`
  query getImage($id: ID!) {
    image(id: $id) {
      altText
      contentTagValues {
        tag {
          name
          id
        }
        name
        id
      }
      createdAt
      id
      contentKeywords {
        id
        name
      }
      name
      updatedAt
      files {
        createdAt
        updatedAt
        id
        height
        language
        mimeType
        originalFileName
        path
        size
        width
        processed
        sha256
      }
    }
  }
`;

/**
 * __useGetImageQuery__
 *
 * To run a query within a React component, call `useGetImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImageQuery(
  baseOptions: Apollo.QueryHookOptions<GetImageQuery, GetImageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetImageQuery, GetImageQueryVariables>(
    GetImageDocument,
    options
  );
}
export function useGetImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetImageQuery,
    GetImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetImageQuery, GetImageQueryVariables>(
    GetImageDocument,
    options
  );
}
export type GetImageQueryHookResult = ReturnType<typeof useGetImageQuery>;
export type GetImageLazyQueryHookResult = ReturnType<
  typeof useGetImageLazyQuery
>;
export type GetImageQueryResult = Apollo.QueryResult<
  GetImageQuery,
  GetImageQueryVariables
>;
export const GetContentTagsDocument = gql`
  query getContentTags(
    $itemsPerPage: Int! = 30
    $page: Int! = 1
    $filter: ContentTagFilterInput
  ) {
    contentTags(itemsPerPage: $itemsPerPage, page: $page, filter: $filter) {
      collection {
        id
        name
      }
      paginationInfo {
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetContentTagsQuery__
 *
 * To run a query within a React component, call `useGetContentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentTagsQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetContentTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContentTagsQuery,
    GetContentTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContentTagsQuery, GetContentTagsQueryVariables>(
    GetContentTagsDocument,
    options
  );
}
export function useGetContentTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentTagsQuery,
    GetContentTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContentTagsQuery, GetContentTagsQueryVariables>(
    GetContentTagsDocument,
    options
  );
}
export type GetContentTagsQueryHookResult = ReturnType<
  typeof useGetContentTagsQuery
>;
export type GetContentTagsLazyQueryHookResult = ReturnType<
  typeof useGetContentTagsLazyQuery
>;
export type GetContentTagsQueryResult = Apollo.QueryResult<
  GetContentTagsQuery,
  GetContentTagsQueryVariables
>;
export const GetImagesDocument = gql`
  query getImages(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: ImageFilterInput
    $sorting: ImageSortInput
  ) {
    images(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      sort: $sorting
    ) {
      collection {
        altText
        contentTagValues {
          tag {
            name
            id
          }
          name
          id
        }
        createdAt
        id
        contentKeywords {
          id
          name
        }
        name
        updatedAt
        files {
          createdAt
          updatedAt
          id
          language
          originalFileName
          path
          processed
          width
          height
          size
        }
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetImagesQuery__
 *
 * To run a query within a React component, call `useGetImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetImagesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetImagesQuery, GetImagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetImagesQuery, GetImagesQueryVariables>(
    GetImagesDocument,
    options
  );
}
export function useGetImagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetImagesQuery,
    GetImagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetImagesQuery, GetImagesQueryVariables>(
    GetImagesDocument,
    options
  );
}
export type GetImagesQueryHookResult = ReturnType<typeof useGetImagesQuery>;
export type GetImagesLazyQueryHookResult = ReturnType<
  typeof useGetImagesLazyQuery
>;
export type GetImagesQueryResult = Apollo.QueryResult<
  GetImagesQuery,
  GetImagesQueryVariables
>;
export const CreateContentKeywordDocument = gql`
  mutation createContentKeyword($input: CreateContentKeywordInput!) {
    createContentKeyword(input: $input) {
      keyword {
        id
        name
      }
    }
  }
`;
export type CreateContentKeywordMutationFn = Apollo.MutationFunction<
  CreateContentKeywordMutation,
  CreateContentKeywordMutationVariables
>;

/**
 * __useCreateContentKeywordMutation__
 *
 * To run a mutation, you first call `useCreateContentKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentKeywordMutation, { data, loading, error }] = useCreateContentKeywordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentKeywordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContentKeywordMutation,
    CreateContentKeywordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContentKeywordMutation,
    CreateContentKeywordMutationVariables
  >(CreateContentKeywordDocument, options);
}
export type CreateContentKeywordMutationHookResult = ReturnType<
  typeof useCreateContentKeywordMutation
>;
export type CreateContentKeywordMutationResult =
  Apollo.MutationResult<CreateContentKeywordMutation>;
export type CreateContentKeywordMutationOptions = Apollo.BaseMutationOptions<
  CreateContentKeywordMutation,
  CreateContentKeywordMutationVariables
>;
export const UpdateContentKeywordDocument = gql`
  mutation updateContentKeyword($input: UpdateContentKeywordInput!) {
    updateContentKeyword(input: $input) {
      keyword {
        id
        name
      }
    }
  }
`;
export type UpdateContentKeywordMutationFn = Apollo.MutationFunction<
  UpdateContentKeywordMutation,
  UpdateContentKeywordMutationVariables
>;

/**
 * __useUpdateContentKeywordMutation__
 *
 * To run a mutation, you first call `useUpdateContentKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentKeywordMutation, { data, loading, error }] = useUpdateContentKeywordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentKeywordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContentKeywordMutation,
    UpdateContentKeywordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContentKeywordMutation,
    UpdateContentKeywordMutationVariables
  >(UpdateContentKeywordDocument, options);
}
export type UpdateContentKeywordMutationHookResult = ReturnType<
  typeof useUpdateContentKeywordMutation
>;
export type UpdateContentKeywordMutationResult =
  Apollo.MutationResult<UpdateContentKeywordMutation>;
export type UpdateContentKeywordMutationOptions = Apollo.BaseMutationOptions<
  UpdateContentKeywordMutation,
  UpdateContentKeywordMutationVariables
>;
export const GetContentKeywordsDocument = gql`
  query getContentKeywords(
    $itemsPerPage: Int! = 30
    $page: Int! = 1
    $sorting: ContentKeywordOrderInput
    $filter: ContentKeywordFilterInput
  ) {
    contentKeywords(
      itemsPerPage: $itemsPerPage
      page: $page
      order: $sorting
      filter: $filter
    ) {
      collection {
        id
        name
      }
      paginationInfo {
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetContentKeywordsQuery__
 *
 * To run a query within a React component, call `useGetContentKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentKeywordsQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetContentKeywordsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContentKeywordsQuery,
    GetContentKeywordsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContentKeywordsQuery,
    GetContentKeywordsQueryVariables
  >(GetContentKeywordsDocument, options);
}
export function useGetContentKeywordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentKeywordsQuery,
    GetContentKeywordsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContentKeywordsQuery,
    GetContentKeywordsQueryVariables
  >(GetContentKeywordsDocument, options);
}
export type GetContentKeywordsQueryHookResult = ReturnType<
  typeof useGetContentKeywordsQuery
>;
export type GetContentKeywordsLazyQueryHookResult = ReturnType<
  typeof useGetContentKeywordsLazyQuery
>;
export type GetContentKeywordsQueryResult = Apollo.QueryResult<
  GetContentKeywordsQuery,
  GetContentKeywordsQueryVariables
>;
export const ListMathInActionActivityDocument = gql`
  query ListMathInActionActivity {
    listMathInActionActivity {
      data {
        actionNumber
        category
        course
        id
        section
        status
        subjectName
      }
    }
  }
`;

/**
 * __useListMathInActionActivityQuery__
 *
 * To run a query within a React component, call `useListMathInActionActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMathInActionActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMathInActionActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMathInActionActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListMathInActionActivityQuery,
    ListMathInActionActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListMathInActionActivityQuery,
    ListMathInActionActivityQueryVariables
  >(ListMathInActionActivityDocument, options);
}
export function useListMathInActionActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListMathInActionActivityQuery,
    ListMathInActionActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListMathInActionActivityQuery,
    ListMathInActionActivityQueryVariables
  >(ListMathInActionActivityDocument, options);
}
export type ListMathInActionActivityQueryHookResult = ReturnType<
  typeof useListMathInActionActivityQuery
>;
export type ListMathInActionActivityLazyQueryHookResult = ReturnType<
  typeof useListMathInActionActivityLazyQuery
>;
export type ListMathInActionActivityQueryResult = Apollo.QueryResult<
  ListMathInActionActivityQuery,
  ListMathInActionActivityQueryVariables
>;
export const UpdateOrCreateMathInActionDocument = gql`
  mutation updateOrCreateMathInAction(
    $category: CategoryEnum!
    $course: String!
    $forceUpdate: Boolean!
    $isActive: Boolean!
    $section: SectionEnum!
    $subjectName: String!
    $actionNumber: String!
  ) {
    updateOrCreateMathInAction(
      input: {
        category: $category
        course: $course
        forceUpdate: $forceUpdate
        isActive: $isActive
        section: $section
        subjectName: $subjectName
        actionNumber: $actionNumber
      }
    ) {
      status
    }
  }
`;
export type UpdateOrCreateMathInActionMutationFn = Apollo.MutationFunction<
  UpdateOrCreateMathInActionMutation,
  UpdateOrCreateMathInActionMutationVariables
>;

/**
 * __useUpdateOrCreateMathInActionMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateMathInActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateMathInActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateMathInActionMutation, { data, loading, error }] = useUpdateOrCreateMathInActionMutation({
 *   variables: {
 *      category: // value for 'category'
 *      course: // value for 'course'
 *      forceUpdate: // value for 'forceUpdate'
 *      isActive: // value for 'isActive'
 *      section: // value for 'section'
 *      subjectName: // value for 'subjectName'
 *      actionNumber: // value for 'actionNumber'
 *   },
 * });
 */
export function useUpdateOrCreateMathInActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrCreateMathInActionMutation,
    UpdateOrCreateMathInActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrCreateMathInActionMutation,
    UpdateOrCreateMathInActionMutationVariables
  >(UpdateOrCreateMathInActionDocument, options);
}
export type UpdateOrCreateMathInActionMutationHookResult = ReturnType<
  typeof useUpdateOrCreateMathInActionMutation
>;
export type UpdateOrCreateMathInActionMutationResult =
  Apollo.MutationResult<UpdateOrCreateMathInActionMutation>;
export type UpdateOrCreateMathInActionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOrCreateMathInActionMutation,
    UpdateOrCreateMathInActionMutationVariables
  >;
export const UpdateImageDocument = gql`
  mutation updateImage($input: UpdateImageInput!) {
    updateImage(input: $input) {
      image {
        altText
        contentTagValues {
          tag {
            name
            id
          }
          name
          id
        }
        createdAt
        id
        contentKeywords {
          id
          name
        }
        name
        updatedAt
        files {
          createdAt
          updatedAt
          id
          height
          language
          mimeType
          originalFileName
          path
          size
          width
          processed
          sha256
        }
      }
    }
  }
`;
export type UpdateImageMutationFn = Apollo.MutationFunction<
  UpdateImageMutation,
  UpdateImageMutationVariables
>;

/**
 * __useUpdateImageMutation__
 *
 * To run a mutation, you first call `useUpdateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageMutation, { data, loading, error }] = useUpdateImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateImageMutation,
    UpdateImageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateImageMutation, UpdateImageMutationVariables>(
    UpdateImageDocument,
    options
  );
}
export type UpdateImageMutationHookResult = ReturnType<
  typeof useUpdateImageMutation
>;
export type UpdateImageMutationResult =
  Apollo.MutationResult<UpdateImageMutation>;
export type UpdateImageMutationOptions = Apollo.BaseMutationOptions<
  UpdateImageMutation,
  UpdateImageMutationVariables
>;
export const GetImagesFormDocument = gql`
  query getImagesForm($fileName: String!) {
    imageFileUploadForm(input: { fileName: $fileName }) {
      fileKey
      formAttributes
      formInputs
      imageUrl
    }
  }
`;

/**
 * __useGetImagesFormQuery__
 *
 * To run a query within a React component, call `useGetImagesFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImagesFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImagesFormQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetImagesFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetImagesFormQuery,
    GetImagesFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetImagesFormQuery, GetImagesFormQueryVariables>(
    GetImagesFormDocument,
    options
  );
}
export function useGetImagesFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetImagesFormQuery,
    GetImagesFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetImagesFormQuery, GetImagesFormQueryVariables>(
    GetImagesFormDocument,
    options
  );
}
export type GetImagesFormQueryHookResult = ReturnType<
  typeof useGetImagesFormQuery
>;
export type GetImagesFormLazyQueryHookResult = ReturnType<
  typeof useGetImagesFormLazyQuery
>;
export type GetImagesFormQueryResult = Apollo.QueryResult<
  GetImagesFormQuery,
  GetImagesFormQueryVariables
>;
export const UpdateContentTagValueDocument = gql`
  mutation updateContentTagValue($input: UpdateContentTagValueInput!) {
    updateContentTagValue(input: $input) {
      tagValue {
        id
        name
      }
    }
  }
`;
export type UpdateContentTagValueMutationFn = Apollo.MutationFunction<
  UpdateContentTagValueMutation,
  UpdateContentTagValueMutationVariables
>;

/**
 * __useUpdateContentTagValueMutation__
 *
 * To run a mutation, you first call `useUpdateContentTagValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentTagValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentTagValueMutation, { data, loading, error }] = useUpdateContentTagValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentTagValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContentTagValueMutation,
    UpdateContentTagValueMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContentTagValueMutation,
    UpdateContentTagValueMutationVariables
  >(UpdateContentTagValueDocument, options);
}
export type UpdateContentTagValueMutationHookResult = ReturnType<
  typeof useUpdateContentTagValueMutation
>;
export type UpdateContentTagValueMutationResult =
  Apollo.MutationResult<UpdateContentTagValueMutation>;
export type UpdateContentTagValueMutationOptions = Apollo.BaseMutationOptions<
  UpdateContentTagValueMutation,
  UpdateContentTagValueMutationVariables
>;
export const GetReaderLibrariesDocument = gql`
  query getReaderLibraries(
    $filter: ReaderLibraryFilterInput
    $page: Int!
    $itemsPerPage: Int!
    $sorting: ReaderLibrarySortInput
  ) {
    readerLibraries(
      filter: $filter
      page: $page
      itemsPerPage: $itemsPerPage
      sort: $sorting
    ) {
      collection {
        description
        id
        enPdfFile
        esPdfFile
        title
        keywords {
          _id
          id
          name
        }
        tagValues {
          _id
          id
          name
          tag {
            id
            name
          }
        }
      }
      paginationInfo {
        lastPage
        itemsPerPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetReaderLibrariesQuery__
 *
 * To run a query within a React component, call `useGetReaderLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderLibrariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetReaderLibrariesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReaderLibrariesQuery,
    GetReaderLibrariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReaderLibrariesQuery,
    GetReaderLibrariesQueryVariables
  >(GetReaderLibrariesDocument, options);
}
export function useGetReaderLibrariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReaderLibrariesQuery,
    GetReaderLibrariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReaderLibrariesQuery,
    GetReaderLibrariesQueryVariables
  >(GetReaderLibrariesDocument, options);
}
export type GetReaderLibrariesQueryHookResult = ReturnType<
  typeof useGetReaderLibrariesQuery
>;
export type GetReaderLibrariesLazyQueryHookResult = ReturnType<
  typeof useGetReaderLibrariesLazyQuery
>;
export type GetReaderLibrariesQueryResult = Apollo.QueryResult<
  GetReaderLibrariesQuery,
  GetReaderLibrariesQueryVariables
>;
export const GetReaderLibraryDocument = gql`
  query getReaderLibrary($id: ID!) {
    readerLibrary(id: $id) {
      readerLibrary {
        description
        id
        enPdfFile
        esPdfFile
        title
        keywords {
          id
          name
        }
        tagValues {
          id
          name
          tag {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetReaderLibraryQuery__
 *
 * To run a query within a React component, call `useGetReaderLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderLibraryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReaderLibraryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReaderLibraryQuery,
    GetReaderLibraryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReaderLibraryQuery, GetReaderLibraryQueryVariables>(
    GetReaderLibraryDocument,
    options
  );
}
export function useGetReaderLibraryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReaderLibraryQuery,
    GetReaderLibraryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReaderLibraryQuery,
    GetReaderLibraryQueryVariables
  >(GetReaderLibraryDocument, options);
}
export type GetReaderLibraryQueryHookResult = ReturnType<
  typeof useGetReaderLibraryQuery
>;
export type GetReaderLibraryLazyQueryHookResult = ReturnType<
  typeof useGetReaderLibraryLazyQuery
>;
export type GetReaderLibraryQueryResult = Apollo.QueryResult<
  GetReaderLibraryQuery,
  GetReaderLibraryQueryVariables
>;
export const CreateReaderLibraryDocument = gql`
  mutation createReaderLibrary($input: CreateReaderLibraryInput!) {
    createReaderLibrary(input: $input) {
      readerLibrary {
        id
        __typename
      }
    }
  }
`;
export type CreateReaderLibraryMutationFn = Apollo.MutationFunction<
  CreateReaderLibraryMutation,
  CreateReaderLibraryMutationVariables
>;

/**
 * __useCreateReaderLibraryMutation__
 *
 * To run a mutation, you first call `useCreateReaderLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReaderLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReaderLibraryMutation, { data, loading, error }] = useCreateReaderLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReaderLibraryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReaderLibraryMutation,
    CreateReaderLibraryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReaderLibraryMutation,
    CreateReaderLibraryMutationVariables
  >(CreateReaderLibraryDocument, options);
}
export type CreateReaderLibraryMutationHookResult = ReturnType<
  typeof useCreateReaderLibraryMutation
>;
export type CreateReaderLibraryMutationResult =
  Apollo.MutationResult<CreateReaderLibraryMutation>;
export type CreateReaderLibraryMutationOptions = Apollo.BaseMutationOptions<
  CreateReaderLibraryMutation,
  CreateReaderLibraryMutationVariables
>;
export const UpdateReaderLibraryDocument = gql`
  mutation updateReaderLibrary($input: UpdateReaderLibraryInput!) {
    updateReaderLibrary(input: $input) {
      readerLibrary {
        description
        id
        enPdfFile
        esPdfFile
        title
        keywords {
          id
          name
        }
        tagValues {
          id
          name
          tag {
            id
            name
          }
        }
      }
    }
  }
`;
export type UpdateReaderLibraryMutationFn = Apollo.MutationFunction<
  UpdateReaderLibraryMutation,
  UpdateReaderLibraryMutationVariables
>;

/**
 * __useUpdateReaderLibraryMutation__
 *
 * To run a mutation, you first call `useUpdateReaderLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReaderLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReaderLibraryMutation, { data, loading, error }] = useUpdateReaderLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReaderLibraryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReaderLibraryMutation,
    UpdateReaderLibraryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateReaderLibraryMutation,
    UpdateReaderLibraryMutationVariables
  >(UpdateReaderLibraryDocument, options);
}
export type UpdateReaderLibraryMutationHookResult = ReturnType<
  typeof useUpdateReaderLibraryMutation
>;
export type UpdateReaderLibraryMutationResult =
  Apollo.MutationResult<UpdateReaderLibraryMutation>;
export type UpdateReaderLibraryMutationOptions = Apollo.BaseMutationOptions<
  UpdateReaderLibraryMutation,
  UpdateReaderLibraryMutationVariables
>;
export const DeleteReaderLibraryDocument = gql`
  mutation deleteReaderLibrary($id: ID!) {
    deleteReaderLibrary(id: $id) {
      readerLibrary {
        id
        __typename
      }
      __typename
    }
  }
`;
export type DeleteReaderLibraryMutationFn = Apollo.MutationFunction<
  DeleteReaderLibraryMutation,
  DeleteReaderLibraryMutationVariables
>;

/**
 * __useDeleteReaderLibraryMutation__
 *
 * To run a mutation, you first call `useDeleteReaderLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReaderLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReaderLibraryMutation, { data, loading, error }] = useDeleteReaderLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReaderLibraryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReaderLibraryMutation,
    DeleteReaderLibraryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReaderLibraryMutation,
    DeleteReaderLibraryMutationVariables
  >(DeleteReaderLibraryDocument, options);
}
export type DeleteReaderLibraryMutationHookResult = ReturnType<
  typeof useDeleteReaderLibraryMutation
>;
export type DeleteReaderLibraryMutationResult =
  Apollo.MutationResult<DeleteReaderLibraryMutation>;
export type DeleteReaderLibraryMutationOptions = Apollo.BaseMutationOptions<
  DeleteReaderLibraryMutation,
  DeleteReaderLibraryMutationVariables
>;
export const CreatePreviewAccountDocument = gql`
  mutation createPreviewAccount($input: CreatePreviewAccountInput!) {
    createPreviewAccount(input: $input) {
      previewAccount {
        id
      }
    }
  }
`;
export type CreatePreviewAccountMutationFn = Apollo.MutationFunction<
  CreatePreviewAccountMutation,
  CreatePreviewAccountMutationVariables
>;

/**
 * __useCreatePreviewAccountMutation__
 *
 * To run a mutation, you first call `useCreatePreviewAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewAccountMutation, { data, loading, error }] = useCreatePreviewAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreviewAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePreviewAccountMutation,
    CreatePreviewAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePreviewAccountMutation,
    CreatePreviewAccountMutationVariables
  >(CreatePreviewAccountDocument, options);
}
export type CreatePreviewAccountMutationHookResult = ReturnType<
  typeof useCreatePreviewAccountMutation
>;
export type CreatePreviewAccountMutationResult =
  Apollo.MutationResult<CreatePreviewAccountMutation>;
export type CreatePreviewAccountMutationOptions = Apollo.BaseMutationOptions<
  CreatePreviewAccountMutation,
  CreatePreviewAccountMutationVariables
>;
export const GetLatestPreviewAccountImportLogDocument = gql`
  query getLatestPreviewAccountImportLog($type: DemoImportLogTypeEnum!) {
    demoImportLogLatest(type: $type) {
      errors {
        field
        value
      }
      importStart
      importEnd
      importSucceeded
      message
    }
  }
`;

/**
 * __useGetLatestPreviewAccountImportLogQuery__
 *
 * To run a query within a React component, call `useGetLatestPreviewAccountImportLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestPreviewAccountImportLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestPreviewAccountImportLogQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLatestPreviewAccountImportLogQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLatestPreviewAccountImportLogQuery,
    GetLatestPreviewAccountImportLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLatestPreviewAccountImportLogQuery,
    GetLatestPreviewAccountImportLogQueryVariables
  >(GetLatestPreviewAccountImportLogDocument, options);
}
export function useGetLatestPreviewAccountImportLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLatestPreviewAccountImportLogQuery,
    GetLatestPreviewAccountImportLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLatestPreviewAccountImportLogQuery,
    GetLatestPreviewAccountImportLogQueryVariables
  >(GetLatestPreviewAccountImportLogDocument, options);
}
export type GetLatestPreviewAccountImportLogQueryHookResult = ReturnType<
  typeof useGetLatestPreviewAccountImportLogQuery
>;
export type GetLatestPreviewAccountImportLogLazyQueryHookResult = ReturnType<
  typeof useGetLatestPreviewAccountImportLogLazyQuery
>;
export type GetLatestPreviewAccountImportLogQueryResult = Apollo.QueryResult<
  GetLatestPreviewAccountImportLogQuery,
  GetLatestPreviewAccountImportLogQueryVariables
>;
export const GetImageCategoriesDocument = gql`
  query getImageCategories($filter: ImageCategoryFilterInput) {
    imageCategories(itemsPerPage: 1000, page: 1, filter: $filter) {
      collection {
        children {
          id
          name
        }
        id
        name
        path {
          id
          name
        }
      }
      paginationInfo {
        totalCount: itemsPerPage
      }
    }
  }
`;

/**
 * __useGetImageCategoriesQuery__
 *
 * To run a query within a React component, call `useGetImageCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetImageCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetImageCategoriesQuery,
    GetImageCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetImageCategoriesQuery,
    GetImageCategoriesQueryVariables
  >(GetImageCategoriesDocument, options);
}
export function useGetImageCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetImageCategoriesQuery,
    GetImageCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetImageCategoriesQuery,
    GetImageCategoriesQueryVariables
  >(GetImageCategoriesDocument, options);
}
export type GetImageCategoriesQueryHookResult = ReturnType<
  typeof useGetImageCategoriesQuery
>;
export type GetImageCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetImageCategoriesLazyQuery
>;
export type GetImageCategoriesQueryResult = Apollo.QueryResult<
  GetImageCategoriesQuery,
  GetImageCategoriesQueryVariables
>;
export const GetPreviewAccountTeacherDocument = gql`
  query getPreviewAccountTeacher($id: ID!) {
    previewAccountTeacher(id: $id) {
      id
      email
      firstName
      previewAccount {
        id
        activityPeriodEnd
        activityPeriodStart
        state
        products {
          productType
        }
      }
      lastName
      user {
        active
        username
        inactivityReason
        plainPassword
      }
    }
  }
`;

/**
 * __useGetPreviewAccountTeacherQuery__
 *
 * To run a query within a React component, call `useGetPreviewAccountTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAccountTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAccountTeacherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPreviewAccountTeacherQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPreviewAccountTeacherQuery,
    GetPreviewAccountTeacherQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPreviewAccountTeacherQuery,
    GetPreviewAccountTeacherQueryVariables
  >(GetPreviewAccountTeacherDocument, options);
}
export function useGetPreviewAccountTeacherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviewAccountTeacherQuery,
    GetPreviewAccountTeacherQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreviewAccountTeacherQuery,
    GetPreviewAccountTeacherQueryVariables
  >(GetPreviewAccountTeacherDocument, options);
}
export type GetPreviewAccountTeacherQueryHookResult = ReturnType<
  typeof useGetPreviewAccountTeacherQuery
>;
export type GetPreviewAccountTeacherLazyQueryHookResult = ReturnType<
  typeof useGetPreviewAccountTeacherLazyQuery
>;
export type GetPreviewAccountTeacherQueryResult = Apollo.QueryResult<
  GetPreviewAccountTeacherQuery,
  GetPreviewAccountTeacherQueryVariables
>;
export const UpdatePreviewAccountDocument = gql`
  mutation updatePreviewAccount($input: UpdatePreviewAccountInput!) {
    updatePreviewAccount(input: $input) {
      previewAccount {
        id
      }
    }
  }
`;
export type UpdatePreviewAccountMutationFn = Apollo.MutationFunction<
  UpdatePreviewAccountMutation,
  UpdatePreviewAccountMutationVariables
>;

/**
 * __useUpdatePreviewAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewAccountMutation, { data, loading, error }] = useUpdatePreviewAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreviewAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePreviewAccountMutation,
    UpdatePreviewAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePreviewAccountMutation,
    UpdatePreviewAccountMutationVariables
  >(UpdatePreviewAccountDocument, options);
}
export type UpdatePreviewAccountMutationHookResult = ReturnType<
  typeof useUpdatePreviewAccountMutation
>;
export type UpdatePreviewAccountMutationResult =
  Apollo.MutationResult<UpdatePreviewAccountMutation>;
export type UpdatePreviewAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdatePreviewAccountMutation,
  UpdatePreviewAccountMutationVariables
>;
export const GetPublicPreviewAccountsDocument = gql`
  query getPublicPreviewAccounts(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $state: StateEnum
  ) {
    previewAccounts(page: $page, itemsPerPage: $itemsPerPage) {
      collection {
        id
        district {
          id
        }
        name
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetPublicPreviewAccountsQuery__
 *
 * To run a query within a React component, call `useGetPublicPreviewAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicPreviewAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicPreviewAccountsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetPublicPreviewAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPublicPreviewAccountsQuery,
    GetPublicPreviewAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPublicPreviewAccountsQuery,
    GetPublicPreviewAccountsQueryVariables
  >(GetPublicPreviewAccountsDocument, options);
}
export function useGetPublicPreviewAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicPreviewAccountsQuery,
    GetPublicPreviewAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublicPreviewAccountsQuery,
    GetPublicPreviewAccountsQueryVariables
  >(GetPublicPreviewAccountsDocument, options);
}
export type GetPublicPreviewAccountsQueryHookResult = ReturnType<
  typeof useGetPublicPreviewAccountsQuery
>;
export type GetPublicPreviewAccountsLazyQueryHookResult = ReturnType<
  typeof useGetPublicPreviewAccountsLazyQuery
>;
export type GetPublicPreviewAccountsQueryResult = Apollo.QueryResult<
  GetPublicPreviewAccountsQuery,
  GetPublicPreviewAccountsQueryVariables
>;
export const GetPreviewAccountDocument = gql`
  query getPreviewAccount($id: ID!) {
    previewAccount(id: $id) {
      id
      activityPeriodStart
      activityPeriodEnd
      state
      registrationToken
      opportunity
      accountExecutiveFirstName
      accountExecutiveLastName
      externalSystem
      products {
        id
        productType
      }
      productGroups {
        id
      }
    }
  }
`;

/**
 * __useGetPreviewAccountQuery__
 *
 * To run a query within a React component, call `useGetPreviewAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPreviewAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPreviewAccountQuery,
    GetPreviewAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPreviewAccountQuery,
    GetPreviewAccountQueryVariables
  >(GetPreviewAccountDocument, options);
}
export function useGetPreviewAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviewAccountQuery,
    GetPreviewAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreviewAccountQuery,
    GetPreviewAccountQueryVariables
  >(GetPreviewAccountDocument, options);
}
export type GetPreviewAccountQueryHookResult = ReturnType<
  typeof useGetPreviewAccountQuery
>;
export type GetPreviewAccountLazyQueryHookResult = ReturnType<
  typeof useGetPreviewAccountLazyQuery
>;
export type GetPreviewAccountQueryResult = Apollo.QueryResult<
  GetPreviewAccountQuery,
  GetPreviewAccountQueryVariables
>;
export const UpdatePreviewAccountTeacherDocument = gql`
  mutation updatePreviewAccountTeacher(
    $input: UpdatePreviewAccountTeacherInput!
  ) {
    updatePreviewAccountTeacher(input: $input) {
      previewAccountTeacher {
        id
      }
    }
  }
`;
export type UpdatePreviewAccountTeacherMutationFn = Apollo.MutationFunction<
  UpdatePreviewAccountTeacherMutation,
  UpdatePreviewAccountTeacherMutationVariables
>;

/**
 * __useUpdatePreviewAccountTeacherMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewAccountTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewAccountTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewAccountTeacherMutation, { data, loading, error }] = useUpdatePreviewAccountTeacherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreviewAccountTeacherMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePreviewAccountTeacherMutation,
    UpdatePreviewAccountTeacherMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePreviewAccountTeacherMutation,
    UpdatePreviewAccountTeacherMutationVariables
  >(UpdatePreviewAccountTeacherDocument, options);
}
export type UpdatePreviewAccountTeacherMutationHookResult = ReturnType<
  typeof useUpdatePreviewAccountTeacherMutation
>;
export type UpdatePreviewAccountTeacherMutationResult =
  Apollo.MutationResult<UpdatePreviewAccountTeacherMutation>;
export type UpdatePreviewAccountTeacherMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePreviewAccountTeacherMutation,
    UpdatePreviewAccountTeacherMutationVariables
  >;
export const UploadPreviewAccountsCsvDocument = gql`
  mutation uploadPreviewAccountsCSV($fileName: String!) {
    createPreviewAccountsCsvPostObject(input: { fileName: $fileName }) {
      fileKey
      formAttributes
      formInputs
    }
  }
`;
export type UploadPreviewAccountsCsvMutationFn = Apollo.MutationFunction<
  UploadPreviewAccountsCsvMutation,
  UploadPreviewAccountsCsvMutationVariables
>;

/**
 * __useUploadPreviewAccountsCsvMutation__
 *
 * To run a mutation, you first call `useUploadPreviewAccountsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPreviewAccountsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPreviewAccountsCsvMutation, { data, loading, error }] = useUploadPreviewAccountsCsvMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUploadPreviewAccountsCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadPreviewAccountsCsvMutation,
    UploadPreviewAccountsCsvMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadPreviewAccountsCsvMutation,
    UploadPreviewAccountsCsvMutationVariables
  >(UploadPreviewAccountsCsvDocument, options);
}
export type UploadPreviewAccountsCsvMutationHookResult = ReturnType<
  typeof useUploadPreviewAccountsCsvMutation
>;
export type UploadPreviewAccountsCsvMutationResult =
  Apollo.MutationResult<UploadPreviewAccountsCsvMutation>;
export type UploadPreviewAccountsCsvMutationOptions =
  Apollo.BaseMutationOptions<
    UploadPreviewAccountsCsvMutation,
    UploadPreviewAccountsCsvMutationVariables
  >;
export const CreateDistrictDocument = gql`
  mutation createDistrict($input: createDistrictInput!) {
    createDistrict(input: $input) {
      district {
        globalName
        id
        localName
        state
        city
      }
      clientMutationId
    }
  }
`;
export type CreateDistrictMutationFn = Apollo.MutationFunction<
  CreateDistrictMutation,
  CreateDistrictMutationVariables
>;

/**
 * __useCreateDistrictMutation__
 *
 * To run a mutation, you first call `useCreateDistrictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDistrictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDistrictMutation, { data, loading, error }] = useCreateDistrictMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDistrictMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDistrictMutation,
    CreateDistrictMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDistrictMutation,
    CreateDistrictMutationVariables
  >(CreateDistrictDocument, options);
}
export type CreateDistrictMutationHookResult = ReturnType<
  typeof useCreateDistrictMutation
>;
export type CreateDistrictMutationResult =
  Apollo.MutationResult<CreateDistrictMutation>;
export type CreateDistrictMutationOptions = Apollo.BaseMutationOptions<
  CreateDistrictMutation,
  CreateDistrictMutationVariables
>;
export const GetProductGroupDocument = gql`
  query getProductGroup($id: ID!) {
    productGroup(id: $id) {
      name
      key
      products {
        id
      }
    }
  }
`;

/**
 * __useGetProductGroupQuery__
 *
 * To run a query within a React component, call `useGetProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProductGroupQuery,
    GetProductGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(
    GetProductGroupDocument,
    options
  );
}
export function useGetProductGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductGroupQuery,
    GetProductGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProductGroupQuery,
    GetProductGroupQueryVariables
  >(GetProductGroupDocument, options);
}
export type GetProductGroupQueryHookResult = ReturnType<
  typeof useGetProductGroupQuery
>;
export type GetProductGroupLazyQueryHookResult = ReturnType<
  typeof useGetProductGroupLazyQuery
>;
export type GetProductGroupQueryResult = Apollo.QueryResult<
  GetProductGroupQuery,
  GetProductGroupQueryVariables
>;
export const UpdateProductGroupDocument = gql`
  mutation updateProductGroup($input: UpdateProductGroupInput!) {
    updateProductGroup(input: $input) {
      productGroup {
        id
        name
      }
    }
  }
`;
export type UpdateProductGroupMutationFn = Apollo.MutationFunction<
  UpdateProductGroupMutation,
  UpdateProductGroupMutationVariables
>;

/**
 * __useUpdateProductGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGroupMutation, { data, loading, error }] = useUpdateProductGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProductGroupMutation,
    UpdateProductGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProductGroupMutation,
    UpdateProductGroupMutationVariables
  >(UpdateProductGroupDocument, options);
}
export type UpdateProductGroupMutationHookResult = ReturnType<
  typeof useUpdateProductGroupMutation
>;
export type UpdateProductGroupMutationResult =
  Apollo.MutationResult<UpdateProductGroupMutation>;
export type UpdateProductGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateProductGroupMutation,
  UpdateProductGroupMutationVariables
>;
export const CreateProductGroupDocument = gql`
  mutation createProductGroup($input: CreateProductGroupInput!) {
    createProductGroup(input: $input) {
      productGroup {
        id
        name
        key
      }
    }
  }
`;
export type CreateProductGroupMutationFn = Apollo.MutationFunction<
  CreateProductGroupMutation,
  CreateProductGroupMutationVariables
>;

/**
 * __useCreateProductGroupMutation__
 *
 * To run a mutation, you first call `useCreateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductGroupMutation, { data, loading, error }] = useCreateProductGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProductGroupMutation,
    CreateProductGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProductGroupMutation,
    CreateProductGroupMutationVariables
  >(CreateProductGroupDocument, options);
}
export type CreateProductGroupMutationHookResult = ReturnType<
  typeof useCreateProductGroupMutation
>;
export type CreateProductGroupMutationResult =
  Apollo.MutationResult<CreateProductGroupMutation>;
export type CreateProductGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateProductGroupMutation,
  CreateProductGroupMutationVariables
>;
export const GetPreviewAccountTeachersDocument = gql`
  query getPreviewAccountTeachers(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: PreviewAccountTeacherFilterInput
  ) {
    previewAccountTeachers(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
    ) {
      collection {
        id
        email
        firstName
        lastName
        user {
          active
          username
          inactivityReason
        }
        previewAccount {
          id
          state
        }
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetPreviewAccountTeachersQuery__
 *
 * To run a query within a React component, call `useGetPreviewAccountTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAccountTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAccountTeachersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPreviewAccountTeachersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPreviewAccountTeachersQuery,
    GetPreviewAccountTeachersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPreviewAccountTeachersQuery,
    GetPreviewAccountTeachersQueryVariables
  >(GetPreviewAccountTeachersDocument, options);
}
export function useGetPreviewAccountTeachersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviewAccountTeachersQuery,
    GetPreviewAccountTeachersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreviewAccountTeachersQuery,
    GetPreviewAccountTeachersQueryVariables
  >(GetPreviewAccountTeachersDocument, options);
}
export type GetPreviewAccountTeachersQueryHookResult = ReturnType<
  typeof useGetPreviewAccountTeachersQuery
>;
export type GetPreviewAccountTeachersLazyQueryHookResult = ReturnType<
  typeof useGetPreviewAccountTeachersLazyQuery
>;
export type GetPreviewAccountTeachersQueryResult = Apollo.QueryResult<
  GetPreviewAccountTeachersQuery,
  GetPreviewAccountTeachersQueryVariables
>;
export const GetPreviewAccountsDocument = gql`
  query getPreviewAccounts(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: PreviewAccountFilterInput
    $order: PreviewAccountOrderInput
  ) {
    previewAccounts(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      order: $order
    ) {
      collection {
        id
        active
        district {
          id
          localName
          state
        }
        activityPeriodStart
        activityPeriodEnd
        firstLoginDate
        registrationToken
        state
        products {
          id
          description
          productType
        }
        productGroups {
          id
          name
          products {
            productType
          }
        }
        teachers {
          id
          email
        }
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetPreviewAccountsQuery__
 *
 * To run a query within a React component, call `useGetPreviewAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAccountsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPreviewAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPreviewAccountsQuery,
    GetPreviewAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPreviewAccountsQuery,
    GetPreviewAccountsQueryVariables
  >(GetPreviewAccountsDocument, options);
}
export function useGetPreviewAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviewAccountsQuery,
    GetPreviewAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreviewAccountsQuery,
    GetPreviewAccountsQueryVariables
  >(GetPreviewAccountsDocument, options);
}
export type GetPreviewAccountsQueryHookResult = ReturnType<
  typeof useGetPreviewAccountsQuery
>;
export type GetPreviewAccountsLazyQueryHookResult = ReturnType<
  typeof useGetPreviewAccountsLazyQuery
>;
export type GetPreviewAccountsQueryResult = Apollo.QueryResult<
  GetPreviewAccountsQuery,
  GetPreviewAccountsQueryVariables
>;
export const GetProductDocument = gql`
  query getProduct($id: ID!) {
    product(id: $id) {
      id
      sku
      productType
      description
      scopeGroups {
        _id
        id
      }
      contentGroups {
        id
        _id
      }
    }
  }
`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProductQuery,
    GetProductQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(
    GetProductDocument,
    options
  );
}
export function useGetProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductQuery,
    GetProductQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(
    GetProductDocument,
    options
  );
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<
  typeof useGetProductLazyQuery
>;
export type GetProductQueryResult = Apollo.QueryResult<
  GetProductQuery,
  GetProductQueryVariables
>;
export const CreateProductDocument = gql`
  mutation createProduct($input: CreateProductInput!) {
    createProduct(createProductInput: $input) {
      product {
        id
        sku
        description
      }
    }
  }
`;
export type CreateProductMutationFn = Apollo.MutationFunction<
  CreateProductMutation,
  CreateProductMutationVariables
>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProductMutation,
    CreateProductMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProductMutation,
    CreateProductMutationVariables
  >(CreateProductDocument, options);
}
export type CreateProductMutationHookResult = ReturnType<
  typeof useCreateProductMutation
>;
export type CreateProductMutationResult =
  Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<
  CreateProductMutation,
  CreateProductMutationVariables
>;
export const UpdateProductDocument = gql`
  mutation updateProduct($input: UpdateProductInput!) {
    updateProduct(updateProductInput: $input) {
      product {
        id
        sku
        productType
        description
        scopeGroups {
          _id
          id
        }
        contentGroups {
          id
          _id
        }
      }
    }
  }
`;
export type UpdateProductMutationFn = Apollo.MutationFunction<
  UpdateProductMutation,
  UpdateProductMutationVariables
>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProductMutation,
    UpdateProductMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProductMutation,
    UpdateProductMutationVariables
  >(UpdateProductDocument, options);
}
export type UpdateProductMutationHookResult = ReturnType<
  typeof useUpdateProductMutation
>;
export type UpdateProductMutationResult =
  Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<
  UpdateProductMutation,
  UpdateProductMutationVariables
>;
export const GetProductsDocument = gql`
  query getProducts(
    $page: Int = 1
    $perPage: Int = 10000
    $filter: ProductFilterInput = null
  ) {
    products(page: $page, itemsPerPage: $perPage, filter: $filter) {
      collection {
        id
        sku
        productType
        description
        scopeGroups {
          _id
          id
        }
        contentGroups {
          _id
          id
        }
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProductsQuery,
    GetProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(
    GetProductsDocument,
    options
  );
}
export function useGetProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductsQuery,
    GetProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(
    GetProductsDocument,
    options
  );
}
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<
  typeof useGetProductsLazyQuery
>;
export type GetProductsQueryResult = Apollo.QueryResult<
  GetProductsQuery,
  GetProductsQueryVariables
>;
export const GetActivitiesByItemDocument = gql`
  query getActivitiesByItem($input: AssessmentPoolInput!) {
    assessmentPool(input: $input) {
      platformAdminPayload {
        list {
          id
          tags {
            name
            value
          }
          title
        }
      }
    }
  }
`;

/**
 * __useGetActivitiesByItemQuery__
 *
 * To run a query within a React component, call `useGetActivitiesByItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesByItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesByItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActivitiesByItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivitiesByItemQuery,
    GetActivitiesByItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActivitiesByItemQuery,
    GetActivitiesByItemQueryVariables
  >(GetActivitiesByItemDocument, options);
}
export function useGetActivitiesByItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivitiesByItemQuery,
    GetActivitiesByItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActivitiesByItemQuery,
    GetActivitiesByItemQueryVariables
  >(GetActivitiesByItemDocument, options);
}
export type GetActivitiesByItemQueryHookResult = ReturnType<
  typeof useGetActivitiesByItemQuery
>;
export type GetActivitiesByItemLazyQueryHookResult = ReturnType<
  typeof useGetActivitiesByItemLazyQuery
>;
export type GetActivitiesByItemQueryResult = Apollo.QueryResult<
  GetActivitiesByItemQuery,
  GetActivitiesByItemQueryVariables
>;
export const AttachQuestionContainerDocument = gql`
  mutation attachQuestionContainer($input: AttachQuestionContainerInput!) {
    attachQuestionContainer(input: $input) {
      statusPayload {
        success
      }
    }
  }
`;
export type AttachQuestionContainerMutationFn = Apollo.MutationFunction<
  AttachQuestionContainerMutation,
  AttachQuestionContainerMutationVariables
>;

/**
 * __useAttachQuestionContainerMutation__
 *
 * To run a mutation, you first call `useAttachQuestionContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachQuestionContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachQuestionContainerMutation, { data, loading, error }] = useAttachQuestionContainerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachQuestionContainerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AttachQuestionContainerMutation,
    AttachQuestionContainerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AttachQuestionContainerMutation,
    AttachQuestionContainerMutationVariables
  >(AttachQuestionContainerDocument, options);
}
export type AttachQuestionContainerMutationHookResult = ReturnType<
  typeof useAttachQuestionContainerMutation
>;
export type AttachQuestionContainerMutationResult =
  Apollo.MutationResult<AttachQuestionContainerMutation>;
export type AttachQuestionContainerMutationOptions = Apollo.BaseMutationOptions<
  AttachQuestionContainerMutation,
  AttachQuestionContainerMutationVariables
>;
export const AssessmentQuestionListDocument = gql`
  query assessmentQuestionList(
    $lesson: String
    $purpose: PurposeEnum
    $category: EdgexlCategoryEnum
    $grade: EdgexlGradeEnum
    $standards: [String!]
    $units: [String!]
    $domains: [String!]
    $topics: [String!]
    $concepts: [String!]
  ) {
    questionPool(
      input: {
        platformAdminInput: {
          lesson: $lesson
          grade: $grade
          category: $category
          purpose: $purpose
          standards: $standards
          units: $units
          domains: $domains
          topics: $topics
          concepts: $concepts
        }
      }
    ) {
      platformAdminPayload {
        list {
          items {
            id
            questionType
            tags {
              name
              value
            }
          }
          tags {
            name
            value
          }
          id
          title
        }
        next
      }
    }
  }
`;

/**
 * __useAssessmentQuestionListQuery__
 *
 * To run a query within a React component, call `useAssessmentQuestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentQuestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentQuestionListQuery({
 *   variables: {
 *      lesson: // value for 'lesson'
 *      purpose: // value for 'purpose'
 *      category: // value for 'category'
 *      grade: // value for 'grade'
 *      standards: // value for 'standards'
 *      units: // value for 'units'
 *      domains: // value for 'domains'
 *      topics: // value for 'topics'
 *      concepts: // value for 'concepts'
 *   },
 * });
 */
export function useAssessmentQuestionListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssessmentQuestionListQuery,
    AssessmentQuestionListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessmentQuestionListQuery,
    AssessmentQuestionListQueryVariables
  >(AssessmentQuestionListDocument, options);
}
export function useAssessmentQuestionListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentQuestionListQuery,
    AssessmentQuestionListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentQuestionListQuery,
    AssessmentQuestionListQueryVariables
  >(AssessmentQuestionListDocument, options);
}
export type AssessmentQuestionListQueryHookResult = ReturnType<
  typeof useAssessmentQuestionListQuery
>;
export type AssessmentQuestionListLazyQueryHookResult = ReturnType<
  typeof useAssessmentQuestionListLazyQuery
>;
export type AssessmentQuestionListQueryResult = Apollo.QueryResult<
  AssessmentQuestionListQuery,
  AssessmentQuestionListQueryVariables
>;
export const GetAssessmentQuestionDocument = gql`
  query getAssessmentQuestion($id: ID!) {
    question(input: { platformAdminInput: { id: $id } }) {
      platformAdminPayload {
        item {
          id
          tags {
            name
            value
          }
        }
      }
    }
  }
`;

/**
 * __useGetAssessmentQuestionQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssessmentQuestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssessmentQuestionQuery,
    GetAssessmentQuestionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssessmentQuestionQuery,
    GetAssessmentQuestionQueryVariables
  >(GetAssessmentQuestionDocument, options);
}
export function useGetAssessmentQuestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentQuestionQuery,
    GetAssessmentQuestionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssessmentQuestionQuery,
    GetAssessmentQuestionQueryVariables
  >(GetAssessmentQuestionDocument, options);
}
export type GetAssessmentQuestionQueryHookResult = ReturnType<
  typeof useGetAssessmentQuestionQuery
>;
export type GetAssessmentQuestionLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentQuestionLazyQuery
>;
export type GetAssessmentQuestionQueryResult = Apollo.QueryResult<
  GetAssessmentQuestionQuery,
  GetAssessmentQuestionQueryVariables
>;
export const UpdateQuestionDocument = gql`
  mutation updateQuestion($input: UpdateQuestionInput!) {
    updateQuestion(input: $input) {
      platformAdminPayload {
        signedRequest
        item {
          id
          questionId
          tags {
            name
            value
          }
        }
      }
      __typename
    }
  }
`;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<
  UpdateQuestionMutation,
  UpdateQuestionMutationVariables
>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateQuestionMutation,
    UpdateQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateQuestionMutation,
    UpdateQuestionMutationVariables
  >(UpdateQuestionDocument, options);
}
export type UpdateQuestionMutationHookResult = ReturnType<
  typeof useUpdateQuestionMutation
>;
export type UpdateQuestionMutationResult =
  Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<
  UpdateQuestionMutation,
  UpdateQuestionMutationVariables
>;
export const GetQuestionDetailDocument = gql`
  query getQuestionDetail($input: QuestionInput!) {
    question(input: $input) {
      platformAdminPayload {
        signedRequest
      }
    }
  }
`;

/**
 * __useGetQuestionDetailQuery__
 *
 * To run a query within a React component, call `useGetQuestionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQuestionDetailQuery,
    GetQuestionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQuestionDetailQuery,
    GetQuestionDetailQueryVariables
  >(GetQuestionDetailDocument, options);
}
export function useGetQuestionDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQuestionDetailQuery,
    GetQuestionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQuestionDetailQuery,
    GetQuestionDetailQueryVariables
  >(GetQuestionDetailDocument, options);
}
export type GetQuestionDetailQueryHookResult = ReturnType<
  typeof useGetQuestionDetailQuery
>;
export type GetQuestionDetailLazyQueryHookResult = ReturnType<
  typeof useGetQuestionDetailLazyQuery
>;
export type GetQuestionDetailQueryResult = Apollo.QueryResult<
  GetQuestionDetailQuery,
  GetQuestionDetailQueryVariables
>;
export const CreateActivityDocument = gql`
  mutation createActivity($input: CreateQuestionContainerInput!) {
    createQuestionContainer(input: $input) {
      statusPayload {
        success
      }
    }
  }
`;
export type CreateActivityMutationFn = Apollo.MutationFunction<
  CreateActivityMutation,
  CreateActivityMutationVariables
>;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutation, { data, loading, error }] = useCreateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateActivityMutation,
    CreateActivityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateActivityMutation,
    CreateActivityMutationVariables
  >(CreateActivityDocument, options);
}
export type CreateActivityMutationHookResult = ReturnType<
  typeof useCreateActivityMutation
>;
export type CreateActivityMutationResult =
  Apollo.MutationResult<CreateActivityMutation>;
export type CreateActivityMutationOptions = Apollo.BaseMutationOptions<
  CreateActivityMutation,
  CreateActivityMutationVariables
>;
export const GetItemTitleDocument = gql`
  query getItemTitle($filter: MathNationScopeFilter) {
    mnScopes(filter: $filter) {
      collection {
        id
        category
        grade
        displayName
        contentAudience
        projectTitles
      }
    }
  }
`;

/**
 * __useGetItemTitleQuery__
 *
 * To run a query within a React component, call `useGetItemTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemTitleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetItemTitleQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetItemTitleQuery,
    GetItemTitleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetItemTitleQuery, GetItemTitleQueryVariables>(
    GetItemTitleDocument,
    options
  );
}
export function useGetItemTitleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetItemTitleQuery,
    GetItemTitleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetItemTitleQuery, GetItemTitleQueryVariables>(
    GetItemTitleDocument,
    options
  );
}
export type GetItemTitleQueryHookResult = ReturnType<
  typeof useGetItemTitleQuery
>;
export type GetItemTitleLazyQueryHookResult = ReturnType<
  typeof useGetItemTitleLazyQuery
>;
export type GetItemTitleQueryResult = Apollo.QueryResult<
  GetItemTitleQuery,
  GetItemTitleQueryVariables
>;
export const CreateSignRequestDocument = gql`
  mutation createSignRequest($input: CreateSignRequestInput) {
    createSignRequest(input: $input) {
      signedRequest
    }
  }
`;
export type CreateSignRequestMutationFn = Apollo.MutationFunction<
  CreateSignRequestMutation,
  CreateSignRequestMutationVariables
>;

/**
 * __useCreateSignRequestMutation__
 *
 * To run a mutation, you first call `useCreateSignRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignRequestMutation, { data, loading, error }] = useCreateSignRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSignRequestMutation,
    CreateSignRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSignRequestMutation,
    CreateSignRequestMutationVariables
  >(CreateSignRequestDocument, options);
}
export type CreateSignRequestMutationHookResult = ReturnType<
  typeof useCreateSignRequestMutation
>;
export type CreateSignRequestMutationResult =
  Apollo.MutationResult<CreateSignRequestMutation>;
export type CreateSignRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateSignRequestMutation,
  CreateSignRequestMutationVariables
>;
export const GetKnowledgeTreeDataDocument = gql`
  query getKnowledgeTreeData($input: AdminKnowledgeTreeInput!) {
    adminKnowledgeTree(input: $input) {
      standards {
        color
        xCoordinate
        id
        desc
        yCoordinate
        standard
      }
      edges {
        from
        to
      }
    }
  }
`;

/**
 * __useGetKnowledgeTreeDataQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeTreeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeTreeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeTreeDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetKnowledgeTreeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetKnowledgeTreeDataQuery,
    GetKnowledgeTreeDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetKnowledgeTreeDataQuery,
    GetKnowledgeTreeDataQueryVariables
  >(GetKnowledgeTreeDataDocument, options);
}
export function useGetKnowledgeTreeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetKnowledgeTreeDataQuery,
    GetKnowledgeTreeDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetKnowledgeTreeDataQuery,
    GetKnowledgeTreeDataQueryVariables
  >(GetKnowledgeTreeDataDocument, options);
}
export type GetKnowledgeTreeDataQueryHookResult = ReturnType<
  typeof useGetKnowledgeTreeDataQuery
>;
export type GetKnowledgeTreeDataLazyQueryHookResult = ReturnType<
  typeof useGetKnowledgeTreeDataLazyQuery
>;
export type GetKnowledgeTreeDataQueryResult = Apollo.QueryResult<
  GetKnowledgeTreeDataQuery,
  GetKnowledgeTreeDataQueryVariables
>;
export const UpdateActivityItemDocument = gql`
  mutation updateActivityItem($input: UpdateAssessmentInput!) {
    updateAssessment(input: $input) {
      platformAdminPayload {
        item {
          id
          items
          title
        }
      }
    }
  }
`;
export type UpdateActivityItemMutationFn = Apollo.MutationFunction<
  UpdateActivityItemMutation,
  UpdateActivityItemMutationVariables
>;

/**
 * __useUpdateActivityItemMutation__
 *
 * To run a mutation, you first call `useUpdateActivityItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityItemMutation, { data, loading, error }] = useUpdateActivityItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActivityItemMutation,
    UpdateActivityItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateActivityItemMutation,
    UpdateActivityItemMutationVariables
  >(UpdateActivityItemDocument, options);
}
export type UpdateActivityItemMutationHookResult = ReturnType<
  typeof useUpdateActivityItemMutation
>;
export type UpdateActivityItemMutationResult =
  Apollo.MutationResult<UpdateActivityItemMutation>;
export type UpdateActivityItemMutationOptions = Apollo.BaseMutationOptions<
  UpdateActivityItemMutation,
  UpdateActivityItemMutationVariables
>;
export const GetStudentsDocument = gql`
  query getStudents(
    $page: Int
    $itemsPerPage: Int
    $stateId: String
    $schoolId: String
  ) {
    users(
      type: student
      page: $page
      stateId: $stateId
      schoolsId: $schoolId
      itemsPerPage: $itemsPerPage
    ) {
      collection {
        _id
        firstName
        lastName
      }
      paginationInfo {
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetStudentsQuery__
 *
 * To run a query within a React component, call `useGetStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      stateId: // value for 'stateId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStudentsQuery,
    GetStudentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStudentsQuery, GetStudentsQueryVariables>(
    GetStudentsDocument,
    options
  );
}
export function useGetStudentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStudentsQuery,
    GetStudentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStudentsQuery, GetStudentsQueryVariables>(
    GetStudentsDocument,
    options
  );
}
export type GetStudentsQueryHookResult = ReturnType<typeof useGetStudentsQuery>;
export type GetStudentsLazyQueryHookResult = ReturnType<
  typeof useGetStudentsLazyQuery
>;
export type GetStudentsQueryResult = Apollo.QueryResult<
  GetStudentsQuery,
  GetStudentsQueryVariables
>;
export const GetAllSchoolsDocument = gql`
  query getAllSchools {
    schools {
      collection {
        _id
        globalName
      }
    }
  }
`;

/**
 * __useGetAllSchoolsQuery__
 *
 * To run a query within a React component, call `useGetAllSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSchoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSchoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllSchoolsQuery,
    GetAllSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllSchoolsQuery, GetAllSchoolsQueryVariables>(
    GetAllSchoolsDocument,
    options
  );
}
export function useGetAllSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllSchoolsQuery,
    GetAllSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllSchoolsQuery, GetAllSchoolsQueryVariables>(
    GetAllSchoolsDocument,
    options
  );
}
export type GetAllSchoolsQueryHookResult = ReturnType<
  typeof useGetAllSchoolsQuery
>;
export type GetAllSchoolsLazyQueryHookResult = ReturnType<
  typeof useGetAllSchoolsLazyQuery
>;
export type GetAllSchoolsQueryResult = Apollo.QueryResult<
  GetAllSchoolsQuery,
  GetAllSchoolsQueryVariables
>;
export const StartImpersonationDocument = gql`
  mutation startImpersonation($userId: String!) {
    createImpersonation(input: { userId: $userId }) {
      impersonation {
        user {
          _id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
export type StartImpersonationMutationFn = Apollo.MutationFunction<
  StartImpersonationMutation,
  StartImpersonationMutationVariables
>;

/**
 * __useStartImpersonationMutation__
 *
 * To run a mutation, you first call `useStartImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImpersonationMutation, { data, loading, error }] = useStartImpersonationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStartImpersonationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartImpersonationMutation,
    StartImpersonationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartImpersonationMutation,
    StartImpersonationMutationVariables
  >(StartImpersonationDocument, options);
}
export type StartImpersonationMutationHookResult = ReturnType<
  typeof useStartImpersonationMutation
>;
export type StartImpersonationMutationResult =
  Apollo.MutationResult<StartImpersonationMutation>;
export type StartImpersonationMutationOptions = Apollo.BaseMutationOptions<
  StartImpersonationMutation,
  StartImpersonationMutationVariables
>;
export const CreateSchoolDocument = gql`
  mutation createSchool($input: createSchoolInput!) {
    createSchool(input: $input) {
      school {
        globalName
        id
        _id
        localName
        districtId
        city
      }
      clientMutationId
    }
  }
`;
export type CreateSchoolMutationFn = Apollo.MutationFunction<
  CreateSchoolMutation,
  CreateSchoolMutationVariables
>;

/**
 * __useCreateSchoolMutation__
 *
 * To run a mutation, you first call `useCreateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolMutation, { data, loading, error }] = useCreateSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchoolMutation,
    CreateSchoolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSchoolMutation,
    CreateSchoolMutationVariables
  >(CreateSchoolDocument, options);
}
export type CreateSchoolMutationHookResult = ReturnType<
  typeof useCreateSchoolMutation
>;
export type CreateSchoolMutationResult =
  Apollo.MutationResult<CreateSchoolMutation>;
export type CreateSchoolMutationOptions = Apollo.BaseMutationOptions<
  CreateSchoolMutation,
  CreateSchoolMutationVariables
>;
export const GetStandardsQuestionsDocument = gql`
  query getStandardsQuestions($input: QuestionsInput!) {
    questions(input: $input) {
      platformAdminPayload {
        list {
          id
          questionId
          tags {
            name
            value
          }
        }
      }
    }
  }
`;

/**
 * __useGetStandardsQuestionsQuery__
 *
 * To run a query within a React component, call `useGetStandardsQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardsQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardsQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStandardsQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStandardsQuestionsQuery,
    GetStandardsQuestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStandardsQuestionsQuery,
    GetStandardsQuestionsQueryVariables
  >(GetStandardsQuestionsDocument, options);
}
export function useGetStandardsQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStandardsQuestionsQuery,
    GetStandardsQuestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStandardsQuestionsQuery,
    GetStandardsQuestionsQueryVariables
  >(GetStandardsQuestionsDocument, options);
}
export type GetStandardsQuestionsQueryHookResult = ReturnType<
  typeof useGetStandardsQuestionsQuery
>;
export type GetStandardsQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetStandardsQuestionsLazyQuery
>;
export type GetStandardsQuestionsQueryResult = Apollo.QueryResult<
  GetStandardsQuestionsQuery,
  GetStandardsQuestionsQueryVariables
>;
export const GetSchoolDocument = gql`
  query getSchool($id: ID!) {
    school(id: $id) {
      globalName
      id
      localName
      districtId
      city
      ncesId
      mathNationId
      district {
        _id
        globalName
      }
    }
  }
`;

/**
 * __useGetSchoolQuery__
 *
 * To run a query within a React component, call `useGetSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolQuery(
  baseOptions: Apollo.QueryHookOptions<GetSchoolQuery, GetSchoolQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSchoolQuery, GetSchoolQueryVariables>(
    GetSchoolDocument,
    options
  );
}
export function useGetSchoolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchoolQuery,
    GetSchoolQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSchoolQuery, GetSchoolQueryVariables>(
    GetSchoolDocument,
    options
  );
}
export type GetSchoolQueryHookResult = ReturnType<typeof useGetSchoolQuery>;
export type GetSchoolLazyQueryHookResult = ReturnType<
  typeof useGetSchoolLazyQuery
>;
export type GetSchoolQueryResult = Apollo.QueryResult<
  GetSchoolQuery,
  GetSchoolQueryVariables
>;
export const GetSchoolsAdminDocument = gql`
  query getSchoolsAdmin(
    $id_list: [String]
    $itemsPerPage: Int = 10000
    $districtId: String
  ) {
    schools(
      id_list: $id_list
      itemsPerPage: $itemsPerPage
      districtId: $districtId
    ) {
      collection {
        globalName
        id
        _id
        name
      }
    }
  }
`;

/**
 * __useGetSchoolsAdminQuery__
 *
 * To run a query within a React component, call `useGetSchoolsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsAdminQuery({
 *   variables: {
 *      id_list: // value for 'id_list'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      districtId: // value for 'districtId'
 *   },
 * });
 */
export function useGetSchoolsAdminQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSchoolsAdminQuery,
    GetSchoolsAdminQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSchoolsAdminQuery, GetSchoolsAdminQueryVariables>(
    GetSchoolsAdminDocument,
    options
  );
}
export function useGetSchoolsAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchoolsAdminQuery,
    GetSchoolsAdminQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSchoolsAdminQuery,
    GetSchoolsAdminQueryVariables
  >(GetSchoolsAdminDocument, options);
}
export type GetSchoolsAdminQueryHookResult = ReturnType<
  typeof useGetSchoolsAdminQuery
>;
export type GetSchoolsAdminLazyQueryHookResult = ReturnType<
  typeof useGetSchoolsAdminLazyQuery
>;
export type GetSchoolsAdminQueryResult = Apollo.QueryResult<
  GetSchoolsAdminQuery,
  GetSchoolsAdminQueryVariables
>;
export const UpdateSchoolDocument = gql`
  mutation updateSchool($input: updateSchoolInput!) {
    updateSchool(input: $input) {
      school {
        globalName
        id
        localName
        districtId
        city
        district {
          _id
          globalName
        }
      }
      clientMutationId
    }
  }
`;
export type UpdateSchoolMutationFn = Apollo.MutationFunction<
  UpdateSchoolMutation,
  UpdateSchoolMutationVariables
>;

/**
 * __useUpdateSchoolMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolMutation, { data, loading, error }] = useUpdateSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolMutation,
    UpdateSchoolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSchoolMutation,
    UpdateSchoolMutationVariables
  >(UpdateSchoolDocument, options);
}
export type UpdateSchoolMutationHookResult = ReturnType<
  typeof useUpdateSchoolMutation
>;
export type UpdateSchoolMutationResult =
  Apollo.MutationResult<UpdateSchoolMutation>;
export type UpdateSchoolMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchoolMutation,
  UpdateSchoolMutationVariables
>;
export const GetSchoolsListDocument = gql`
  query getSchoolsList(
    $page: Int = 1
    $perPage: Int = 30
    $sorting: [SchoolFilter_order]
    $filter: [SchoolFilter]
  ) {
    schools(
      page: $page
      itemsPerPage: $perPage
      order: $sorting
      filter: $filter
    ) {
      collection {
        globalName
        localName
        id
        _id
        city
        name
        mathNationId
        district {
          globalName
          state
          id
        }
      }
      paginationInfo {
        totalCount
        lastPage
        itemsPerPage
      }
    }
  }
`;

/**
 * __useGetSchoolsListQuery__
 *
 * To run a query within a React component, call `useGetSchoolsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSchoolsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSchoolsListQuery,
    GetSchoolsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSchoolsListQuery, GetSchoolsListQueryVariables>(
    GetSchoolsListDocument,
    options
  );
}
export function useGetSchoolsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchoolsListQuery,
    GetSchoolsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSchoolsListQuery, GetSchoolsListQueryVariables>(
    GetSchoolsListDocument,
    options
  );
}
export type GetSchoolsListQueryHookResult = ReturnType<
  typeof useGetSchoolsListQuery
>;
export type GetSchoolsListLazyQueryHookResult = ReturnType<
  typeof useGetSchoolsListLazyQuery
>;
export type GetSchoolsListQueryResult = Apollo.QueryResult<
  GetSchoolsListQuery,
  GetSchoolsListQueryVariables
>;
export const GetStandardsListDocument = gql`
  query getStandardsList($input: StandardListInput!) {
    standardList(input: $input) {
      standards
    }
  }
`;

/**
 * __useGetStandardsListQuery__
 *
 * To run a query within a React component, call `useGetStandardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStandardsListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStandardsListQuery,
    GetStandardsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStandardsListQuery, GetStandardsListQueryVariables>(
    GetStandardsListDocument,
    options
  );
}
export function useGetStandardsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStandardsListQuery,
    GetStandardsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStandardsListQuery,
    GetStandardsListQueryVariables
  >(GetStandardsListDocument, options);
}
export type GetStandardsListQueryHookResult = ReturnType<
  typeof useGetStandardsListQuery
>;
export type GetStandardsListLazyQueryHookResult = ReturnType<
  typeof useGetStandardsListLazyQuery
>;
export type GetStandardsListQueryResult = Apollo.QueryResult<
  GetStandardsListQuery,
  GetStandardsListQueryVariables
>;
export const GetAllStandardsListDocument = gql`
  query getAllStandardsList($input: StandardsListInput!) {
    standardsList(input: $input) {
      data {
        description
        id
        response
        standard
        state
        status
        subject
      }
      total
    }
  }
`;

/**
 * __useGetAllStandardsListQuery__
 *
 * To run a query within a React component, call `useGetAllStandardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStandardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStandardsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllStandardsListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllStandardsListQuery,
    GetAllStandardsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllStandardsListQuery,
    GetAllStandardsListQueryVariables
  >(GetAllStandardsListDocument, options);
}
export function useGetAllStandardsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllStandardsListQuery,
    GetAllStandardsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllStandardsListQuery,
    GetAllStandardsListQueryVariables
  >(GetAllStandardsListDocument, options);
}
export type GetAllStandardsListQueryHookResult = ReturnType<
  typeof useGetAllStandardsListQuery
>;
export type GetAllStandardsListLazyQueryHookResult = ReturnType<
  typeof useGetAllStandardsListLazyQuery
>;
export type GetAllStandardsListQueryResult = Apollo.QueryResult<
  GetAllStandardsListQuery,
  GetAllStandardsListQueryVariables
>;
export const CreateStandardDocument = gql`
  query createStandard($input: StandardsInput!) {
    createStandard(input: $input) {
      description
      id
      response
      standard
      state
      status
      subject
    }
  }
`;

/**
 * __useCreateStandardQuery__
 *
 * To run a query within a React component, call `useCreateStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateStandardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStandardQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateStandardQuery,
    CreateStandardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreateStandardQuery, CreateStandardQueryVariables>(
    CreateStandardDocument,
    options
  );
}
export function useCreateStandardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateStandardQuery,
    CreateStandardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreateStandardQuery, CreateStandardQueryVariables>(
    CreateStandardDocument,
    options
  );
}
export type CreateStandardQueryHookResult = ReturnType<
  typeof useCreateStandardQuery
>;
export type CreateStandardLazyQueryHookResult = ReturnType<
  typeof useCreateStandardLazyQuery
>;
export type CreateStandardQueryResult = Apollo.QueryResult<
  CreateStandardQuery,
  CreateStandardQueryVariables
>;
export const DeleteStandardDocument = gql`
  query deleteStandard($input: StandardDeleteInput!) {
    deteleStandard(input: $input) {
      response
      standardId
      status
    }
  }
`;

/**
 * __useDeleteStandardQuery__
 *
 * To run a query within a React component, call `useDeleteStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteStandardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStandardQuery(
  baseOptions: Apollo.QueryHookOptions<
    DeleteStandardQuery,
    DeleteStandardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DeleteStandardQuery, DeleteStandardQueryVariables>(
    DeleteStandardDocument,
    options
  );
}
export function useDeleteStandardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeleteStandardQuery,
    DeleteStandardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DeleteStandardQuery, DeleteStandardQueryVariables>(
    DeleteStandardDocument,
    options
  );
}
export type DeleteStandardQueryHookResult = ReturnType<
  typeof useDeleteStandardQuery
>;
export type DeleteStandardLazyQueryHookResult = ReturnType<
  typeof useDeleteStandardLazyQuery
>;
export type DeleteStandardQueryResult = Apollo.QueryResult<
  DeleteStandardQuery,
  DeleteStandardQueryVariables
>;
export const UpdateSubscriptionPackageDocument = gql`
  mutation updateSubscriptionPackage(
    $updateSubscriptionPackageInput: UpdateSubscriptionPackageInput!
  ) {
    updateSubscriptionPackage(
      updateSubscriptionPackageInput: $updateSubscriptionPackageInput
    ) {
      subscriptionPackage {
        id
        schools {
          district {
            globalName
          }
          globalName
        }
      }
    }
  }
`;
export type UpdateSubscriptionPackageMutationFn = Apollo.MutationFunction<
  UpdateSubscriptionPackageMutation,
  UpdateSubscriptionPackageMutationVariables
>;

/**
 * __useUpdateSubscriptionPackageMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionPackageMutation, { data, loading, error }] = useUpdateSubscriptionPackageMutation({
 *   variables: {
 *      updateSubscriptionPackageInput: // value for 'updateSubscriptionPackageInput'
 *   },
 * });
 */
export function useUpdateSubscriptionPackageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubscriptionPackageMutation,
    UpdateSubscriptionPackageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSubscriptionPackageMutation,
    UpdateSubscriptionPackageMutationVariables
  >(UpdateSubscriptionPackageDocument, options);
}
export type UpdateSubscriptionPackageMutationHookResult = ReturnType<
  typeof useUpdateSubscriptionPackageMutation
>;
export type UpdateSubscriptionPackageMutationResult =
  Apollo.MutationResult<UpdateSubscriptionPackageMutation>;
export type UpdateSubscriptionPackageMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSubscriptionPackageMutation,
    UpdateSubscriptionPackageMutationVariables
  >;
export const GetSubscriptionPackageDocument = gql`
  query getSubscriptionPackage($id: ID!) {
    subscriptionPackage(id: $id) {
      id
      schools {
        _id
        localName
        globalName
        district {
          id
          _id
          state
          localName
          globalName
        }
      }
      scope
      subscriptions {
        id
        dateEnd
        dateStart
        quantity
        products {
          id
          sku
          description
        }
      }
    }
  }
`;

/**
 * __useGetSubscriptionPackageQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionPackageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubscriptionPackageQuery,
    GetSubscriptionPackageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionPackageQuery,
    GetSubscriptionPackageQueryVariables
  >(GetSubscriptionPackageDocument, options);
}
export function useGetSubscriptionPackageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionPackageQuery,
    GetSubscriptionPackageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionPackageQuery,
    GetSubscriptionPackageQueryVariables
  >(GetSubscriptionPackageDocument, options);
}
export type GetSubscriptionPackageQueryHookResult = ReturnType<
  typeof useGetSubscriptionPackageQuery
>;
export type GetSubscriptionPackageLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionPackageLazyQuery
>;
export type GetSubscriptionPackageQueryResult = Apollo.QueryResult<
  GetSubscriptionPackageQuery,
  GetSubscriptionPackageQueryVariables
>;
export const CreateSubscriptionDocument = gql`
  mutation createSubscription(
    $createSubscriptionInput: CreateSubscriptionInput!
  ) {
    createSubscription(createSubscriptionInput: $createSubscriptionInput) {
      subscription {
        id
      }
    }
  }
`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      createSubscriptionInput: // value for 'createSubscriptionInput'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubscriptionMutation,
    CreateSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubscriptionMutation,
    CreateSubscriptionMutationVariables
  >(CreateSubscriptionDocument, options);
}
export type CreateSubscriptionMutationHookResult = ReturnType<
  typeof useCreateSubscriptionMutation
>;
export type CreateSubscriptionMutationResult =
  Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;
export const CreateSubscriptionPackageDocument = gql`
  mutation createSubscriptionPackage(
    $createSubscriptionPackageInput: CreateSubscriptionPackageInput!
  ) {
    createSubscriptionPackage(
      createSubscriptionPackageInput: $createSubscriptionPackageInput
    ) {
      subscriptionPackage {
        id
        schools {
          district {
            globalName
          }
          globalName
        }
      }
    }
  }
`;
export type CreateSubscriptionPackageMutationFn = Apollo.MutationFunction<
  CreateSubscriptionPackageMutation,
  CreateSubscriptionPackageMutationVariables
>;

/**
 * __useCreateSubscriptionPackageMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionPackageMutation, { data, loading, error }] = useCreateSubscriptionPackageMutation({
 *   variables: {
 *      createSubscriptionPackageInput: // value for 'createSubscriptionPackageInput'
 *   },
 * });
 */
export function useCreateSubscriptionPackageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubscriptionPackageMutation,
    CreateSubscriptionPackageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubscriptionPackageMutation,
    CreateSubscriptionPackageMutationVariables
  >(CreateSubscriptionPackageDocument, options);
}
export type CreateSubscriptionPackageMutationHookResult = ReturnType<
  typeof useCreateSubscriptionPackageMutation
>;
export type CreateSubscriptionPackageMutationResult =
  Apollo.MutationResult<CreateSubscriptionPackageMutation>;
export type CreateSubscriptionPackageMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSubscriptionPackageMutation,
    CreateSubscriptionPackageMutationVariables
  >;
export const UpdateSubscriptionDocument = gql`
  mutation updateSubscription(
    $updateSubscriptionInput: UpdateSubscriptionInput!
  ) {
    updateSubscription(updateSubscriptionInput: $updateSubscriptionInput) {
      subscription {
        id
      }
    }
  }
`;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables
>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      updateSubscriptionInput: // value for 'updateSubscriptionInput'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubscriptionMutation,
    UpdateSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSubscriptionMutation,
    UpdateSubscriptionMutationVariables
  >(UpdateSubscriptionDocument, options);
}
export type UpdateSubscriptionMutationHookResult = ReturnType<
  typeof useUpdateSubscriptionMutation
>;
export type UpdateSubscriptionMutationResult =
  Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables
>;
export const ListTagProjectsDocument = gql`
  query listTagProjects {
    listTagProjects {
      data {
        id
        category
        name
        projectTitle
      }
    }
  }
`;

/**
 * __useListTagProjectsQuery__
 *
 * To run a query within a React component, call `useListTagProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTagProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTagProjectsQuery,
    ListTagProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTagProjectsQuery, ListTagProjectsQueryVariables>(
    ListTagProjectsDocument,
    options
  );
}
export function useListTagProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTagProjectsQuery,
    ListTagProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTagProjectsQuery,
    ListTagProjectsQueryVariables
  >(ListTagProjectsDocument, options);
}
export type ListTagProjectsQueryHookResult = ReturnType<
  typeof useListTagProjectsQuery
>;
export type ListTagProjectsLazyQueryHookResult = ReturnType<
  typeof useListTagProjectsLazyQuery
>;
export type ListTagProjectsQueryResult = Apollo.QueryResult<
  ListTagProjectsQuery,
  ListTagProjectsQueryVariables
>;
export const UpdateStandardTagsDocument = gql`
  mutation updateStandardTags($input: UpdateStandardTagsInput!) {
    updateStandardTags(input: $input) {
      status
    }
  }
`;
export type UpdateStandardTagsMutationFn = Apollo.MutationFunction<
  UpdateStandardTagsMutation,
  UpdateStandardTagsMutationVariables
>;

/**
 * __useUpdateStandardTagsMutation__
 *
 * To run a mutation, you first call `useUpdateStandardTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStandardTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStandardTagsMutation, { data, loading, error }] = useUpdateStandardTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStandardTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStandardTagsMutation,
    UpdateStandardTagsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStandardTagsMutation,
    UpdateStandardTagsMutationVariables
  >(UpdateStandardTagsDocument, options);
}
export type UpdateStandardTagsMutationHookResult = ReturnType<
  typeof useUpdateStandardTagsMutation
>;
export type UpdateStandardTagsMutationResult =
  Apollo.MutationResult<UpdateStandardTagsMutation>;
export type UpdateStandardTagsMutationOptions = Apollo.BaseMutationOptions<
  UpdateStandardTagsMutation,
  UpdateStandardTagsMutationVariables
>;
export const CheckStaffOnExistenceDocument = gql`
  query checkStaffOnExistence(
    $staffId: String
    $withStaffId: Boolean!
    $withLmsId: Boolean!
    $lmsId: String
    $districtId: String
  ) {
    usersByStaffId: users(staffId: $staffId, districtId: $districtId)
      @include(if: $withStaffId) {
      collection {
        id
      }
    }
    usersByLmsId: users(stateId: $lmsId, districtId: $districtId)
      @include(if: $withLmsId) {
      collection {
        id
      }
    }
  }
`;

/**
 * __useCheckStaffOnExistenceQuery__
 *
 * To run a query within a React component, call `useCheckStaffOnExistenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckStaffOnExistenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckStaffOnExistenceQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      withStaffId: // value for 'withStaffId'
 *      withLmsId: // value for 'withLmsId'
 *      lmsId: // value for 'lmsId'
 *      districtId: // value for 'districtId'
 *   },
 * });
 */
export function useCheckStaffOnExistenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckStaffOnExistenceQuery,
    CheckStaffOnExistenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckStaffOnExistenceQuery,
    CheckStaffOnExistenceQueryVariables
  >(CheckStaffOnExistenceDocument, options);
}
export function useCheckStaffOnExistenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckStaffOnExistenceQuery,
    CheckStaffOnExistenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckStaffOnExistenceQuery,
    CheckStaffOnExistenceQueryVariables
  >(CheckStaffOnExistenceDocument, options);
}
export type CheckStaffOnExistenceQueryHookResult = ReturnType<
  typeof useCheckStaffOnExistenceQuery
>;
export type CheckStaffOnExistenceLazyQueryHookResult = ReturnType<
  typeof useCheckStaffOnExistenceLazyQuery
>;
export type CheckStaffOnExistenceQueryResult = Apollo.QueryResult<
  CheckStaffOnExistenceQuery,
  CheckStaffOnExistenceQueryVariables
>;
export const GetProductGroupsDocument = gql`
  query getProductGroups(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: ProductGroupFilterInput
  ) {
    productGroups(page: $page, itemsPerPage: $itemsPerPage, filter: $filter) {
      collection {
        id
        key
        products {
          id
          productType
          contentGroups {
            _id
            id
          }
          productType
        }
        name
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
    products(page: 1, itemsPerPage: 10000) {
      collection {
        id
        sku
        productType
        description
        scopeGroups {
          _id
          id
        }
        contentGroups {
          _id
          id
        }
      }
    }
  }
`;

/**
 * __useGetProductGroupsQuery__
 *
 * To run a query within a React component, call `useGetProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProductGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProductGroupsQuery,
    GetProductGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductGroupsQuery, GetProductGroupsQueryVariables>(
    GetProductGroupsDocument,
    options
  );
}
export function useGetProductGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductGroupsQuery,
    GetProductGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProductGroupsQuery,
    GetProductGroupsQueryVariables
  >(GetProductGroupsDocument, options);
}
export type GetProductGroupsQueryHookResult = ReturnType<
  typeof useGetProductGroupsQuery
>;
export type GetProductGroupsLazyQueryHookResult = ReturnType<
  typeof useGetProductGroupsLazyQuery
>;
export type GetProductGroupsQueryResult = Apollo.QueryResult<
  GetProductGroupsQuery,
  GetProductGroupsQueryVariables
>;
export const CreateReviewerDocument = gql`
  mutation createReviewer($input: CreateAdoptionReviewerInput!) {
    createAdoptionReviewer(input: $input) {
      adoptionReviewer {
        id
        user {
          username
        }
      }
    }
  }
`;
export type CreateReviewerMutationFn = Apollo.MutationFunction<
  CreateReviewerMutation,
  CreateReviewerMutationVariables
>;

/**
 * __useCreateReviewerMutation__
 *
 * To run a mutation, you first call `useCreateReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewerMutation, { data, loading, error }] = useCreateReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReviewerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReviewerMutation,
    CreateReviewerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReviewerMutation,
    CreateReviewerMutationVariables
  >(CreateReviewerDocument, options);
}
export type CreateReviewerMutationHookResult = ReturnType<
  typeof useCreateReviewerMutation
>;
export type CreateReviewerMutationResult =
  Apollo.MutationResult<CreateReviewerMutation>;
export type CreateReviewerMutationOptions = Apollo.BaseMutationOptions<
  CreateReviewerMutation,
  CreateReviewerMutationVariables
>;
export const GetAllTutorsDocument = gql`
  query getAllTutors {
    tutors(itemsPerPage: 300, page: 1) {
      collection {
        id
        firstName
        lastName
      }
    }
  }
`;

/**
 * __useGetAllTutorsQuery__
 *
 * To run a query within a React component, call `useGetAllTutorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTutorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTutorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTutorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllTutorsQuery,
    GetAllTutorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllTutorsQuery, GetAllTutorsQueryVariables>(
    GetAllTutorsDocument,
    options
  );
}
export function useGetAllTutorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllTutorsQuery,
    GetAllTutorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllTutorsQuery, GetAllTutorsQueryVariables>(
    GetAllTutorsDocument,
    options
  );
}
export type GetAllTutorsQueryHookResult = ReturnType<
  typeof useGetAllTutorsQuery
>;
export type GetAllTutorsLazyQueryHookResult = ReturnType<
  typeof useGetAllTutorsLazyQuery
>;
export type GetAllTutorsQueryResult = Apollo.QueryResult<
  GetAllTutorsQuery,
  GetAllTutorsQueryVariables
>;
export const AddQuestionsToVideoDocument = gql`
  mutation addQuestionsToVideo($input: AddQuestionsToVideoInput!) {
    addQuestionsToVideo(input: $input) {
      video {
        ... on Video {
          id
        }
      }
    }
  }
`;
export type AddQuestionsToVideoMutationFn = Apollo.MutationFunction<
  AddQuestionsToVideoMutation,
  AddQuestionsToVideoMutationVariables
>;

/**
 * __useAddQuestionsToVideoMutation__
 *
 * To run a mutation, you first call `useAddQuestionsToVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionsToVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionsToVideoMutation, { data, loading, error }] = useAddQuestionsToVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuestionsToVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddQuestionsToVideoMutation,
    AddQuestionsToVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddQuestionsToVideoMutation,
    AddQuestionsToVideoMutationVariables
  >(AddQuestionsToVideoDocument, options);
}
export type AddQuestionsToVideoMutationHookResult = ReturnType<
  typeof useAddQuestionsToVideoMutation
>;
export type AddQuestionsToVideoMutationResult =
  Apollo.MutationResult<AddQuestionsToVideoMutation>;
export type AddQuestionsToVideoMutationOptions = Apollo.BaseMutationOptions<
  AddQuestionsToVideoMutation,
  AddQuestionsToVideoMutationVariables
>;
export const UploadVideoDocument = gql`
  mutation uploadVideo(
    $fileName: String!
    $groupIdentifier: String
    $groupType: VideoGroupEnum!
    $userId: String
    $index: String
    $forceCreate: Boolean!
    $description: String
    $glossaryTerm: String
    $mediaType: MediaTypeEnum = MEDIA_TYPE_VIDEO
    $k5: Boolean = false
  ) {
    createVideoPostObject(
      input: {
        description: $description
        forceCreate: $forceCreate
        fileName: $fileName
        groupIdentifier: $groupIdentifier
        groupType: $groupType
        tutorId: $userId
        glossaryTerm: $glossaryTerm
        videoIndex: $index
        mediaType: $mediaType
        k5: $k5
      }
    ) {
      id
      fileKey
      formAttributes
      formInputs
    }
  }
`;
export type UploadVideoMutationFn = Apollo.MutationFunction<
  UploadVideoMutation,
  UploadVideoMutationVariables
>;

/**
 * __useUploadVideoMutation__
 *
 * To run a mutation, you first call `useUploadVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVideoMutation, { data, loading, error }] = useUploadVideoMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      groupIdentifier: // value for 'groupIdentifier'
 *      groupType: // value for 'groupType'
 *      userId: // value for 'userId'
 *      index: // value for 'index'
 *      forceCreate: // value for 'forceCreate'
 *      description: // value for 'description'
 *      glossaryTerm: // value for 'glossaryTerm'
 *      mediaType: // value for 'mediaType'
 *      k5: // value for 'k5'
 *   },
 * });
 */
export function useUploadVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadVideoMutation,
    UploadVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadVideoMutation, UploadVideoMutationVariables>(
    UploadVideoDocument,
    options
  );
}
export type UploadVideoMutationHookResult = ReturnType<
  typeof useUploadVideoMutation
>;
export type UploadVideoMutationResult =
  Apollo.MutationResult<UploadVideoMutation>;
export type UploadVideoMutationOptions = Apollo.BaseMutationOptions<
  UploadVideoMutation,
  UploadVideoMutationVariables
>;
export const GetVideosListDocument = gql`
  query getVideosList(
    $page: Int!
    $itemsPerPage: Int!
    $filter: VideoFilterInput!
  ) {
    videos(page: $page, itemsPerPage: $itemsPerPage, filter: $filter) {
      collection {
        ... on Video {
          id
          fileName
          mnIdentifier
          videoIndex
          active
          groupIdentifier
          questionList
          tutor {
            id
            firstName
            lastName
            initialTag
          }
          videoUrl
          spriteUrl
          subtitlesUrl
          processStatus
          description
          glossary
          glossaryTerm
          k5
        }
        ... on Pdf {
          id
          url
          groupIdentifier
          fileName
          entityId
        }
      }
      paginationInfo {
        lastPage
        itemsPerPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetVideosListQuery__
 *
 * To run a query within a React component, call `useGetVideosListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetVideosListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVideosListQuery,
    GetVideosListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVideosListQuery, GetVideosListQueryVariables>(
    GetVideosListDocument,
    options
  );
}
export function useGetVideosListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVideosListQuery,
    GetVideosListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVideosListQuery, GetVideosListQueryVariables>(
    GetVideosListDocument,
    options
  );
}
export type GetVideosListQueryHookResult = ReturnType<
  typeof useGetVideosListQuery
>;
export type GetVideosListLazyQueryHookResult = ReturnType<
  typeof useGetVideosListLazyQuery
>;
export type GetVideosListQueryResult = Apollo.QueryResult<
  GetVideosListQuery,
  GetVideosListQueryVariables
>;
export const MoveVideoDocument = gql`
  mutation moveVideo(
    $fromMovedInput: FromMoveVideoInput!
    $toMovedInput: ToMoveVideoInput!
    $groupType: VideoGroupEnum!
    $active: Boolean
    $description: String
    $glossaryTerm: String
    $mediaType: MediaTypeEnum = MEDIA_TYPE_VIDEO
    $k5: Boolean
    $videoId: String
    $force: Boolean
  ) {
    moveVideo(
      input: {
        active: $active
        fromMovedInput: $fromMovedInput
        toMovedInput: $toMovedInput
        groupType: $groupType
        description: $description
        glossaryTerm: $glossaryTerm
        mediaType: $mediaType
        k5: $k5
        videoId: $videoId
        force: $force
      }
    ) {
      video {
        ... on Video {
          mnIdentifier
          id
        }
        ... on Pdf {
          id
        }
      }
    }
  }
`;
export type MoveVideoMutationFn = Apollo.MutationFunction<
  MoveVideoMutation,
  MoveVideoMutationVariables
>;

/**
 * __useMoveVideoMutation__
 *
 * To run a mutation, you first call `useMoveVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveVideoMutation, { data, loading, error }] = useMoveVideoMutation({
 *   variables: {
 *      fromMovedInput: // value for 'fromMovedInput'
 *      toMovedInput: // value for 'toMovedInput'
 *      groupType: // value for 'groupType'
 *      active: // value for 'active'
 *      description: // value for 'description'
 *      glossaryTerm: // value for 'glossaryTerm'
 *      mediaType: // value for 'mediaType'
 *      k5: // value for 'k5'
 *      videoId: // value for 'videoId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useMoveVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveVideoMutation,
    MoveVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MoveVideoMutation, MoveVideoMutationVariables>(
    MoveVideoDocument,
    options
  );
}
export type MoveVideoMutationHookResult = ReturnType<
  typeof useMoveVideoMutation
>;
export type MoveVideoMutationResult = Apollo.MutationResult<MoveVideoMutation>;
export type MoveVideoMutationOptions = Apollo.BaseMutationOptions<
  MoveVideoMutation,
  MoveVideoMutationVariables
>;
export const DeleteVideoDocument = gql`
  mutation deleteVideo(
    $videoIndex: String
    $groupIdentifier: String!
    $userId: String
    $groupType: VideoGroupEnum!
    $mediaType: MediaTypeEnum = MEDIA_TYPE_VIDEO
  ) {
    deleteVideo(
      input: {
        videoIndex: $videoIndex
        groupIdentifier: $groupIdentifier
        tutorId: $userId
        groupType: $groupType
        mediaType: $mediaType
      }
    ) {
      video {
        ... on Video {
          id
        }
        ... on Pdf {
          id
        }
      }
    }
  }
`;
export type DeleteVideoMutationFn = Apollo.MutationFunction<
  DeleteVideoMutation,
  DeleteVideoMutationVariables
>;

/**
 * __useDeleteVideoMutation__
 *
 * To run a mutation, you first call `useDeleteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoMutation, { data, loading, error }] = useDeleteVideoMutation({
 *   variables: {
 *      videoIndex: // value for 'videoIndex'
 *      groupIdentifier: // value for 'groupIdentifier'
 *      userId: // value for 'userId'
 *      groupType: // value for 'groupType'
 *      mediaType: // value for 'mediaType'
 *   },
 * });
 */
export function useDeleteVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVideoMutation,
    DeleteVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteVideoMutation, DeleteVideoMutationVariables>(
    DeleteVideoDocument,
    options
  );
}
export type DeleteVideoMutationHookResult = ReturnType<
  typeof useDeleteVideoMutation
>;
export type DeleteVideoMutationResult =
  Apollo.MutationResult<DeleteVideoMutation>;
export type DeleteVideoMutationOptions = Apollo.BaseMutationOptions<
  DeleteVideoMutation,
  DeleteVideoMutationVariables
>;
export const GetQuestionDocument = gql`
  query getQuestion($id: ID!) {
    question(input: { platformAdminInput: { id: $id } }) {
      platformAdminPayload {
        item {
          id
          questionId
        }
      }
    }
  }
`;

/**
 * __useGetQuestionQuery__
 *
 * To run a query within a React component, call `useGetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQuestionQuery,
    GetQuestionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQuestionQuery, GetQuestionQueryVariables>(
    GetQuestionDocument,
    options
  );
}
export function useGetQuestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQuestionQuery,
    GetQuestionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQuestionQuery, GetQuestionQueryVariables>(
    GetQuestionDocument,
    options
  );
}
export type GetQuestionQueryHookResult = ReturnType<typeof useGetQuestionQuery>;
export type GetQuestionLazyQueryHookResult = ReturnType<
  typeof useGetQuestionLazyQuery
>;
export type GetQuestionQueryResult = Apollo.QueryResult<
  GetQuestionQuery,
  GetQuestionQueryVariables
>;
export const PreviewQuestionDocument = gql`
  mutation previewQuestion($items: [String!]!) {
    createSignRequest(items: $items) {
      signedRequest
    }
  }
`;
export type PreviewQuestionMutationFn = Apollo.MutationFunction<
  PreviewQuestionMutation,
  PreviewQuestionMutationVariables
>;

/**
 * __usePreviewQuestionMutation__
 *
 * To run a mutation, you first call `usePreviewQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewQuestionMutation, { data, loading, error }] = usePreviewQuestionMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function usePreviewQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PreviewQuestionMutation,
    PreviewQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PreviewQuestionMutation,
    PreviewQuestionMutationVariables
  >(PreviewQuestionDocument, options);
}
export type PreviewQuestionMutationHookResult = ReturnType<
  typeof usePreviewQuestionMutation
>;
export type PreviewQuestionMutationResult =
  Apollo.MutationResult<PreviewQuestionMutation>;
export type PreviewQuestionMutationOptions = Apollo.BaseMutationOptions<
  PreviewQuestionMutation,
  PreviewQuestionMutationVariables
>;
export const UploadStemscopesVideoDocument = gql`
  mutation uploadStemscopesVideo(
    $input: CreateStemscopesMediaPostObjectInput!
  ) {
    createStemscopesMediaPostObject(input: $input) {
      videoPostObject {
        formInputs
        fileKey
        formAttributes
      }
      subtitlesPostObject {
        formInputs
        fileKey
        formAttributes
      }
    }
  }
`;
export type UploadStemscopesVideoMutationFn = Apollo.MutationFunction<
  UploadStemscopesVideoMutation,
  UploadStemscopesVideoMutationVariables
>;

/**
 * __useUploadStemscopesVideoMutation__
 *
 * To run a mutation, you first call `useUploadStemscopesVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadStemscopesVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadStemscopesVideoMutation, { data, loading, error }] = useUploadStemscopesVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadStemscopesVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadStemscopesVideoMutation,
    UploadStemscopesVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadStemscopesVideoMutation,
    UploadStemscopesVideoMutationVariables
  >(UploadStemscopesVideoDocument, options);
}
export type UploadStemscopesVideoMutationHookResult = ReturnType<
  typeof useUploadStemscopesVideoMutation
>;
export type UploadStemscopesVideoMutationResult =
  Apollo.MutationResult<UploadStemscopesVideoMutation>;
export type UploadStemscopesVideoMutationOptions = Apollo.BaseMutationOptions<
  UploadStemscopesVideoMutation,
  UploadStemscopesVideoMutationVariables
>;
export const GetStemscopesMediasDocument = gql`
  query getStemscopesMedias(
    $page: Int!
    $itemsPerPage: Int!
    $filter: StemscopesMediaFilterInput!
  ) {
    stemscopesMedias(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
    ) {
      collection {
        id
        quality
        language
        title
        url
        active
        type
        subtitlesSrtFormat
        area
        status
        createdAt
      }
      paginationInfo {
        lastPage
        itemsPerPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetStemscopesMediasQuery__
 *
 * To run a query within a React component, call `useGetStemscopesMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStemscopesMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStemscopesMediasQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetStemscopesMediasQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStemscopesMediasQuery,
    GetStemscopesMediasQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStemscopesMediasQuery,
    GetStemscopesMediasQueryVariables
  >(GetStemscopesMediasDocument, options);
}
export function useGetStemscopesMediasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStemscopesMediasQuery,
    GetStemscopesMediasQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStemscopesMediasQuery,
    GetStemscopesMediasQueryVariables
  >(GetStemscopesMediasDocument, options);
}
export type GetStemscopesMediasQueryHookResult = ReturnType<
  typeof useGetStemscopesMediasQuery
>;
export type GetStemscopesMediasLazyQueryHookResult = ReturnType<
  typeof useGetStemscopesMediasLazyQuery
>;
export type GetStemscopesMediasQueryResult = Apollo.QueryResult<
  GetStemscopesMediasQuery,
  GetStemscopesMediasQueryVariables
>;
export const UpdateStemscopesMediaDocument = gql`
  mutation updateStemscopesMedia($input: UpdateStemscopesMediaInput!) {
    updateStemscopesMedia(input: $input) {
      videoPostObject {
        formInputs
        fileKey
        formAttributes
      }
      subtitlesPostObject {
        formInputs
        fileKey
        formAttributes
      }
    }
  }
`;
export type UpdateStemscopesMediaMutationFn = Apollo.MutationFunction<
  UpdateStemscopesMediaMutation,
  UpdateStemscopesMediaMutationVariables
>;

/**
 * __useUpdateStemscopesMediaMutation__
 *
 * To run a mutation, you first call `useUpdateStemscopesMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStemscopesMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStemscopesMediaMutation, { data, loading, error }] = useUpdateStemscopesMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStemscopesMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStemscopesMediaMutation,
    UpdateStemscopesMediaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStemscopesMediaMutation,
    UpdateStemscopesMediaMutationVariables
  >(UpdateStemscopesMediaDocument, options);
}
export type UpdateStemscopesMediaMutationHookResult = ReturnType<
  typeof useUpdateStemscopesMediaMutation
>;
export type UpdateStemscopesMediaMutationResult =
  Apollo.MutationResult<UpdateStemscopesMediaMutation>;
export type UpdateStemscopesMediaMutationOptions = Apollo.BaseMutationOptions<
  UpdateStemscopesMediaMutation,
  UpdateStemscopesMediaMutationVariables
>;
export const DeleteStemscopesMediaDocument = gql`
  mutation deleteStemscopesMedia($id: ID!) {
    deleteStemscopesMedia(id: $id) {
      media {
        id
      }
    }
  }
`;
export type DeleteStemscopesMediaMutationFn = Apollo.MutationFunction<
  DeleteStemscopesMediaMutation,
  DeleteStemscopesMediaMutationVariables
>;

/**
 * __useDeleteStemscopesMediaMutation__
 *
 * To run a mutation, you first call `useDeleteStemscopesMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStemscopesMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStemscopesMediaMutation, { data, loading, error }] = useDeleteStemscopesMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStemscopesMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteStemscopesMediaMutation,
    DeleteStemscopesMediaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteStemscopesMediaMutation,
    DeleteStemscopesMediaMutationVariables
  >(DeleteStemscopesMediaDocument, options);
}
export type DeleteStemscopesMediaMutationHookResult = ReturnType<
  typeof useDeleteStemscopesMediaMutation
>;
export type DeleteStemscopesMediaMutationResult =
  Apollo.MutationResult<DeleteStemscopesMediaMutation>;
export type DeleteStemscopesMediaMutationOptions = Apollo.BaseMutationOptions<
  DeleteStemscopesMediaMutation,
  DeleteStemscopesMediaMutationVariables
>;
export const UploadStreamingVideoDocument = gql`
  mutation uploadStreamingVideo($input: CreateStreamingVideoPostObjectInput!) {
    createStreamingVideoPostObject(input: $input) {
      id
      fileKey
      formAttributes
      formInputs
    }
  }
`;
export type UploadStreamingVideoMutationFn = Apollo.MutationFunction<
  UploadStreamingVideoMutation,
  UploadStreamingVideoMutationVariables
>;

/**
 * __useUploadStreamingVideoMutation__
 *
 * To run a mutation, you first call `useUploadStreamingVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadStreamingVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadStreamingVideoMutation, { data, loading, error }] = useUploadStreamingVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadStreamingVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadStreamingVideoMutation,
    UploadStreamingVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadStreamingVideoMutation,
    UploadStreamingVideoMutationVariables
  >(UploadStreamingVideoDocument, options);
}
export type UploadStreamingVideoMutationHookResult = ReturnType<
  typeof useUploadStreamingVideoMutation
>;
export type UploadStreamingVideoMutationResult =
  Apollo.MutationResult<UploadStreamingVideoMutation>;
export type UploadStreamingVideoMutationOptions = Apollo.BaseMutationOptions<
  UploadStreamingVideoMutation,
  UploadStreamingVideoMutationVariables
>;
export const GetStreamingVideosDocument = gql`
  query getStreamingVideos(
    $page: Int!
    $itemsPerPage: Int!
    $filter: StreamingVideoFilterInput
  ) {
    streamingVideos(page: $page, itemsPerPage: $itemsPerPage, filter: $filter) {
      collection {
        id
        quality
        language
        title
        url
        active
        type
        duration
        date
      }
      paginationInfo {
        lastPage
        itemsPerPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetStreamingVideosQuery__
 *
 * To run a query within a React component, call `useGetStreamingVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamingVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamingVideosQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetStreamingVideosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStreamingVideosQuery,
    GetStreamingVideosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStreamingVideosQuery,
    GetStreamingVideosQueryVariables
  >(GetStreamingVideosDocument, options);
}
export function useGetStreamingVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStreamingVideosQuery,
    GetStreamingVideosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStreamingVideosQuery,
    GetStreamingVideosQueryVariables
  >(GetStreamingVideosDocument, options);
}
export type GetStreamingVideosQueryHookResult = ReturnType<
  typeof useGetStreamingVideosQuery
>;
export type GetStreamingVideosLazyQueryHookResult = ReturnType<
  typeof useGetStreamingVideosLazyQuery
>;
export type GetStreamingVideosQueryResult = Apollo.QueryResult<
  GetStreamingVideosQuery,
  GetStreamingVideosQueryVariables
>;
export const UpdateStreamingVideoDocument = gql`
  mutation updateStreamingVideo($input: UpdateStreamingVideoInput!) {
    updateStreamingVideo(input: $input) {
      id
      formInputs
      fileKey
      formAttributes
    }
  }
`;
export type UpdateStreamingVideoMutationFn = Apollo.MutationFunction<
  UpdateStreamingVideoMutation,
  UpdateStreamingVideoMutationVariables
>;

/**
 * __useUpdateStreamingVideoMutation__
 *
 * To run a mutation, you first call `useUpdateStreamingVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStreamingVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStreamingVideoMutation, { data, loading, error }] = useUpdateStreamingVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStreamingVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStreamingVideoMutation,
    UpdateStreamingVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStreamingVideoMutation,
    UpdateStreamingVideoMutationVariables
  >(UpdateStreamingVideoDocument, options);
}
export type UpdateStreamingVideoMutationHookResult = ReturnType<
  typeof useUpdateStreamingVideoMutation
>;
export type UpdateStreamingVideoMutationResult =
  Apollo.MutationResult<UpdateStreamingVideoMutation>;
export type UpdateStreamingVideoMutationOptions = Apollo.BaseMutationOptions<
  UpdateStreamingVideoMutation,
  UpdateStreamingVideoMutationVariables
>;
export const DeleteStreamingVideoDocument = gql`
  mutation deleteStreamingVideo($id: ID!) {
    deleteStreamingVideo(id: $id) {
      video {
        id
      }
    }
  }
`;
export type DeleteStreamingVideoMutationFn = Apollo.MutationFunction<
  DeleteStreamingVideoMutation,
  DeleteStreamingVideoMutationVariables
>;

/**
 * __useDeleteStreamingVideoMutation__
 *
 * To run a mutation, you first call `useDeleteStreamingVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStreamingVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStreamingVideoMutation, { data, loading, error }] = useDeleteStreamingVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStreamingVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteStreamingVideoMutation,
    DeleteStreamingVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteStreamingVideoMutation,
    DeleteStreamingVideoMutationVariables
  >(DeleteStreamingVideoDocument, options);
}
export type DeleteStreamingVideoMutationHookResult = ReturnType<
  typeof useDeleteStreamingVideoMutation
>;
export type DeleteStreamingVideoMutationResult =
  Apollo.MutationResult<DeleteStreamingVideoMutation>;
export type DeleteStreamingVideoMutationOptions = Apollo.BaseMutationOptions<
  DeleteStreamingVideoMutation,
  DeleteStreamingVideoMutationVariables
>;
export const AddLinkedVideoDocument = gql`
  mutation addLinkedVideo($input: AddLinkedVideoInput!) {
    addLinkedVideo(input: $input) {
      video {
        ... on Video {
          id
        }
      }
    }
  }
`;
export type AddLinkedVideoMutationFn = Apollo.MutationFunction<
  AddLinkedVideoMutation,
  AddLinkedVideoMutationVariables
>;

/**
 * __useAddLinkedVideoMutation__
 *
 * To run a mutation, you first call `useAddLinkedVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLinkedVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLinkedVideoMutation, { data, loading, error }] = useAddLinkedVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLinkedVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddLinkedVideoMutation,
    AddLinkedVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddLinkedVideoMutation,
    AddLinkedVideoMutationVariables
  >(AddLinkedVideoDocument, options);
}
export type AddLinkedVideoMutationHookResult = ReturnType<
  typeof useAddLinkedVideoMutation
>;
export type AddLinkedVideoMutationResult =
  Apollo.MutationResult<AddLinkedVideoMutation>;
export type AddLinkedVideoMutationOptions = Apollo.BaseMutationOptions<
  AddLinkedVideoMutation,
  AddLinkedVideoMutationVariables
>;
export const GetLinkedVideosForVideoDocument = gql`
  query getLinkedVideosForVideo($id: ID!) {
    video(id: $id) {
      video {
        ... on Video {
          linkedVideos(page: 1, itemsPerPage: 10000) {
            collection {
              ... on Video {
                id
                mnIdentifier
                groupIdentifier
                videoIndex
                glossaryTerm
                k5
                tutor {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetLinkedVideosForVideoQuery__
 *
 * To run a query within a React component, call `useGetLinkedVideosForVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedVideosForVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedVideosForVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLinkedVideosForVideoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLinkedVideosForVideoQuery,
    GetLinkedVideosForVideoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLinkedVideosForVideoQuery,
    GetLinkedVideosForVideoQueryVariables
  >(GetLinkedVideosForVideoDocument, options);
}
export function useGetLinkedVideosForVideoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLinkedVideosForVideoQuery,
    GetLinkedVideosForVideoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLinkedVideosForVideoQuery,
    GetLinkedVideosForVideoQueryVariables
  >(GetLinkedVideosForVideoDocument, options);
}
export type GetLinkedVideosForVideoQueryHookResult = ReturnType<
  typeof useGetLinkedVideosForVideoQuery
>;
export type GetLinkedVideosForVideoLazyQueryHookResult = ReturnType<
  typeof useGetLinkedVideosForVideoLazyQuery
>;
export type GetLinkedVideosForVideoQueryResult = Apollo.QueryResult<
  GetLinkedVideosForVideoQuery,
  GetLinkedVideosForVideoQueryVariables
>;
export const GetSubscriptionPackagesDocument = gql`
  query getSubscriptionPackages(
    $itemsPerPage: Int!
    $page: Int!
    $filter: SubscriptionPackageFilterInput
  ) {
    subscriptionPackages(
      itemsPerPage: $itemsPerPage
      page: $page
      filter: $filter
    ) {
      collection {
        id
        schools {
          localName
          globalName
          district {
            state
            localName
            globalName
          }
        }
        subscriptions {
          products {
            sku
          }
        }
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetSubscriptionPackagesQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPackagesQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSubscriptionPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubscriptionPackagesQuery,
    GetSubscriptionPackagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionPackagesQuery,
    GetSubscriptionPackagesQueryVariables
  >(GetSubscriptionPackagesDocument, options);
}
export function useGetSubscriptionPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionPackagesQuery,
    GetSubscriptionPackagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionPackagesQuery,
    GetSubscriptionPackagesQueryVariables
  >(GetSubscriptionPackagesDocument, options);
}
export type GetSubscriptionPackagesQueryHookResult = ReturnType<
  typeof useGetSubscriptionPackagesQuery
>;
export type GetSubscriptionPackagesLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionPackagesLazyQuery
>;
export type GetSubscriptionPackagesQueryResult = Apollo.QueryResult<
  GetSubscriptionPackagesQuery,
  GetSubscriptionPackagesQueryVariables
>;
export const GetReviewerDocument = gql`
  query getReviewer($id: ID!) {
    adoptionReviewer(id: $id) {
      id
      beginDate
      expirationDate
      adoptionAccount {
        id
        name
        state
        adoptionEvent {
          name
          id
          expirationDate
          beginDate
        }
      }
      user {
        email
        firstName
        lastName
        middleName
        plainPassword
        userRoles {
          collection {
            id
            roleId
          }
        }
        active
        username
      }
      type
      multiSession
    }
  }
`;

/**
 * __useGetReviewerQuery__
 *
 * To run a query within a React component, call `useGetReviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReviewerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReviewerQuery,
    GetReviewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewerQuery, GetReviewerQueryVariables>(
    GetReviewerDocument,
    options
  );
}
export function useGetReviewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReviewerQuery,
    GetReviewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewerQuery, GetReviewerQueryVariables>(
    GetReviewerDocument,
    options
  );
}
export type GetReviewerQueryHookResult = ReturnType<typeof useGetReviewerQuery>;
export type GetReviewerLazyQueryHookResult = ReturnType<
  typeof useGetReviewerLazyQuery
>;
export type GetReviewerQueryResult = Apollo.QueryResult<
  GetReviewerQuery,
  GetReviewerQueryVariables
>;
export const GetRoleDocument = gql`
  query getRole($id: ID!) {
    role(id: $id) {
      code
    }
  }
`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(
    GetRoleDocument,
    options
  );
}
export function useGetRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(
    GetRoleDocument,
    options
  );
}
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<
  GetRoleQuery,
  GetRoleQueryVariables
>;
export const GetTutorsDocument = gql`
  query getTutors($page: Int!, $itemsPerPage: Int!) {
    tutors(page: $page, itemsPerPage: $itemsPerPage) {
      collection {
        id
        bioText
        bioVideo
        depthScale
        firstName
        lastName
        initialTag
        order
        mainProfilePhoto
        profilePhoto
      }
      paginationInfo {
        lastPage
        itemsPerPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetTutorsQuery__
 *
 * To run a query within a React component, call `useGetTutorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTutorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTutorsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetTutorsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTutorsQuery, GetTutorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTutorsQuery, GetTutorsQueryVariables>(
    GetTutorsDocument,
    options
  );
}
export function useGetTutorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTutorsQuery,
    GetTutorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTutorsQuery, GetTutorsQueryVariables>(
    GetTutorsDocument,
    options
  );
}
export type GetTutorsQueryHookResult = ReturnType<typeof useGetTutorsQuery>;
export type GetTutorsLazyQueryHookResult = ReturnType<
  typeof useGetTutorsLazyQuery
>;
export type GetTutorsQueryResult = Apollo.QueryResult<
  GetTutorsQuery,
  GetTutorsQueryVariables
>;
export const GetTutorDocument = gql`
  query getTutor($id: ID!) {
    tutor(id: $id) {
      tutor {
        id
        bioText
        bioVideo
        depthScale
        firstName
        lastName
        initialTag
        order
        mainProfilePhoto
        profilePhoto
      }
    }
  }
`;

/**
 * __useGetTutorQuery__
 *
 * To run a query within a React component, call `useGetTutorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTutorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTutorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTutorQuery(
  baseOptions: Apollo.QueryHookOptions<GetTutorQuery, GetTutorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTutorQuery, GetTutorQueryVariables>(
    GetTutorDocument,
    options
  );
}
export function useGetTutorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTutorQuery,
    GetTutorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTutorQuery, GetTutorQueryVariables>(
    GetTutorDocument,
    options
  );
}
export type GetTutorQueryHookResult = ReturnType<typeof useGetTutorQuery>;
export type GetTutorLazyQueryHookResult = ReturnType<
  typeof useGetTutorLazyQuery
>;
export type GetTutorQueryResult = Apollo.QueryResult<
  GetTutorQuery,
  GetTutorQueryVariables
>;
export const CreateTutorDocument = gql`
  mutation createTutor($input: CreateTutorInput!) {
    createTutor(input: $input) {
      tutor {
        id
      }
    }
  }
`;
export type CreateTutorMutationFn = Apollo.MutationFunction<
  CreateTutorMutation,
  CreateTutorMutationVariables
>;

/**
 * __useCreateTutorMutation__
 *
 * To run a mutation, you first call `useCreateTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTutorMutation, { data, loading, error }] = useCreateTutorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTutorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTutorMutation,
    CreateTutorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTutorMutation, CreateTutorMutationVariables>(
    CreateTutorDocument,
    options
  );
}
export type CreateTutorMutationHookResult = ReturnType<
  typeof useCreateTutorMutation
>;
export type CreateTutorMutationResult =
  Apollo.MutationResult<CreateTutorMutation>;
export type CreateTutorMutationOptions = Apollo.BaseMutationOptions<
  CreateTutorMutation,
  CreateTutorMutationVariables
>;
export const UpdateTutorDocument = gql`
  mutation updateTutor($input: UpdateTutorInput!) {
    updateTutor(input: $input) {
      tutor {
        id
      }
    }
  }
`;
export type UpdateTutorMutationFn = Apollo.MutationFunction<
  UpdateTutorMutation,
  UpdateTutorMutationVariables
>;

/**
 * __useUpdateTutorMutation__
 *
 * To run a mutation, you first call `useUpdateTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTutorMutation, { data, loading, error }] = useUpdateTutorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTutorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTutorMutation,
    UpdateTutorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTutorMutation, UpdateTutorMutationVariables>(
    UpdateTutorDocument,
    options
  );
}
export type UpdateTutorMutationHookResult = ReturnType<
  typeof useUpdateTutorMutation
>;
export type UpdateTutorMutationResult =
  Apollo.MutationResult<UpdateTutorMutation>;
export type UpdateTutorMutationOptions = Apollo.BaseMutationOptions<
  UpdateTutorMutation,
  UpdateTutorMutationVariables
>;
export const DeleteTutorDocument = gql`
  mutation deleteTutor($id: ID!) {
    deleteTutor(id: $id) {
      tutor {
        id
      }
    }
  }
`;
export type DeleteTutorMutationFn = Apollo.MutationFunction<
  DeleteTutorMutation,
  DeleteTutorMutationVariables
>;

/**
 * __useDeleteTutorMutation__
 *
 * To run a mutation, you first call `useDeleteTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTutorMutation, { data, loading, error }] = useDeleteTutorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTutorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTutorMutation,
    DeleteTutorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTutorMutation, DeleteTutorMutationVariables>(
    DeleteTutorDocument,
    options
  );
}
export type DeleteTutorMutationHookResult = ReturnType<
  typeof useDeleteTutorMutation
>;
export type DeleteTutorMutationResult =
  Apollo.MutationResult<DeleteTutorMutation>;
export type DeleteTutorMutationOptions = Apollo.BaseMutationOptions<
  DeleteTutorMutation,
  DeleteTutorMutationVariables
>;
export const GetUsersDocument = gql`
  query getUsers(
    $page: Int!
    $perPage: Int!
    $sorting: [UserFilter_order]
    $filter: [UserFilter]
  ) {
    users(
      page: $page
      itemsPerPage: $perPage
      order: $sorting
      filter: $filter
    ) {
      collection {
        _id
        id
        userRoles {
          collection {
            role {
              code
              _id
              id
              name
            }
            schoolIds
          }
        }
        preferences
        username
        firstName
        middleName
        lastName
        stateId
        externalSystemName
        email
        active
        district {
          id
          _id
          localName
          globalName
          state
        }
      }
      paginationInfo {
        totalCount
        lastPage
        itemsPerPage
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetUserDocument = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      id
      active
      type
      username
      plainPassword
      firstName
      lastName
      middleName
      email
      gradeLevel
      districtUuid
      district {
        _id
        globalName
      }
      language
      staffId
      stateId
      sisId
      externalId
      externalSystemName
      curriculumAreas
      userRoles {
        collection {
          id
          roleId
          schoolIds
          allSchoolsAccess
        }
      }
      createdAt
      createdByUsername
      updatedAt
      updatedByUsername
      manualMaintenance
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>;
export const GetUserRolesDocument = gql`
  query getUserRoles {
    roles(
      page: 1
      itemsPerPage: 1000
      filter: { categories: [District, Platform] }
    ) {
      collection {
        id
        name
        code
      }
    }
  }
`;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserRolesQuery,
    GetUserRolesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(
    GetUserRolesDocument,
    options
  );
}
export function useGetUserRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserRolesQuery,
    GetUserRolesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(
    GetUserRolesDocument,
    options
  );
}
export type GetUserRolesQueryHookResult = ReturnType<
  typeof useGetUserRolesQuery
>;
export type GetUserRolesLazyQueryHookResult = ReturnType<
  typeof useGetUserRolesLazyQuery
>;
export type GetUserRolesQueryResult = Apollo.QueryResult<
  GetUserRolesQuery,
  GetUserRolesQueryVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($input: createUserInput!) {
    createUser(input: $input) {
      user {
        _id
        firstName
        lastName
      }
      clientMutationId
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserMutation,
    CreateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>;
export type CreateUserMutationResult =
  Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($input: updateUserInput!) {
    updateUser(input: $input) {
      user {
        _id
        firstName
        lastName
      }
      clientMutationId
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const GetSchoolsDocument = gql`
  query getSchools(
    $id_list: [String]
    $itemsPerPage: Int = 10000
    $districtId: String
  ) {
    schools(
      id_list: $id_list
      itemsPerPage: $itemsPerPage
      districtId: $districtId
    ) {
      collection {
        globalName
        id
        _id
        name
        district {
          globalName
          state
        }
      }
    }
  }
`;

/**
 * __useGetSchoolsQuery__
 *
 * To run a query within a React component, call `useGetSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsQuery({
 *   variables: {
 *      id_list: // value for 'id_list'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      districtId: // value for 'districtId'
 *   },
 * });
 */
export function useGetSchoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSchoolsQuery,
    GetSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSchoolsQuery, GetSchoolsQueryVariables>(
    GetSchoolsDocument,
    options
  );
}
export function useGetSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchoolsQuery,
    GetSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSchoolsQuery, GetSchoolsQueryVariables>(
    GetSchoolsDocument,
    options
  );
}
export type GetSchoolsQueryHookResult = ReturnType<typeof useGetSchoolsQuery>;
export type GetSchoolsLazyQueryHookResult = ReturnType<
  typeof useGetSchoolsLazyQuery
>;
export type GetSchoolsQueryResult = Apollo.QueryResult<
  GetSchoolsQuery,
  GetSchoolsQueryVariables
>;
export const ApplicationSettingsDocument = gql`
  query applicationSettings {
    applicationSettings {
      value
      id
    }
  }
`;

/**
 * __useApplicationSettingsQuery__
 *
 * To run a query within a React component, call `useApplicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ApplicationSettingsQuery,
    ApplicationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ApplicationSettingsQuery,
    ApplicationSettingsQueryVariables
  >(ApplicationSettingsDocument, options);
}
export function useApplicationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationSettingsQuery,
    ApplicationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApplicationSettingsQuery,
    ApplicationSettingsQueryVariables
  >(ApplicationSettingsDocument, options);
}
export type ApplicationSettingsQueryHookResult = ReturnType<
  typeof useApplicationSettingsQuery
>;
export type ApplicationSettingsLazyQueryHookResult = ReturnType<
  typeof useApplicationSettingsLazyQuery
>;
export type ApplicationSettingsQueryResult = Apollo.QueryResult<
  ApplicationSettingsQuery,
  ApplicationSettingsQueryVariables
>;
export const CheckStudentOnExistenceDocument = gql`
  query checkStudentOnExistence(
    $sisId: String
    $withSisId: Boolean!
    $withStateId: Boolean!
    $stateId: String
    $districtId: String
  ) {
    usersBySisId: users(sisId: $sisId, districtId: $districtId)
      @include(if: $withSisId) {
      collection {
        id
        _id
        firstName
        lastName
        userRoles {
          collection {
            schoolIds
          }
        }
      }
    }
    usersByStateId: users(stateId: $stateId, districtId: $districtId)
      @include(if: $withStateId) {
      collection {
        id
        _id
        firstName
        lastName
        userRoles {
          collection {
            schoolIds
          }
        }
      }
    }
  }
`;

/**
 * __useCheckStudentOnExistenceQuery__
 *
 * To run a query within a React component, call `useCheckStudentOnExistenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckStudentOnExistenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckStudentOnExistenceQuery({
 *   variables: {
 *      sisId: // value for 'sisId'
 *      withSisId: // value for 'withSisId'
 *      withStateId: // value for 'withStateId'
 *      stateId: // value for 'stateId'
 *      districtId: // value for 'districtId'
 *   },
 * });
 */
export function useCheckStudentOnExistenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckStudentOnExistenceQuery,
    CheckStudentOnExistenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckStudentOnExistenceQuery,
    CheckStudentOnExistenceQueryVariables
  >(CheckStudentOnExistenceDocument, options);
}
export function useCheckStudentOnExistenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckStudentOnExistenceQuery,
    CheckStudentOnExistenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckStudentOnExistenceQuery,
    CheckStudentOnExistenceQueryVariables
  >(CheckStudentOnExistenceDocument, options);
}
export type CheckStudentOnExistenceQueryHookResult = ReturnType<
  typeof useCheckStudentOnExistenceQuery
>;
export type CheckStudentOnExistenceLazyQueryHookResult = ReturnType<
  typeof useCheckStudentOnExistenceLazyQuery
>;
export type CheckStudentOnExistenceQueryResult = Apollo.QueryResult<
  CheckStudentOnExistenceQuery,
  CheckStudentOnExistenceQueryVariables
>;
export const GetReviewersDocument = gql`
  query getReviewers(
    $page: Int = 1
    $itemsPerPage: Int = 10000
    $filter: AdoptionReviewerFilterInput
  ) {
    adoptionReviewers(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
    ) {
      collection {
        id
        active
        adoptionAccount {
          id
          name
          adoptionEvent {
            name
            id
          }
        }
        beginDate
        expirationDate
        user {
          id
          email
          firstName
          lastName
          plainPassword
          userRoles {
            collection {
              role {
                id
                code
              }
            }
          }
          active
          username
        }
        type
        multiSession
      }
      paginationInfo {
        itemsPerPage
        totalCount
        lastPage
      }
    }
  }
`;

/**
 * __useGetReviewersQuery__
 *
 * To run a query within a React component, call `useGetReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetReviewersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReviewersQuery,
    GetReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewersQuery, GetReviewersQueryVariables>(
    GetReviewersDocument,
    options
  );
}
export function useGetReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReviewersQuery,
    GetReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewersQuery, GetReviewersQueryVariables>(
    GetReviewersDocument,
    options
  );
}
export type GetReviewersQueryHookResult = ReturnType<
  typeof useGetReviewersQuery
>;
export type GetReviewersLazyQueryHookResult = ReturnType<
  typeof useGetReviewersLazyQuery
>;
export type GetReviewersQueryResult = Apollo.QueryResult<
  GetReviewersQuery,
  GetReviewersQueryVariables
>;
export const GetAdoptionReviewersWithTotalCountDocument = gql`
  query getAdoptionReviewersWithTotalCount(
    $filter: AdoptionReviewerFilterInput
    $itemsPerPage: Int!
    $order: AdoptionReviewerOrderInput = null
    $page: Int!
  ) {
    reviewersData: adoptionReviewers(
      filter: $filter
      itemsPerPage: $itemsPerPage
      order: $order
      page: $page
    ) {
      collection {
        id
        active
        adoptionAccount {
          id
          name
          adoptionEvent {
            name
            id
          }
        }
        beginDate
        expirationDate
        user {
          id
          email
          firstName
          lastName
          plainPassword
          userRoles {
            collection {
              role {
                id
                code
              }
            }
          }
          active
          username
        }
        type
        multiSession
      }
      paginationInfo {
        lastPage
        totalCount
      }
    }
    reviewersPaginationInfo: adoptionReviewers(itemsPerPage: 0, page: 1) {
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetAdoptionReviewersWithTotalCountQuery__
 *
 * To run a query within a React component, call `useGetAdoptionReviewersWithTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdoptionReviewersWithTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdoptionReviewersWithTotalCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAdoptionReviewersWithTotalCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdoptionReviewersWithTotalCountQuery,
    GetAdoptionReviewersWithTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdoptionReviewersWithTotalCountQuery,
    GetAdoptionReviewersWithTotalCountQueryVariables
  >(GetAdoptionReviewersWithTotalCountDocument, options);
}
export function useGetAdoptionReviewersWithTotalCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdoptionReviewersWithTotalCountQuery,
    GetAdoptionReviewersWithTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdoptionReviewersWithTotalCountQuery,
    GetAdoptionReviewersWithTotalCountQueryVariables
  >(GetAdoptionReviewersWithTotalCountDocument, options);
}
export type GetAdoptionReviewersWithTotalCountQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewersWithTotalCountQuery
>;
export type GetAdoptionReviewersWithTotalCountLazyQueryHookResult = ReturnType<
  typeof useGetAdoptionReviewersWithTotalCountLazyQuery
>;
export type GetAdoptionReviewersWithTotalCountQueryResult = Apollo.QueryResult<
  GetAdoptionReviewersWithTotalCountQuery,
  GetAdoptionReviewersWithTotalCountQueryVariables
>;
export const UpdateReviewerDocument = gql`
  mutation updateReviewer($input: UpdateAdoptionReviewerInput!) {
    updateAdoptionReviewer(input: $input) {
      adoptionReviewer {
        id
        user {
          username
        }
      }
    }
  }
`;
export type UpdateReviewerMutationFn = Apollo.MutationFunction<
  UpdateReviewerMutation,
  UpdateReviewerMutationVariables
>;

/**
 * __useUpdateReviewerMutation__
 *
 * To run a mutation, you first call `useUpdateReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewerMutation, { data, loading, error }] = useUpdateReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReviewerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReviewerMutation,
    UpdateReviewerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateReviewerMutation,
    UpdateReviewerMutationVariables
  >(UpdateReviewerDocument, options);
}
export type UpdateReviewerMutationHookResult = ReturnType<
  typeof useUpdateReviewerMutation
>;
export type UpdateReviewerMutationResult =
  Apollo.MutationResult<UpdateReviewerMutation>;
export type UpdateReviewerMutationOptions = Apollo.BaseMutationOptions<
  UpdateReviewerMutation,
  UpdateReviewerMutationVariables
>;
